import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AcceptResetPasswordOutputObjectType = {
  __typename?: 'AcceptResetPasswordOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddBlockedRecordDocumentFileName = {
  originalFileName: Scalars['String']['input'];
  uploadFileName: Scalars['String']['input'];
};

export type AddBlockedRecordExamSession = {
  endedAt: Scalars['DateTime']['input'];
  roundNumber: Scalars['Int']['input'];
  startedAt: Scalars['DateTime']['input'];
};

export type AddBlockedRecordInput = {
  blockedAt: Scalars['DateTime']['input'];
  blockedReason?: InputMaybe<Scalars['String']['input']>;
  blockedScope: BlockedRecordBlockedScope;
  blockedType: BlockedRecordBlockedType;
  blockedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  documentFileNames?: InputMaybe<Array<AddBlockedRecordDocumentFileName>>;
  email: Scalars['String']['input'];
  examCenterCode?: InputMaybe<Scalars['String']['input']>;
  examCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
  idType: BlockedUserIdType;
  lastName: Scalars['String']['input'];
  metadata?: InputMaybe<AddBlockedRecordMetadata>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type AddBlockedRecordMetadata = {
  department?: InputMaybe<Scalars['String']['input']>;
  enforcementEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  examSession?: InputMaybe<AddBlockedRecordExamSession>;
  position?: InputMaybe<Scalars['String']['input']>;
};

export type AddBlockedRecordOutput = {
  __typename?: 'AddBlockedRecordOutput';
  blockedRecord: BlockedRecord;
};

export type AddMemberToExamCenterInput = {
  type: ExamCenterMemberType;
  userId: Scalars['String']['input'];
};

export type AddMembersToExamCenterInput = {
  examCenterCode: Scalars['String']['input'];
  members: Array<AddMemberToExamCenterInput>;
};

export type AddMembersToExamCenterOutput = {
  __typename?: 'AddMembersToExamCenterOutput';
  examCenterMembers: Array<ExamCenterMember>;
};

export type AdminGetExamCenterProctorRequestByIdInputType = {
  id: Scalars['String']['input'];
};

export type AdminGetExamCenterProctorRequestByIdOutput = {
  __typename?: 'AdminGetExamCenterProctorRequestByIdOutput';
  examCenterProctorRequest: ExamCenterProctorRequest;
};

export type AdminGetExamRoomRequestInfoByIdInputType = {
  id: Scalars['String']['input'];
};

export type AdminGetExamRoomRequestInfoByIdOutput = {
  __typename?: 'AdminGetExamRoomRequestInfoByIdOutput';
  examRoomRequestInfo: ExamRoomRequestInfo;
};

export type AdminGetExamRoomRequestInfoCount = {
  __typename?: 'AdminGetExamRoomRequestInfoCount';
  inReview: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
};

export type AdminGetExamRoomRequestInfoCountOutput = {
  __typename?: 'AdminGetExamRoomRequestInfoCountOutput';
  examRoomRequestInfoCountByStatus: AdminGetExamRoomRequestInfoCount;
};

export type AdminSearchExamCenterProctorRequestsOutput = {
  __typename?: 'AdminSearchExamCenterProctorRequestsOutput';
  examCenterProctorRequests: Array<ExamCenterProctorRequest>;
  total: Scalars['Int']['output'];
};

export type AdminSearchMyExamCenterProctorFilterInput = {
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  step: AdminSearchMyExamCenterProctorRequestsStep;
  types?: InputMaybe<Array<ExamCenterProctorRequestType>>;
};

export type AdminSearchMyExamCenterProctorRequestsInput = {
  filter?: InputMaybe<AdminSearchMyExamCenterProctorFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export enum AdminSearchMyExamCenterProctorRequestsStep {
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED'
}

export type AdminSearchMyExamRoomRequestInfosFilterInput = {
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  step: AdminSearchMyExamRoomRequestInfosStep;
};

export type AdminSearchMyExamRoomRequestInfosInput = {
  filter?: InputMaybe<AdminSearchMyExamRoomRequestInfosFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type AdminSearchMyExamRoomRequestInfosOutput = {
  __typename?: 'AdminSearchMyExamRoomRequestInfosOutput';
  examRoomRequestInfos: Array<ExamRoomRequestInfo>;
  total: Scalars['Int']['output'];
};

export enum AdminSearchMyExamRoomRequestInfosStep {
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED'
}

export type AdminSearchRoomByLocationNameInput = {
  filter?: InputMaybe<SearchFilterInput>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  paging?: InputMaybe<PagingInput>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminSearchRoomByLocationNameOutput = {
  __typename?: 'AdminSearchRoomByLocationNameOutput';
  rooms: Array<Room>;
  total: Scalars['Int']['output'];
};

export type AdminUpdateExamCenterInput = {
  addressEN: Scalars['String']['input'];
  addressTH: Scalars['String']['input'];
  email: Scalars['String']['input'];
  examCenterCode: Scalars['String']['input'];
  examResultRecipientEmail: Scalars['String']['input'];
  nameEN: Scalars['String']['input'];
  nameTH: Scalars['String']['input'];
  phoneEN: Scalars['String']['input'];
  phoneTH: Scalars['String']['input'];
  website: Scalars['String']['input'];
};

export type AdminUpdateExamCenterOutput = {
  __typename?: 'AdminUpdateExamCenterOutput';
  examCenter: ExamCenter;
};

export type Announcement = {
  __typename?: 'Announcement';
  announcedAt: Maybe<Scalars['DateTime']['output']>;
  content: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  link: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AntivirusProgramOption = {
  __typename?: 'AntivirusProgramOption';
  otherDetail: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type AppPermission = {
  __typename?: 'AppPermission';
  action: Scalars['String']['output'];
  category: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AppRole = {
  __typename?: 'AppRole';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type AppRoleIdsInput = {
  appRoleIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppRoleSearchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AppRoleSearchResult = {
  __typename?: 'AppRoleSearchResult';
  roles: Array<AppRole>;
  total: Scalars['Int']['output'];
};

export type ApplicantGroupInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ApplicantGroupType>;
};

export enum ApplicantGroupType {
  Bank = 'BANK',
  InsuranceCompany = 'INSURANCE_COMPANY',
  Others = 'OTHERS',
  ProjectCharge = 'PROJECT_CHARGE',
  ProjectFree = 'PROJECT_FREE',
  SecuritiesCompany = 'SECURITIES_COMPANY',
  Student = 'STUDENT'
}

export type AssignExamCoursesToExamCenterInput = {
  examCenterCode: Scalars['String']['input'];
  examCourseIds: Array<Scalars['String']['input']>;
};

export type AssignExamCoursesToExamCenterOutput = {
  __typename?: 'AssignExamCoursesToExamCenterOutput';
  examCourses: Array<ExamCourse>;
};

export type AssignExamsByExamCourseCodesAndMonthOfYearInput = {
  examCourseCodes: Array<Scalars['String']['input']>;
  month: Scalars['Float']['input'];
  year: Scalars['Float']['input'];
};

export type AssignExamsByExamCourseCodesAndMonthOfYearOutput = {
  __typename?: 'AssignExamsByExamCourseCodesAndMonthOfYearOutput';
  examCoursesChosen: Scalars['Float']['output'];
  examEventsAssigned: Scalars['Float']['output'];
};

export type AssignUserAppRoleInput = {
  appRoleId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type AssignUserAppRoleMutationResponse = {
  __typename?: 'AssignUserAppRoleMutationResponse';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user: Maybe<Array<UserAppRoleView>>;
};

export type AssignUserAppRolesInput = {
  appRoleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignUserAppRolesMutationResponse = {
  __typename?: 'AssignUserAppRolesMutationResponse';
  appRoles: Maybe<Array<AppRole>>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AssignedExamEventCoursesInput = {
  examEventCourseId: Scalars['String']['input'];
  qSetId?: InputMaybe<Scalars['String']['input']>;
};

export type AttachDocumentSettings = {
  __typename?: 'AttachDocumentSettings';
  bucket: Scalars['String']['output'];
  fileName: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  provider: StorageProvider;
};

export type AttachDocumentSettingsInput = {
  originalFileName: Scalars['String']['input'];
  uploadFileName: Scalars['String']['input'];
};

export enum AuditActionType {
  Add = 'ADD',
  Approve = 'APPROVE',
  AutoSync = 'AUTO_SYNC',
  ChangeStatus = 'CHANGE_STATUS',
  Create = 'CREATE',
  Delete = 'DELETE',
  Disable = 'DISABLE',
  Download = 'DOWNLOAD',
  Export = 'EXPORT',
  Grant = 'GRANT',
  Import = 'IMPORT',
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  Reject = 'REJECT',
  Remove = 'REMOVE',
  Revoke = 'REVOKE',
  SendResultToWr = 'SEND_RESULT_TO_WR',
  Submit = 'SUBMIT',
  Update = 'UPDATE',
  Upload = 'UPLOAD',
  View = 'VIEW'
}

export enum AuditLogExecutionResult {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export enum AuditType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type BlockedRecord = {
  __typename?: 'BlockedRecord';
  blockedAt: Scalars['DateTime']['output'];
  blockedReason: Maybe<Scalars['String']['output']>;
  blockedRecordCourses: Array<BlockedRecordCourse>;
  blockedScope: BlockedRecordBlockedScope;
  blockedType: BlockedRecordBlockedType;
  blockedUntil: Maybe<Scalars['DateTime']['output']>;
  blockedUserId: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  examCenter: Maybe<ExamCenter>;
  examCenterCode: Maybe<Scalars['String']['output']>;
  examEvent: Maybe<ExamEvent>;
  examEventId: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata: BlockedRecordMetadata;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export enum BlockedRecordBlockedScope {
  AllScope = 'ALL_SCOPE',
  PartialScope = 'PARTIAL_SCOPE'
}

export enum BlockedRecordBlockedType {
  Cheater = 'CHEATER',
  ExamCenterManager = 'EXAM_CENTER_MANAGER',
  ExamPasser = 'EXAM_PASSER',
  Instructor = 'INSTRUCTOR',
  MysteryAudit = 'MYSTERY_AUDIT',
  Other = 'OTHER',
  Proctor_1 = 'PROCTOR_1',
  Proctor_2 = 'PROCTOR_2',
  Proctor_3 = 'PROCTOR_3',
  Staff = 'STAFF',
  Vendor = 'VENDOR'
}

export enum BlockedRecordContentType {
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Pdf = 'PDF',
  Png = 'PNG'
}

export type BlockedRecordCourse = {
  __typename?: 'BlockedRecordCourse';
  blockedRecordId: Scalars['String']['output'];
  blockedUserId: Scalars['String']['output'];
  examCourse: Maybe<ExamCourse>;
  examCourseCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type BlockedRecordExamSession = {
  __typename?: 'BlockedRecordExamSession';
  endedAt: Scalars['DateTime']['output'];
  roundNumber: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type BlockedRecordMetadata = {
  __typename?: 'BlockedRecordMetadata';
  department: Maybe<Scalars['String']['output']>;
  documentStorageObjects: Maybe<Array<StorageObject>>;
  enforcementEndDate: Maybe<Scalars['DateTime']['output']>;
  examSession: Maybe<BlockedRecordExamSession>;
  position: Maybe<Scalars['String']['output']>;
};

export type BlockedUser = {
  __typename?: 'BlockedUser';
  blockedRecords: Array<BlockedRecord>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idNumber: Scalars['String']['output'];
  idType: BlockedUserIdType;
  lastName: Scalars['String']['output'];
  middleName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum BlockedUserIdType {
  CitizenCard = 'CITIZEN_CARD',
  Passport = 'PASSPORT'
}

export type Building = {
  __typename?: 'Building';
  id: Scalars['String']['output'];
  location: Location;
  locationId: Scalars['String']['output'];
  nameEn: Maybe<Scalars['String']['output']>;
  nameTh: Scalars['String']['output'];
};

export type CancelExamEventExamineeInput = {
  cancelationReason: CancelationReason;
  examEventExamineeId: Scalars['String']['input'];
  remark: Scalars['String']['input'];
};

export type CancelExamEventExamineeOutput = {
  __typename?: 'CancelExamEventExamineeOutput';
  examEventExaminee: ExamEventExaminee;
};

export enum CancelationReason {
  Accident = 'ACCIDENT',
  Cheating = 'CHEATING',
  TechnicalIssue = 'TECHNICAL_ISSUE'
}

export type CertificateSettings = {
  __typename?: 'CertificateSettings';
  averageScoreCondition: Maybe<ExamCourseCertificateAverageScoreCondition>;
  delayedDays: Maybe<Scalars['Int']['output']>;
  failedTemplate: ExamCourseCertificateFailedTemplate;
  passedTemplate: ExamCourseCertificatePassedTemplate;
  validityDurationYears: Maybe<Scalars['Int']['output']>;
};

export type CertificateSettingsInput = {
  averageScoreCondition?: InputMaybe<ExamCourseCertificateAverageScoreCondition>;
  delayedDays?: InputMaybe<Scalars['Int']['input']>;
  failedTemplate: ExamCourseCertificateFailedTemplate;
  passedTemplate: ExamCourseCertificatePassedTemplate;
  validityDurationYears?: InputMaybe<Scalars['Int']['input']>;
};

export type ClearSessionOutputObjectType = {
  __typename?: 'ClearSessionOutputObjectType';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ComputerDetails = {
  __typename?: 'ComputerDetails';
  computerSeatImages: Maybe<Array<Scalars['String']['output']>>;
  computerSpecImages: Maybe<Array<Scalars['String']['output']>>;
  cpu: Maybe<CpuOption>;
  monitor: Maybe<WithOtherDetail>;
  os: Maybe<OsOption>;
  osUpdateCadence: Maybe<UpdateCadenceOption>;
  ram: Maybe<RamSizeOption>;
  sebVersionStatus: Maybe<Scalars['String']['output']>;
  storage: Maybe<StorageOption>;
  webBrowser: Maybe<WebBrowserOption>;
};

export type CountActiveExamCenterProctorsByTypeInput = {
  examCenterCode: Scalars['String']['input'];
};

export type CountActiveExamCenterProctorsByTypeOutput = {
  __typename?: 'CountActiveExamCenterProctorsByTypeOutput';
  proctorsCountByType: Scalars['JSONObject']['output'];
};

export type CountExamCenterRoomsByProvinceInput = {
  examCenterCode: Scalars['String']['input'];
};

export type CountExamCenterRoomsByProvinceOutput = {
  __typename?: 'CountExamCenterRoomsByProvinceOutput';
  examCenterRoomsCountByProvince: Scalars['JSONObject']['output'];
};

export type CountExamEventsWithQuestionnairesInput = {
  endDate: Scalars['DateTime']['input'];
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate: Scalars['DateTime']['input'];
  templateId: QuestionnaireTemplateId;
};

export type CountExamEventsWithQuestionnairesOutput = {
  __typename?: 'CountExamEventsWithQuestionnairesOutput';
  total: Scalars['Int']['output'];
};

export type CpuOption = {
  __typename?: 'CpuOption';
  otherDetail: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type CreateAnnouncementInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateAnnouncementOutput = {
  __typename?: 'CreateAnnouncementOutput';
  announcement: Announcement;
};

export type CreateAppRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type CreateAppRoleMutationResponse = {
  __typename?: 'CreateAppRoleMutationResponse';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  newAppRole: AppRole;
  success: Scalars['Boolean']['output'];
};

export type CreateExamCenterInput = {
  code: Scalars['String']['input'];
  nameEN: Scalars['String']['input'];
  nameTH: Scalars['String']['input'];
};

export type CreateExamCenterOutput = {
  __typename?: 'CreateExamCenterOutput';
  examCenter: ExamCenter;
};

export type CreateExamCenterProctorFileNameInput = {
  originalFileName: Scalars['String']['input'];
  uploadFileName: Scalars['String']['input'];
};

export type CreateExamCenterProctorInput = {
  agreementFileNames: Array<CreateExamCenterProctorFileNameInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  examCenterCode: Scalars['String']['input'];
  examCenterProctorType: ExamCenterProctorType;
  examEventId?: InputMaybe<Scalars['String']['input']>;
  firstNameTh: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
  idType: IdType;
  lastNameTh: Scalars['String']['input'];
  middleNameTh?: InputMaybe<Scalars['String']['input']>;
  personalInfoFileNames: Array<CreateExamCenterProctorFileNameInput>;
  titleTh: Scalars['String']['input'];
};

export type CreateExamCenterProctorOutput = {
  __typename?: 'CreateExamCenterProctorOutput';
  examCenterProctor: ExamCenterProctor;
};

export type CreateExamCenterProctorRequestFileNameInput = {
  originalFileName: Scalars['String']['input'];
  uploadFileName: Scalars['String']['input'];
};

export type CreateExamCenterProctorRequestInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  agreementFileNames: Array<CreateExamCenterProctorRequestFileNameInput>;
  department?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  examCenterCode: Scalars['String']['input'];
  firstNameEn: Scalars['String']['input'];
  firstNameTh: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
  idType: ExamCenterProctorRequestIdType;
  lastNameEn: Scalars['String']['input'];
  lastNameTh: Scalars['String']['input'];
  middleNameEn?: InputMaybe<Scalars['String']['input']>;
  middleNameTh?: InputMaybe<Scalars['String']['input']>;
  personalInfoFileNames: Array<CreateExamCenterProctorRequestFileNameInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  startedAt: Scalars['DateTime']['input'];
  titleEn: Scalars['String']['input'];
  titleTh: Scalars['String']['input'];
  type: ExamCenterProctorRequestType;
};

export type CreateExamCenterProctorRequestOutput = {
  __typename?: 'CreateExamCenterProctorRequestOutput';
  examCenterProctorRequest: ExamCenterProctorRequest;
};

export type CreateExamEventDateInput = {
  examEndedAt: Scalars['DateTime']['input'];
  examStartedAt: Scalars['DateTime']['input'];
  registrationEndedAt: Scalars['DateTime']['input'];
  registrationStartedAt: Scalars['DateTime']['input'];
  requestId: Scalars['String']['input'];
  sessions: Array<ExamEventSessionInput>;
};

export type CreateExamEventInput = {
  examCenterCode: Scalars['String']['input'];
  examCourseIds: Array<Scalars['String']['input']>;
  examEndedAt: Scalars['DateTime']['input'];
  examLocationId: Scalars['String']['input'];
  examStartedAt: Scalars['DateTime']['input'];
  examType: ExamType;
  metadata?: InputMaybe<ExamEventMetadataInput>;
  name: Scalars['String']['input'];
  proctorIds: Array<Scalars['String']['input']>;
  registrationEndedAt: Scalars['DateTime']['input'];
  registrationStartedAt: Scalars['DateTime']['input'];
  registrationType: RegistrationType;
  roomIds: Array<Scalars['String']['input']>;
  seat: Scalars['Int']['input'];
  sessions: Array<ExamEventSessionInput>;
};

export type CreateExamEventOutput = {
  __typename?: 'CreateExamEventOutput';
  examEvent: ExamEvent;
};

export type CreateExamEventsInput = {
  examCenterCode: Scalars['String']['input'];
  examCourseIds: Array<Scalars['String']['input']>;
  examEventDates: Array<CreateExamEventDateInput>;
  examLocationId: Scalars['String']['input'];
  examType: ExamType;
  metadata?: InputMaybe<ExamEventMetadataInput>;
  name: Scalars['String']['input'];
  proctorIds: Array<Scalars['String']['input']>;
  registrationType: RegistrationType;
  roomIds: Array<Scalars['String']['input']>;
  seat: Scalars['Int']['input'];
};

export type CreateExamEventsOutput = {
  __typename?: 'CreateExamEventsOutput';
  examEvents: Array<ExamEvent>;
  failedExamEvents: Array<FailedExamEvent>;
};

export type CreateExamLocationRequestInfoInputType = {
  buildingId?: InputMaybe<Scalars['String']['input']>;
  buildingName?: InputMaybe<Scalars['String']['input']>;
  examCenterCode: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameTh?: InputMaybe<Scalars['String']['input']>;
  provinceId: Scalars['String']['input'];
};

export type CreateExamLocationRequestInfoOutput = {
  __typename?: 'CreateExamLocationRequestInfoOutput';
  examLocationRequestInfo: ExamLocationRequestInfo;
};

export type CreateExamRoomRequestInfoInputType = {
  examLocationRequestInfoId: Scalars['String']['input'];
  floor: Scalars['String']['input'];
  name: Scalars['String']['input'];
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  seatCount: Scalars['Float']['input'];
};

export type CreateExamRoomRequestInfoOutput = {
  __typename?: 'CreateExamRoomRequestInfoOutput';
  examRoomRequestInfo: ExamRoomRequestInfo;
};

export type CreateOrUpdateExamCenterProctorRequestVerdictInputType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  proctorRequestId: Scalars['String']['input'];
  verdict?: InputMaybe<Verdict>;
};

export type CreateOrUpdateExamCenterProctorRequestVerdictOutput = {
  __typename?: 'CreateOrUpdateExamCenterProctorRequestVerdictOutput';
  examCenterProctorRequestVerdict: ExamCenterProctorRequestVerdict;
};

export type CreateOrUpdateExamLocationRequestVerdictInputType = {
  approvalType?: InputMaybe<ExamLocationRequestApprovalType>;
  comment?: InputMaybe<Scalars['String']['input']>;
  examRoomRequestInfoId: Scalars['String']['input'];
  grantedRoomId?: InputMaybe<Scalars['String']['input']>;
  verdict?: InputMaybe<ExamLocationVerdict>;
};

export type CreateOrUpdateExamLocationRequestVerdictOutput = {
  __typename?: 'CreateOrUpdateExamLocationRequestVerdictOutput';
  examLocationVerdict: ExamLocationRequestVerdict;
};

export type CreateOrUpdateExamRoomRequestComputerInfoInputType = {
  examRoomRequestInfoId: Scalars['String']['input'];
  info?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateOrUpdateExamRoomRequestComputerInfoOutput = {
  __typename?: 'CreateOrUpdateExamRoomRequestComputerInfoOutput';
  examRoomRequestComputerInfo: ExamRoomRequestComputerInfo;
};

export type CreateOrUpdateExamRoomRequestPhysicalInfoInputType = {
  examRoomRequestInfoId: Scalars['String']['input'];
  info?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateOrUpdateExamRoomRequestPhysicalInfoOutput = {
  __typename?: 'CreateOrUpdateExamRoomRequestPhysicalInfoOutput';
  examRoomRequestPhysicalInfo: ExamRoomRequestPhysicalInfo;
};

export type DeleteAppRoleInput = {
  appRoleId: Scalars['String']['input'];
};

export type DeleteAppRoleMutationResponse = {
  __typename?: 'DeleteAppRoleMutationResponse';
  appRole: AppRole;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteExamCenterProctorRequestByIdInput = {
  id: Scalars['String']['input'];
};

export type DeleteExamCenterProctorRequestByIdOutput = {
  __typename?: 'DeleteExamCenterProctorRequestByIdOutput';
  data: Maybe<Scalars['JSON']['output']>;
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export type DeleteExamLocationRequestInfoByIdInputType = {
  id: Scalars['String']['input'];
};

export type DeleteExamLocationRequestInfoByIdOutput = {
  __typename?: 'DeleteExamLocationRequestInfoByIdOutput';
  data: Maybe<Scalars['JSON']['output']>;
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export type DeleteExamRoomRequestInfoByIdInputType = {
  id: Scalars['String']['input'];
};

export type DeleteExamRoomRequestInfoByIdOutput = {
  __typename?: 'DeleteExamRoomRequestInfoByIdOutput';
  data: Maybe<Scalars['JSON']['output']>;
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export type DeleteManagerFromExamCenterInput = {
  examCenterManagerId: Scalars['String']['input'];
};

export type DeleteMemberFromExamCenterOutput = {
  __typename?: 'DeleteMemberFromExamCenterOutput';
  data: Maybe<Scalars['JSON']['output']>;
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export type DoorInfo = {
  __typename?: 'DoorInfo';
  images: Maybe<Array<Scalars['String']['output']>>;
  numberOfDoors: Maybe<Scalars['Float']['output']>;
};

export enum DopaVerificationStatus {
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Success = 'SUCCESS',
  Unauthorized = 'UNAUTHORIZED',
  Unknown = 'UNKNOWN'
}

export type DownloadExamByExamEventIdInput = {
  examEventId: Scalars['String']['input'];
};

export type DownloadExamByExamEventIdOutput = {
  __typename?: 'DownloadExamByExamEventIdOutput';
  data: Maybe<Scalars['JSON']['output']>;
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export type DownloadSetPortalExamResultFileInput = {
  id: Scalars['String']['input'];
};

export type DownloadSetPortalExamResultFileOutput = {
  __typename?: 'DownloadSETPortalExamResultFileOutput';
  downloadUrl: Scalars['String']['output'];
};

export type DuplicateExamRoomRequestInfoInputType = {
  examRoomRequestInfoId: Scalars['String']['input'];
};

export type DuplicateExamRoomRequestInfoOutput = {
  __typename?: 'DuplicateExamRoomRequestInfoOutput';
  examRoomRequestInfo: ExamRoomRequestInfo;
};

export type EKycDocumentObjectType = {
  __typename?: 'EKycDocumentObjectType';
  storageObject: EKycStorageObjectObjectType;
  type: EKycDocumentType;
};

export enum EKycDocumentType {
  CitizenCardBack = 'CITIZEN_CARD_BACK',
  CitizenCardFront = 'CITIZEN_CARD_FRONT',
  FaceImage = 'FACE_IMAGE'
}

export enum EKycDocumentVerificationStatus {
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  NotStarted = 'NOT_STARTED',
  Rejected = 'REJECTED',
  Uploaded = 'UPLOADED',
  Verified = 'VERIFIED'
}

export enum EKycIdType {
  CitizenCard = 'CITIZEN_CARD',
  Passport = 'PASSPORT'
}

export type EKycInfo = {
  __typename?: 'EKycInfo';
  address: Maybe<Scalars['String']['output']>;
  backCardVerified: EKycDocumentVerificationStatus;
  cardVerified: EKycDocumentVerificationStatus;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth: Maybe<Scalars['DateTime']['output']>;
  documents: Array<EKycDocumentObjectType>;
  email: Scalars['String']['output'];
  expiryDate: Maybe<Scalars['DateTime']['output']>;
  faceMatchSimilarity: Maybe<Scalars['Float']['output']>;
  faceMatched: EKycDocumentVerificationStatus;
  firstname: Maybe<Scalars['String']['output']>;
  firstnameEng: Maybe<Scalars['String']['output']>;
  frontCardVerified: EKycDocumentVerificationStatus;
  id: Scalars['String']['output'];
  idCode: Maybe<Scalars['String']['output']>;
  idNumber: Maybe<Scalars['String']['output']>;
  idType: Maybe<EKycIdType>;
  issuedDate: Maybe<Scalars['DateTime']['output']>;
  lastname: Maybe<Scalars['String']['output']>;
  lastnameEng: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
  middleNameEng: Maybe<Scalars['String']['output']>;
  reasons: Array<EKycInfoReasonObjectType>;
  status: EKycVerificationStatus;
  title: Maybe<Scalars['String']['output']>;
  titleEng: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  verificationCheckList: Maybe<EKycVerificationCheckListObjectType>;
  verifiedAt: Maybe<Scalars['DateTime']['output']>;
  verifiedBy: Maybe<Scalars['String']['output']>;
};

export enum EKycInfoReasonId {
  ClearBackCardText = 'CLEAR_BACK_CARD_TEXT',
  ClearFaceImage = 'CLEAR_FACE_IMAGE',
  ClearFrontCardText = 'CLEAR_FRONT_CARD_TEXT',
  MatchedFaceImage = 'MATCHED_FACE_IMAGE',
  MatchedIdCardInfo = 'MATCHED_ID_CARD_INFO'
}

export type EKycInfoReasonObjectType = {
  __typename?: 'EKycInfoReasonObjectType';
  id: EKycInfoReasonId;
  isPassed: Scalars['Boolean']['output'];
};

export type EKycStorageObjectObjectType = {
  __typename?: 'EKycStorageObjectObjectType';
  bucket: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  type: StorageObjectProvider;
};

export type EKycVerificationCheckListObjectType = {
  __typename?: 'EKycVerificationCheckListObjectType';
  idPhotoClarity: Scalars['Boolean']['output'];
  photoClarity: Scalars['Boolean']['output'];
  photoIdentityMatch: Scalars['Boolean']['output'];
};

export enum EKycVerificationStatus {
  Approved = 'APPROVED',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  NotRequired = 'NOT_REQUIRED',
  NotStarted = 'NOT_STARTED',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED',
  Terminated = 'TERMINATED'
}

export type EnableExamCourseByIdInput = {
  id: Scalars['String']['input'];
};

export type EnableExamCourseByIdOutput = {
  __typename?: 'EnableExamCourseByIdOutput';
  examCourse: ExamCourse;
};

export type ExamCenter = {
  __typename?: 'ExamCenter';
  addressEN: Maybe<Scalars['String']['output']>;
  addressTH: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  examCenterId: Scalars['Int']['output'];
  examResultRecipientEmail: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logoSrc: Maybe<Scalars['String']['output']>;
  nameEN: Scalars['String']['output'];
  nameTH: Scalars['String']['output'];
  phoneEN: Maybe<Scalars['String']['output']>;
  phoneTH: Maybe<Scalars['String']['output']>;
  scoreReportUrl: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

export type ExamCenterCourse = {
  __typename?: 'ExamCenterCourse';
  createdAt: Scalars['DateTime']['output'];
  examCenterCode: Scalars['String']['output'];
  examCourse: ExamCourse;
  examCourseCode: Scalars['String']['output'];
  examCourseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExamCenterEventSummaries = {
  __typename?: 'ExamCenterEventSummaries';
  inHouseAbsentExamineeCount: Scalars['Int']['output'];
  inHouseAttendedExamineeCount: Scalars['Int']['output'];
  inHouseCanceledExamineeCount: Scalars['Int']['output'];
  inHouseExamEventExamineeCount: Scalars['Int']['output'];
  inHouseRoundCount: Scalars['Int']['output'];
  inHouseSeatCount: Scalars['Int']['output'];
  publicAbsentExamineeCount: Scalars['Int']['output'];
  publicAttendedExamineeCount: Scalars['Int']['output'];
  publicCanceledExamineeCount: Scalars['Int']['output'];
  publicExamEventExamineeCount: Scalars['Int']['output'];
  publicRoundCount: Scalars['Int']['output'];
  publicSeatCount: Scalars['Int']['output'];
};

export type ExamCenterLocation = {
  __typename?: 'ExamCenterLocation';
  approvedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  examCenterCode: Scalars['String']['output'];
  examRoomRequestInfo: Maybe<ExamRoomRequestInfo>;
  examRoomRequestInfoId: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location: Maybe<Location>;
  refId: Scalars['String']['output'];
  type: ExamCenterLocationType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ExamCenterLocationType {
  Building = 'BUILDING',
  Location = 'LOCATION',
  Room = 'ROOM'
}

export type ExamCenterMember = {
  __typename?: 'ExamCenterMember';
  examCenterCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: ExamCenterMemberType;
  user: Maybe<RawUser>;
  userId: Scalars['String']['output'];
};

export enum ExamCenterMemberType {
  Manager = 'MANAGER',
  Proctor_1 = 'PROCTOR_1',
  Proctor_2 = 'PROCTOR_2'
}

export type ExamCenterProctor = {
  __typename?: 'ExamCenterProctor';
  address: Maybe<Scalars['String']['output']>;
  agreementStorageObjects: Maybe<Array<ExamCenterProctorStorageObject>>;
  blockedRecordId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  endedAt: Maybe<Scalars['DateTime']['output']>;
  examCenterCode: Scalars['String']['output'];
  firstNameEn: Maybe<Scalars['String']['output']>;
  firstNameTh: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idNumber: Scalars['String']['output'];
  lastNameEn: Maybe<Scalars['String']['output']>;
  lastNameTh: Scalars['String']['output'];
  metadata: Maybe<ExamCenterProctorMetadata>;
  middleNameEn: Maybe<Scalars['String']['output']>;
  middleNameTh: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  titleEn: Maybe<Scalars['String']['output']>;
  titleTh: Scalars['String']['output'];
  type: ExamCenterProctorType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Maybe<Scalars['String']['output']>;
  updatedUser: Maybe<RawUser>;
  userId: Maybe<Scalars['String']['output']>;
};

export enum ExamCenterProctorContentType {
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Pdf = 'PDF',
  Png = 'PNG'
}

export type ExamCenterProctorMetadata = {
  __typename?: 'ExamCenterProctorMetadata';
  department: Maybe<Scalars['String']['output']>;
  employeeId: Maybe<Scalars['String']['output']>;
  position: Maybe<Scalars['String']['output']>;
};

export type ExamCenterProctorRequest = {
  __typename?: 'ExamCenterProctorRequest';
  address: Maybe<Scalars['String']['output']>;
  agreementStorageObjects: Array<ExamCenterProctorRequestStorageObject>;
  editedAt: Maybe<Scalars['DateTime']['output']>;
  editedBy: Maybe<Scalars['String']['output']>;
  editedUser: Maybe<RawUser>;
  email: Scalars['String']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  examCenterCode: Scalars['String']['output'];
  examCenterProctorId: Maybe<Scalars['String']['output']>;
  firstNameEn: Scalars['String']['output'];
  firstNameTh: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idNumber: Scalars['String']['output'];
  idType: ExamCenterProctorRequestIdType;
  lastNameEn: Scalars['String']['output'];
  lastNameTh: Scalars['String']['output'];
  metadata: Maybe<ExamCenterProctorRequestMetadata>;
  middleNameEn: Maybe<Scalars['String']['output']>;
  middleNameTh: Maybe<Scalars['String']['output']>;
  personalInfoStorageObjects: Array<ExamCenterProctorRequestStorageObject>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  refCode: Maybe<Scalars['String']['output']>;
  requestedAt: Maybe<Scalars['DateTime']['output']>;
  requestedBy: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  step: ExamCenterProctorRequestStep;
  taskId: Maybe<Scalars['String']['output']>;
  titleEn: Scalars['String']['output'];
  titleTh: Scalars['String']['output'];
  type: ExamCenterProctorRequestType;
  verdicts: Array<ExamCenterProctorRequestVerdict>;
};

export enum ExamCenterProctorRequestContentType {
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Pdf = 'PDF',
  Png = 'PNG'
}

export enum ExamCenterProctorRequestIdType {
  CitizenCard = 'CITIZEN_CARD',
  Passport = 'PASSPORT'
}

export type ExamCenterProctorRequestMetadata = {
  __typename?: 'ExamCenterProctorRequestMetadata';
  department: Maybe<Scalars['String']['output']>;
  employeeId: Maybe<Scalars['String']['output']>;
  position: Maybe<Scalars['String']['output']>;
};

export enum ExamCenterProctorRequestStep {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  InReview_1 = 'IN_REVIEW_1',
  InReview_2 = 'IN_REVIEW_2',
  Rejected = 'REJECTED'
}

export type ExamCenterProctorRequestStorageObject = {
  __typename?: 'ExamCenterProctorRequestStorageObject';
  bucket: Scalars['String']['output'];
  fileName: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  provider: StorageProvider;
};

export enum ExamCenterProctorRequestType {
  Proctor_1 = 'PROCTOR_1',
  Proctor_2 = 'PROCTOR_2'
}

export type ExamCenterProctorRequestVerdict = {
  __typename?: 'ExamCenterProctorRequestVerdict';
  comment: Maybe<Scalars['String']['output']>;
  examCenterProctorRequestId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  requestedAt: Scalars['DateTime']['output'];
  step: ExamCenterProctorRequestVerdictStep;
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  updatedUser: Maybe<RawUser>;
  verdict: Maybe<Verdict>;
};

export enum ExamCenterProctorRequestVerdictStep {
  InReview_1 = 'IN_REVIEW_1',
  InReview_2 = 'IN_REVIEW_2'
}

export type ExamCenterProctorStorageObject = {
  __typename?: 'ExamCenterProctorStorageObject';
  bucket: Scalars['String']['output'];
  fileName: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  provider: StorageProvider;
};

export enum ExamCenterProctorType {
  Proctor_1 = 'PROCTOR_1',
  Proctor_2 = 'PROCTOR_2',
  Proctor_3 = 'PROCTOR_3'
}

/** A room approved for an exam center, with when it was approved. */
export type ExamCenterRoom = {
  __typename?: 'ExamCenterRoom';
  approvedAt: Scalars['DateTime']['output'];
  room: Room;
};

export type ExamCourse = {
  __typename?: 'ExamCourse';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  examId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  language: ExamCourseLanguage;
  name: Scalars['String']['output'];
  settings: ExamCourseSettings;
  type: ExamCourseType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ExamCourseCertificateAverageScoreCondition {
  AllCenters = 'ALL_CENTERS',
  EachCenter = 'EACH_CENTER'
}

export enum ExamCourseCertificateFailedTemplate {
  AverageScoreByPart = 'AVERAGE_SCORE_BY_PART',
  AverageScoreBySubject = 'AVERAGE_SCORE_BY_SUBJECT',
  NoScore = 'NO_SCORE',
  SectionScore = 'SECTION_SCORE'
}

export enum ExamCourseCertificatePassedTemplate {
  AverageScoreByPart = 'AVERAGE_SCORE_BY_PART',
  AverageScoreBySubject = 'AVERAGE_SCORE_BY_SUBJECT',
  NoScore = 'NO_SCORE',
  SectionScore = 'SECTION_SCORE'
}

export enum ExamCourseLanguage {
  En = 'EN',
  Th = 'TH'
}

export type ExamCourseSettings = {
  __typename?: 'ExamCourseSettings';
  attachDocument: Maybe<AttachDocumentSettings>;
  certificate: Maybe<CertificateSettings>;
  examDuration: Maybe<ExamDurationSettings>;
  questionnaire: QuestionnaireSettings;
  resultDisplay: ResultDisplaySettings;
  resultSend: ResultSendSettings;
};

export type ExamCourseSettingsInput = {
  attachDocument?: InputMaybe<AttachDocumentSettingsInput>;
  certificate?: InputMaybe<CertificateSettingsInput>;
  examDuration?: InputMaybe<ExamDurationSettingsInput>;
  questionnaire: QuestionnaireSettingsInput;
  resultDisplay: ResultDisplaySettingsInput;
  resultSend: ResultSendSettingsInput;
};

export enum ExamCourseType {
  Main = 'MAIN',
  Mock = 'MOCK'
}

export type ExamCoursesWithAvailableQSetsAndExamCenterCourses = {
  __typename?: 'ExamCoursesWithAvailableQSetsAndExamCenterCourses';
  availableQSets: Array<QSet>;
  code: Scalars['String']['output'];
  examCenterCourses: Array<ExamCenterCourse>;
  examId: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  settings: ExamCourseSettings;
};

export type ExamDurationSession = {
  __typename?: 'ExamDurationSession';
  order: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type ExamDurationSessionInput = {
  order: Scalars['Int']['input'];
  value: Scalars['Int']['input'];
};

export enum ExamDurationSessionType {
  Multiple = 'MULTIPLE',
  Single = 'SINGLE'
}

export type ExamDurationSettings = {
  __typename?: 'ExamDurationSettings';
  sessions: Array<ExamDurationSession>;
  type: ExamDurationSessionType;
};

export type ExamDurationSettingsInput = {
  sessions: Array<ExamDurationSessionInput>;
  type: ExamDurationSessionType;
};

export type ExamEvent = {
  __typename?: 'ExamEvent';
  courses: Array<ExamEventCourse>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  downloadedUser: Maybe<RawUser>;
  examCenter: ExamCenter;
  examCenterCode: Scalars['String']['output'];
  examEndedAt: Scalars['DateTime']['output'];
  examLocation: Location;
  examLocationId: Scalars['String']['output'];
  examRoundId: Scalars['String']['output'];
  examStartedAt: Scalars['DateTime']['output'];
  examType: ExamType;
  ictExamYear: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  numberOfExaminees: Maybe<Scalars['Int']['output']>;
  postponeEndDurationInMs: Maybe<Scalars['Int']['output']>;
  postponeStartDurationInMs: Maybe<Scalars['Int']['output']>;
  postponementRemark: Maybe<Scalars['String']['output']>;
  proctors: Maybe<Array<ExamCenterProctor>>;
  questionnairesCount: Scalars['Int']['output'];
  registrationEndedAt: Scalars['DateTime']['output'];
  registrationStartedAt: Scalars['DateTime']['output'];
  registrationStatus: RegistrationStatus;
  registrationType: RegistrationType;
  requestId: Maybe<Scalars['String']['output']>;
  rooms: Maybe<Array<Room>>;
  roundNumber: Scalars['Int']['output'];
  seat: Scalars['Int']['output'];
  sendResultToWRStatus: Maybe<SendResultToWrStatus>;
  sessions: Array<ExamEventSession>;
  status: ExamEventStatus;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type ExamEventAuditLog = {
  __typename?: 'ExamEventAuditLog';
  action: AuditActionType;
  actionTime: Scalars['DateTime']['output'];
  auditType: AuditType;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  executionInput: Scalars['String']['output'];
  executionMethod: Scalars['String']['output'];
  executionOutput: Scalars['String']['output'];
  executionResult: AuditLogExecutionResult;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers: Array<ExamEventAuditLogIdentifier>;
  type: ExamEventAuditLogType;
  userId: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
  userType: UserType;
};

export type ExamEventAuditLogIdentifier = {
  __typename?: 'ExamEventAuditLogIdentifier';
  identifierId: Scalars['String']['output'];
  identifierType: ExamEventAuditLogIdentifierType;
};

export enum ExamEventAuditLogIdentifierType {
  ExamCourseId = 'EXAM_COURSE_ID',
  ExamEventExamineeId = 'EXAM_EVENT_EXAMINEE_ID',
  ExamEventId = 'EXAM_EVENT_ID',
  ExamEventProctorId = 'EXAM_EVENT_PROCTOR_ID',
  ExamEventSessionExamineeId = 'EXAM_EVENT_SESSION_EXAMINEE_ID',
  ExamEventSessionId = 'EXAM_EVENT_SESSION_ID',
  ExamRoomReservationId = 'EXAM_ROOM_RESERVATION_ID',
  ExamRoundId = 'EXAM_ROUND_ID'
}

export enum ExamEventAuditLogType {
  ExamEvent = 'EXAM_EVENT',
  ExamEventExaminee = 'EXAM_EVENT_EXAMINEE',
  ExamEventExamineeTagResult = 'EXAM_EVENT_EXAMINEE_TAG_RESULT',
  ExamEventLocation = 'EXAM_EVENT_LOCATION',
  ExamEventPaper = 'EXAM_EVENT_PAPER',
  ExamEventProctor = 'EXAM_EVENT_PROCTOR',
  ExamEventSession = 'EXAM_EVENT_SESSION',
  ExamEventSessionExaminee = 'EXAM_EVENT_SESSION_EXAMINEE'
}

export type ExamEventCourse = {
  __typename?: 'ExamEventCourse';
  examCourse: Maybe<ExamCourse>;
  examCourseId: Scalars['String']['output'];
  examEventId: Scalars['String']['output'];
  examId: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata: Maybe<ExamEventCourseMetadata>;
  qSet: Maybe<QSet>;
  qSetId: Maybe<Scalars['String']['output']>;
  status: ExamEventCourseStatus;
};

export type ExamEventCourseMetadata = {
  __typename?: 'ExamEventCourseMetadata';
  isManuallyAssigned: Maybe<Scalars['Boolean']['output']>;
  sessionTimeAdjustments: Maybe<Array<ExamEventCourseSessionTimeAdjustment>>;
  settings: ExamEventCourseSettings;
};

export type ExamEventCourseSessionTimeAdjustment = {
  __typename?: 'ExamEventCourseSessionTimeAdjustment';
  extendDurationInMs: Scalars['Float']['output'];
  maxExtendableDurationInMs: Scalars['Float']['output'];
  sessionId: Scalars['String']['output'];
  timeExtensionRemark: Maybe<Scalars['String']['output']>;
};

export type ExamEventCourseSettings = {
  __typename?: 'ExamEventCourseSettings';
  attachDocument: Maybe<AttachDocumentSettings>;
  certificate: Maybe<CertificateSettings>;
  examDuration: Maybe<ExamDurationSettings>;
  questionnaire: QuestionnaireSettings;
  resultDisplay: ResultDisplaySettings;
  resultSend: ResultSendSettings;
};

export enum ExamEventCourseStatus {
  Allocated = 'ALLOCATED',
  Assigned = 'ASSIGNED',
  NoAccess = 'NO_ACCESS',
  NoQset = 'NO_QSET',
  Pause = 'PAUSE',
  Unassigned = 'UNASSIGNED'
}

export type ExamEventCourseWithAssignableQSetsObjectType = {
  __typename?: 'ExamEventCourseWithAssignableQSetsObjectType';
  availableQSets: Array<QSet>;
  examEventCourse: ExamEventCourse;
};

export type ExamEventDateInput = {
  examEndedAt: Scalars['DateTime']['input'];
  examStartedAt: Scalars['DateTime']['input'];
  registrationEndedAt: Scalars['DateTime']['input'];
  registrationStartedAt: Scalars['DateTime']['input'];
  sessions: Array<ExamEventSessionInput>;
};

export enum ExamEventErrorCode {
  CloseRegistrationTaskTitleMismatch = 'CLOSE_REGISTRATION_TASK_TITLE_MISMATCH',
  EachSessionShouldBeAtLeast_15Minutes = 'EACH_SESSION_SHOULD_BE_AT_LEAST_15_MINUTES',
  EachSessionShouldNotBeGreaterThan_12Hours = 'EACH_SESSION_SHOULD_NOT_BE_GREATER_THAN_12_HOURS',
  EmailAlreadyExist = 'EMAIL_ALREADY_EXIST',
  ExamCourseIdsRequired = 'EXAM_COURSE_IDS_REQUIRED',
  ExamEndedAtShouldBeGreaterThanExamStartedAtAtLeast_15Minutes = 'EXAM_ENDED_AT_SHOULD_BE_GREATER_THAN_EXAM_STARTED_AT_AT_LEAST_15_MINUTES',
  ExamEventPostponeAlreadyUpdated = 'EXAM_EVENT_POSTPONE_ALREADY_UPDATED',
  ExamSessionAlreadyStarted = 'EXAM_SESSION_ALREADY_STARTED',
  ExamSessionEndTimeExceedsMidnight = 'EXAM_SESSION_END_TIME_EXCEEDS_MIDNIGHT',
  ExamStartedAtShouldBeGreaterThanNow = 'EXAM_STARTED_AT_SHOULD_BE_GREATER_THAN_NOW',
  ExamTypeNotAllowedToDownloadExam = 'EXAM_TYPE_NOT_ALLOWED_TO_DOWNLOAD_EXAM',
  InvalidStatusTransition = 'INVALID_STATUS_TRANSITION',
  MaximumExamCourseIdsExceeded = 'MAXIMUM_EXAM_COURSE_IDS_EXCEEDED',
  MaximumSessionExceeded = 'MAXIMUM_SESSION_EXCEEDED',
  MinimumExamCourseIdsRequired = 'MINIMUM_EXAM_COURSE_IDS_REQUIRED',
  MinimumSessionRequired = 'MINIMUM_SESSION_REQUIRED',
  NotAllowedToImportExamineesWhenExamStartAtLeast_30Minutes = 'NOT_ALLOWED_TO_IMPORT_EXAMINEES_WHEN_EXAM_START_AT_LEAST_30_MINUTES',
  OpenRegistrationTaskTitleMismatch = 'OPEN_REGISTRATION_TASK_TITLE_MISMATCH',
  QSetIdRequired = 'Q_SET_ID_REQUIRED',
  ReasonIsRequired = 'REASON_IS_REQUIRED',
  RegistrationEndedAtShouldBeGreaterThanNowAtLeast_15Minutes = 'REGISTRATION_ENDED_AT_SHOULD_BE_GREATER_THAN_NOW_AT_LEAST_15_MINUTES',
  RegistrationEndedAtShouldBeGreaterThanRegistrationStartedAt = 'REGISTRATION_ENDED_AT_SHOULD_BE_GREATER_THAN_REGISTRATION_STARTED_AT',
  RegistrationEndedAtShouldBeLessThanExamStartedAtAtLeast_30Minutes = 'REGISTRATION_ENDED_AT_SHOULD_BE_LESS_THAN_EXAM_STARTED_AT_AT_LEAST_30_MINUTES',
  RegistrationStartedAtShouldBeGreaterThanNow = 'REGISTRATION_STARTED_AT_SHOULD_BE_GREATER_THAN_NOW',
  RegistrationStatusNotAllowedToImportExaminees = 'REGISTRATION_STATUS_NOT_ALLOWED_TO_IMPORT_EXAMINEES',
  RegistrationStatusNotAllowedToUpdateData = 'REGISTRATION_STATUS_NOT_ALLOWED_TO_UPDATE_DATA',
  RoomsAreNotInGivenLocation = 'ROOMS_ARE_NOT_IN_GIVEN_LOCATION',
  SeatCannotBeLessThanExamineesCount = 'SEAT_CANNOT_BE_LESS_THAN_EXAMINEES_COUNT',
  SessionEndedAtShouldBeAfterSessionStartedAt = 'SESSION_ENDED_AT_SHOULD_BE_AFTER_SESSION_STARTED_AT',
  SessionEndedAtShouldBeBetweenExamTime = 'SESSION_ENDED_AT_SHOULD_BE_BETWEEN_EXAM_TIME',
  SessionGapShouldBeAtLeast_30Minutes = 'SESSION_GAP_SHOULD_BE_AT_LEAST_30_MINUTES',
  SessionStartedAtShouldBeBeforePreviousSessionEndedAt = 'SESSION_STARTED_AT_SHOULD_BE_BEFORE_PREVIOUS_SESSION_ENDED_AT',
  SessionStartedAtShouldBeBetweenExamTime = 'SESSION_STARTED_AT_SHOULD_BE_BETWEEN_EXAM_TIME',
  SomeExamCourseIdsInvalid = 'SOME_EXAM_COURSE_IDS_INVALID',
  SomeProctorsAreUnavailable = 'SOME_PROCTORS_ARE_UNAVAILABLE',
  SomeProctorIdsAreNotFound = 'SOME_PROCTOR_IDS_ARE_NOT_FOUND',
  SomeQSetIdsCannotUpdateExamUsage = 'SOME_Q_SET_IDS_CANNOT_UPDATE_EXAM_USAGE',
  SomeRoomsAreNotGrantedAccess = 'SOME_ROOMS_ARE_NOT_GRANTED_ACCESS',
  SomeRoomsAreNotInSameLocation = 'SOME_ROOMS_ARE_NOT_IN_SAME_LOCATION',
  SomeRoomsAreUnavailable = 'SOME_ROOMS_ARE_UNAVAILABLE',
  SomeRoomIdsAreNotFound = 'SOME_ROOM_IDS_ARE_NOT_FOUND',
  TotalSessionDurationShouldNotExceed_24Hours = 'TOTAL_SESSION_DURATION_SHOULD_NOT_EXCEED_24_HOURS',
  UnableToCreateExamEvent = 'UNABLE_TO_CREATE_EXAM_EVENT',
  UnableToUpdateOpenRegistrationStartedAtAfterOpenRegistrationHasStarted = 'UNABLE_TO_UPDATE_OPEN_REGISTRATION_STARTED_AT_AFTER_OPEN_REGISTRATION_HAS_STARTED',
  UnableToUpdateRegistrationStatus = 'UNABLE_TO_UPDATE_REGISTRATION_STATUS',
  UndefinedRegistrationStatus = 'UNDEFINED_REGISTRATION_STATUS',
  UpdateUnableDueTheKycStatus = 'UPDATE_UNABLE_DUE_THE_KYC_STATUS',
  UpdateUnableOnAllocatedExamCourse = 'UPDATE_UNABLE_ON_ALLOCATED_EXAM_COURSE',
  WebRegisterConfigurationNotFound = 'WEB_REGISTER_CONFIGURATION_NOT_FOUND'
}

export type ExamEventExaminee = {
  __typename?: 'ExamEventExaminee';
  additionalEmail: Maybe<Scalars['String']['output']>;
  cancelationReason: Maybe<CancelationReason>;
  certificateStatus: ExamEventExamineeCertificateStatus;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  examCardId: Maybe<Scalars['String']['output']>;
  examCenterCode: Scalars['String']['output'];
  examCourse: ExamCourse;
  examCourseId: Scalars['String']['output'];
  examEventExamineeResult: Maybe<ExamEventExamineeResult>;
  examEventId: Scalars['String']['output'];
  examEventSessionExaminee: Maybe<ExamEventSessionExaminee>;
  examEventSessionExaminees: Maybe<Array<ExamEventSessionExaminee>>;
  examinee: Examinee;
  examineeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isExamReady: Scalars['Boolean']['output'];
  lastEmailUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  registeredAt: Maybe<Scalars['DateTime']['output']>;
  registeredBy: Maybe<Scalars['String']['output']>;
  registrationDoc: Maybe<RegistrationDoc>;
  registrationStatus: ExamineeRegistrationStatus;
  registrationType: Maybe<ExamineeRegistrationType>;
  remark: Maybe<Scalars['String']['output']>;
  seatNumber: Maybe<Scalars['Float']['output']>;
  sentToSETPortalAt: Maybe<Scalars['DateTime']['output']>;
  source: ExamEventExamineeSource;
  status: ExamEventExamineeStatus;
  updateStatusSource: Maybe<ExamEventExamineeUpdateStatusSource>;
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};


export type ExamEventExamineeExamEventSessionExamineeArgs = {
  examEventSessionId: InputMaybe<Scalars['String']['input']>;
};

export enum ExamEventExamineeCertificateStatus {
  NonIssued = 'NON_ISSUED',
  NotSent = 'NOT_SENT',
  Sent = 'SENT'
}

export type ExamEventExamineeForSession = {
  __typename?: 'ExamEventExamineeForSession';
  examEndedAt: Maybe<Scalars['DateTime']['output']>;
  examEventExaminee: ExamEventExaminee;
};

export type ExamEventExamineeResult = {
  __typename?: 'ExamEventExamineeResult';
  courseName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  examEventExamineeId: Scalars['String']['output'];
  examEventId: Scalars['String']['output'];
  examineeId: Scalars['String']['output'];
  fullScore: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  result: ExamResult;
  score: Scalars['Float']['output'];
};

export type ExamEventExamineeScoreReport = {
  __typename?: 'ExamEventExamineeScoreReport';
  firstName: Scalars['String']['output'];
  idNumber: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName: Maybe<Scalars['String']['output']>;
  registrationStatus: ExamineeRegistrationStatus;
  result: Maybe<ExamResult>;
  resultByTags: Array<ExamEventExamineeScoreReportByTag>;
  seatNumber: Maybe<Scalars['Int']['output']>;
  status: ExamEventExamineeStatus;
  title: Scalars['String']['output'];
  totalScore: Scalars['Float']['output'];
};

export type ExamEventExamineeScoreReportByTag = {
  __typename?: 'ExamEventExamineeScoreReportByTag';
  category: TagCategory;
  refId: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  tagId: Scalars['String']['output'];
  tagName: Scalars['String']['output'];
};

export enum ExamEventExamineeSource {
  ManualImport = 'MANUAL_IMPORT',
  WebRegister = 'WEB_REGISTER'
}

export enum ExamEventExamineeStatus {
  Absent = 'ABSENT',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  PendingResults = 'PENDING_RESULTS',
  PrepareForExam = 'PREPARE_FOR_EXAM',
  Processing = 'PROCESSING',
  Registered = 'REGISTERED'
}

export enum ExamEventExamineeUpdateStatusSource {
  ExamCenter = 'EXAM_CENTER',
  WebRegister = 'WEB_REGISTER'
}

export type ExamEventMetadataInput = {
  applicantGroup?: InputMaybe<ApplicantGroupInput>;
};

export enum ExamEventQConfigStructureCategory {
  AllSubTopic = 'ALL_SUB_TOPIC',
  Chapter = 'CHAPTER',
  Course = 'COURSE',
  Group = 'GROUP',
  ItemSet = 'ITEM_SET',
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  NonSpecificTopic = 'NON_SPECIFIC_TOPIC',
  Part = 'PART',
  Single = 'SINGLE',
  Subject = 'SUBJECT',
  SubTopic = 'SUB_TOPIC',
  Topic = 'TOPIC'
}

export type ExamEventQConfigStructureObjectType = {
  __typename?: 'ExamEventQConfigStructureObjectType';
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  totalQuestions: Scalars['Float']['output'];
  type: QConfigStructureType;
};

export type ExamEventQConfigStructureReorderedObjectType = {
  __typename?: 'ExamEventQConfigStructureReorderedObjectType';
  calculatedOrder: Scalars['Float']['output'];
  qConfigStructure: ExamEventQConfigStructureObjectType;
};

export type ExamEventSession = {
  __typename?: 'ExamEventSession';
  endedAt: Scalars['DateTime']['output'];
  examEventId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  postponeDurationInMs: Maybe<Scalars['Int']['output']>;
  proctorEndedAt: Maybe<Scalars['DateTime']['output']>;
  proctorStartedAt: Maybe<Scalars['DateTime']['output']>;
  round: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type ExamEventSessionExaminee = {
  __typename?: 'ExamEventSessionExaminee';
  autoExtendDurationInMs: Maybe<Scalars['Int']['output']>;
  examEventExaminee: ExamEventExaminee;
  examEventExamineeId: Scalars['String']['output'];
  examEventSessionId: Scalars['String']['output'];
  examStartedAt: Maybe<Scalars['DateTime']['output']>;
  examStatus: ProgressStatus;
  examSubmitStatus: ProgressStatus;
  examinee: Examinee;
  examineeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  loggedInAt: Maybe<Scalars['DateTime']['output']>;
  loginStatus: ProgressStatus;
  manualExtendDurationInMs: Maybe<Scalars['Int']['output']>;
  questionnaireStatus: ProgressStatus;
  refExamPaperId: Scalars['String']['output'];
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  submittedQuestionnaireAt: Maybe<Scalars['DateTime']['output']>;
  timeExtensionRemark: Maybe<Scalars['String']['output']>;
};

export type ExamEventSessionExamineeForTimeExtension = {
  __typename?: 'ExamEventSessionExamineeForTimeExtension';
  autoExtendDurationInMs: Scalars['Int']['output'];
  examEndedAt: Maybe<Scalars['DateTime']['output']>;
  examEventSessionExaminee: ExamEventSessionExaminee;
  manualExtendDurationInMs: Scalars['Int']['output'];
  maxExtendableDurationInMs: Scalars['Int']['output'];
  remainingExtendableTimeInMs: Scalars['Int']['output'];
  totalExtendedDurationInMs: Scalars['Int']['output'];
};

export type ExamEventSessionInput = {
  endedAt: Scalars['DateTime']['input'];
  round: Scalars['Int']['input'];
  startedAt: Scalars['DateTime']['input'];
};

export enum ExamEventStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  ReadyToExam = 'READY_TO_EXAM',
  Scheduled = 'SCHEDULED'
}

export type ExamEventWithQuestionnaireCount = {
  __typename?: 'ExamEventWithQuestionnaireCount';
  examEvent: ExamEvent;
  questionnaireCount: Scalars['Int']['output'];
};

export type ExamEventsCountByMonth = {
  __typename?: 'ExamEventsCountByMonth';
  examEventsCountByExamCenterCode: Scalars['JSONObject']['output'];
  month: Scalars['Int']['output'];
};

export enum ExamGradingStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export enum ExamLocationRequestApprovalType {
  GrantAccess = 'GRANT_ACCESS',
  New = 'NEW'
}

export type ExamLocationRequestInfo = {
  __typename?: 'ExamLocationRequestInfo';
  building: Maybe<Building>;
  buildingId: Maybe<Scalars['String']['output']>;
  buildingName: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  editedAt: Scalars['DateTime']['output'];
  editedBy: Scalars['String']['output'];
  editedUser: Maybe<RawUser>;
  examCenter: Maybe<ExamCenter>;
  examCenterCode: Scalars['String']['output'];
  examRoomRequestInfos: Array<ExamRoomRequestInfo>;
  id: Scalars['String']['output'];
  isDraft: Scalars['Boolean']['output'];
  location: Maybe<Location>;
  locationId: Maybe<Scalars['String']['output']>;
  nameEn: Maybe<Scalars['String']['output']>;
  nameTh: Maybe<Scalars['String']['output']>;
  province: Province;
  provinceId: Scalars['String']['output'];
};

export type ExamLocationRequestVerdict = {
  __typename?: 'ExamLocationRequestVerdict';
  approvalType: Maybe<ExamLocationRequestApprovalType>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  examRoomRequestInfoId: Maybe<Scalars['String']['output']>;
  grantedRoomId: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  locationId: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['DateTime']['output'];
  step: ExamLocationRequestWorkflowStepCode;
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  updatedUser: Maybe<RawUser>;
  verdict: Maybe<ExamLocationVerdict>;
};

export enum ExamLocationRequestWorkflowStepCode {
  ExamLocationRequestApproved = 'EXAM_LOCATION_REQUEST_APPROVED',
  ExamLocationRequestInReview_1 = 'EXAM_LOCATION_REQUEST_IN_REVIEW_1',
  ExamLocationRequestInReview_2 = 'EXAM_LOCATION_REQUEST_IN_REVIEW_2',
  ExamLocationRequestRejected = 'EXAM_LOCATION_REQUEST_REJECTED'
}

export enum ExamLocationVerdict {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export enum ExamResult {
  Failed = 'FAILED',
  None = 'NONE',
  Passed = 'PASSED'
}

export type ExamRoomComputerInfo = {
  __typename?: 'ExamRoomComputerInfo';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  info: Maybe<ExamRoomComputerInfoAttributes>;
  roomId: Scalars['String']['output'];
};

export type ExamRoomComputerInfoAttributes = {
  __typename?: 'ExamRoomComputerInfoAttributes';
  computerDetails: Maybe<ComputerDetails>;
  internetDetails: Maybe<InternetDetails>;
  securityDetails: Maybe<SecurityDetails>;
};

export type ExamRoomPhysicalAttributes = {
  __typename?: 'ExamRoomPhysicalAttributes';
  entryExitDoors: Maybe<DoorInfo>;
  examineeStorage: Maybe<FeatureCheck>;
  frontOfExamRoom: Maybe<PhotoSet>;
  insideExamRoom: Maybe<PhotoSet>;
  registrationArea: Maybe<FeatureCheck>;
  screenDistance: Maybe<FeatureCheck>;
  seatFrontBackSpacing: Maybe<FeatureCheck>;
  seatSideSpacing: Maybe<FeatureCheck>;
  securityCameras: Maybe<FeatureCheck>;
  sharedOpenArea: Maybe<FeatureCheck>;
  storageLocker: Maybe<FeatureCheck>;
  toilets: Maybe<FeatureCheck>;
  windows: Maybe<FeatureCheck>;
};

export type ExamRoomPhysicalInfo = {
  __typename?: 'ExamRoomPhysicalInfo';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  info: Maybe<ExamRoomPhysicalAttributes>;
  roomId: Scalars['String']['output'];
};

export type ExamRoomRequestComputerAttributes = {
  __typename?: 'ExamRoomRequestComputerAttributes';
  computerDetails: Maybe<ComputerDetails>;
  internetDetails: Maybe<InternetDetails>;
  securityDetails: Maybe<SecurityDetails>;
};

export type ExamRoomRequestComputerInfo = {
  __typename?: 'ExamRoomRequestComputerInfo';
  createdAt: Scalars['DateTime']['output'];
  examRoomRequestInfoId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  info: Maybe<ExamRoomRequestComputerAttributes>;
};

export type ExamRoomRequestInfo = {
  __typename?: 'ExamRoomRequestInfo';
  createdAt: Scalars['DateTime']['output'];
  editedAt: Scalars['DateTime']['output'];
  editedBy: Scalars['String']['output'];
  editedUser: Maybe<RawUser>;
  examCenter: Maybe<ExamCenter>;
  examCenterCode: Scalars['String']['output'];
  examLocationRequestInfo: ExamLocationRequestInfo;
  examLocationRequestInfoId: Scalars['String']['output'];
  examLocationRequestVerdicts: Array<ExamLocationRequestVerdict>;
  examRoomRequestComputerInfo: Maybe<ExamRoomRequestComputerInfo>;
  examRoomRequestPhysicalInfo: Maybe<ExamRoomRequestPhysicalInfo>;
  floor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  requestedAt: Maybe<Scalars['DateTime']['output']>;
  requestedBy: Maybe<Scalars['String']['output']>;
  roomNumber: Maybe<Scalars['String']['output']>;
  seatCount: Scalars['Float']['output'];
  step: Maybe<ExamLocationRequestWorkflowStepCode>;
  taskCode: Maybe<Scalars['String']['output']>;
  taskId: Maybe<Scalars['String']['output']>;
};

export type ExamRoomRequestPhysicalAttributes = {
  __typename?: 'ExamRoomRequestPhysicalAttributes';
  entryExitDoors: Maybe<DoorInfo>;
  examineeStorage: Maybe<FeatureCheck>;
  frontOfExamRoom: Maybe<PhotoSet>;
  insideExamRoom: Maybe<PhotoSet>;
  registrationArea: Maybe<FeatureCheck>;
  screenDistance: Maybe<FeatureCheck>;
  seatFrontBackSpacing: Maybe<FeatureCheck>;
  seatSideSpacing: Maybe<FeatureCheck>;
  securityCameras: Maybe<FeatureCheck>;
  sharedOpenArea: Maybe<FeatureCheck>;
  storageLocker: Maybe<FeatureCheck>;
  toilets: Maybe<FeatureCheck>;
  windows: Maybe<FeatureCheck>;
};

export type ExamRoomRequestPhysicalInfo = {
  __typename?: 'ExamRoomRequestPhysicalInfo';
  createdAt: Scalars['DateTime']['output'];
  examRoomRequestInfoId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  info: Maybe<ExamRoomRequestPhysicalAttributes>;
};

export enum ExamType {
  Computer = 'COMPUTER',
  Paper = 'PAPER'
}

export type Examinee = {
  __typename?: 'Examinee';
  countryCode: Maybe<ExamineeCountryCode>;
  dateOfBirth: Maybe<Scalars['DateTime']['output']>;
  eKycExpiredAt: Maybe<Scalars['DateTime']['output']>;
  eKycStatus: EKycVerificationStatus;
  faceImageObjectKey: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idCode: Maybe<Scalars['String']['output']>;
  idNumber: Scalars['String']['output'];
  idType: IdType;
  lastName: Scalars['String']['output'];
  middleName: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum ExamineeCountryCode {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type ExamineeEKycStatusInExamEvent = {
  __typename?: 'ExamineeEKycStatusInExamEvent';
  examEventExaminee: ExamEventExaminee;
  sourceEKycStatus: EKycVerificationStatus;
};

export enum ExamineeRegistrationStatus {
  Failed = 'FAILED',
  NotRegistered = 'NOT_REGISTERED',
  Registered = 'REGISTERED'
}

export enum ExamineeRegistrationType {
  Attachments = 'ATTACHMENTS',
  DipChip = 'DIP_CHIP'
}

export type ExamineeValidationError = {
  __typename?: 'ExamineeValidationError';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idNumber: Scalars['String']['output'];
  idType: IdType;
  lastName: Scalars['String']['output'];
  middleName: Maybe<Scalars['String']['output']>;
  property: Maybe<Scalars['String']['output']>;
};

export type ExportBlockedUsersInput = {
  blockedTypes?: InputMaybe<Array<BlockedRecordBlockedType>>;
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<SearchFilterInput>;
};

export type ExportBlockedUsersOutput = {
  __typename?: 'ExportBlockedUsersOutput';
  signedUrl: Scalars['String']['output'];
};

export type ExportExamEventExamineeScoreReportsInput = {
  examCourseId: Scalars['String']['input'];
  examEventId: Scalars['String']['input'];
  tagCategory: TagCategory;
};

export type ExportExamEventExamineeScoreReportsOutput = {
  __typename?: 'ExportExamEventExamineeScoreReportsOutput';
  status: GenericResponseStatus;
};

export type ExportExaminationCodeByExamEventExamineeIdInput = {
  examEventExamineeId: Scalars['String']['input'];
};

export type ExportExaminationCodeByExamEventExamineeIdOutput = {
  __typename?: 'ExportExaminationCodeByExamEventExamineeIdOutput';
  url: Scalars['String']['output'];
};

export type ExportExaminationCodesByExamEventIdInput = {
  examEventId: Scalars['String']['input'];
};

export type ExportExaminationCodesByExamEventIdOutput = {
  __typename?: 'ExportExaminationCodesByExamEventIdOutput';
  url: Scalars['String']['output'];
};

export type ExportQuestionnairesInput = {
  endDate: Scalars['DateTime']['input'];
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate: Scalars['DateTime']['input'];
  templateId: QuestionnaireTemplateId;
};

export type ExportQuestionnairesOutput = {
  __typename?: 'ExportQuestionnairesOutput';
  data: Maybe<Scalars['JSON']['output']>;
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export type ExtendExamEventSessionExamineesTimeInput = {
  examEventId: Scalars['String']['input'];
  examEventSessionExamineeIds: Array<Scalars['String']['input']>;
  extendedTimeInMinutes: Scalars['Float']['input'];
  remark: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type ExtendExamEventSessionExamineesTimeOutput = {
  __typename?: 'ExtendExamEventSessionExamineesTimeOutput';
  results: Array<ExtendedExamineeResult>;
};

export type ExtendExamEventSessionTimeInput = {
  examEventId: Scalars['String']['input'];
  extendedTime: Scalars['Float']['input'];
  remark: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type ExtendExamEventSessionTimeOutput = {
  __typename?: 'ExtendExamEventSessionTimeOutput';
  success: Scalars['Boolean']['output'];
};

export type ExtendedExamineeResult = {
  __typename?: 'ExtendedExamineeResult';
  actualExtendedTimeInMs: Scalars['Float']['output'];
  examEventSessionExamineeId: Scalars['String']['output'];
  extended: Scalars['Boolean']['output'];
  reason: Maybe<Scalars['String']['output']>;
};

export type FailedExamEvent = {
  __typename?: 'FailedExamEvent';
  errorCodes: Array<ExamEventErrorCode>;
  requestId: Scalars['String']['output'];
};

export type FeatureCheck = {
  __typename?: 'FeatureCheck';
  additionalInfo: Maybe<Scalars['String']['output']>;
  images: Maybe<Array<Scalars['String']['output']>>;
  valid: Maybe<Scalars['Boolean']['output']>;
};

export type FilterConditionInput = {
  /** Field to filter by */
  field: Scalars['String']['input'];
  operator: FilterOperator;
  /** Value to filter by */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum FilterOperator {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  In = 'IN',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  Like = 'LIKE',
  NotEqual = 'NOT_EQUAL',
  NotIn = 'NOT_IN'
}

export type GenerateSeatNumberInput = {
  examEventId: Scalars['String']['input'];
};

export type GenerateSeatNumberOutput = {
  __typename?: 'GenerateSeatNumberOutput';
  examEventExaminees: Array<ExamEventExaminee>;
};

export type GenerateTwoFactorSecretOutputObjectType = {
  __typename?: 'GenerateTwoFactorSecretOutputObjectType';
  email: Scalars['String']['output'];
  issuer: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export enum GenericResponseStatus {
  Success = 'SUCCESS'
}

export type GetAllAnnouncementsOutput = {
  __typename?: 'GetAllAnnouncementsOutput';
  announcements: Array<Announcement>;
};

export type GetAllEnabledExamCoursesOutput = {
  __typename?: 'GetAllEnabledExamCoursesOutput';
  examCourses: Array<ExamCourse>;
};

export type GetAllExamCenterCoursesInput = {
  examCenterCode: Scalars['String']['input'];
  sessionCount?: InputMaybe<Scalars['Int']['input']>;
};

export type GetAllExamCenterCoursesOutput = {
  __typename?: 'GetAllExamCenterCoursesOutput';
  examCenterCourses: Array<ExamCenterCourse>;
};

export type GetAllExamCentersOutput = {
  __typename?: 'GetAllExamCentersOutput';
  examCenters: Array<ExamCenter>;
};

export type GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesOutput = {
  __typename?: 'GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesOutput';
  examCoursesWithAvailableQSetsAndExamCenterCourses: Array<ExamCoursesWithAvailableQSetsAndExamCenterCourses>;
};

export type GetAllExamEventsByExamCenterCodeInput = {
  examCenterCode: Scalars['String']['input'];
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
};

export type GetAllExamEventsByExamCenterCodeOutput = {
  __typename?: 'GetAllExamEventsByExamCenterCodeOutput';
  examEvents: Array<ExamEvent>;
  total: Scalars['Int']['output'];
};

export type GetAllProvincesOutput = {
  __typename?: 'GetAllProvincesOutput';
  provinces: Array<Province>;
};

export type GetAnnouncementByIdInput = {
  id: Scalars['String']['input'];
};

export type GetAnnouncementByIdOutput = {
  __typename?: 'GetAnnouncementByIdOutput';
  announcement: Announcement;
};

export type GetAppRoleOutputObjectType = {
  __typename?: 'GetAppRoleOutputObjectType';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type GetAvailableExamEventIctYearsOutput = {
  __typename?: 'GetAvailableExamEventICTYearsOutput';
  ictExamYears: Array<Scalars['Int']['output']>;
};

export type GetAvailableQSetsByExamEventIdInput = {
  examEventId: Scalars['String']['input'];
};

export type GetAvailableQSetsByExamEventIdOutput = {
  __typename?: 'GetAvailableQSetsByExamEventIdOutput';
  examEvent: ExamEvent;
  examEventCoursesWithAssignableQSets: Array<ExamEventCourseWithAssignableQSetsObjectType>;
};

export type GetAvailableRoomsByLocationIdAndTimeFrameInput = {
  endedAt: Scalars['DateTime']['input'];
  examCenterCode: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  startedAt: Scalars['DateTime']['input'];
};

export type GetAvailableRoomsByLocationIdAndTimeFrameOutput = {
  __typename?: 'GetAvailableRoomsByLocationIdAndTimeFrameOutput';
  rooms: Array<Room>;
};

export type GetBlockedUserByIdInput = {
  id: Scalars['String']['input'];
};

export type GetBlockedUserByIdOutput = {
  __typename?: 'GetBlockedUserByIdOutput';
  blockedUser: BlockedUser;
};

export type GetBuildingsByLocationIdInput = {
  locationId: Scalars['String']['input'];
};

export type GetBuildingsByLocationIdOutput = {
  __typename?: 'GetBuildingsByLocationIdOutput';
  buildings: Array<Building>;
};

export type GetDipChipDeepLinkUrlInput = {
  examEventId: Scalars['String']['input'];
};

export type GetDipChipDeepLinkUrlOutput = {
  __typename?: 'GetDipChipDeepLinkUrlOutput';
  deepLinkUrl: Scalars['String']['output'];
};

export type GetDownloadSignedUrlForBlockedRecordInput = {
  blockedRecordId: Scalars['String']['input'];
  fileNames: Array<Scalars['String']['input']>;
};

export type GetDownloadSignedUrlForBlockedRecordOutput = {
  __typename?: 'GetDownloadSignedUrlForBlockedRecordOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForExamCenterProctorRequestInput = {
  examCenterProctorRequestId: Scalars['String']['input'];
  fileNames: Array<Scalars['String']['input']>;
};

export type GetDownloadSignedUrlForExamCenterProctorRequestOutput = {
  __typename?: 'GetDownloadSignedUrlForExamCenterProctorRequestOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForExamCourseAttachDocumentInput = {
  examCourseId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type GetDownloadSignedUrlForExamCourseAttachDocumentOutput = {
  __typename?: 'GetDownloadSignedUrlForExamCourseAttachDocumentOutput';
  signedUrl: Scalars['String']['output'];
};

export type GetDownloadSignedUrlForExamRoomComputerInfoInput = {
  examRoomId: Scalars['String']['input'];
  fileNames: Array<Scalars['String']['input']>;
};

export type GetDownloadSignedUrlForExamRoomComputerInfoOutput = {
  __typename?: 'GetDownloadSignedUrlForExamRoomComputerInfoOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForExamRoomPhysicalInfoInput = {
  examRoomId: Scalars['String']['input'];
  fileNames: Array<Scalars['String']['input']>;
};

export type GetDownloadSignedUrlForExamRoomPhysicalInfoOutput = {
  __typename?: 'GetDownloadSignedUrlForExamRoomPhysicalInfoOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForExamRoomRequestComputerInfoInputType = {
  examRoomRequestInfoId: Scalars['String']['input'];
  fileNames: Array<Scalars['String']['input']>;
};

export type GetDownloadSignedUrlForExamRoomRequestComputerInfoOutput = {
  __typename?: 'GetDownloadSignedUrlForExamRoomRequestComputerInfoOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlForExamRoomRequestPhysicalInfoInputType = {
  examRoomRequestInfoId: Scalars['String']['input'];
  fileNames: Array<Scalars['String']['input']>;
};

export type GetDownloadSignedUrlForExamRoomRequestPhysicalInfoOutput = {
  __typename?: 'GetDownloadSignedUrlForExamRoomRequestPhysicalInfoOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDownloadSignedUrlsForExamCenterProctorInput = {
  examCenterProctorId: Scalars['String']['input'];
  fileNames: Array<Scalars['String']['input']>;
};

export type GetDownloadSignedUrlsForExamCenterProctorOutput = {
  __typename?: 'GetDownloadSignedUrlsForExamCenterProctorOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetDraftExamLocationRequestVerdictsByExamRoomRequestInfoIdInputType = {
  examRoomRequestInfoId: Scalars['String']['input'];
  step?: InputMaybe<ExamLocationRequestWorkflowStepCode>;
};

export type GetDraftExamLocationRequestVerdictsByExamRoomRequestInfoIdOutput = {
  __typename?: 'GetDraftExamLocationRequestVerdictsByExamRoomRequestInfoIdOutput';
  examLocationRequestVerdicts: Array<ExamLocationRequestVerdict>;
};

export type GetEKycDocumentDownloadSignedUrlInput = {
  examEventId: Scalars['String']['input'];
  examineeId: Scalars['String']['input'];
  fileNames: Array<Scalars['String']['input']>;
};

export type GetEKycDocumentDownloadSignedUrlOutput = {
  __typename?: 'GetEKycDocumentDownloadSignedUrlOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetEKycInfoByExamineeIdAndExamEventIdInput = {
  examEventId: Scalars['String']['input'];
  examineeId: Scalars['String']['input'];
};

export type GetEKycInfoByExamineeIdAndExamEventIdOutput = {
  __typename?: 'GetEKycInfoByExamineeIdAndExamEventIdOutput';
  eKycInfo: EKycInfo;
  examEvent: ExamEvent;
  examinee: Examinee;
};

export type GetExamCenterByExamCenterCodeInput = {
  examCenterCode: Scalars['String']['input'];
};

export type GetExamCenterByExamCenterCodeOutput = {
  __typename?: 'GetExamCenterByExamCenterCodeOutput';
  examCenter: ExamCenter;
};

export type GetExamCenterEventSummariesInput = {
  endedAt: Scalars['DateTime']['input'];
  examCenterCode: Scalars['String']['input'];
  startedAt: Scalars['DateTime']['input'];
};

export type GetExamCenterEventSummariesOutput = {
  __typename?: 'GetExamCenterEventSummariesOutput';
  examCenterEventSummaries: ExamCenterEventSummaries;
};

export type GetExamCenterLocationsByProvinceIdInput = {
  examCenterCode: Scalars['String']['input'];
  provinceId: Scalars['String']['input'];
};

export type GetExamCenterLocationsByProvinceIdOutput = {
  __typename?: 'GetExamCenterLocationsByProvinceIdOutput';
  examCenterLocations: Array<ExamCenterLocation>;
};

export type GetExamCenterMemberByIdInput = {
  examCenterMemberId: Scalars['String']['input'];
};

export type GetExamCenterMemberByIdOutput = {
  __typename?: 'GetExamCenterMemberByIdOutput';
  examCenterMember: ExamCenterMember;
};

export type GetExamCenterMembersByExamCenterCodeInput = {
  examCenterCode: Scalars['String']['input'];
};

export type GetExamCenterMembersByExamCenterCodeOutput = {
  __typename?: 'GetExamCenterMembersByExamCenterCodeOutput';
  examCenterMembers: Array<ExamCenterMember>;
};

export type GetExamCenterProctorByIdInput = {
  examCenterProctorId: Scalars['String']['input'];
};

export type GetExamCenterProctorByIdOutput = {
  __typename?: 'GetExamCenterProctorByIdOutput';
  examCenterProctor: ExamCenterProctor;
};

export type GetExamCenterProctorRequestByIdInputType = {
  id: Scalars['String']['input'];
};

export type GetExamCenterProctorRequestByIdOutput = {
  __typename?: 'GetExamCenterProctorRequestByIdOutput';
  examCenterProctorRequest: ExamCenterProctorRequest;
};

export type GetExamCenterProctorRequestsCountByExamCenterCodeInput = {
  examCenterCode?: InputMaybe<Scalars['String']['input']>;
};

export type GetExamCenterProctorRequestsCountByExamCenterCodeOutput = {
  __typename?: 'GetExamCenterProctorRequestsCountByExamCenterCodeOutput';
  proctorRequestCountByStatus: NumberOfProctorRequestsByStatus;
};

export type GetExamCourseByExamCourseCodeInput = {
  examCourseCode: Scalars['String']['input'];
};

export type GetExamCourseByExamCourseCodeOutput = {
  __typename?: 'GetExamCourseByExamCourseCodeOutput';
  examCourse: ExamCourse;
};

export type GetExamCoursesByExamEventIdInput = {
  examEventId: Scalars['String']['input'];
  statuses?: InputMaybe<Array<ExamEventCourseStatus>>;
};

export type GetExamCoursesByExamEventIdOutput = {
  __typename?: 'GetExamCoursesByExamEventIdOutput';
  examCourses: Array<ExamCourse>;
};

export type GetExamEventByIdInput = {
  id: Scalars['String']['input'];
};

export type GetExamEventByIdOutput = {
  __typename?: 'GetExamEventByIdOutput';
  examEvent: ExamEvent;
};

export type GetExamEventCoursesByExamEventIdsInput = {
  examEventIds: Array<Scalars['String']['input']>;
};

export type GetExamEventCoursesByExamEventIdsOutput = {
  __typename?: 'GetExamEventCoursesByExamEventIdsOutput';
  examEventCourses: Array<ExamEventCourse>;
};

export type GetExamEventExamineeByIdInput = {
  id: Scalars['String']['input'];
};

export type GetExamEventExamineeByIdOutput = {
  __typename?: 'GetExamEventExamineeByIdOutput';
  examEventExaminee: ExamEventExaminee;
};

export type GetExamEventExamineeCountSummaryForProctoringInput = {
  examEventId: Scalars['String']['input'];
};

export type GetExamEventExamineeCountSummaryForProctoringOutput = {
  __typename?: 'GetExamEventExamineeCountSummaryForProctoringOutput';
  absent: Scalars['Int']['output'];
  canceled: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  eKyc: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  passed: Scalars['Int']['output'];
  pendingResults: Scalars['Int']['output'];
  prepareForExam: Scalars['Int']['output'];
  processing: Scalars['Int']['output'];
  registered: Scalars['Int']['output'];
  registrationStatusRegistered: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GetExamEventExamineeCountSummaryInput = {
  examEventId: Scalars['String']['input'];
};

export type GetExamEventExamineeCountSummaryOutput = {
  __typename?: 'GetExamEventExamineeCountSummaryOutput';
  absent: Scalars['Int']['output'];
  canceled: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  eKyc: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  pendingResults: Scalars['Int']['output'];
  prepareForExam: Scalars['Int']['output'];
  processing: Scalars['Int']['output'];
  registered: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GetExamEventExamineeScoreReportsInput = {
  examCourseId: Scalars['String']['input'];
  examEventId: Scalars['String']['input'];
  tagCategory: TagCategory;
};

export type GetExamEventExamineeScoreReportsOutput = {
  __typename?: 'GetExamEventExamineeScoreReportsOutput';
  examEventExamineeScoreReports: Array<ExamEventExamineeScoreReport>;
};

export type GetExamEventExamineesForSessionInput = {
  examEventId: Scalars['String']['input'];
  paging?: InputMaybe<PagingInput>;
  searchExaminee?: InputMaybe<SearchExamineeInput>;
  sessionId: Scalars['String']['input'];
};

export type GetExamEventExamineesForSessionOutput = {
  __typename?: 'GetExamEventExamineesForSessionOutput';
  result: Array<ExamEventExamineeForSession>;
  total: Scalars['Int']['output'];
};

export type GetExamEventParticipatedCoursesInput = {
  examEventId: Scalars['String']['input'];
};

export type GetExamEventParticipatedCoursesOutput = {
  __typename?: 'GetExamEventParticipatedCoursesOutput';
  examEventCourses: Array<ExamEventCourse>;
};

export type GetExamEventResultSummaryInput = {
  examEventId: Scalars['String']['input'];
};

export type GetExamEventResultSummaryOutput = {
  __typename?: 'GetExamEventResultSummaryOutput';
  absent: Scalars['Int']['output'];
  canceled: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  passed: Scalars['Int']['output'];
};

export type GetExamEventSessionByIdInput = {
  id: Scalars['String']['input'];
};

export type GetExamEventSessionByIdOutput = {
  __typename?: 'GetExamEventSessionByIdOutput';
  examEventSession: ExamEventSession;
};

export type GetExamEventSessionExamineesForTimeExtensionInput = {
  examEventId: Scalars['String']['input'];
  extendableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  paging?: InputMaybe<PagingInput>;
  searchExaminee?: InputMaybe<SearchExamineeInput>;
  sessionId: Scalars['String']['input'];
};

export type GetExamEventSessionExamineesForTimeExtensionOutput = {
  __typename?: 'GetExamEventSessionExamineesForTimeExtensionOutput';
  result: Array<ExamEventSessionExamineeForTimeExtension>;
  total: Scalars['Int']['output'];
};

export type GetExamEventsByDateRangeInput = {
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examEndedAt: Scalars['DateTime']['input'];
  examStartedAt: Scalars['DateTime']['input'];
  provinceIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetExamEventsByDateRangeOutput = {
  __typename?: 'GetExamEventsByDateRangeOutput';
  examEvents: Array<ExamEvent>;
};

export type GetExamLocationRequestInfoByIdInputType = {
  id: Scalars['String']['input'];
};

export type GetExamLocationRequestInfoByIdOutput = {
  __typename?: 'GetExamLocationRequestInfoByIdOutput';
  examLocationRequestInfo: ExamLocationRequestInfo;
};

export type GetExamLocationRequestInfoCountByExamCenterCode = {
  __typename?: 'GetExamLocationRequestInfoCountByExamCenterCode';
  draft: Scalars['Int']['output'];
  inReview: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
};

export type GetExamLocationRequestInfoCountByExamCenterCodeInputType = {
  examCenterCode: Scalars['String']['input'];
};

export type GetExamLocationRequestInfoCountByExamCenterCodeOutput = {
  __typename?: 'GetExamLocationRequestInfoCountByExamCenterCodeOutput';
  examLocationRequestInfoCountByStatus: GetExamLocationRequestInfoCountByExamCenterCode;
};

export type GetExamRoomByIdInput = {
  id: Scalars['String']['input'];
};

export type GetExamRoomByIdOutput = {
  __typename?: 'GetExamRoomByIdOutput';
  examRoom: Room;
};

export type GetExamRoomRequestInfoByIdInputType = {
  id: Scalars['String']['input'];
};

export type GetExamRoomRequestInfoByIdOutput = {
  __typename?: 'GetExamRoomRequestInfoByIdOutput';
  examRoomRequestInfo: ExamRoomRequestInfo;
};

export type GetExamineeDetailsByIdNumberAndExamEventIdInput = {
  examEventId: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
};

export type GetExamineeDetailsByIdNumberAndExamEventIdOutput = {
  __typename?: 'GetExamineeDetailsByIdNumberAndExamEventIdOutput';
  examEventExaminee: Maybe<ExamEventExaminee>;
  examinee: Examinee;
};

export type GetIctExamEventYearsByExamCenterCodeInput = {
  examCenterCode: Scalars['String']['input'];
};

export type GetIctExamEventYearsByExamCenterCodeOutput = {
  __typename?: 'GetICTExamEventYearsByExamCenterCodeOutput';
  ictExamYears: Array<Scalars['Int']['output']>;
};

export type GetLocationsByProvinceIdInput = {
  provinceId: Scalars['String']['input'];
};

export type GetLocationsByProvinceIdOutput = {
  __typename?: 'GetLocationsByProvinceIdOutput';
  locations: Array<Location>;
};

export type GetMonthlyExamEventOverviewInput = {
  examCenterCode: Scalars['String']['input'];
  ictExamYear: Scalars['Int']['input'];
};

export type GetMonthlyExamEventOverviewOutput = {
  __typename?: 'GetMonthlyExamEventOverviewOutput';
  overview: Array<MonthlyExamEventResult>;
};

export type GetMyExamCentersOutput = {
  __typename?: 'GetMyExamCentersOutput';
  examCenters: Array<ExamCenter>;
};

export type GetMyNotificationsInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type GetMyNotificationsOutput = {
  __typename?: 'GetMyNotificationsOutput';
  notificationRecipients: Array<NotificationRecipient>;
  total: Scalars['Float']['output'];
};

export type GetMyProctorExamEventsInput = {
  filter?: InputMaybe<GetProctorExamEventsFilterInput>;
};

export type GetProctorExamEventsFilterInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  examCenterCode?: InputMaybe<Scalars['String']['input']>;
  provinceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  registrationStatuses?: InputMaybe<Array<RegistrationStatus>>;
  registrationTypes?: InputMaybe<Array<RegistrationType>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ExamEventStatus>;
};

export type GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdInput = {
  examCourseId: Scalars['String']['input'];
  examEventId: Scalars['String']['input'];
  tagCategory: ExamEventQConfigStructureCategory;
};

export type GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdOutput = {
  __typename?: 'GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdOutput';
  qConfigStructures: Array<ExamEventQConfigStructureReorderedObjectType>;
};

export type GetServerTimeOutput = {
  __typename?: 'GetServerTimeOutput';
  currentTime: Scalars['DateTime']['output'];
};

export type GetUpcomingExamEventsByExamCenterCodeInput = {
  examCenterCode: Scalars['String']['input'];
};

export type GetUpcomingExamEventsByExamCenterCodeOutput = {
  __typename?: 'GetUpcomingExamEventsByExamCenterCodeOutput';
  examEvents: Array<ExamEvent>;
};

export type GetUpcomingRoomReservationSummaryInput = {
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  roomId: Scalars['String']['input'];
};

export type GetUpcomingRoomReservationSummaryOutput = {
  __typename?: 'GetUpcomingRoomReservationSummaryOutput';
  roomId: Scalars['String']['output'];
  roomReservationSummaries: Array<RoomReservationSummary>;
};

export type GetUploadSignedUrlForAlternativeRegistrationInput = {
  contentType: Scalars['String']['input'];
  examEventExamineeId: Scalars['String']['input'];
};

export type GetUploadSignedUrlForAlternativeRegistrationOutput = {
  __typename?: 'GetUploadSignedUrlForAlternativeRegistrationOutput';
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetUploadSignedUrlForExamCourseAttachDocumentInput = {
  examCourseId: Scalars['String']['input'];
};

export type GetUploadSignedUrlForExamCourseAttachDocumentOutput = {
  __typename?: 'GetUploadSignedUrlForExamCourseAttachDocumentOutput';
  storageObject: StorageObject;
  url: Scalars['String']['output'];
};

export type GetUploadSignedUrlForExamRoomRequestComputerInfoInputType = {
  contentTypes: Array<Scalars['String']['input']>;
  examRoomRequestInfoId: Scalars['String']['input'];
};

export type GetUploadSignedUrlForExamRoomRequestComputerInfoOutput = {
  __typename?: 'GetUploadSignedUrlForExamRoomRequestComputerInfoOutput';
  signedUrls: Array<GetUploadSignedUrlForExamRoomRequestComputerInfoSignedUrl>;
};

export type GetUploadSignedUrlForExamRoomRequestComputerInfoSignedUrl = {
  __typename?: 'GetUploadSignedUrlForExamRoomRequestComputerInfoSignedUrl';
  contentType: UploadableContentType;
  storageObject: StorageObject;
  url: Scalars['String']['output'];
};

export type GetUploadSignedUrlForExamRoomRequestPhysicalInfoInputType = {
  contentTypes: Array<Scalars['String']['input']>;
  examRoomRequestInfoId: Scalars['String']['input'];
};

export type GetUploadSignedUrlForExamRoomRequestPhysicalInfoOutput = {
  __typename?: 'GetUploadSignedUrlForExamRoomRequestPhysicalInfoOutput';
  signedUrls: Array<GetUploadSignedUrlForExamRoomRequestPhysicalInfoSignedUrl>;
};

export type GetUploadSignedUrlForExamRoomRequestPhysicalInfoSignedUrl = {
  __typename?: 'GetUploadSignedUrlForExamRoomRequestPhysicalInfoSignedUrl';
  contentType: UploadableContentType;
  storageObject: StorageObject;
  url: Scalars['String']['output'];
};

export type GetUploadSignedUrlForImportExamineesAnswersInput = {
  contentType: Scalars['String']['input'];
  examEventId: Scalars['String']['input'];
};

export type GetUploadSignedUrlForImportExamineesAnswersOutput = {
  __typename?: 'GetUploadSignedUrlForImportExamineesAnswersOutput';
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetUploadSignedUrlForImportExamineesInput = {
  contentType: Scalars['String']['input'];
  examEventId: Scalars['String']['input'];
};

export type GetUploadSignedUrlForImportExamineesOutput = {
  __typename?: 'GetUploadSignedUrlForImportExamineesOutput';
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetUploadSignedUrlsForBlockedRecordInput = {
  blockedRecordId?: InputMaybe<Scalars['String']['input']>;
  contentTypes: Array<BlockedRecordContentType>;
};

export type GetUploadSignedUrlsForBlockedRecordOutput = {
  __typename?: 'GetUploadSignedUrlsForBlockedRecordOutput';
  signedUrls: Array<GetUploadSignedUrlsForBlockedRecordSignedUrl>;
};

export type GetUploadSignedUrlsForBlockedRecordSignedUrl = {
  __typename?: 'GetUploadSignedUrlsForBlockedRecordSignedUrl';
  contentType: BlockedRecordContentType;
  storageObject: StorageObject;
  url: Scalars['String']['output'];
};

export type GetUploadSignedUrlsForExamCenterProctorInputType = {
  contentTypes: Array<ExamCenterProctorContentType>;
  examCenterProctorId?: InputMaybe<Scalars['String']['input']>;
};

export type GetUploadSignedUrlsForExamCenterProctorOutput = {
  __typename?: 'GetUploadSignedUrlsForExamCenterProctorOutput';
  signedUrls: Array<GetUploadSignedUrlsForExamCenterProctorSignedUrl>;
};

export type GetUploadSignedUrlsForExamCenterProctorRequestInputType = {
  contentTypes: Array<ExamCenterProctorRequestContentType>;
  examCenterProctorRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type GetUploadSignedUrlsForExamCenterProctorRequestOutput = {
  __typename?: 'GetUploadSignedUrlsForExamCenterProctorRequestOutput';
  signedUrls: Array<GetUploadSignedUrlsForExamCenterProctorRequestSignedUrl>;
};

export type GetUploadSignedUrlsForExamCenterProctorRequestSignedUrl = {
  __typename?: 'GetUploadSignedUrlsForExamCenterProctorRequestSignedUrl';
  contentType: ExamCenterProctorRequestContentType;
  storageObject: StorageObject;
  url: Scalars['String']['output'];
};

export type GetUploadSignedUrlsForExamCenterProctorSignedUrl = {
  __typename?: 'GetUploadSignedUrlsForExamCenterProctorSignedUrl';
  contentType: ExamCenterProctorContentType;
  storageObject: StorageObject;
  url: Scalars['String']['output'];
};

export type GetUserByIdOutputObjectType = {
  __typename?: 'GetUserByIdOutputObjectType';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['JSON']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type GetYearlyExamEventsCountByMonthInput = {
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  ictExamYear: Scalars['Float']['input'];
};

export type GetYearlyExamEventsCountByMonthOutput = {
  __typename?: 'GetYearlyExamEventsCountByMonthOutput';
  examEventsCountByMonth: Array<ExamEventsCountByMonth>;
};

export enum IdType {
  CitizenCard = 'CITIZEN_CARD',
  Passport = 'PASSPORT'
}

export type ImportExamineesAnswersSpreadSheetInput = {
  examEventId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type ImportExamineesAnswersSpreadSheetOutput = {
  __typename?: 'ImportExamineesAnswersSpreadSheetOutput';
  data: Maybe<ImportExamineesAnswersSpreadSheetOutputData>;
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export type ImportExamineesAnswersSpreadSheetOutputData = {
  __typename?: 'ImportExamineesAnswersSpreadSheetOutputData';
  examGradingStatus: Maybe<ExamGradingStatus>;
};

export type ImportExamineesSpreadsheetInput = {
  examEventId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type ImportExamineesSpreadsheetOutput = {
  __typename?: 'ImportExamineesSpreadsheetOutput';
  fileName: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type InternetDetails = {
  __typename?: 'InternetDetails';
  internetSpeed: Maybe<InternetSpeedOption>;
  speedTestImages: Maybe<Array<Scalars['String']['output']>>;
};

export type InternetSpeedOption = {
  __typename?: 'InternetSpeedOption';
  otherDetail: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  id: Scalars['String']['output'];
  nameEn: Maybe<Scalars['String']['output']>;
  nameTh: Scalars['String']['output'];
  province: Province;
  provinceId: Scalars['String']['output'];
};

export type LocationAuditLog = {
  __typename?: 'LocationAuditLog';
  action: AuditActionType;
  actionTime: Scalars['DateTime']['output'];
  auditType: AuditType;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  executionInput: Scalars['String']['output'];
  executionMethod: Scalars['String']['output'];
  executionOutput: Scalars['String']['output'];
  executionResult: AuditLogExecutionResult;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers: Array<LocationAuditLogIdentifier>;
  type: LocationAuditLogType;
  userId: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
  userType: UserType;
};

export type LocationAuditLogIdentifier = {
  __typename?: 'LocationAuditLogIdentifier';
  identifierId: Scalars['String']['output'];
  identifierType: LocationAuditLogIdentifierType;
};

export enum LocationAuditLogIdentifierType {
  BuildingId = 'BUILDING_ID',
  ExamCenterId = 'EXAM_CENTER_ID',
  LocationId = 'LOCATION_ID',
  RoomId = 'ROOM_ID'
}

export enum LocationAuditLogType {
  ExamBuilding = 'EXAM_BUILDING',
  ExamLocation = 'EXAM_LOCATION',
  ExamRoom = 'EXAM_ROOM',
  ExamRoomComputerInfo = 'EXAM_ROOM_COMPUTER_INFO',
  ExamRoomPermission = 'EXAM_ROOM_PERMISSION',
  ExamRoomPhysicalInfo = 'EXAM_ROOM_PHYSICAL_INFO'
}

export type LoginTwoFactorInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type LoginTwoFactorResponse = {
  __typename?: 'LoginTwoFactorResponse';
  code: Scalars['String']['output'];
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LogoutOutputObjectType = {
  __typename?: 'LogoutOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ManuallyAssignedExamEventCoursesInput = {
  assignedExamEventCourses: Array<AssignedExamEventCoursesInput>;
  examEventId: Scalars['String']['input'];
};

export type ManuallyAssignedExamEventCoursesOutput = {
  __typename?: 'ManuallyAssignedExamEventCoursesOutput';
  examEventCourses: Array<ExamEventCourse>;
};

export type MarkExamPasserAsACheaterOutput = {
  __typename?: 'MarkExamPasserAsACheaterOutput';
  data: Maybe<Scalars['JSON']['output']>;
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export type MarkExamPasserAsCheaterDocumentFileName = {
  originalFileName: Scalars['String']['input'];
  uploadFileName: Scalars['String']['input'];
};

export type MarkExamPasserAsCheaterInput = {
  additionalExamCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  blockedReason?: InputMaybe<Scalars['String']['input']>;
  blockedRecordId: Scalars['String']['input'];
  blockedScope: BlockedRecordBlockedScope;
  blockedUntil: Scalars['DateTime']['input'];
  documentFileNames?: InputMaybe<Array<MarkExamPasserAsCheaterDocumentFileName>>;
};

export type MonthlyExamEventResult = {
  __typename?: 'MonthlyExamEventResult';
  courses: Scalars['Int']['output'];
  events: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  assignUserAppRoles: AssignUserAppRolesMutationResponse;
  ecAddBlockedRecord: AddBlockedRecordOutput;
  ecAddMembersToExamCenter: AddMembersToExamCenterOutput;
  ecAdminUpdateExamCenter: AdminUpdateExamCenterOutput;
  ecAssignExamCoursesToExamCenter: AssignExamCoursesToExamCenterOutput;
  ecAssignExamsByExamCourseCodesAndMonthOfYear: AssignExamsByExamCourseCodesAndMonthOfYearOutput;
  ecCancelExamEventExaminee: CancelExamEventExamineeOutput;
  ecCreateAnnouncement: CreateAnnouncementOutput;
  ecCreateExamCenter: CreateExamCenterOutput;
  ecCreateExamCenterProctor: CreateExamCenterProctorOutput;
  ecCreateExamCenterProctorRequest: CreateExamCenterProctorRequestOutput;
  ecCreateExamEvent: CreateExamEventOutput;
  ecCreateExamEvents: CreateExamEventsOutput;
  ecCreateExamLocationRequestInfo: CreateExamLocationRequestInfoOutput;
  ecCreateExamRoomRequestInfo: CreateExamRoomRequestInfoOutput;
  ecCreateOrUpdateExamCenterProctorRequestVerdict: CreateOrUpdateExamCenterProctorRequestVerdictOutput;
  ecCreateOrUpdateExamLocationRequestVerdict: CreateOrUpdateExamLocationRequestVerdictOutput;
  ecCreateOrUpdateExamRoomRequestComputerInfo: CreateOrUpdateExamRoomRequestComputerInfoOutput;
  ecCreateOrUpdateExamRoomRequestPhysicalInfo: CreateOrUpdateExamRoomRequestPhysicalInfoOutput;
  ecDeleteExamCenterProctorRequestById: DeleteExamCenterProctorRequestByIdOutput;
  ecDeleteExamLocationRequestInfoById: DeleteExamLocationRequestInfoByIdOutput;
  ecDeleteExamRoomRequestInfoById: DeleteExamRoomRequestInfoByIdOutput;
  ecDeleteManagerFromExamCenter: DeleteMemberFromExamCenterOutput;
  ecDownloadExamByExamEventId: DownloadExamByExamEventIdOutput;
  ecDuplicateExamRoomRequestInfo: DuplicateExamRoomRequestInfoOutput;
  ecEnableExamCourseById: EnableExamCourseByIdOutput;
  ecExtendExamEventSessionExamineesTime: ExtendExamEventSessionExamineesTimeOutput;
  ecExtendExamEventSessionTime: ExtendExamEventSessionTimeOutput;
  ecGenerateSeatNumber: GenerateSeatNumberOutput;
  ecImportExamineesAnswersSpreadSheet: ImportExamineesAnswersSpreadSheetOutput;
  ecImportExamineesSpreadsheet: ImportExamineesSpreadsheetOutput;
  ecManuallyAssignedExamEventCourses: ManuallyAssignedExamEventCoursesOutput;
  ecMarkExamPasserAsCheater: MarkExamPasserAsACheaterOutput;
  ecOverrideExamEventExamineeEmail: OverrideExamEventExamineeEmailOutput;
  ecPostponeExamEventTime: PostponeExamEventTimeOutput;
  ecRegisterExamineeWithAlternativeDocument: RegisterExamineeWithAlternativeDocumentOutput;
  ecRegisterForeignerExamineeWithAlternativeDocument: RegisterForeignerExamineeWithAlternativeDocument;
  ecReinstateExamEventExaminee: ReinstateExamEventExamineeOutput;
  ecResendCertificateEmail: ResendCertificateEmailOutput;
  ecResendEKycRequestEmail: ResendEKycRequestEmailOutput;
  ecRetireRoomById: RetireRoomByIdOutput;
  ecRevokeExamCenterLocationById: RevokeExamCenterLocationByIdOutput;
  ecSaveExamCenterProctorRequestAsDraft: SaveExamCenterProctorRequestAsDraftOutput;
  ecSaveExamCenterProctorRequestAsRejected: SaveExamCenterProctorRequestAsRejectedOutput;
  ecSubmitExamCenterProctorRequest: SubmitExamCenterProctorRequestOutput;
  ecSubmitExamLocationRequestInfo: SubmitExamLocationRequestInfoOutput;
  ecSubmitExamRoomRequest: SubmitExamRoomRequestOutput;
  ecSubmitReviewExamCenterProctorRequest: SubmitReviewExamCenterProctorRequestOutput;
  ecSubmitReviewExamRoomRequestInfo: SubmitReviewExamRoomRequestInfoOutput;
  ecSyncExamEventExamineeWithWr: SyncExamEventExamineeWithWrOutput;
  ecUnassignExams: UnassignExamsOutput;
  ecUpdateBlockedRecord: UpdateBlockedRecordOutput;
  ecUpdateBlockedUser: UpdateBlockedUserOutput;
  ecUpdateEKycStatus: UpdateEKycStatusOutput;
  ecUpdateExamCenter: UpdateExamCenterOutput;
  ecUpdateExamCenterProctorFromExamCenterManager: UpdateExamCenterProctorFromExamCenterManagerOutput;
  ecUpdateExamCenterProctorFromProctorAdmin: UpdateExamCenterProctorFromProctorAdminOutput;
  ecUpdateExamCourseSettings: UpdateExamCourseSettingsOutput;
  ecUpdateExamEvent: UpdateExamEventOutput;
  ecUpdateExamEventExamineeRegistrationStatus: UpdateExamEventExamineeRegistrationStatusOutput;
  ecUpdateExamLocationRequestInfo: UpdateExamLocationRequestInfoOutput;
  ecUpdateExamRoom: UpdateExamRoomOutput;
  ecUpdateExamRoomRequestInfo: UpdateExamRoomRequestInfoOutput;
  ecVerifyCitizenCard: VerifyCitizenCardOutput;
  suAcceptResetPassword: AcceptResetPasswordOutputObjectType;
  suAssignUserAppRole: AssignUserAppRoleMutationResponse;
  suClearSession: ClearSessionOutputObjectType;
  suCreateAppRole: CreateAppRoleMutationResponse;
  suDeleteAppRole: DeleteAppRoleMutationResponse;
  suGenerateTwoFactorSecret: GenerateTwoFactorSecretOutputObjectType;
  suLoginTwoFactor: LoginTwoFactorResponse;
  suLogout: LogoutOutputObjectType;
  suQuickCreateUser: QuickCreateUserObjectType;
  suResendResetPasswordEmail: ResendResetPasswordEmailOutputObjectType;
  suResendResetPasswordUserLocked: ResendResetPasswordUserLockedOutputObjectType;
  suResetPassword: ResetPasswordOutputObjectType;
  suResetUserTwoFactor: ResetUserTwoFactorOutputObjectType;
  suUnassignUserAppRoles: UnassignUserAppRolesMutationResponse;
  suUnlockUserTwoFactor: UnlockUserTwoFactorOutputObjectType;
  suUpdateAppRole: UpdateAppRoleMutationResponse;
  suUpdateAppRoleAppPermissions: UpdateAppRoleAppPermissionsMutationResponse;
  suUpdateUser: UpdateUserOutputObjectType;
  suUpdateUserStatus: UpdateUserStatusOutputObjectType;
  suVerifyUserTwoFactor: VerifyUserTwoFactorOutputObjectType;
  unassignUserAppRole: AssignUserAppRoleMutationResponse;
  updateUserAppRoleByNames: UpdateUserAppRoleByNameMutationResponse;
  updateUserAppRoles: UpdateUserAppRolesMutationResponse;
};


export type MutationAssignUserAppRolesArgs = {
  data: AssignUserAppRolesInput;
};


export type MutationEcAddBlockedRecordArgs = {
  AddBlockedRecordInput: AddBlockedRecordInput;
};


export type MutationEcAddMembersToExamCenterArgs = {
  addMembersToExamCenterInput: AddMembersToExamCenterInput;
};


export type MutationEcAdminUpdateExamCenterArgs = {
  adminUpdateExamCenterInput: AdminUpdateExamCenterInput;
};


export type MutationEcAssignExamCoursesToExamCenterArgs = {
  assignExamCoursesToExamCenterInput: AssignExamCoursesToExamCenterInput;
};


export type MutationEcAssignExamsByExamCourseCodesAndMonthOfYearArgs = {
  input: AssignExamsByExamCourseCodesAndMonthOfYearInput;
};


export type MutationEcCancelExamEventExamineeArgs = {
  cancelExamEventExamineeInput: CancelExamEventExamineeInput;
};


export type MutationEcCreateAnnouncementArgs = {
  createAnnouncementInput: CreateAnnouncementInput;
};


export type MutationEcCreateExamCenterArgs = {
  createExamCenterInput: CreateExamCenterInput;
};


export type MutationEcCreateExamCenterProctorArgs = {
  CreateExamCenterProctorInput: CreateExamCenterProctorInput;
};


export type MutationEcCreateExamCenterProctorRequestArgs = {
  createExamCenterProctorRequestInput: CreateExamCenterProctorRequestInput;
};


export type MutationEcCreateExamEventArgs = {
  CreateExamEventInput: CreateExamEventInput;
};


export type MutationEcCreateExamEventsArgs = {
  CreateExamEventsInput: CreateExamEventsInput;
};


export type MutationEcCreateExamLocationRequestInfoArgs = {
  createExamLocationRequestInfoInput: CreateExamLocationRequestInfoInputType;
};


export type MutationEcCreateExamRoomRequestInfoArgs = {
  createExamRoomRequestInfoInput: CreateExamRoomRequestInfoInputType;
};


export type MutationEcCreateOrUpdateExamCenterProctorRequestVerdictArgs = {
  createOrUpdateExamCenterProctorRequestVerdictInput: CreateOrUpdateExamCenterProctorRequestVerdictInputType;
};


export type MutationEcCreateOrUpdateExamLocationRequestVerdictArgs = {
  createOrUpdateExamLocationRequestVerdictInput: CreateOrUpdateExamLocationRequestVerdictInputType;
};


export type MutationEcCreateOrUpdateExamRoomRequestComputerInfoArgs = {
  createOrUpdateExamRoomRequestComputerInfoInput: CreateOrUpdateExamRoomRequestComputerInfoInputType;
};


export type MutationEcCreateOrUpdateExamRoomRequestPhysicalInfoArgs = {
  createOrUpdateExamRoomRequestPhysicalInfoInput: CreateOrUpdateExamRoomRequestPhysicalInfoInputType;
};


export type MutationEcDeleteExamCenterProctorRequestByIdArgs = {
  deleteExamCenterProctorRequestByIdInput: DeleteExamCenterProctorRequestByIdInput;
};


export type MutationEcDeleteExamLocationRequestInfoByIdArgs = {
  deleteExamLocationRequestInfoByIdInput: DeleteExamLocationRequestInfoByIdInputType;
};


export type MutationEcDeleteExamRoomRequestInfoByIdArgs = {
  deleteExamRoomRequestInfoByIdInput: DeleteExamRoomRequestInfoByIdInputType;
};


export type MutationEcDeleteManagerFromExamCenterArgs = {
  deleteManagerFromExamCenterInput: DeleteManagerFromExamCenterInput;
};


export type MutationEcDownloadExamByExamEventIdArgs = {
  DownloadExamByExamEventIdInput: DownloadExamByExamEventIdInput;
};


export type MutationEcDuplicateExamRoomRequestInfoArgs = {
  duplicateExamRoomRequestInfoInput: DuplicateExamRoomRequestInfoInputType;
};


export type MutationEcEnableExamCourseByIdArgs = {
  enableExamCourseByIdInput: EnableExamCourseByIdInput;
};


export type MutationEcExtendExamEventSessionExamineesTimeArgs = {
  ExtendExamEventSessionExamineesTimeInput: ExtendExamEventSessionExamineesTimeInput;
};


export type MutationEcExtendExamEventSessionTimeArgs = {
  ExtendExamEventSessionTimeInput: ExtendExamEventSessionTimeInput;
};


export type MutationEcGenerateSeatNumberArgs = {
  generateSeatNumberInput: GenerateSeatNumberInput;
};


export type MutationEcImportExamineesAnswersSpreadSheetArgs = {
  importExamineesAnswersSpreadSheetInput: ImportExamineesAnswersSpreadSheetInput;
};


export type MutationEcImportExamineesSpreadsheetArgs = {
  importExamineesSpreadsheetInput: ImportExamineesSpreadsheetInput;
};


export type MutationEcManuallyAssignedExamEventCoursesArgs = {
  input: ManuallyAssignedExamEventCoursesInput;
};


export type MutationEcMarkExamPasserAsCheaterArgs = {
  MarkExamPasserAsCheaterInput: MarkExamPasserAsCheaterInput;
};


export type MutationEcOverrideExamEventExamineeEmailArgs = {
  overrideExamEventExamineeEmailInput: OverrideExamEventExamineeEmailInput;
};


export type MutationEcPostponeExamEventTimeArgs = {
  PostponeExamEventTimeInput: PostponeExamEventTimeInput;
};


export type MutationEcRegisterExamineeWithAlternativeDocumentArgs = {
  registerExamineeWithAlternativeDocumentInput: RegisterExamineeWithAlternativeDocumentInput;
};


export type MutationEcRegisterForeignerExamineeWithAlternativeDocumentArgs = {
  registerForeignerExamineeWithAlternativeDocumentInput: RegisterForeignerExamineeWithAlternativeDocumentInput;
};


export type MutationEcReinstateExamEventExamineeArgs = {
  reinstateExamEventExamineeInput: ReinstateExamEventExamineeInput;
};


export type MutationEcResendCertificateEmailArgs = {
  resendCertificateEmailInput: ResendCertificateEmailInput;
};


export type MutationEcResendEKycRequestEmailArgs = {
  resendEKycRequestEmailInput: ResendEKycRequestEmailInput;
};


export type MutationEcRetireRoomByIdArgs = {
  RetireRoomByIdInput: RetireRoomByIdInput;
};


export type MutationEcRevokeExamCenterLocationByIdArgs = {
  revokeExamCenterLocationByIdInput: RevokeExamCenterLocationByIdInput;
};


export type MutationEcSaveExamCenterProctorRequestAsDraftArgs = {
  saveExamCenterProctorRequestAsDraftInput: SaveExamCenterProctorRequestAsDraftInput;
};


export type MutationEcSaveExamCenterProctorRequestAsRejectedArgs = {
  saveExamCenterProctorRequestAsRejectedInput: SaveExamCenterProctorRequestAsRejectedInput;
};


export type MutationEcSubmitExamCenterProctorRequestArgs = {
  submitExamCenterProctorRequestInput: SubmitExamCenterProctorRequestInput;
};


export type MutationEcSubmitExamLocationRequestInfoArgs = {
  submitExamLocationRequestInfoInput: SubmitExamLocationRequestInfoInputType;
};


export type MutationEcSubmitExamRoomRequestArgs = {
  submitExamRoomRequestInput: SubmitExamRoomRequestInputType;
};


export type MutationEcSubmitReviewExamCenterProctorRequestArgs = {
  submitReviewExamCenterProctorRequestInput: SubmitReviewExamCenterProctorRequestInput;
};


export type MutationEcSubmitReviewExamRoomRequestInfoArgs = {
  submitReviewExamRoomRequestInfoInput: SubmitReviewExamRoomRequestInfoInputType;
};


export type MutationEcSyncExamEventExamineeWithWrArgs = {
  syncExamEventExamineeWithWrInput: SyncExamEventExamineeWithWrInput;
};


export type MutationEcUnassignExamsArgs = {
  UnassignExamsInput: UnassignExamsInput;
};


export type MutationEcUpdateBlockedRecordArgs = {
  UpdateBlockedRecordInput: UpdateBlockedRecordInput;
};


export type MutationEcUpdateBlockedUserArgs = {
  UpdateBlockedUserInput: UpdateBlockedUserInput;
};


export type MutationEcUpdateEKycStatusArgs = {
  updateEKycStatusInput: UpdateEKycStatusInput;
};


export type MutationEcUpdateExamCenterArgs = {
  updateExamCenterInput: UpdateExamCenterInput;
};


export type MutationEcUpdateExamCenterProctorFromExamCenterManagerArgs = {
  UpdateExamCenterProctorFromExamCenterManagerInput: UpdateExamCenterProctorFromExamCenterManagerInput;
};


export type MutationEcUpdateExamCenterProctorFromProctorAdminArgs = {
  UpdateExamCenterProctorFromProctorAdminInput: UpdateExamCenterProctorFromProctorAdminInput;
};


export type MutationEcUpdateExamCourseSettingsArgs = {
  updateExamCourseSettingsInput: UpdateExamCourseSettingsInput;
};


export type MutationEcUpdateExamEventArgs = {
  UpdateExamEventInput: UpdateExamEventInput;
};


export type MutationEcUpdateExamEventExamineeRegistrationStatusArgs = {
  UpdateExamEventExamineeRegistrationStatusInput: UpdateExamEventExamineeRegistrationStatusInput;
};


export type MutationEcUpdateExamLocationRequestInfoArgs = {
  updateExamLocationRequestInfoInput: UpdateExamLocationRequestInfoInputType;
};


export type MutationEcUpdateExamRoomArgs = {
  UpdateExamRoomInput: UpdateExamRoomInput;
};


export type MutationEcUpdateExamRoomRequestInfoArgs = {
  updateExamRoomRequestInfoInput: UpdateExamRoomRequestInfoInputType;
};


export type MutationEcVerifyCitizenCardArgs = {
  verifyCitizenCardInput: VerifyCitizenCardInput;
};


export type MutationSuAcceptResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSuAssignUserAppRoleArgs = {
  data: AssignUserAppRoleInput;
};


export type MutationSuCreateAppRoleArgs = {
  data: CreateAppRoleInput;
};


export type MutationSuDeleteAppRoleArgs = {
  data: DeleteAppRoleInput;
};


export type MutationSuLoginTwoFactorArgs = {
  LoginTwoFactorInput: LoginTwoFactorInput;
};


export type MutationSuQuickCreateUserArgs = {
  appRoleIds: InputMaybe<AppRoleIdsInput>;
  quickCreateInput: QuickCreateInput;
};


export type MutationSuResendResetPasswordEmailArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSuResendResetPasswordUserLockedArgs = {
  email: Scalars['String']['input'];
};


export type MutationSuResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSuResetUserTwoFactorArgs = {
  data: ResetUserTwoFactorInput;
};


export type MutationSuUnassignUserAppRolesArgs = {
  data: UnassignUserAppRolesInput;
};


export type MutationSuUnlockUserTwoFactorArgs = {
  data: UnlockUserTwoFactorInput;
};


export type MutationSuUpdateAppRoleArgs = {
  data: UpdateAppRoleInput;
};


export type MutationSuUpdateAppRoleAppPermissionsArgs = {
  appPermissionIds: Array<Scalars['String']['input']>;
  appRoleId: Scalars['String']['input'];
};


export type MutationSuUpdateUserArgs = {
  data: UpdateUserInput;
  userId: Scalars['String']['input'];
};


export type MutationSuUpdateUserStatusArgs = {
  data: UpdateUserStatusInput;
};


export type MutationSuVerifyUserTwoFactorArgs = {
  input: VerifyUserTwoFactorInput;
};


export type MutationUnassignUserAppRoleArgs = {
  data: UnassignUserAppRoleInput;
};


export type MutationUpdateUserAppRoleByNamesArgs = {
  data: UpdateUserAppRoleByNamesInput;
};


export type MutationUpdateUserAppRolesArgs = {
  data: UpdateUserAppRolesInput;
};

export type Notification = {
  __typename?: 'Notification';
  actionUrl: Maybe<Scalars['String']['output']>;
  audience: NotificationAudience;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  ref: NotificationReference;
  refId: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: NotificationType;
  validUntil: Maybe<Scalars['DateTime']['output']>;
};

export enum NotificationAudience {
  All = 'ALL',
  User = 'USER'
}

export type NotificationRecipient = {
  __typename?: 'NotificationRecipient';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  notification: Maybe<Notification>;
  notificationId: Scalars['String']['output'];
  readAt: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export enum NotificationReference {
  ExamAssignment = 'EXAM_ASSIGNMENT',
  ExamEvent = 'EXAM_EVENT',
  ExamEventAllocation = 'EXAM_EVENT_ALLOCATION',
  ExamLocationRequest = 'EXAM_LOCATION_REQUEST',
  ExamProctorRequest = 'EXAM_PROCTOR_REQUEST',
  Other = 'OTHER'
}

export enum NotificationType {
  Error = 'ERROR',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type NumberOfProctorRequestsByStatus = {
  __typename?: 'NumberOfProctorRequestsByStatus';
  APPROVED: Scalars['Int']['output'];
  DRAFT: Scalars['Int']['output'];
  IN_REVIEW: Scalars['Int']['output'];
  REJECTED: Scalars['Int']['output'];
};

export enum OperatorType {
  And = 'AND',
  Or = 'OR'
}

export type OrderInput = {
  /** Field to order by */
  field: Scalars['String']['input'];
  type: OrderType;
};

export enum OrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OsOption = {
  __typename?: 'OsOption';
  otherDetail: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type OverrideExamEventExamineeEmailInput = {
  email: Scalars['String']['input'];
  examEventExamineeId: Scalars['String']['input'];
  examEventId: Scalars['String']['input'];
};

export type OverrideExamEventExamineeEmailOutput = {
  __typename?: 'OverrideExamEventExamineeEmailOutput';
  examEventExaminee: ExamEventExaminee;
};

export type PageInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PagingInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PhotoSet = {
  __typename?: 'PhotoSet';
  images: Maybe<Array<Scalars['String']['output']>>;
};

export type PostponeExamEventTimeInput = {
  examEventId: Scalars['String']['input'];
  lastPostponedAt?: InputMaybe<Scalars['String']['input']>;
  postponeDurationInMinutes: Scalars['Float']['input'];
  postponementRemark: Scalars['String']['input'];
};

export type PostponeExamEventTimeOutput = {
  __typename?: 'PostponeExamEventTimeOutput';
  examEvent: ExamEvent;
};

export type ProctorAuditLog = {
  __typename?: 'ProctorAuditLog';
  action: AuditActionType;
  actionTime: Scalars['DateTime']['output'];
  auditType: AuditType;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  executionInput: Scalars['String']['output'];
  executionMethod: Scalars['String']['output'];
  executionOutput: Scalars['String']['output'];
  executionResult: AuditLogExecutionResult;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers: Array<ProctorAuditLogIdentifier>;
  type: ProctorAuditLogType;
  userId: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
  userType: UserType;
};

export type ProctorAuditLogIdentifier = {
  __typename?: 'ProctorAuditLogIdentifier';
  identifierId: Scalars['String']['output'];
  identifierType: ProctorAuditLogIdentifierType;
};

export enum ProctorAuditLogIdentifierType {
  ExamEventProctorId = 'EXAM_EVENT_PROCTOR_ID',
  ProctorId = 'PROCTOR_ID'
}

export enum ProctorAuditLogType {
  Proctor = 'PROCTOR',
  ProctorType_1 = 'PROCTOR_TYPE_1',
  ProctorType_2 = 'PROCTOR_TYPE_2',
  ProctorType_3 = 'PROCTOR_TYPE_3'
}

export enum ProgressStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type Province = {
  __typename?: 'Province';
  code: Scalars['String']['output'];
  geographyId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  nameTh: Scalars['String']['output'];
};

export enum QConfigStructureType {
  QuestionType = 'QUESTION_TYPE',
  QBankStructure = 'Q_BANK_STRUCTURE',
  QBankStructureLevelItem = 'Q_BANK_STRUCTURE_LEVEL_ITEM',
  QConfig = 'Q_CONFIG',
  Tag = 'TAG'
}

export type QSet = {
  __typename?: 'QSet';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  UsBoGetTokenStatus: UsBoGetTokenStatusResponse;
  UsBoSearchUsersWithAppRoleFilters: UsBoUserSearchResult;
  UsBoUser: UsBoUser;
  UsBoUsers: UsBoUserSearchResult;
  ecAdminGetDownloadSignedUrlForExamCenterProctorRequest: GetDownloadSignedUrlForExamCenterProctorRequestOutput;
  ecAdminGetDownloadSignedUrlForExamRoomComputerInfo: GetDownloadSignedUrlForExamRoomComputerInfoOutput;
  ecAdminGetDownloadSignedUrlForExamRoomPhysicalInfo: GetDownloadSignedUrlForExamRoomPhysicalInfoOutput;
  ecAdminGetDownloadSignedUrlForExamRoomRequestComputerInfo: GetDownloadSignedUrlForExamRoomRequestComputerInfoOutput;
  ecAdminGetDownloadSignedUrlForExamRoomRequestPhysicalInfo: GetDownloadSignedUrlForExamRoomRequestPhysicalInfoOutput;
  ecAdminGetDownloadSignedUrlsForExamCenterProctor: GetDownloadSignedUrlsForExamCenterProctorOutput;
  ecAdminGetExamCenterByExamCenterCode: GetExamCenterByExamCenterCodeOutput;
  ecAdminGetExamCenterMemberById: GetExamCenterMemberByIdOutput;
  ecAdminGetExamCenterMembersByExamCenterCode: GetExamCenterMembersByExamCenterCodeOutput;
  ecAdminGetExamCenterProctorById: GetExamCenterProctorByIdOutput;
  ecAdminGetExamCenterProctorRequestById: AdminGetExamCenterProctorRequestByIdOutput;
  ecAdminGetExamCenterProctorRequestsCountByExamCenterCode: GetExamCenterProctorRequestsCountByExamCenterCodeOutput;
  ecAdminGetExamRoomById: GetExamRoomByIdOutput;
  ecAdminGetExamRoomRequestInfoById: AdminGetExamRoomRequestInfoByIdOutput;
  ecAdminGetExamRoomRequestInfoCount: AdminGetExamRoomRequestInfoCountOutput;
  ecAdminGetUpcomingRoomReservationSummary: GetUpcomingRoomReservationSummaryOutput;
  ecAdminSearchExamCenterCourses: SearchExamCenterCoursesOutput;
  ecAdminSearchExamCenterProctors: SearchExamCenterProctorsOutput;
  ecAdminSearchMyExamCenterProctorRequests: AdminSearchExamCenterProctorRequestsOutput;
  ecAdminSearchMyExamRoomRequestInfos: AdminSearchMyExamRoomRequestInfosOutput;
  ecAdminSearchRoomByLocationName: AdminSearchRoomByLocationNameOutput;
  ecAdminSearchRooms: SearchRoomsOutput;
  ecCountActiveExamCenterProctorsByType: CountActiveExamCenterProctorsByTypeOutput;
  ecCountExamCenterRoomsByProvince: CountExamCenterRoomsByProvinceOutput;
  ecCountExamEventsWithQuestionnaires: CountExamEventsWithQuestionnairesOutput;
  ecDownloadSETPortalExamResultFile: DownloadSetPortalExamResultFileOutput;
  ecExportBlockedUsers: ExportBlockedUsersOutput;
  ecExportExamEventExamineeScoreReports: ExportExamEventExamineeScoreReportsOutput;
  ecExportExaminationCodeByExamEventExamineeId: ExportExaminationCodeByExamEventExamineeIdOutput;
  ecExportExaminationCodesByExamEventId: ExportExaminationCodesByExamEventIdOutput;
  ecExportQuestionnaires: ExportQuestionnairesOutput;
  ecGetAllAnnouncements: GetAllAnnouncementsOutput;
  ecGetAllEnabledExamCourses: GetAllEnabledExamCoursesOutput;
  ecGetAllExamCenterCourses: GetAllExamCenterCoursesOutput;
  ecGetAllExamCenters: GetAllExamCentersOutput;
  ecGetAllExamCoursesWithAvailableQSetsAndExamCenterCourses: GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesOutput;
  ecGetAllExamEventsByExamCenterCode: GetAllExamEventsByExamCenterCodeOutput;
  ecGetAllProvinces: GetAllProvincesOutput;
  ecGetAnnouncementById: GetAnnouncementByIdOutput;
  ecGetAvailableExamEventICTYears: GetAvailableExamEventIctYearsOutput;
  ecGetAvailableQSetsByExamEventId: GetAvailableQSetsByExamEventIdOutput;
  ecGetAvailableRoomsByLocationIdAndTimeFrame: GetAvailableRoomsByLocationIdAndTimeFrameOutput;
  ecGetBlockedUserById: GetBlockedUserByIdOutput;
  ecGetBuildingsByLocationId: GetBuildingsByLocationIdOutput;
  ecGetDipChipDeepLinkUrl: GetDipChipDeepLinkUrlOutput;
  ecGetDownloadSignedUrlForBlockedRecord: GetDownloadSignedUrlForBlockedRecordOutput;
  ecGetDownloadSignedUrlForExamCenterProctorRequest: GetDownloadSignedUrlForExamCenterProctorRequestOutput;
  ecGetDownloadSignedUrlForExamCourseAttachDocument: GetDownloadSignedUrlForExamCourseAttachDocumentOutput;
  ecGetDownloadSignedUrlForExamRoomComputerInfo: GetDownloadSignedUrlForExamRoomComputerInfoOutput;
  ecGetDownloadSignedUrlForExamRoomPhysicalInfo: GetDownloadSignedUrlForExamRoomPhysicalInfoOutput;
  ecGetDownloadSignedUrlForExamRoomRequestComputerInfo: GetDownloadSignedUrlForExamRoomRequestComputerInfoOutput;
  ecGetDownloadSignedUrlForExamRoomRequestPhysicalInfo: GetDownloadSignedUrlForExamRoomRequestPhysicalInfoOutput;
  ecGetDownloadSignedUrlsForExamCenterProctor: GetDownloadSignedUrlsForExamCenterProctorOutput;
  ecGetDraftExamLocationRequestVerdictsByExamRoomRequestInfoId: GetDraftExamLocationRequestVerdictsByExamRoomRequestInfoIdOutput;
  ecGetEKycDocumentDownloadSignedUrl: GetEKycDocumentDownloadSignedUrlOutput;
  ecGetEKycInfoByExamineeIdAndExamEventId: GetEKycInfoByExamineeIdAndExamEventIdOutput;
  ecGetExamCenterByExamCenterCode: GetExamCenterByExamCenterCodeOutput;
  ecGetExamCenterEventSummaries: GetExamCenterEventSummariesOutput;
  ecGetExamCenterLocationsByProvinceId: GetExamCenterLocationsByProvinceIdOutput;
  ecGetExamCenterMemberById: GetExamCenterMemberByIdOutput;
  ecGetExamCenterMembersByExamCenterCode: GetExamCenterMembersByExamCenterCodeOutput;
  ecGetExamCenterProctorById: GetExamCenterProctorByIdOutput;
  ecGetExamCenterProctorRequestById: GetExamCenterProctorRequestByIdOutput;
  ecGetExamCenterProctorRequestsCountByExamCenterCode: GetExamCenterProctorRequestsCountByExamCenterCodeOutput;
  ecGetExamCourseByExamCourseCode: GetExamCourseByExamCourseCodeOutput;
  ecGetExamCoursesByExamEventId: GetExamCoursesByExamEventIdOutput;
  ecGetExamEventById: GetExamEventByIdOutput;
  ecGetExamEventCoursesByExamEventIds: GetExamEventCoursesByExamEventIdsOutput;
  ecGetExamEventExamineeById: GetExamEventExamineeByIdOutput;
  ecGetExamEventExamineeCountSummary: GetExamEventExamineeCountSummaryOutput;
  ecGetExamEventExamineeCountSummaryForProctoring: GetExamEventExamineeCountSummaryForProctoringOutput;
  ecGetExamEventExamineeScoreReports: GetExamEventExamineeScoreReportsOutput;
  ecGetExamEventExamineesForSession: GetExamEventExamineesForSessionOutput;
  ecGetExamEventParticipatedCourses: GetExamEventParticipatedCoursesOutput;
  ecGetExamEventResultSummary: GetExamEventResultSummaryOutput;
  ecGetExamEventSessionById: GetExamEventSessionByIdOutput;
  ecGetExamEventSessionExamineesForTimeExtension: GetExamEventSessionExamineesForTimeExtensionOutput;
  ecGetExamEventsByDateRange: GetExamEventsByDateRangeOutput;
  ecGetExamLocationRequestInfoById: GetExamLocationRequestInfoByIdOutput;
  ecGetExamLocationRequestInfoCountByExamCenterCode: GetExamLocationRequestInfoCountByExamCenterCodeOutput;
  ecGetExamRoomById: GetExamRoomByIdOutput;
  ecGetExamRoomRequestInfoById: GetExamRoomRequestInfoByIdOutput;
  ecGetExamineeDetailsByIdNumberAndExamEventId: GetExamineeDetailsByIdNumberAndExamEventIdOutput;
  ecGetICTExamEventYearsByExamCenterCode: GetIctExamEventYearsByExamCenterCodeOutput;
  ecGetLocationsByProvinceId: GetLocationsByProvinceIdOutput;
  ecGetMonthlyExamEventOverview: GetMonthlyExamEventOverviewOutput;
  ecGetMyExamCenters: GetMyExamCentersOutput;
  ecGetMyNotifications: GetMyNotificationsOutput;
  ecGetMyProctorExamEvents: GetAllExamEventsByExamCenterCodeOutput;
  ecGetQConfigStructuresReorderedByExamEventIdAndExamCourseId: GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdOutput;
  ecGetServerTime: GetServerTimeOutput;
  ecGetUpcomingExamEventsByExamCenterCode: GetUpcomingExamEventsByExamCenterCodeOutput;
  ecGetUpcomingRoomReservationSummary: GetUpcomingRoomReservationSummaryOutput;
  ecGetUploadSignedUrlForAlternativeRegistration: GetUploadSignedUrlForAlternativeRegistrationOutput;
  ecGetUploadSignedUrlForExamCourseAttachDocument: GetUploadSignedUrlForExamCourseAttachDocumentOutput;
  ecGetUploadSignedUrlForExamRoomRequestComputerInfo: GetUploadSignedUrlForExamRoomRequestComputerInfoOutput;
  ecGetUploadSignedUrlForExamRoomRequestPhysicalInfo: GetUploadSignedUrlForExamRoomRequestPhysicalInfoOutput;
  ecGetUploadSignedUrlForImportExaminees: GetUploadSignedUrlForImportExamineesOutput;
  ecGetUploadSignedUrlForImportExamineesAnswers: GetUploadSignedUrlForImportExamineesAnswersOutput;
  ecGetUploadSignedUrlsForBlockedRecord: GetUploadSignedUrlsForBlockedRecordOutput;
  ecGetUploadSignedUrlsForExamCenterProctor: GetUploadSignedUrlsForExamCenterProctorOutput;
  ecGetUploadSignedUrlsForExamCenterProctorRequest: GetUploadSignedUrlsForExamCenterProctorRequestOutput;
  ecGetYearlyExamEventsCountByMonth: GetYearlyExamEventsCountByMonthOutput;
  ecSearchAssignableExamCourses: SearchAssignableExamCoursesOutput;
  ecSearchAvailableExamCenterManagerUsers: SearchAvailableExamCenterManagerUsersOutput;
  ecSearchAvailableExamCenterProctorsByTimeFrame: SearchAvailableExamCenterProctorsByTimeFrameOutput;
  ecSearchBlockedUsers: SearchBlockedUsersOutput;
  ecSearchExamCenterCourses: SearchExamCenterCoursesOutput;
  ecSearchExamCenterLocationsUsage: SearchExamCenterLocationsUsageOutput;
  ecSearchExamCenterProctorRequests: SearchExamCenterProctorRequestsOutput;
  ecSearchExamCenterProctors: SearchExamCenterProctorsOutput;
  ecSearchExamCenterRooms: SearchExamCenterRoomsOutput;
  ecSearchExamCenters: SearchExamCentersOutput;
  ecSearchExamCourses: SearchExamCoursesOutput;
  ecSearchExamEventAuditLog: SearchExamEventAuditLogOutput;
  ecSearchExamEventExaminees: SearchExamEventExamineesOutput;
  ecSearchExamEventsWithQuestionnaires: SearchExamEventsWithQuestionnairesOutput;
  ecSearchExamLocationRequestInfos: SearchExamLocationRequestInfosOutput;
  ecSearchExamRoomRequestInfos: SearchExamRoomRequestInfosOutput;
  ecSearchExamineeEKycStatusesInExamEvent: SearchExamineeEKycStatusesInExamEventOutput;
  ecSearchExamineeStatusesInExamEvent: SearchExamineeStatusesInExamEventOutput;
  ecSearchLocationAuditLog: SearchLocationAuditLogOutput;
  ecSearchProctorAuditLog: SearchProctorAuditLogOutput;
  ecSearchSETPortalExamResultFiles: SearchSetPortalExamResultFilesOutput;
  ecSearchTimeExtendedExamEventSessionExaminees: SearchTimeExtendedExamEventSessionExamineeOutput;
  ecValidateExamEventsCreation: ValidateExamEventsCreationOutput;
  getAppPermissions: Array<AppPermission>;
  getAppRoleAppPermissions: Array<AppPermission>;
  getAppRoles: AppRoleSearchResult;
  getMyProfile: UsUser;
  getUserAppRoleView: UserAppRoleViewSearchResult;
  suGetAppRole: GetAppRoleOutputObjectType;
  suUser: GetUserByIdOutputObjectType;
  validateToken: ValidateTokenResult;
};


export type QueryUsBoSearchUsersWithAppRoleFiltersArgs = {
  appRoleIds: InputMaybe<Array<Scalars['String']['input']>>;
  appRoleNames: InputMaybe<Array<Scalars['String']['input']>>;
  excludeAppRoleIds: InputMaybe<Array<Scalars['String']['input']>>;
  excludeFields: InputMaybe<UsBoUserExcludeFieldsInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search?: InputMaybe<UsBoUserSearchInput>;
};


export type QueryUsBoUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUsBoUsersArgs = {
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search: InputMaybe<UsBoUserSearchInput>;
};


export type QueryEcAdminGetDownloadSignedUrlForExamCenterProctorRequestArgs = {
  getDownloadSignedUrlForExamCenterProctorRequestInput: GetDownloadSignedUrlForExamCenterProctorRequestInput;
};


export type QueryEcAdminGetDownloadSignedUrlForExamRoomComputerInfoArgs = {
  GetDownloadSignedUrlForExamRoomComputerInfoInput: GetDownloadSignedUrlForExamRoomComputerInfoInput;
};


export type QueryEcAdminGetDownloadSignedUrlForExamRoomPhysicalInfoArgs = {
  GetDownloadSignedUrlForExamRoomPhysicalInfoInput: GetDownloadSignedUrlForExamRoomPhysicalInfoInput;
};


export type QueryEcAdminGetDownloadSignedUrlForExamRoomRequestComputerInfoArgs = {
  GetDownloadSignedUrlForExamRoomRequestComputerInfoInput: GetDownloadSignedUrlForExamRoomRequestComputerInfoInputType;
};


export type QueryEcAdminGetDownloadSignedUrlForExamRoomRequestPhysicalInfoArgs = {
  GetDownloadSignedUrlForExamRoomRequestPhysicalInfoInput: GetDownloadSignedUrlForExamRoomRequestPhysicalInfoInputType;
};


export type QueryEcAdminGetDownloadSignedUrlsForExamCenterProctorArgs = {
  GetDownloadSignedUrlsForExamCenterProctorInput: GetDownloadSignedUrlsForExamCenterProctorInput;
};


export type QueryEcAdminGetExamCenterByExamCenterCodeArgs = {
  getExamCenterByExamCenterCodeInput: GetExamCenterByExamCenterCodeInput;
};


export type QueryEcAdminGetExamCenterMemberByIdArgs = {
  getExamCenterMemberByIdInput: GetExamCenterMemberByIdInput;
};


export type QueryEcAdminGetExamCenterMembersByExamCenterCodeArgs = {
  getExamCenterMembersByExamCenterCodeInput: GetExamCenterMembersByExamCenterCodeInput;
};


export type QueryEcAdminGetExamCenterProctorByIdArgs = {
  GetExamCenterProctorByIdInput: GetExamCenterProctorByIdInput;
};


export type QueryEcAdminGetExamCenterProctorRequestByIdArgs = {
  adminGetExamCenterProctorRequestByIdInput: AdminGetExamCenterProctorRequestByIdInputType;
};


export type QueryEcAdminGetExamCenterProctorRequestsCountByExamCenterCodeArgs = {
  getExamCenterProctorRequestsCountByExamCenterCodeInput: GetExamCenterProctorRequestsCountByExamCenterCodeInput;
};


export type QueryEcAdminGetExamRoomByIdArgs = {
  GetExamRoomByIdInput: GetExamRoomByIdInput;
};


export type QueryEcAdminGetExamRoomRequestInfoByIdArgs = {
  adminGetExamRoomRequestInfoByIdInput: AdminGetExamRoomRequestInfoByIdInputType;
};


export type QueryEcAdminGetUpcomingRoomReservationSummaryArgs = {
  GetUpcomingRoomReservationSummaryInput: GetUpcomingRoomReservationSummaryInput;
};


export type QueryEcAdminSearchExamCenterCoursesArgs = {
  searchExamCenterCoursesInput: SearchExamCenterCoursesInput;
};


export type QueryEcAdminSearchExamCenterProctorsArgs = {
  SearchExamCenterProctorsInput: SearchExamCenterProctorsInput;
};


export type QueryEcAdminSearchMyExamCenterProctorRequestsArgs = {
  adminSearchExamCenterProctorRequestsInput: AdminSearchMyExamCenterProctorRequestsInput;
};


export type QueryEcAdminSearchMyExamRoomRequestInfosArgs = {
  adminSearchMyExamRoomRequestInfosInput: AdminSearchMyExamRoomRequestInfosInput;
};


export type QueryEcAdminSearchRoomByLocationNameArgs = {
  AdminSearchRoomByLocationNameInput: AdminSearchRoomByLocationNameInput;
};


export type QueryEcAdminSearchRoomsArgs = {
  SearchRoomsInput: SearchRoomsInput;
};


export type QueryEcCountActiveExamCenterProctorsByTypeArgs = {
  CountActiveExamCenterProctorsByTypeInput: CountActiveExamCenterProctorsByTypeInput;
};


export type QueryEcCountExamCenterRoomsByProvinceArgs = {
  CountExamCenterRoomsByProvinceInput: CountExamCenterRoomsByProvinceInput;
};


export type QueryEcCountExamEventsWithQuestionnairesArgs = {
  CountExamEventsWithQuestionnairesInput: CountExamEventsWithQuestionnairesInput;
};


export type QueryEcDownloadSetPortalExamResultFileArgs = {
  DownloadSETPortalExamResultFileInput: DownloadSetPortalExamResultFileInput;
};


export type QueryEcExportBlockedUsersArgs = {
  ExportBlockedUsersInput: ExportBlockedUsersInput;
};


export type QueryEcExportExamEventExamineeScoreReportsArgs = {
  exportExamEventExamineeScoreReportsInput: ExportExamEventExamineeScoreReportsInput;
};


export type QueryEcExportExaminationCodeByExamEventExamineeIdArgs = {
  exportExaminationCodeByExamEventExamineeIdInput: ExportExaminationCodeByExamEventExamineeIdInput;
};


export type QueryEcExportExaminationCodesByExamEventIdArgs = {
  exportExaminationCodesByExamEventIdInput: ExportExaminationCodesByExamEventIdInput;
};


export type QueryEcExportQuestionnairesArgs = {
  ExportQuestionnairesInput: ExportQuestionnairesInput;
};


export type QueryEcGetAllExamCenterCoursesArgs = {
  getAllExamCenterCoursesInput: GetAllExamCenterCoursesInput;
};


export type QueryEcGetAllExamEventsByExamCenterCodeArgs = {
  GetAllExamEventsByExamCenterCodeInput: GetAllExamEventsByExamCenterCodeInput;
};


export type QueryEcGetAnnouncementByIdArgs = {
  getAnnouncementByIdInput: GetAnnouncementByIdInput;
};


export type QueryEcGetAvailableQSetsByExamEventIdArgs = {
  input: GetAvailableQSetsByExamEventIdInput;
};


export type QueryEcGetAvailableRoomsByLocationIdAndTimeFrameArgs = {
  GetAvailableRoomsByLocationIdAndTimeFrameInput: GetAvailableRoomsByLocationIdAndTimeFrameInput;
};


export type QueryEcGetBlockedUserByIdArgs = {
  GetBlockedUserByIdInput: GetBlockedUserByIdInput;
};


export type QueryEcGetBuildingsByLocationIdArgs = {
  getBuildingsByLocationIdInput: GetBuildingsByLocationIdInput;
};


export type QueryEcGetDipChipDeepLinkUrlArgs = {
  GetDipChipDeepLinkUrlInput: GetDipChipDeepLinkUrlInput;
};


export type QueryEcGetDownloadSignedUrlForBlockedRecordArgs = {
  GetDownloadSignedUrlForBlockedRecordInput: GetDownloadSignedUrlForBlockedRecordInput;
};


export type QueryEcGetDownloadSignedUrlForExamCenterProctorRequestArgs = {
  getDownloadSignedUrlForExamCenterProctorRequestInput: GetDownloadSignedUrlForExamCenterProctorRequestInput;
};


export type QueryEcGetDownloadSignedUrlForExamCourseAttachDocumentArgs = {
  getDownloadSignedUrlForExamCourseAttachDocumentInput: GetDownloadSignedUrlForExamCourseAttachDocumentInput;
};


export type QueryEcGetDownloadSignedUrlForExamRoomComputerInfoArgs = {
  GetDownloadSignedUrlForExamRoomComputerInfoInput: GetDownloadSignedUrlForExamRoomComputerInfoInput;
};


export type QueryEcGetDownloadSignedUrlForExamRoomPhysicalInfoArgs = {
  GetDownloadSignedUrlForExamRoomPhysicalInfoInput: GetDownloadSignedUrlForExamRoomPhysicalInfoInput;
};


export type QueryEcGetDownloadSignedUrlForExamRoomRequestComputerInfoArgs = {
  GetDownloadSignedUrlForExamRoomRequestComputerInfoInput: GetDownloadSignedUrlForExamRoomRequestComputerInfoInputType;
};


export type QueryEcGetDownloadSignedUrlForExamRoomRequestPhysicalInfoArgs = {
  GetDownloadSignedUrlForExamRoomRequestPhysicalInfoInput: GetDownloadSignedUrlForExamRoomRequestPhysicalInfoInputType;
};


export type QueryEcGetDownloadSignedUrlsForExamCenterProctorArgs = {
  GetDownloadSignedUrlsForExamCenterProctorInput: GetDownloadSignedUrlsForExamCenterProctorInput;
};


export type QueryEcGetDraftExamLocationRequestVerdictsByExamRoomRequestInfoIdArgs = {
  GetDraftExamLocationRequestVerdictsByExamRoomRequestInfoIdInput: GetDraftExamLocationRequestVerdictsByExamRoomRequestInfoIdInputType;
};


export type QueryEcGetEKycDocumentDownloadSignedUrlArgs = {
  getEKycDocumentDownloadSignedUrlInput: GetEKycDocumentDownloadSignedUrlInput;
};


export type QueryEcGetEKycInfoByExamineeIdAndExamEventIdArgs = {
  getEKycInfoByExamineeIdAndExamEventIdInput: GetEKycInfoByExamineeIdAndExamEventIdInput;
};


export type QueryEcGetExamCenterByExamCenterCodeArgs = {
  getExamCenterByExamCenterCodeInput: GetExamCenterByExamCenterCodeInput;
};


export type QueryEcGetExamCenterEventSummariesArgs = {
  GetExamCenterEventSummariesInput: GetExamCenterEventSummariesInput;
};


export type QueryEcGetExamCenterLocationsByProvinceIdArgs = {
  getExamCenterLocationsByProvinceIdInput: GetExamCenterLocationsByProvinceIdInput;
};


export type QueryEcGetExamCenterMemberByIdArgs = {
  getExamCenterMemberByIdInput: GetExamCenterMemberByIdInput;
};


export type QueryEcGetExamCenterMembersByExamCenterCodeArgs = {
  getExamCenterMembersByExamCenterCodeInput: GetExamCenterMembersByExamCenterCodeInput;
};


export type QueryEcGetExamCenterProctorByIdArgs = {
  GetExamCenterProctorByIdInput: GetExamCenterProctorByIdInput;
};


export type QueryEcGetExamCenterProctorRequestByIdArgs = {
  getExamCenterProctorRequestByIdInput: GetExamCenterProctorRequestByIdInputType;
};


export type QueryEcGetExamCenterProctorRequestsCountByExamCenterCodeArgs = {
  getExamCenterProctorRequestsCountByExamCenterCodeInput: GetExamCenterProctorRequestsCountByExamCenterCodeInput;
};


export type QueryEcGetExamCourseByExamCourseCodeArgs = {
  getExamCourseByExamCourseCodeInput: GetExamCourseByExamCourseCodeInput;
};


export type QueryEcGetExamCoursesByExamEventIdArgs = {
  input: GetExamCoursesByExamEventIdInput;
};


export type QueryEcGetExamEventByIdArgs = {
  GetExamEventByIdInput: GetExamEventByIdInput;
};


export type QueryEcGetExamEventCoursesByExamEventIdsArgs = {
  input: GetExamEventCoursesByExamEventIdsInput;
};


export type QueryEcGetExamEventExamineeByIdArgs = {
  getExamEventExamineeByIdInput: GetExamEventExamineeByIdInput;
};


export type QueryEcGetExamEventExamineeCountSummaryArgs = {
  getExamEventExamineeCountSummaryInput: GetExamEventExamineeCountSummaryInput;
};


export type QueryEcGetExamEventExamineeCountSummaryForProctoringArgs = {
  getExamEventExamineeCountSummaryForProctoringInput: GetExamEventExamineeCountSummaryForProctoringInput;
};


export type QueryEcGetExamEventExamineeScoreReportsArgs = {
  getExamEventExamineeScoreReportsInput: GetExamEventExamineeScoreReportsInput;
};


export type QueryEcGetExamEventExamineesForSessionArgs = {
  GetExamEventExamineesForSessionInput: GetExamEventExamineesForSessionInput;
};


export type QueryEcGetExamEventParticipatedCoursesArgs = {
  input: GetExamEventParticipatedCoursesInput;
};


export type QueryEcGetExamEventResultSummaryArgs = {
  GetExamEventResultSummaryInput: GetExamEventResultSummaryInput;
};


export type QueryEcGetExamEventSessionByIdArgs = {
  GetExamEventSessionByIdInput: GetExamEventSessionByIdInput;
};


export type QueryEcGetExamEventSessionExamineesForTimeExtensionArgs = {
  GetExamEventSessionExamineesForTimeExtensionInput: GetExamEventSessionExamineesForTimeExtensionInput;
};


export type QueryEcGetExamEventsByDateRangeArgs = {
  GetExamEventsByDateRangeInput: GetExamEventsByDateRangeInput;
};


export type QueryEcGetExamLocationRequestInfoByIdArgs = {
  getExamLocationRequestInfoByIdInput: GetExamLocationRequestInfoByIdInputType;
};


export type QueryEcGetExamLocationRequestInfoCountByExamCenterCodeArgs = {
  getExamLocationRequestInfoCountByExamCenterCodeInput: GetExamLocationRequestInfoCountByExamCenterCodeInputType;
};


export type QueryEcGetExamRoomByIdArgs = {
  GetExamRoomByIdInput: GetExamRoomByIdInput;
};


export type QueryEcGetExamRoomRequestInfoByIdArgs = {
  getExamRoomRequestInfoByIdInput: GetExamRoomRequestInfoByIdInputType;
};


export type QueryEcGetExamineeDetailsByIdNumberAndExamEventIdArgs = {
  getExamineeDetailsByIdNumberAndExamEventIdInput: GetExamineeDetailsByIdNumberAndExamEventIdInput;
};


export type QueryEcGetIctExamEventYearsByExamCenterCodeArgs = {
  getICTExamEventYearsByExamCenterCodeInput: GetIctExamEventYearsByExamCenterCodeInput;
};


export type QueryEcGetLocationsByProvinceIdArgs = {
  GetLocationsByProvinceIdInput: GetLocationsByProvinceIdInput;
};


export type QueryEcGetMonthlyExamEventOverviewArgs = {
  getMonthlyExamEventOverviewInput: GetMonthlyExamEventOverviewInput;
};


export type QueryEcGetMyNotificationsArgs = {
  GetMyNotificationsInput: InputMaybe<GetMyNotificationsInput>;
};


export type QueryEcGetMyProctorExamEventsArgs = {
  GetMyProctorExamEventsInput: GetMyProctorExamEventsInput;
};


export type QueryEcGetQConfigStructuresReorderedByExamEventIdAndExamCourseIdArgs = {
  input: GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdInput;
};


export type QueryEcGetUpcomingExamEventsByExamCenterCodeArgs = {
  GetUpcomingExamEventsByExamCenterCodeInput: GetUpcomingExamEventsByExamCenterCodeInput;
};


export type QueryEcGetUpcomingRoomReservationSummaryArgs = {
  GetUpcomingRoomReservationSummaryInput: GetUpcomingRoomReservationSummaryInput;
};


export type QueryEcGetUploadSignedUrlForAlternativeRegistrationArgs = {
  getUploadSignedUrlForAlternativeRegistrationInput: GetUploadSignedUrlForAlternativeRegistrationInput;
};


export type QueryEcGetUploadSignedUrlForExamCourseAttachDocumentArgs = {
  getUploadSignedUrlForExamCourseAttachDocumentInput: GetUploadSignedUrlForExamCourseAttachDocumentInput;
};


export type QueryEcGetUploadSignedUrlForExamRoomRequestComputerInfoArgs = {
  GetUploadSignedUrlForExamRoomRequestComputerInfoInput: GetUploadSignedUrlForExamRoomRequestComputerInfoInputType;
};


export type QueryEcGetUploadSignedUrlForExamRoomRequestPhysicalInfoArgs = {
  GetUploadSignedUrlForExamRoomRequestPhysicalInfoInput: GetUploadSignedUrlForExamRoomRequestPhysicalInfoInputType;
};


export type QueryEcGetUploadSignedUrlForImportExamineesArgs = {
  getUploadSignedUrlForImportExamineesInput: GetUploadSignedUrlForImportExamineesInput;
};


export type QueryEcGetUploadSignedUrlForImportExamineesAnswersArgs = {
  getUploadSignedUrlForImportExamineesAnswersInput: GetUploadSignedUrlForImportExamineesAnswersInput;
};


export type QueryEcGetUploadSignedUrlsForBlockedRecordArgs = {
  GetUploadSignedUrlsForBlockedRecordInput: GetUploadSignedUrlsForBlockedRecordInput;
};


export type QueryEcGetUploadSignedUrlsForExamCenterProctorArgs = {
  getUploadSignedUrlsForExamCenterProctorInput: GetUploadSignedUrlsForExamCenterProctorInputType;
};


export type QueryEcGetUploadSignedUrlsForExamCenterProctorRequestArgs = {
  getUploadSignedUrlsForExamCenterProctorRequestInput: GetUploadSignedUrlsForExamCenterProctorRequestInputType;
};


export type QueryEcGetYearlyExamEventsCountByMonthArgs = {
  GetYearlyExamEventsCountByMonthInput: GetYearlyExamEventsCountByMonthInput;
};


export type QueryEcSearchAssignableExamCoursesArgs = {
  searchAssignableExamCoursesInput: SearchAssignableExamCoursesInput;
};


export type QueryEcSearchAvailableExamCenterManagerUsersArgs = {
  searchAvailableExamCenterManagerUsersInput: SearchAvailableExamCenterManagerUsersInput;
};


export type QueryEcSearchAvailableExamCenterProctorsByTimeFrameArgs = {
  SearchAvailableExamCenterProctorsByTimeFrameInput: SearchAvailableExamCenterProctorsByTimeFrameInput;
};


export type QueryEcSearchBlockedUsersArgs = {
  SearchBlockedUsersInput: SearchBlockedUsersInput;
};


export type QueryEcSearchExamCenterCoursesArgs = {
  searchExamCenterCoursesInput: SearchExamCenterCoursesInput;
};


export type QueryEcSearchExamCenterLocationsUsageArgs = {
  searchExamCenterLocationsUsageInput: SearchExamCenterLocationsUsageInput;
};


export type QueryEcSearchExamCenterProctorRequestsArgs = {
  searchExamCenterProctorRequestsInput: SearchExamCenterProctorRequestsInput;
};


export type QueryEcSearchExamCenterProctorsArgs = {
  SearchExamCenterProctorsInput: SearchExamCenterProctorsInput;
};


export type QueryEcSearchExamCenterRoomsArgs = {
  SearchExamCenterRoomsInput: SearchExamCenterRoomsInput;
};


export type QueryEcSearchExamCentersArgs = {
  searchExamCentersInput: SearchExamCentersInput;
};


export type QueryEcSearchExamCoursesArgs = {
  searchExamCoursesInput: SearchExamCoursesInput;
};


export type QueryEcSearchExamEventAuditLogArgs = {
  SearchExamEventAuditLogInput: SearchExamEventAuditLogInput;
};


export type QueryEcSearchExamEventExamineesArgs = {
  searchExamEventExaminees: SearchExamEventExamineesInput;
};


export type QueryEcSearchExamEventsWithQuestionnairesArgs = {
  SearchExamEventsWithQuestionnairesInput: SearchExamEventsWithQuestionnairesInput;
};


export type QueryEcSearchExamLocationRequestInfosArgs = {
  searchExamLocationRequestInfosInput: SearchExamLocationRequestInfosInputType;
};


export type QueryEcSearchExamRoomRequestInfosArgs = {
  searchExamRoomRequestInfosInput: SearchExamRoomRequestInfosInputType;
};


export type QueryEcSearchExamineeEKycStatusesInExamEventArgs = {
  searchExamineeEKycStatusesInExamEvent: SearchExamineeEKycStatusesInExamEventInput;
};


export type QueryEcSearchExamineeStatusesInExamEventArgs = {
  searchExamineeStatusesInExamEvent: SearchExamineeStatusesInExamEventInput;
};


export type QueryEcSearchLocationAuditLogArgs = {
  SearchLocationAuditLogInput: SearchLocationAuditLogInput;
};


export type QueryEcSearchProctorAuditLogArgs = {
  SearchProctorAuditLogInput: SearchProctorAuditLogInput;
};


export type QueryEcSearchSetPortalExamResultFilesArgs = {
  SearchSETPortalExamResultFilesInput: SearchSetPortalExamResultFilesInput;
};


export type QueryEcSearchTimeExtendedExamEventSessionExamineesArgs = {
  SearchTimeExtendedExamEventSessionExamineeInput: SearchTimeExtendedExamEventSessionExamineeInput;
};


export type QueryEcValidateExamEventsCreationArgs = {
  ValidateExamEventsCreationInput: ValidateExamEventsCreationInput;
};


export type QueryGetAppRoleAppPermissionsArgs = {
  appRoleId: Scalars['String']['input'];
};


export type QueryGetAppRolesArgs = {
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search: InputMaybe<AppRoleSearchInput>;
};


export type QueryGetUserAppRoleViewArgs = {
  appRoleId: InputMaybe<Scalars['String']['input']>;
  invertRoleFilter?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search?: InputMaybe<SearchInput>;
};


export type QuerySuGetAppRoleArgs = {
  appRoleId: Scalars['String']['input'];
};


export type QuerySuUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryValidateTokenArgs = {
  token: Scalars['String']['input'];
};

export type QuestionnaireSettings = {
  __typename?: 'QuestionnaireSettings';
  templateId: Maybe<QuestionnaireTemplateId>;
};

export type QuestionnaireSettingsInput = {
  templateId?: InputMaybe<QuestionnaireTemplateId>;
};

export enum QuestionnaireTemplateId {
  TemplateA = 'TEMPLATE_A',
  TemplateB = 'TEMPLATE_B',
  TemplateC = 'TEMPLATE_C'
}

export type QuickCreateInput = {
  blockedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QuickCreateUserObjectType = {
  __typename?: 'QuickCreateUserObjectType';
  appRolesResponse: AssignUserAppRolesMutationResponse;
  code: Scalars['String']['output'];
  createdUser: UserAppRoleView;
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RamSizeOption = {
  __typename?: 'RamSizeOption';
  otherDetail: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type RawUser = {
  __typename?: 'RawUser';
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['String']['output']>;
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Scalars['Boolean']['output'];
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type RegisterExamineeWithAlternativeDocumentInput = {
  examEventExamineeId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  middlename?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  registrationDocType: RegistrationDocType;
  title: Scalars['String']['input'];
};

export type RegisterExamineeWithAlternativeDocumentOutput = {
  __typename?: 'RegisterExamineeWithAlternativeDocumentOutput';
  message: Scalars['String']['output'];
};

export type RegisterForeignerExamineeWithAlternativeDocument = {
  __typename?: 'RegisterForeignerExamineeWithAlternativeDocument';
  message: Scalars['String']['output'];
};

export type RegisterForeignerExamineeWithAlternativeDocumentInput = {
  countryCode: ExamineeCountryCode;
  examEventExamineeId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  middlename?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type RegistrationDoc = {
  __typename?: 'RegistrationDoc';
  details: RegistrationDocDetails;
  fileName: Maybe<Scalars['String']['output']>;
  type: RegistrationDocType;
};

export type RegistrationDocDetails = {
  __typename?: 'RegistrationDocDetails';
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum RegistrationDocType {
  CitizenCard = 'CITIZEN_CARD',
  DigitalDocument = 'DIGITAL_DOCUMENT',
  DipChip = 'DIP_CHIP',
  DriverLicense = 'DRIVER_LICENSE',
  Passport = 'PASSPORT'
}

export enum RegistrationStatus {
  Canceled = 'CANCELED',
  OpenForRegistration = 'OPEN_FOR_REGISTRATION',
  RegistrationClosed = 'REGISTRATION_CLOSED',
  Scheduled = 'SCHEDULED',
  SessionFull = 'SESSION_FULL',
  TemporarilyClosed = 'TEMPORARILY_CLOSED'
}

export enum RegistrationType {
  InHouse = 'IN_HOUSE',
  Public = 'PUBLIC'
}

export type ReinstateExamEventExamineeInput = {
  examEventExamineeId: Scalars['String']['input'];
  remark: Scalars['String']['input'];
};

export type ReinstateExamEventExamineeOutput = {
  __typename?: 'ReinstateExamEventExamineeOutput';
  examEventExaminee: ExamEventExaminee;
};

export type ResendCertificateEmailInput = {
  email: Scalars['String']['input'];
  examEventExamineeId: Scalars['String']['input'];
};

export type ResendCertificateEmailOutput = {
  __typename?: 'ResendCertificateEmailOutput';
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export type ResendEKycRequestEmailInput = {
  examEventExamineeId: Scalars['String']['input'];
};

export type ResendEKycRequestEmailOutput = {
  __typename?: 'ResendEKycRequestEmailOutput';
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export type ResendResetPasswordEmailOutputObjectType = {
  __typename?: 'ResendResetPasswordEmailOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResendResetPasswordUserLockedOutputObjectType = {
  __typename?: 'ResendResetPasswordUserLockedOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordOutputObjectType = {
  __typename?: 'ResetPasswordOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetUserTwoFactorInput = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ResetUserTwoFactorOutputObjectType = {
  __typename?: 'ResetUserTwoFactorOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user: UserAppRoleView;
};

export type ResultDisplaySettings = {
  __typename?: 'ResultDisplaySettings';
  examResult: Scalars['Boolean']['output'];
};

export type ResultDisplaySettingsInput = {
  examResult: Scalars['Boolean']['input'];
};

export type ResultSendSettings = {
  __typename?: 'ResultSendSettings';
  portal: Scalars['Boolean']['output'];
};

export type ResultSendSettingsInput = {
  portal: Scalars['Boolean']['input'];
};

export type RetireRoomByIdInput = {
  retiredRemark: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
};

export type RetireRoomByIdOutput = {
  __typename?: 'RetireRoomByIdOutput';
  room: Room;
};

export type RevokeExamCenterLocationByIdInput = {
  examCenterLocationId: Scalars['String']['input'];
  remark: Scalars['String']['input'];
};

export type RevokeExamCenterLocationByIdOutput = {
  __typename?: 'RevokeExamCenterLocationByIdOutput';
  code: RevokeExamCenterLocationByIdResponseCode;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum RevokeExamCenterLocationByIdResponseCode {
  HasUpcomingReservations = 'HAS_UPCOMING_RESERVATIONS',
  InvalidType = 'INVALID_TYPE',
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

export type Room = {
  __typename?: 'Room';
  building: Building;
  buildingId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  examRoomComputerInfo: Maybe<ExamRoomComputerInfo>;
  examRoomPhysicalInfo: Maybe<ExamRoomPhysicalInfo>;
  floor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  retiredAt: Maybe<Scalars['DateTime']['output']>;
  retiredBy: Maybe<Scalars['String']['output']>;
  retiredByUser: Maybe<RawUser>;
  retiredRemark: Maybe<Scalars['String']['output']>;
  roomNumber: Maybe<Scalars['String']['output']>;
  seat: Scalars['Int']['output'];
  status: RoomStatus;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Maybe<Scalars['String']['output']>;
  updatedUser: Maybe<RawUser>;
};

export type RoomReservationSummary = {
  __typename?: 'RoomReservationSummary';
  endedAt: Scalars['DateTime']['output'];
  examCenterCode: Scalars['String']['output'];
  reservationCount: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export enum RoomStatus {
  Active = 'ACTIVE',
  Retired = 'RETIRED'
}

export type SetPortalExamResultFile = {
  __typename?: 'SETPortalExamResultFile';
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['String']['output'];
};

export type SaveExamCenterProctorRequestAsDraftFileNameInput = {
  originalFileName: Scalars['String']['input'];
  uploadFileName: Scalars['String']['input'];
};

export type SaveExamCenterProctorRequestAsDraftInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  agreementFileNames: Array<SaveExamCenterProctorRequestAsDraftFileNameInput>;
  department?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  examCenterCode: Scalars['String']['input'];
  firstNameEn: Scalars['String']['input'];
  firstNameTh: Scalars['String']['input'];
  id: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
  idType: ExamCenterProctorRequestIdType;
  lastNameEn: Scalars['String']['input'];
  lastNameTh: Scalars['String']['input'];
  middleNameEn?: InputMaybe<Scalars['String']['input']>;
  middleNameTh?: InputMaybe<Scalars['String']['input']>;
  personalInfoFileNames: Array<SaveExamCenterProctorRequestAsDraftFileNameInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  startedAt: Scalars['DateTime']['input'];
  titleEn: Scalars['String']['input'];
  titleTh: Scalars['String']['input'];
  type: ExamCenterProctorRequestType;
};

export type SaveExamCenterProctorRequestAsDraftOutput = {
  __typename?: 'SaveExamCenterProctorRequestAsDraftOutput';
  examCenterProctorRequest: ExamCenterProctorRequest;
};

export type SaveExamCenterProctorRequestAsRejectedFileNameInput = {
  originalFileName: Scalars['String']['input'];
  uploadFileName: Scalars['String']['input'];
};

export type SaveExamCenterProctorRequestAsRejectedInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  agreementFileNames: Array<SaveExamCenterProctorRequestAsRejectedFileNameInput>;
  department?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  examCenterCode: Scalars['String']['input'];
  firstNameEn: Scalars['String']['input'];
  firstNameTh: Scalars['String']['input'];
  id: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
  idType: ExamCenterProctorRequestIdType;
  lastNameEn: Scalars['String']['input'];
  lastNameTh: Scalars['String']['input'];
  middleNameEn?: InputMaybe<Scalars['String']['input']>;
  middleNameTh?: InputMaybe<Scalars['String']['input']>;
  personalInfoFileNames: Array<SaveExamCenterProctorRequestAsRejectedFileNameInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  startedAt: Scalars['DateTime']['input'];
  titleEn: Scalars['String']['input'];
  titleTh: Scalars['String']['input'];
};

export type SaveExamCenterProctorRequestAsRejectedOutput = {
  __typename?: 'SaveExamCenterProctorRequestAsRejectedOutput';
  examCenterProctorRequest: ExamCenterProctorRequest;
};

export type SearchAssignableExamCoursesInput = {
  examCenterCode: Scalars['String']['input'];
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchAssignableExamCoursesOutput = {
  __typename?: 'SearchAssignableExamCoursesOutput';
  examCourses: Array<ExamCourse>;
  total: Scalars['Float']['output'];
};

export type SearchAvailableExamCenterManagerUsersFilterInput = {
  searchText?: InputMaybe<SearchTextInput>;
};

export type SearchAvailableExamCenterManagerUsersInput = {
  filter?: InputMaybe<SearchAvailableExamCenterManagerUsersFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchAvailableExamCenterManagerUsersOutput = {
  __typename?: 'SearchAvailableExamCenterManagerUsersOutput';
  total: Scalars['Int']['output'];
  users: Array<RawUser>;
};

export type SearchAvailableExamCenterProctorsByTimeFrameInput = {
  endedAt: Scalars['DateTime']['input'];
  searchOptions?: InputMaybe<SearchExamCenterProctorsInput>;
  startedAt: Scalars['DateTime']['input'];
};

export type SearchAvailableExamCenterProctorsByTimeFrameOutput = {
  __typename?: 'SearchAvailableExamCenterProctorsByTimeFrameOutput';
  examCenterProctors: Array<ExamCenterProctor>;
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchBlockedUsersInput = {
  blockedTypes?: InputMaybe<Array<BlockedRecordBlockedType>>;
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchBlockedUsersOutput = {
  __typename?: 'SearchBlockedUsersOutput';
  blockedUsers: Array<BlockedUser>;
  total: Scalars['Float']['output'];
};

export type SearchExamCenterCoursesInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamCenterCoursesOutput = {
  __typename?: 'SearchExamCenterCoursesOutput';
  examCenterCourses: Array<ExamCenterCourse>;
  total: Scalars['Float']['output'];
};

export type SearchExamCenterLocationsUsageInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamCenterLocationsUsageOutput = {
  __typename?: 'SearchExamCenterLocationsUsageOutput';
  examCenterLocations: Array<ExamCenterLocation>;
  total: Scalars['Float']['output'];
};

export type SearchExamCenterProctorRequestsInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamCenterProctorRequestsOutput = {
  __typename?: 'SearchExamCenterProctorRequestsOutput';
  examCenterProctorRequests: Array<ExamCenterProctorRequest>;
  total: Scalars['Int']['output'];
};

export type SearchExamCenterProctorsInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamCenterProctorsOutput = {
  __typename?: 'SearchExamCenterProctorsOutput';
  examCenterProctors: Array<ExamCenterProctor>;
  total: Scalars['Int']['output'];
};

export type SearchExamCenterRoomsInput = {
  examCenterCode: Scalars['String']['input'];
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamCenterRoomsOutput = {
  __typename?: 'SearchExamCenterRoomsOutput';
  rooms: Array<ExamCenterRoom>;
  total: Scalars['Int']['output'];
};

export type SearchExamCentersInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamCentersOutput = {
  __typename?: 'SearchExamCentersOutput';
  examCenters: Array<ExamCenter>;
  total: Scalars['Int']['output'];
};

export type SearchExamCoursesInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamCoursesOutput = {
  __typename?: 'SearchExamCoursesOutput';
  examCourses: Array<ExamCourse>;
  total: Scalars['Float']['output'];
};

export type SearchExamEventAuditLogInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamEventAuditLogOutput = {
  __typename?: 'SearchExamEventAuditLogOutput';
  examEventAuditLogs: Array<ExamEventAuditLog>;
  total: Scalars['Float']['output'];
};

export type SearchExamEventExamineesInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamEventExamineesOutput = {
  __typename?: 'SearchExamEventExamineesOutput';
  examEventExaminees: Array<ExamEventExaminee>;
  total: Scalars['Int']['output'];
};

export type SearchExamEventsWithQuestionnairesInput = {
  endDate: Scalars['DateTime']['input'];
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  paging: PagingInput;
  startDate: Scalars['DateTime']['input'];
  templateId: QuestionnaireTemplateId;
};

export type SearchExamEventsWithQuestionnairesOutput = {
  __typename?: 'SearchExamEventsWithQuestionnairesOutput';
  data: Array<ExamEventWithQuestionnaireCount>;
  total: Scalars['Int']['output'];
};

export type SearchExamLocationRequestInfosInputType = {
  filter?: InputMaybe<SearchFilterInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamLocationRequestInfosOutput = {
  __typename?: 'SearchExamLocationRequestInfosOutput';
  examLocationRequestInfos: Array<ExamLocationRequestInfo>;
  total: Scalars['Int']['output'];
};

export type SearchExamRoomRequestInfosInputType = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
  provinceId?: InputMaybe<Scalars['String']['input']>;
  searchLocationName?: InputMaybe<Scalars['String']['input']>;
};

export type SearchExamRoomRequestInfosOutput = {
  __typename?: 'SearchExamRoomRequestInfosOutput';
  examRoomRequestInfos: Array<ExamRoomRequestInfo>;
  total: Scalars['Int']['output'];
};

export type SearchExamineeEKycStatusesInExamEventInput = {
  eKycStatuses?: InputMaybe<Array<EKycVerificationStatus>>;
  examEventId: Scalars['String']['input'];
  filter?: InputMaybe<SearchFilterInput>;
  paging?: InputMaybe<PagingInput>;
  searchExaminee?: InputMaybe<SearchExamineeInput>;
};

export type SearchExamineeEKycStatusesInExamEventOutput = {
  __typename?: 'SearchExamineeEKycStatusesInExamEventOutput';
  examineeEKycStatuses: Array<ExamineeEKycStatusInExamEvent>;
  total: Scalars['Float']['output'];
};

export type SearchExamineeInput = {
  filter?: InputMaybe<SearchFilterInput>;
};

export type SearchExamineeStatusesInExamEventInput = {
  examEventId: Scalars['String']['input'];
  filter?: InputMaybe<SearchFilterInput>;
  paging?: InputMaybe<PagingInput>;
  searchExaminee?: InputMaybe<SearchExamineeInput>;
};

export type SearchExamineeStatusesInExamEventOutput = {
  __typename?: 'SearchExamineeStatusesInExamEventOutput';
  examEventExaminees: Array<ExamEventExaminee>;
  total: Scalars['Float']['output'];
};

export type SearchFilterInput = {
  conditions?: InputMaybe<Array<FilterConditionInput>>;
  searchText?: InputMaybe<SearchTextInput>;
};

export type SearchInput = {
  operator: OperatorType;
  value: Scalars['String']['input'];
};

export type SearchLocationAuditLogInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchLocationAuditLogOutput = {
  __typename?: 'SearchLocationAuditLogOutput';
  locationAuditLogs: Array<LocationAuditLog>;
  total: Scalars['Float']['output'];
};

export type SearchProctorAuditLogInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchProctorAuditLogOutput = {
  __typename?: 'SearchProctorAuditLogOutput';
  proctorAuditLogs: Array<ProctorAuditLog>;
  total: Scalars['Float']['output'];
};

export type SearchRoomsInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchRoomsOutput = {
  __typename?: 'SearchRoomsOutput';
  rooms: Array<Room>;
  total: Scalars['Int']['output'];
};

export type SearchSetPortalExamResultFilesInput = {
  filter?: InputMaybe<SearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchSetPortalExamResultFilesOutput = {
  __typename?: 'SearchSETPortalExamResultFilesOutput';
  setPortalExamResultFiles: Array<SetPortalExamResultFile>;
  total: Scalars['Int']['output'];
};

export type SearchTextInput = {
  /** Fields to search in */
  fields: Array<Scalars['String']['input']>;
  /** Search text */
  value: Scalars['String']['input'];
};

export type SearchTimeExtendedExamEventSessionExamineeInput = {
  examEventId: Scalars['String']['input'];
  paging?: InputMaybe<PagingInput>;
  searchExaminee?: InputMaybe<SearchExamineeInput>;
  sessionId: Scalars['String']['input'];
};

export type SearchTimeExtendedExamEventSessionExamineeOutput = {
  __typename?: 'SearchTimeExtendedExamEventSessionExamineeOutput';
  extendedExamEventSessionExaminees: Array<TimeExtendedExamEventSessionExaminee>;
  total: Scalars['Int']['output'];
};

export type SecurityDetails = {
  __typename?: 'SecurityDetails';
  antivirusConfigForSEB: Maybe<Scalars['String']['output']>;
  antivirusProgram: Maybe<AntivirusProgramOption>;
  antivirusUpdateCadence: Maybe<UpdateCadenceOption>;
  isSyncedWithThaiServer: Maybe<Scalars['Boolean']['output']>;
  robotTestImages: Maybe<Array<Scalars['String']['output']>>;
  timeSyncImages: Maybe<Array<Scalars['String']['output']>>;
  usbPortCheck: Maybe<Scalars['String']['output']>;
};

export enum SendResultToWrStatus {
  Failed = 'FAILED',
  NotSent = 'NOT_SENT',
  Sent = 'SENT'
}

export type StorageObject = {
  __typename?: 'StorageObject';
  bucket: Scalars['String']['output'];
  fileName: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  provider: StorageProvider;
};

export enum StorageObjectProvider {
  Gcs = 'GCS'
}

export type StorageOption = {
  __typename?: 'StorageOption';
  otherDetail: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export enum StorageProvider {
  GcloudStorage = 'GCLOUD_STORAGE'
}

export type SubmitExamCenterProctorRequestInput = {
  id: Scalars['String']['input'];
};

export type SubmitExamCenterProctorRequestOutput = {
  __typename?: 'SubmitExamCenterProctorRequestOutput';
  examCenterProctorRequest: ExamCenterProctorRequest;
};

export type SubmitExamLocationRequestInfoInputType = {
  id: Scalars['String']['input'];
};

export type SubmitExamLocationRequestInfoOutput = {
  __typename?: 'SubmitExamLocationRequestInfoOutput';
  details: Scalars['JSON']['output'];
  isSuccess: Scalars['Boolean']['output'];
};

export type SubmitExamRoomRequestInputType = {
  id: Scalars['String']['input'];
};

export type SubmitExamRoomRequestOutput = {
  __typename?: 'SubmitExamRoomRequestOutput';
  hasComputerInfoError: Scalars['Boolean']['output'];
  hasPhysicalInfoError: Scalars['Boolean']['output'];
  isSuccess: Scalars['Boolean']['output'];
};

export type SubmitReviewExamCenterProctorRequestInput = {
  examCenterProctorRequestId: Scalars['String']['input'];
};

export type SubmitReviewExamCenterProctorRequestOutput = {
  __typename?: 'SubmitReviewExamCenterProctorRequestOutput';
  examCenterProctorRequest: ExamCenterProctorRequest;
};

export type SubmitReviewExamRoomRequestInfoInputType = {
  examRoomRequestInfoId: Scalars['String']['input'];
};

export type SubmitReviewExamRoomRequestInfoOutput = {
  __typename?: 'SubmitReviewExamRoomRequestInfoOutput';
  examRoomRequestInfo: ExamRoomRequestInfo;
};

export type SyncExamEventExamineeWithWrOutput = {
  __typename?: 'SyncExamEventExamineeWithWrOutput';
  errors: Maybe<Array<ExamineeValidationError>>;
  success: Scalars['Boolean']['output'];
  summary: SyncExamEventExamineeWithWrSummary;
};

export type SyncExamEventExamineeWithWrSummary = {
  __typename?: 'SyncExamEventExamineeWithWrSummary';
  canceledExamineeCount: Scalars['Int']['output'];
  validExamineeCount: Scalars['Int']['output'];
};

export enum TagCategory {
  AllSubTopic = 'ALL_SUB_TOPIC',
  Bloom = 'BLOOM',
  Calculation = 'CALCULATION',
  Chapter = 'CHAPTER',
  CognitiveDomain = 'COGNITIVE_DOMAIN',
  Course = 'COURSE',
  CourseCode = 'COURSE_CODE',
  Difficulty = 'DIFFICULTY',
  ExamCampaign = 'EXAM_CAMPAIGN',
  ExamType = 'EXAM_TYPE',
  Grade = 'GRADE',
  Group = 'GROUP',
  Indicator = 'INDICATOR',
  ItemSet = 'ITEM_SET',
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  NonSpecificTopic = 'NON_SPECIFIC_TOPIC',
  Objective = 'OBJECTIVE',
  Owner = 'OWNER',
  Part = 'PART',
  QbankStructureLevel = 'QBANK_STRUCTURE_LEVEL',
  QuestionExamType = 'QUESTION_EXAM_TYPE',
  QuestionType = 'QUESTION_TYPE',
  QBankStructure = 'Q_BANK_STRUCTURE',
  QBankStructureLevelItem = 'Q_BANK_STRUCTURE_LEVEL_ITEM',
  QConfig = 'Q_CONFIG',
  SatExamModule = 'SAT_EXAM_MODULE',
  Section = 'SECTION',
  Single = 'SINGLE',
  Subject = 'SUBJECT',
  Subsection = 'SUBSECTION',
  Subtopic = 'SUBTOPIC',
  SubTopic = 'SUB_TOPIC',
  Tag = 'TAG',
  Term = 'TERM',
  Topic = 'TOPIC'
}

export type TimeExtendedExamEventSessionExaminee = {
  __typename?: 'TimeExtendedExamEventSessionExaminee';
  autoExtendDurationInMs: Maybe<Scalars['Int']['output']>;
  examEventExaminee: ExamEventExaminee;
  examEventExamineeId: Scalars['String']['output'];
  examEventSessionId: Scalars['String']['output'];
  examStartedAt: Maybe<Scalars['DateTime']['output']>;
  examStatus: ProgressStatus;
  examSubmitStatus: ProgressStatus;
  examinee: Examinee;
  examineeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  loggedInAt: Maybe<Scalars['DateTime']['output']>;
  loginStatus: ProgressStatus;
  manualExtendDurationInMs: Maybe<Scalars['Int']['output']>;
  questionnaireStatus: ProgressStatus;
  refExamPaperId: Scalars['String']['output'];
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  submittedQuestionnaireAt: Maybe<Scalars['DateTime']['output']>;
  timeExtensionRemark: Maybe<Scalars['String']['output']>;
  totalExtendedDurationInMs: Scalars['Int']['output'];
};

export type TokenStatus = {
  __typename?: 'TokenStatus';
  email: Maybe<Scalars['String']['output']>;
  scopes: Maybe<Array<Scalars['String']['output']>>;
  ttl: Maybe<Scalars['Float']['output']>;
  twoFactorStatus: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type UnassignExamsInput = {
  examCourseCodes: Array<Scalars['String']['input']>;
  month: Scalars['Float']['input'];
  year: Scalars['Float']['input'];
};

export type UnassignExamsOutput = {
  __typename?: 'UnassignExamsOutput';
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export type UnassignUserAppRoleInput = {
  appRoleId: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UnassignUserAppRolesInput = {
  appRoleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UnassignUserAppRolesMutationResponse = {
  __typename?: 'UnassignUserAppRolesMutationResponse';
  appRoles: Array<AppRole>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UnlockUserTwoFactorInput = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UnlockUserTwoFactorOutputObjectType = {
  __typename?: 'UnlockUserTwoFactorOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user: UserAppRoleView;
};

export type UpdateAppRoleAppPermissionsMutationResponse = {
  __typename?: 'UpdateAppRoleAppPermissionsMutationResponse';
  appPermission: Array<AppPermission>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateAppRoleInput = {
  appRoleId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateAppRoleMutationResponse = {
  __typename?: 'UpdateAppRoleMutationResponse';
  appRole: AppRole;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateBlockedRecordInfo = {
  blockedReason?: InputMaybe<Scalars['String']['input']>;
  blockedScope?: InputMaybe<BlockedRecordBlockedScope>;
  blockedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  enforcementEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  examCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  position?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlockedRecordInput = {
  blockedRecordId: Scalars['String']['input'];
  info: UpdateBlockedRecordInfo;
};

export type UpdateBlockedRecordOutput = {
  __typename?: 'UpdateBlockedRecordOutput';
  blockedRecord: BlockedRecord;
};

export type UpdateBlockedUserInfoInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlockedUserInput = {
  blockedUserId: Scalars['String']['input'];
  info: UpdateBlockedUserInfoInput;
};

export type UpdateBlockedUserOutput = {
  __typename?: 'UpdateBlockedUserOutput';
  blockedUser: BlockedUser;
};

export type UpdateCadenceOption = {
  __typename?: 'UpdateCadenceOption';
  otherDetail: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type UpdateEKycStatusInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  examEventId: Scalars['String']['input'];
  examineeId: Scalars['String']['input'];
  status: EKycVerificationStatus;
  verificationCheckList?: InputMaybe<VerificationCheckListInput>;
};

export type UpdateEKycStatusOutput = {
  __typename?: 'UpdateEKycStatusOutput';
  eKycInfo: EKycInfo;
  examinee: Examinee;
};

export type UpdateExamCenterInput = {
  addressEN: Scalars['String']['input'];
  addressTH: Scalars['String']['input'];
  email: Scalars['String']['input'];
  examCenterCode: Scalars['String']['input'];
  examResultRecipientEmail: Scalars['String']['input'];
  phoneEN: Scalars['String']['input'];
  phoneTH: Scalars['String']['input'];
  website: Scalars['String']['input'];
};

export type UpdateExamCenterOutput = {
  __typename?: 'UpdateExamCenterOutput';
  examCenter: ExamCenter;
};

export type UpdateExamCenterProctorFromExamCenterManagerInfoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<UpdateExamCenterProctorFromExamCenterManagerMetadataInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExamCenterProctorFromExamCenterManagerInput = {
  examCenterProctorId: Scalars['String']['input'];
  info: UpdateExamCenterProctorFromExamCenterManagerInfoInput;
};

export type UpdateExamCenterProctorFromExamCenterManagerMetadataInput = {
  department?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExamCenterProctorFromExamCenterManagerOutput = {
  __typename?: 'UpdateExamCenterProctorFromExamCenterManagerOutput';
  examCenterProctor: ExamCenterProctor;
};

export type UpdateExamCenterProctorFromProctorAdminInfoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstNameEn?: InputMaybe<Scalars['String']['input']>;
  firstNameTh?: InputMaybe<Scalars['String']['input']>;
  lastNameEn?: InputMaybe<Scalars['String']['input']>;
  lastNameTh?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<UpdateExamCenterProctorFromProctorAdminMetadataInput>;
  middleNameEn?: InputMaybe<Scalars['String']['input']>;
  middleNameTh?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  titleEn?: InputMaybe<Scalars['String']['input']>;
  titleTh?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExamCenterProctorFromProctorAdminInput = {
  examCenterProctorId: Scalars['String']['input'];
  info: UpdateExamCenterProctorFromProctorAdminInfoInput;
};

export type UpdateExamCenterProctorFromProctorAdminMetadataInput = {
  department?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExamCenterProctorFromProctorAdminOutput = {
  __typename?: 'UpdateExamCenterProctorFromProctorAdminOutput';
  examCenterProctor: ExamCenterProctor;
};

export type UpdateExamCourseSettingsInput = {
  id: Scalars['String']['input'];
  settings: ExamCourseSettingsInput;
};

export type UpdateExamCourseSettingsOutput = {
  __typename?: 'UpdateExamCourseSettingsOutput';
  examCourse: ExamCourse;
};

export type UpdateExamEventDataInput = {
  examLocationId?: InputMaybe<Scalars['String']['input']>;
  examType?: InputMaybe<ExamType>;
  metadata?: InputMaybe<UpdateExamEventMetadataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  proctorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  registrationEndedAt?: InputMaybe<Scalars['DateTime']['input']>;
  registrationStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  registrationType?: InputMaybe<RegistrationType>;
  roomIds?: InputMaybe<Array<Scalars['String']['input']>>;
  seat?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateExamEventExamineeRegistrationStatusInput = {
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  examEventExamineeId: Scalars['String']['input'];
  examineeRegistrationStatus: ExamineeRegistrationStatus;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExamEventExamineeRegistrationStatusOutput = {
  __typename?: 'UpdateExamEventExamineeRegistrationStatusOutput';
  examEventExaminee: ExamEventExaminee;
};

export type UpdateExamEventInput = {
  data?: InputMaybe<UpdateExamEventDataInput>;
  id: Scalars['String']['input'];
  toRegistrationStatus?: InputMaybe<UpdateExamEventRegistrationStatusInput>;
};

export type UpdateExamEventMetadataInput = {
  applicantGroup?: InputMaybe<ApplicantGroupInput>;
};

export type UpdateExamEventOutput = {
  __typename?: 'UpdateExamEventOutput';
  examEvent: ExamEvent;
};

export type UpdateExamEventRegistrationStatusInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  status: RegistrationStatus;
};

export type UpdateExamLocationRequestInfoInputType = {
  buildingId?: InputMaybe<Scalars['String']['input']>;
  buildingName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameTh?: InputMaybe<Scalars['String']['input']>;
  provinceId: Scalars['String']['input'];
};

export type UpdateExamLocationRequestInfoOutput = {
  __typename?: 'UpdateExamLocationRequestInfoOutput';
  examLocationRequestInfo: ExamLocationRequestInfo;
};

export type UpdateExamRoomInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateExamRoomOutput = {
  __typename?: 'UpdateExamRoomOutput';
  examRoom: Room;
};

export type UpdateExamRoomRequestInfoInputType = {
  floor: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  seatCount: Scalars['Float']['input'];
};

export type UpdateExamRoomRequestInfoOutput = {
  __typename?: 'UpdateExamRoomRequestInfoOutput';
  examRoomRequestInfo: ExamRoomRequestInfo;
};

export type UpdateUserAppRoleByNameMutationResponse = {
  __typename?: 'UpdateUserAppRoleByNameMutationResponse';
  appRoles: Maybe<Array<AppRole>>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserAppRoleByNamesInput = {
  appRoleNames: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateUserAppRolesInput = {
  appRoleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateUserAppRolesMutationResponse = {
  __typename?: 'UpdateUserAppRolesMutationResponse';
  appRoles: Maybe<Array<AppRole>>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserInput = {
  appRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  organizationInfo?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserOutputObjectType = {
  __typename?: 'UpdateUserOutputObjectType';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['JSON']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type UpdateUserStatusInput = {
  status: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateUserStatusOutputObjectType = {
  __typename?: 'UpdateUserStatusOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedUser: UserAppRoleView;
};

export enum UploadableContentType {
  Gif = 'gif',
  Jpeg = 'jpeg',
  Png = 'png',
  Webp = 'webp'
}

export type UsBoGetTokenStatusResponse = {
  __typename?: 'UsBoGetTokenStatusResponse';
  result: TokenStatus;
};

export type UsBoUser = {
  __typename?: 'UsBoUser';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  isDisabled: Maybe<Scalars['Boolean']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Maybe<Scalars['Boolean']['output']>;
  isVerified: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  newEmail: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['String']['output']>;
  organizationInfo: Maybe<Scalars['JSON']['output']>;
  realm: Maybe<Scalars['String']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  teamIds: Array<Scalars['String']['output']>;
  twoFactorStatus: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type UsBoUserExcludeFieldsInput = {
  additional1?: InputMaybe<Array<Scalars['String']['input']>>;
  additional2?: InputMaybe<Array<Scalars['String']['input']>>;
  additional3?: InputMaybe<Array<Scalars['String']['input']>>;
  additional4?: InputMaybe<Array<Scalars['String']['input']>>;
  additional5?: InputMaybe<Array<Scalars['String']['input']>>;
  additional6?: InputMaybe<Array<Scalars['String']['input']>>;
  additional7?: InputMaybe<Array<Scalars['String']['input']>>;
  additional8?: InputMaybe<Array<Scalars['String']['input']>>;
  additional9?: InputMaybe<Array<Scalars['String']['input']>>;
  additional10?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  firstname?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['String']['input']>>;
  lastname?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceId?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UsBoUserSearchInput = {
  additional1?: InputMaybe<Scalars['String']['input']>;
  additional2?: InputMaybe<Scalars['String']['input']>;
  additional3?: InputMaybe<Scalars['String']['input']>;
  additional4?: InputMaybe<Scalars['String']['input']>;
  additional5?: InputMaybe<Scalars['String']['input']>;
  additional6?: InputMaybe<Scalars['String']['input']>;
  additional7?: InputMaybe<Scalars['String']['input']>;
  additional8?: InputMaybe<Scalars['String']['input']>;
  additional9?: InputMaybe<Scalars['String']['input']>;
  additional10?: InputMaybe<Scalars['String']['input']>;
  blockedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsBoUserSearchResult = {
  __typename?: 'UsBoUserSearchResult';
  total: Scalars['Int']['output'];
  users: Array<UsBoUser>;
};

export type UsUser = {
  __typename?: 'UsUser';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['DateTime']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['DateTime']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['String']['output']>;
  isAdmin: Maybe<Scalars['Boolean']['output']>;
  isDisabled: Maybe<Scalars['Boolean']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Maybe<Scalars['Boolean']['output']>;
  isVerified: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  newEmail: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['String']['output']>;
  organizationInfo: Maybe<Scalars['JSON']['output']>;
  realm: Maybe<Scalars['String']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  teamIds: Array<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type UserAppRoleView = {
  __typename?: 'UserAppRoleView';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['JSON']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type UserAppRoleViewSearchResult = {
  __typename?: 'UserAppRoleViewSearchResult';
  total: Scalars['Int']['output'];
  users: Array<UserAppRoleView>;
};

export enum UserType {
  ClientUser = 'CLIENT_USER',
  UserApi = 'USER_API'
}

export type ValidateExamEventsCreationInput = {
  examCenterCode: Scalars['String']['input'];
  examCourseIds: Array<Scalars['String']['input']>;
  examEventDates: Array<ExamEventDateInput>;
  examLocationId: Scalars['String']['input'];
  examType: ExamType;
  metadata?: InputMaybe<ExamEventMetadataInput>;
  name: Scalars['String']['input'];
  proctorIds: Array<Scalars['String']['input']>;
  registrationType: RegistrationType;
  roomIds: Array<Scalars['String']['input']>;
  seat: Scalars['Int']['input'];
};

export type ValidateExamEventsCreationOutput = {
  __typename?: 'ValidateExamEventsCreationOutput';
  validatedExamEvents: Array<ValidatedExamEvent>;
};

export type ValidateTokenResult = {
  __typename?: 'ValidateTokenResult';
  description: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
};

export type ValidatedExamEvent = {
  __typename?: 'ValidatedExamEvent';
  errorCodes: Array<ExamEventErrorCode>;
  examEndedAt: Scalars['DateTime']['output'];
  examStartedAt: Scalars['DateTime']['output'];
  isValid: Scalars['Boolean']['output'];
  registrationEndedAt: Scalars['DateTime']['output'];
  registrationStartedAt: Scalars['DateTime']['output'];
};

export enum Verdict {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type VerificationCheckListInput = {
  idPhotoClarity: Scalars['Boolean']['input'];
  photoClarity: Scalars['Boolean']['input'];
  photoIdentityMatch: Scalars['Boolean']['input'];
};

export type VerifyCitizenCardInput = {
  dateOfBirth: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  idCode: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type VerifyCitizenCardOutput = {
  __typename?: 'VerifyCitizenCardOutput';
  dopaVerificationStatus: DopaVerificationStatus;
  message: Scalars['String']['output'];
};

export type VerifyUserTwoFactorInput = {
  code: Scalars['String']['input'];
};

export type VerifyUserTwoFactorOutputObjectType = {
  __typename?: 'VerifyUserTwoFactorOutputObjectType';
  code: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type WebBrowserOption = {
  __typename?: 'WebBrowserOption';
  otherDetail: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type WithOtherDetail = {
  __typename?: 'WithOtherDetail';
  otherDetail: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type SyncExamEventExamineeWithWrInput = {
  examEventId: Scalars['String']['input'];
};

export type CreateAnnouncementMutationVariables = Exact<{
  createAnnouncementInput: CreateAnnouncementInput;
}>;


export type CreateAnnouncementMutation = { __typename?: 'Mutation', ecCreateAnnouncement: { __typename?: 'CreateAnnouncementOutput', announcement: { __typename?: 'Announcement', id: string, title: string, content: string | null, link: string | null, announcedAt: Date | null } } };

export type GetAllAnnouncementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAnnouncementsQuery = { __typename?: 'Query', ecGetAllAnnouncements: { __typename?: 'GetAllAnnouncementsOutput', announcements: Array<{ __typename?: 'Announcement', id: string, title: string, content: string | null, link: string | null, announcedAt: Date | null }> } };

export type AddBlockedRecordMutationVariables = Exact<{
  input: AddBlockedRecordInput;
}>;


export type AddBlockedRecordMutation = { __typename?: 'Mutation', ecAddBlockedRecord: { __typename?: 'AddBlockedRecordOutput', blockedRecord: { __typename?: 'BlockedRecord', id: string, blockedUserId: string } } };

export type GetBlockedRecordByBlockedUserIdQueryVariables = Exact<{
  input: GetBlockedUserByIdInput;
}>;


export type GetBlockedRecordByBlockedUserIdQuery = { __typename?: 'Query', ecGetBlockedUserById: { __typename?: 'GetBlockedUserByIdOutput', blockedUser: { __typename?: 'BlockedUser', id: string, title: string, firstName: string, middleName: string | null, lastName: string, idNumber: string, phoneNumber: string | null, blockedRecords: Array<{ __typename?: 'BlockedRecord', id: string, email: string | null, blockedType: BlockedRecordBlockedType, blockedScope: BlockedRecordBlockedScope, blockedAt: Date, blockedUntil: Date | null, blockedReason: string | null, examEvent: { __typename?: 'ExamEvent', sessions: Array<{ __typename?: 'ExamEventSession', round: number, startedAt: Date, endedAt: Date }> } | null, metadata: { __typename?: 'BlockedRecordMetadata', position: string | null, department: string | null, enforcementEndDate: Date | null, examSession: { __typename?: 'BlockedRecordExamSession', roundNumber: number, startedAt: Date, endedAt: Date } | null, documentStorageObjects: Array<{ __typename?: 'StorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }> | null }, examCenter: { __typename?: 'ExamCenter', nameTH: string, code: string } | null, blockedRecordCourses: Array<{ __typename?: 'BlockedRecordCourse', id: string, examCourse: { __typename?: 'ExamCourse', code: string, name: string } | null }> }> } } };

export type UpdateBlockedRecordMutationVariables = Exact<{
  input: UpdateBlockedRecordInput;
}>;


export type UpdateBlockedRecordMutation = { __typename?: 'Mutation', ecUpdateBlockedRecord: { __typename?: 'UpdateBlockedRecordOutput', blockedRecord: { __typename?: 'BlockedRecord', id: string, blockedReason: string | null } } };

export type GetUploadSignedUrlsForBlockedRecordQueryVariables = Exact<{
  getUploadSignedUrlsForBlockedRecordInput: GetUploadSignedUrlsForBlockedRecordInput;
}>;


export type GetUploadSignedUrlsForBlockedRecordQuery = { __typename?: 'Query', ecGetUploadSignedUrlsForBlockedRecord: { __typename?: 'GetUploadSignedUrlsForBlockedRecordOutput', signedUrls: Array<{ __typename?: 'GetUploadSignedUrlsForBlockedRecordSignedUrl', url: string, storageObject: { __typename?: 'StorageObject', fileName: string | null } }> } };

export type GetDownloadSignedUrlForBlockedRecordQueryVariables = Exact<{
  getDownloadSignedUrlForBlockedRecordInput: GetDownloadSignedUrlForBlockedRecordInput;
}>;


export type GetDownloadSignedUrlForBlockedRecordQuery = { __typename?: 'Query', ecGetDownloadSignedUrlForBlockedRecord: { __typename?: 'GetDownloadSignedUrlForBlockedRecordOutput', signedUrls: any } };

export type MarkExamPasserAsCheaterMutationVariables = Exact<{
  markExamPasserAsCheaterInput: MarkExamPasserAsCheaterInput;
}>;


export type MarkExamPasserAsCheaterMutation = { __typename?: 'Mutation', ecMarkExamPasserAsCheater: { __typename?: 'MarkExamPasserAsACheaterOutput', status: GenericResponseStatus, message: string, data: any | null } };

export type SearchBlockedUsersQueryVariables = Exact<{
  searchBlockedUsersInput: SearchBlockedUsersInput;
}>;


export type SearchBlockedUsersQuery = { __typename?: 'Query', ecSearchBlockedUsers: { __typename?: 'SearchBlockedUsersOutput', total: number, blockedUsers: Array<{ __typename?: 'BlockedUser', id: string, title: string, firstName: string, middleName: string | null, lastName: string, idNumber: string, blockedRecords: Array<{ __typename?: 'BlockedRecord', id: string, examCenterCode: string | null, blockedType: BlockedRecordBlockedType, blockedAt: Date, blockedUntil: Date | null }> }> } };

export type GetBlockedUserByIdQueryVariables = Exact<{
  input: GetBlockedUserByIdInput;
}>;


export type GetBlockedUserByIdQuery = { __typename?: 'Query', ecGetBlockedUserById: { __typename?: 'GetBlockedUserByIdOutput', blockedUser: { __typename?: 'BlockedUser', id: string, title: string, firstName: string, middleName: string | null, lastName: string, idNumber: string, email: string | null, phoneNumber: string | null, blockedRecords: Array<{ __typename?: 'BlockedRecord', id: string, blockedType: BlockedRecordBlockedType, blockedScope: BlockedRecordBlockedScope, blockedAt: Date, blockedUntil: Date | null, blockedReason: string | null, metadata: { __typename?: 'BlockedRecordMetadata', position: string | null, department: string | null, enforcementEndDate: Date | null, examSession: { __typename?: 'BlockedRecordExamSession', roundNumber: number, startedAt: Date, endedAt: Date } | null }, blockedRecordCourses: Array<{ __typename?: 'BlockedRecordCourse', id: string, examCourse: { __typename?: 'ExamCourse', code: string, name: string } | null }>, examCenter: { __typename?: 'ExamCenter', code: string, nameTH: string } | null, examEvent: { __typename?: 'ExamEvent', id: string, examStartedAt: Date, examEndedAt: Date, roundNumber: number } | null }> } } };

export type UpdateBlockedUserMutationVariables = Exact<{
  updateBlockedUserInput: UpdateBlockedUserInput;
}>;


export type UpdateBlockedUserMutation = { __typename?: 'Mutation', ecUpdateBlockedUser: { __typename?: 'UpdateBlockedUserOutput', blockedUser: { __typename?: 'BlockedUser', id: string } } };

export type ExportBlockedUsersQueryVariables = Exact<{
  exportBlockedUsersInput: ExportBlockedUsersInput;
}>;


export type ExportBlockedUsersQuery = { __typename?: 'Query', ecExportBlockedUsers: { __typename?: 'ExportBlockedUsersOutput', signedUrl: string } };

export type SearchAssignableExamCoursesQueryVariables = Exact<{
  searchAssignableExamCoursesInput: SearchAssignableExamCoursesInput;
}>;


export type SearchAssignableExamCoursesQuery = { __typename?: 'Query', ecSearchAssignableExamCourses: { __typename?: 'SearchAssignableExamCoursesOutput', total: number, examCourses: Array<{ __typename?: 'ExamCourse', id: string, code: string, examId: number, name: string, type: ExamCourseType, language: ExamCourseLanguage }> } };

export type AssignExamCoursesToExamCenterMutationVariables = Exact<{
  assignExamCoursesToExamCenterInput: AssignExamCoursesToExamCenterInput;
}>;


export type AssignExamCoursesToExamCenterMutation = { __typename?: 'Mutation', ecAssignExamCoursesToExamCenter: { __typename?: 'AssignExamCoursesToExamCenterOutput', examCourses: Array<{ __typename?: 'ExamCourse', id: string, code: string, examId: number, name: string, type: ExamCourseType, language: ExamCourseLanguage, enabled: boolean }> } };

export type GetAllExamCenterCoursesQueryVariables = Exact<{
  getAllExamCenterCoursesInput: GetAllExamCenterCoursesInput;
}>;


export type GetAllExamCenterCoursesQuery = { __typename?: 'Query', ecGetAllExamCenterCourses: { __typename?: 'GetAllExamCenterCoursesOutput', examCenterCourses: Array<{ __typename?: 'ExamCenterCourse', examCourse: { __typename?: 'ExamCourse', id: string, name: string, examId: number } }> } };

export type CreateExamRoomRequestInfoMutationVariables = Exact<{
  createExamRoomRequestInfoInput: CreateExamRoomRequestInfoInputType;
}>;


export type CreateExamRoomRequestInfoMutation = { __typename?: 'Mutation', ecCreateExamRoomRequestInfo: { __typename?: 'CreateExamRoomRequestInfoOutput', examRoomRequestInfo: { __typename?: 'ExamRoomRequestInfo', id: string, floor: string, name: string, roomNumber: string | null, seatCount: number } } };

export type UpdateExamRoomRequestInfoMutationVariables = Exact<{
  updateExamRoomRequestInfoInput: UpdateExamRoomRequestInfoInputType;
}>;


export type UpdateExamRoomRequestInfoMutation = { __typename?: 'Mutation', ecUpdateExamRoomRequestInfo: { __typename?: 'UpdateExamRoomRequestInfoOutput', examRoomRequestInfo: { __typename?: 'ExamRoomRequestInfo', id: string, floor: string, name: string, roomNumber: string | null, seatCount: number } } };

export type GetExamRoomRequestInfoByIdQueryVariables = Exact<{
  getExamRoomRequestInfoByIdInput: GetExamRoomRequestInfoByIdInputType;
}>;


export type GetExamRoomRequestInfoByIdQuery = { __typename?: 'Query', ecGetExamRoomRequestInfoById: { __typename?: 'GetExamRoomRequestInfoByIdOutput', examRoomRequestInfo: { __typename?: 'ExamRoomRequestInfo', id: string, examLocationRequestInfoId: string, examCenterCode: string, floor: string, name: string, roomNumber: string | null, seatCount: number, step: ExamLocationRequestWorkflowStepCode | null, taskId: string | null, taskCode: string | null, requestedAt: Date | null, createdAt: Date, examLocationRequestInfo: { __typename?: 'ExamLocationRequestInfo', id: string, provinceId: string, locationId: string | null, nameTh: string | null, nameEn: string | null, buildingId: string | null, buildingName: string | null, editedAt: Date, editedBy: string, createdAt: Date, province: { __typename?: 'Province', id: string, nameTh: string }, building: { __typename?: 'Building', id: string, nameTh: string, nameEn: string | null, locationId: string } | null, editedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }, examRoomRequestComputerInfo: { __typename?: 'ExamRoomRequestComputerInfo', createdAt: Date, examRoomRequestInfoId: string, id: string, info: { __typename?: 'ExamRoomRequestComputerAttributes', computerDetails: { __typename?: 'ComputerDetails', sebVersionStatus: string | null, computerSpecImages: Array<string> | null, computerSeatImages: Array<string> | null, monitor: { __typename?: 'WithOtherDetail', value: string | null, otherDetail: string | null } | null, cpu: { __typename?: 'CpuOption', value: string | null, otherDetail: string | null } | null, ram: { __typename?: 'RamSizeOption', value: string | null, otherDetail: string | null } | null, os: { __typename?: 'OsOption', value: string | null, otherDetail: string | null } | null, storage: { __typename?: 'StorageOption', value: string | null, otherDetail: string | null } | null, webBrowser: { __typename?: 'WebBrowserOption', value: string | null, otherDetail: string | null } | null, osUpdateCadence: { __typename?: 'UpdateCadenceOption', value: string | null, otherDetail: string | null } | null } | null, internetDetails: { __typename?: 'InternetDetails', speedTestImages: Array<string> | null, internetSpeed: { __typename?: 'InternetSpeedOption', value: string | null, otherDetail: string | null } | null } | null, securityDetails: { __typename?: 'SecurityDetails', antivirusConfigForSEB: string | null, isSyncedWithThaiServer: boolean | null, timeSyncImages: Array<string> | null, usbPortCheck: string | null, robotTestImages: Array<string> | null, antivirusProgram: { __typename?: 'AntivirusProgramOption', value: string | null, otherDetail: string | null } | null, antivirusUpdateCadence: { __typename?: 'UpdateCadenceOption', value: string | null, otherDetail: string | null } | null } | null } | null } | null, examRoomRequestPhysicalInfo: { __typename?: 'ExamRoomRequestPhysicalInfo', id: string, examRoomRequestInfoId: string, createdAt: Date, info: { __typename?: 'ExamRoomRequestPhysicalAttributes', seatSideSpacing: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, screenDistance: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, seatFrontBackSpacing: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, windows: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, storageLocker: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, examineeStorage: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, securityCameras: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, entryExitDoors: { __typename?: 'DoorInfo', numberOfDoors: number | null, images: Array<string> | null } | null, frontOfExamRoom: { __typename?: 'PhotoSet', images: Array<string> | null } | null, insideExamRoom: { __typename?: 'PhotoSet', images: Array<string> | null } | null, registrationArea: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, toilets: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, sharedOpenArea: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null } | null } | null, examLocationRequestVerdicts: Array<{ __typename?: 'ExamLocationRequestVerdict', id: string, examRoomRequestInfoId: string | null, verdict: ExamLocationVerdict | null, locationId: string | null, requestedAt: Date, submittedAt: Date | null, step: ExamLocationRequestWorkflowStepCode, comment: string | null, updatedBy: string, updatedAt: Date, createdAt: Date, approvalType: ExamLocationRequestApprovalType | null, grantedRoomId: string | null, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }> } } };

export type CreateExamLocationRequestInfoMutationVariables = Exact<{
  createExamLocationRequestInfoInput: CreateExamLocationRequestInfoInputType;
}>;


export type CreateExamLocationRequestInfoMutation = { __typename?: 'Mutation', ecCreateExamLocationRequestInfo: { __typename?: 'CreateExamLocationRequestInfoOutput', examLocationRequestInfo: { __typename?: 'ExamLocationRequestInfo', id: string, provinceId: string, locationId: string | null, nameTh: string | null, nameEn: string | null, buildingId: string | null, buildingName: string | null, editedBy: string, editedAt: Date, createdAt: Date } } };

export type GetExamLocationRequestInfoQueryVariables = Exact<{
  getExamLocationRequestInfoByIdInput: GetExamLocationRequestInfoByIdInputType;
}>;


export type GetExamLocationRequestInfoQuery = { __typename?: 'Query', ecGetExamLocationRequestInfoById: { __typename?: 'GetExamLocationRequestInfoByIdOutput', examLocationRequestInfo: { __typename?: 'ExamLocationRequestInfo', id: string, examCenterCode: string, provinceId: string, locationId: string | null, nameTh: string | null, nameEn: string | null, buildingId: string | null, buildingName: string | null, editedAt: Date, createdAt: Date, editedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null, examRoomRequestInfos: Array<{ __typename?: 'ExamRoomRequestInfo', id: string, examLocationRequestInfoId: string, floor: string, name: string, roomNumber: string | null, seatCount: number, step: ExamLocationRequestWorkflowStepCode | null, taskId: string | null, taskCode: string | null, requestedAt: Date | null, createdAt: Date, examRoomRequestComputerInfo: { __typename?: 'ExamRoomRequestComputerInfo', id: string, examRoomRequestInfoId: string, createdAt: Date } | null, examRoomRequestPhysicalInfo: { __typename?: 'ExamRoomRequestPhysicalInfo', id: string, examRoomRequestInfoId: string, createdAt: Date } | null }> } } };

export type UpdateExamLocationRequestInfoMutationVariables = Exact<{
  updateExamLocationRequestInfoInput: UpdateExamLocationRequestInfoInputType;
}>;


export type UpdateExamLocationRequestInfoMutation = { __typename?: 'Mutation', ecUpdateExamLocationRequestInfo: { __typename?: 'UpdateExamLocationRequestInfoOutput', examLocationRequestInfo: { __typename?: 'ExamLocationRequestInfo', id: string, provinceId: string, examCenterCode: string, locationId: string | null, nameTh: string | null, nameEn: string | null, buildingId: string | null, buildingName: string | null, editedBy: string, editedAt: Date, createdAt: Date } } };

export type CreateOrUpdateExamRoomRequestPhysicalInfoMutationVariables = Exact<{
  createOrUpdateExamRoomRequestPhysicalInfoInput: CreateOrUpdateExamRoomRequestPhysicalInfoInputType;
}>;


export type CreateOrUpdateExamRoomRequestPhysicalInfoMutation = { __typename?: 'Mutation', ecCreateOrUpdateExamRoomRequestPhysicalInfo: { __typename?: 'CreateOrUpdateExamRoomRequestPhysicalInfoOutput', examRoomRequestPhysicalInfo: { __typename?: 'ExamRoomRequestPhysicalInfo', id: string, examRoomRequestInfoId: string, createdAt: Date } } };

export type CreateOrUpdateExamRoomRequestComputerInfoMutationVariables = Exact<{
  createOrUpdateExamRoomRequestComputerInfoInput: CreateOrUpdateExamRoomRequestComputerInfoInputType;
}>;


export type CreateOrUpdateExamRoomRequestComputerInfoMutation = { __typename?: 'Mutation', ecCreateOrUpdateExamRoomRequestComputerInfo: { __typename?: 'CreateOrUpdateExamRoomRequestComputerInfoOutput', examRoomRequestComputerInfo: { __typename?: 'ExamRoomRequestComputerInfo', id: string, examRoomRequestInfoId: string, createdAt: Date } } };

export type GetUploadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables = Exact<{
  getUploadSignedUrlForExamRoomRequestPhysicalInfoInput: GetUploadSignedUrlForExamRoomRequestPhysicalInfoInputType;
}>;


export type GetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery = { __typename?: 'Query', ecGetUploadSignedUrlForExamRoomRequestPhysicalInfo: { __typename?: 'GetUploadSignedUrlForExamRoomRequestPhysicalInfoOutput', signedUrls: Array<{ __typename?: 'GetUploadSignedUrlForExamRoomRequestPhysicalInfoSignedUrl', url: string, contentType: UploadableContentType, storageObject: { __typename?: 'StorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null } }> } };

export type GetUploadSignedUrlForExamRoomRequestComputerInfoQueryVariables = Exact<{
  getUploadSignedUrlForExamRoomRequestComputerInfoInput: GetUploadSignedUrlForExamRoomRequestComputerInfoInputType;
}>;


export type GetUploadSignedUrlForExamRoomRequestComputerInfoQuery = { __typename?: 'Query', ecGetUploadSignedUrlForExamRoomRequestComputerInfo: { __typename?: 'GetUploadSignedUrlForExamRoomRequestComputerInfoOutput', signedUrls: Array<{ __typename?: 'GetUploadSignedUrlForExamRoomRequestComputerInfoSignedUrl', url: string, contentType: UploadableContentType, storageObject: { __typename?: 'StorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null } }> } };

export type GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables = Exact<{
  getDownloadSignedUrlForExamRoomRequestPhysicalInfoInput: GetDownloadSignedUrlForExamRoomRequestPhysicalInfoInputType;
}>;


export type GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery = { __typename?: 'Query', ecGetDownloadSignedUrlForExamRoomRequestPhysicalInfo: { __typename?: 'GetDownloadSignedUrlForExamRoomRequestPhysicalInfoOutput', signedUrls: any } };

export type GetDownloadSignedUrlForExamRoomRequestComputerInfoQueryVariables = Exact<{
  getDownloadSignedUrlForExamRoomRequestComputerInfoInput: GetDownloadSignedUrlForExamRoomRequestComputerInfoInputType;
}>;


export type GetDownloadSignedUrlForExamRoomRequestComputerInfoQuery = { __typename?: 'Query', ecGetDownloadSignedUrlForExamRoomRequestComputerInfo: { __typename?: 'GetDownloadSignedUrlForExamRoomRequestComputerInfoOutput', signedUrls: any } };

export type GetBuildingsByLocationIdQueryVariables = Exact<{
  getBuildingsByLocationIdInput: GetBuildingsByLocationIdInput;
}>;


export type GetBuildingsByLocationIdQuery = { __typename?: 'Query', ecGetBuildingsByLocationId: { __typename?: 'GetBuildingsByLocationIdOutput', buildings: Array<{ __typename?: 'Building', id: string, nameTh: string, nameEn: string | null }> } };

export type SearchExamLocationRequestInfosQueryVariables = Exact<{
  searchExamLocationRequestInfosInput: SearchExamLocationRequestInfosInputType;
}>;


export type SearchExamLocationRequestInfosQuery = { __typename?: 'Query', ecSearchExamLocationRequestInfos: { __typename?: 'SearchExamLocationRequestInfosOutput', total: number, examLocationRequestInfos: Array<{ __typename?: 'ExamLocationRequestInfo', id: string, buildingName: string | null, editedAt: Date, nameTh: string | null, building: { __typename?: 'Building', id: string, nameTh: string, nameEn: string | null, locationId: string } | null, editedUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null, province: { __typename?: 'Province', nameTh: string }, location: { __typename?: 'Location', nameTh: string } | null }> } };

export type GetExamLocationRequestInfoCountByStatusQueryVariables = Exact<{
  getExamLocationRequestInfoCountByExamCenterCodeInput: GetExamLocationRequestInfoCountByExamCenterCodeInputType;
}>;


export type GetExamLocationRequestInfoCountByStatusQuery = { __typename?: 'Query', ecGetExamLocationRequestInfoCountByExamCenterCode: { __typename?: 'GetExamLocationRequestInfoCountByExamCenterCodeOutput', examLocationRequestInfoCountByStatus: { __typename?: 'GetExamLocationRequestInfoCountByExamCenterCode', draft: number, inReview: number, rejected: number } } };

export type SubmitExamLocationRequestInfoMutationVariables = Exact<{
  submitExamLocationRequestInfoInput: SubmitExamLocationRequestInfoInputType;
}>;


export type SubmitExamLocationRequestInfoMutation = { __typename?: 'Mutation', ecSubmitExamLocationRequestInfo: { __typename?: 'SubmitExamLocationRequestInfoOutput', isSuccess: boolean, details: any } };

export type AdminSearchMyExamRoomRequestInfosQueryVariables = Exact<{
  adminSearchMyExamRoomRequestInfosInput: AdminSearchMyExamRoomRequestInfosInput;
}>;


export type AdminSearchMyExamRoomRequestInfosQuery = { __typename?: 'Query', ecAdminSearchMyExamRoomRequestInfos: { __typename?: 'AdminSearchMyExamRoomRequestInfosOutput', total: number, examRoomRequestInfos: Array<{ __typename?: 'ExamRoomRequestInfo', id: string, taskCode: string | null, floor: string, name: string, roomNumber: string | null, examCenterCode: string, requestedAt: Date | null, step: ExamLocationRequestWorkflowStepCode | null, examLocationRequestInfo: { __typename?: 'ExamLocationRequestInfo', nameTh: string | null, buildingName: string | null, building: { __typename?: 'Building', nameTh: string } | null, province: { __typename?: 'Province', nameTh: string } }, examLocationRequestVerdicts: Array<{ __typename?: 'ExamLocationRequestVerdict', step: ExamLocationRequestWorkflowStepCode, verdict: ExamLocationVerdict | null, submittedAt: Date | null, requestedAt: Date }> }> } };

export type SearchExamRoomRequestInfosQueryVariables = Exact<{
  searchExamRoomRequestInfosInput: SearchExamRoomRequestInfosInputType;
}>;


export type SearchExamRoomRequestInfosQuery = { __typename?: 'Query', ecSearchExamRoomRequestInfos: { __typename?: 'SearchExamRoomRequestInfosOutput', total: number, examRoomRequestInfos: Array<{ __typename?: 'ExamRoomRequestInfo', id: string, floor: string, name: string, roomNumber: string | null, taskCode: string | null, examCenterCode: string, requestedAt: Date | null, createdAt: Date, step: ExamLocationRequestWorkflowStepCode | null, examLocationRequestVerdicts: Array<{ __typename?: 'ExamLocationRequestVerdict', id: string, verdict: ExamLocationVerdict | null, locationId: string | null, requestedAt: Date, submittedAt: Date | null, step: ExamLocationRequestWorkflowStepCode, comment: string | null, updatedBy: string, updatedAt: Date, createdAt: Date, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }>, examLocationRequestInfo: { __typename?: 'ExamLocationRequestInfo', buildingName: string | null, nameTh: string | null, building: { __typename?: 'Building', nameTh: string } | null, province: { __typename?: 'Province', nameTh: string } } }> } };

export type AdminSearchRoomByLocationNameQueryVariables = Exact<{
  adminSearchRoomByLocationNameInput: AdminSearchRoomByLocationNameInput;
}>;


export type AdminSearchRoomByLocationNameQuery = { __typename?: 'Query', ecAdminSearchRoomByLocationName: { __typename?: 'AdminSearchRoomByLocationNameOutput', total: number, rooms: Array<{ __typename?: 'Room', id: string, name: string, buildingId: string, floor: string, roomNumber: string | null, seat: number, status: RoomStatus, retiredRemark: string | null, retiredAt: Date | null, updatedAt: Date, building: { __typename?: 'Building', id: string, nameTh: string, nameEn: string | null, locationId: string, location: { __typename?: 'Location', id: string, nameTh: string, nameEn: string | null, provinceId: string, province: { __typename?: 'Province', id: string, nameTh: string, nameEn: string, code: string, geographyId: string } } } }> } };

export type CreateOrUpdateExamLocationRequestVerdictMutationVariables = Exact<{
  createOrUpdateExamLocationRequestVerdictInput: CreateOrUpdateExamLocationRequestVerdictInputType;
}>;


export type CreateOrUpdateExamLocationRequestVerdictMutation = { __typename?: 'Mutation', ecCreateOrUpdateExamLocationRequestVerdict: { __typename?: 'CreateOrUpdateExamLocationRequestVerdictOutput', examLocationVerdict: { __typename?: 'ExamLocationRequestVerdict', id: string, examRoomRequestInfoId: string | null, verdict: ExamLocationVerdict | null, locationId: string | null, requestedAt: Date, submittedAt: Date | null, step: ExamLocationRequestWorkflowStepCode, comment: string | null, approvalType: ExamLocationRequestApprovalType | null, grantedRoomId: string | null, updatedBy: string, updatedAt: Date, createdAt: Date } } };

export type SubmitReviewExamRoomRequestInfoMutationVariables = Exact<{
  submitReviewExamRoomRequestInfoInput: SubmitReviewExamRoomRequestInfoInputType;
}>;


export type SubmitReviewExamRoomRequestInfoMutation = { __typename?: 'Mutation', ecSubmitReviewExamRoomRequestInfo: { __typename?: 'SubmitReviewExamRoomRequestInfoOutput', examRoomRequestInfo: { __typename?: 'ExamRoomRequestInfo', id: string, examLocationRequestInfoId: string, examCenterCode: string, floor: string, name: string, roomNumber: string | null, seatCount: number, step: ExamLocationRequestWorkflowStepCode | null, taskId: string | null, taskCode: string | null, requestedAt: Date | null, editedBy: string, editedAt: Date, createdAt: Date } } };

export type SubmitExamRoomRequestMutationVariables = Exact<{
  submitExamRoomRequestInput: SubmitExamRoomRequestInputType;
}>;


export type SubmitExamRoomRequestMutation = { __typename?: 'Mutation', ecSubmitExamRoomRequest: { __typename?: 'SubmitExamRoomRequestOutput', hasComputerInfoError: boolean, hasPhysicalInfoError: boolean, isSuccess: boolean } };

export type AdminGetExamRoomRequestInfoByIdQueryVariables = Exact<{
  adminGetExamRoomRequestInfoByIdInput: AdminGetExamRoomRequestInfoByIdInputType;
}>;


export type AdminGetExamRoomRequestInfoByIdQuery = { __typename?: 'Query', ecAdminGetExamRoomRequestInfoById: { __typename?: 'AdminGetExamRoomRequestInfoByIdOutput', examRoomRequestInfo: { __typename?: 'ExamRoomRequestInfo', id: string, examLocationRequestInfoId: string, examCenterCode: string, floor: string, name: string, roomNumber: string | null, seatCount: number, step: ExamLocationRequestWorkflowStepCode | null, taskId: string | null, taskCode: string | null, requestedAt: Date | null, createdAt: Date, examLocationRequestInfo: { __typename?: 'ExamLocationRequestInfo', id: string, provinceId: string, locationId: string | null, nameTh: string | null, nameEn: string | null, buildingId: string | null, buildingName: string | null, editedAt: Date, editedBy: string, createdAt: Date, province: { __typename?: 'Province', id: string, nameTh: string }, building: { __typename?: 'Building', id: string, nameTh: string, nameEn: string | null, locationId: string } | null, editedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }, examRoomRequestComputerInfo: { __typename?: 'ExamRoomRequestComputerInfo', createdAt: Date, examRoomRequestInfoId: string, id: string, info: { __typename?: 'ExamRoomRequestComputerAttributes', computerDetails: { __typename?: 'ComputerDetails', sebVersionStatus: string | null, computerSpecImages: Array<string> | null, computerSeatImages: Array<string> | null, monitor: { __typename?: 'WithOtherDetail', value: string | null, otherDetail: string | null } | null, cpu: { __typename?: 'CpuOption', value: string | null, otherDetail: string | null } | null, ram: { __typename?: 'RamSizeOption', value: string | null, otherDetail: string | null } | null, os: { __typename?: 'OsOption', value: string | null, otherDetail: string | null } | null, storage: { __typename?: 'StorageOption', value: string | null, otherDetail: string | null } | null, webBrowser: { __typename?: 'WebBrowserOption', value: string | null, otherDetail: string | null } | null, osUpdateCadence: { __typename?: 'UpdateCadenceOption', value: string | null, otherDetail: string | null } | null } | null, internetDetails: { __typename?: 'InternetDetails', speedTestImages: Array<string> | null, internetSpeed: { __typename?: 'InternetSpeedOption', value: string | null, otherDetail: string | null } | null } | null, securityDetails: { __typename?: 'SecurityDetails', antivirusConfigForSEB: string | null, isSyncedWithThaiServer: boolean | null, timeSyncImages: Array<string> | null, usbPortCheck: string | null, robotTestImages: Array<string> | null, antivirusProgram: { __typename?: 'AntivirusProgramOption', value: string | null, otherDetail: string | null } | null, antivirusUpdateCadence: { __typename?: 'UpdateCadenceOption', value: string | null, otherDetail: string | null } | null } | null } | null } | null, examRoomRequestPhysicalInfo: { __typename?: 'ExamRoomRequestPhysicalInfo', id: string, examRoomRequestInfoId: string, createdAt: Date, info: { __typename?: 'ExamRoomRequestPhysicalAttributes', seatSideSpacing: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, screenDistance: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, seatFrontBackSpacing: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, windows: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, storageLocker: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, examineeStorage: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, securityCameras: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, entryExitDoors: { __typename?: 'DoorInfo', numberOfDoors: number | null, images: Array<string> | null } | null, frontOfExamRoom: { __typename?: 'PhotoSet', images: Array<string> | null } | null, insideExamRoom: { __typename?: 'PhotoSet', images: Array<string> | null } | null, registrationArea: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, toilets: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, sharedOpenArea: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null } | null } | null, examLocationRequestVerdicts: Array<{ __typename?: 'ExamLocationRequestVerdict', id: string, examRoomRequestInfoId: string | null, verdict: ExamLocationVerdict | null, locationId: string | null, requestedAt: Date, submittedAt: Date | null, step: ExamLocationRequestWorkflowStepCode, comment: string | null, updatedBy: string, updatedAt: Date, createdAt: Date, approvalType: ExamLocationRequestApprovalType | null, grantedRoomId: string | null, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }> } } };

export type AdminGetExamRoomRequestInfoCountQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetExamRoomRequestInfoCountQuery = { __typename?: 'Query', ecAdminGetExamRoomRequestInfoCount: { __typename?: 'AdminGetExamRoomRequestInfoCountOutput', examRoomRequestInfoCountByStatus: { __typename?: 'AdminGetExamRoomRequestInfoCount', inReview: number, rejected: number } } };

export type DeleteExamRoomRequestInfoByIdMutationVariables = Exact<{
  deleteExamRoomRequestInfoByIdInput: DeleteExamRoomRequestInfoByIdInputType;
}>;


export type DeleteExamRoomRequestInfoByIdMutation = { __typename?: 'Mutation', ecDeleteExamRoomRequestInfoById: { __typename?: 'DeleteExamRoomRequestInfoByIdOutput', status: GenericResponseStatus, message: string, data: any | null } };

export type DuplicateExamRoomRequestInfoMutationVariables = Exact<{
  duplicateExamRoomRequestInfoInput: DuplicateExamRoomRequestInfoInputType;
}>;


export type DuplicateExamRoomRequestInfoMutation = { __typename?: 'Mutation', ecDuplicateExamRoomRequestInfo: { __typename?: 'DuplicateExamRoomRequestInfoOutput', examRoomRequestInfo: { __typename?: 'ExamRoomRequestInfo', id: string } } };

export type DeleteExamLocationRequestInfoByIdMutationVariables = Exact<{
  deleteExamLocationRequestInfoByIdInput: DeleteExamLocationRequestInfoByIdInputType;
}>;


export type DeleteExamLocationRequestInfoByIdMutation = { __typename?: 'Mutation', ecDeleteExamLocationRequestInfoById: { __typename?: 'DeleteExamLocationRequestInfoByIdOutput', status: GenericResponseStatus, message: string, data: any | null } };

export type RoomFragment = { __typename?: 'Room', id: string, name: string, buildingId: string, floor: string, roomNumber: string | null, seat: number, status: RoomStatus, retiredRemark: string | null, retiredAt: Date | null, updatedAt: Date, retiredByUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null, updatedUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null, building: { __typename?: 'Building', id: string, nameTh: string, nameEn: string | null, locationId: string, location: { __typename?: 'Location', id: string, nameTh: string, nameEn: string | null, provinceId: string, province: { __typename?: 'Province', id: string, nameTh: string, nameEn: string, code: string, geographyId: string } } } };

export type SearchExamCenterRoomsQueryVariables = Exact<{
  searchExamCenterRoomsInput: SearchExamCenterRoomsInput;
}>;


export type SearchExamCenterRoomsQuery = { __typename?: 'Query', ecSearchExamCenterRooms: { __typename?: 'SearchExamCenterRoomsOutput', total: number, rooms: Array<{ __typename?: 'ExamCenterRoom', approvedAt: Date, room: { __typename?: 'Room', id: string, name: string, buildingId: string, floor: string, roomNumber: string | null, seat: number, status: RoomStatus, retiredRemark: string | null, retiredAt: Date | null, updatedAt: Date, retiredByUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null, updatedUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null, building: { __typename?: 'Building', id: string, nameTh: string, nameEn: string | null, locationId: string, location: { __typename?: 'Location', id: string, nameTh: string, nameEn: string | null, provinceId: string, province: { __typename?: 'Province', id: string, nameTh: string, nameEn: string, code: string, geographyId: string } } } } }> } };

export type AdminSearchRoomsQueryVariables = Exact<{
  searchRoomsInput: SearchRoomsInput;
}>;


export type AdminSearchRoomsQuery = { __typename?: 'Query', ecAdminSearchRooms: { __typename?: 'SearchRoomsOutput', total: number, rooms: Array<{ __typename?: 'Room', id: string, name: string, buildingId: string, floor: string, roomNumber: string | null, seat: number, status: RoomStatus, retiredRemark: string | null, retiredAt: Date | null, updatedAt: Date, retiredByUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null, updatedUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null, building: { __typename?: 'Building', id: string, nameTh: string, nameEn: string | null, locationId: string, location: { __typename?: 'Location', id: string, nameTh: string, nameEn: string | null, provinceId: string, province: { __typename?: 'Province', id: string, nameTh: string, nameEn: string, code: string, geographyId: string } } } }> } };

export type GetUpcomingRoomReservationSummaryQueryVariables = Exact<{
  getUpcomingRoomReservationSummaryInput: GetUpcomingRoomReservationSummaryInput;
}>;


export type GetUpcomingRoomReservationSummaryQuery = { __typename?: 'Query', ecGetUpcomingRoomReservationSummary: { __typename?: 'GetUpcomingRoomReservationSummaryOutput', roomId: string, roomReservationSummaries: Array<{ __typename?: 'RoomReservationSummary', endedAt: Date, examCenterCode: string, reservationCount: number, startedAt: Date }> } };

export type AdminGetUpcomingRoomReservationSummaryQueryVariables = Exact<{
  getUpcomingRoomReservationSummaryInput: GetUpcomingRoomReservationSummaryInput;
}>;


export type AdminGetUpcomingRoomReservationSummaryQuery = { __typename?: 'Query', ecAdminGetUpcomingRoomReservationSummary: { __typename?: 'GetUpcomingRoomReservationSummaryOutput', roomId: string, roomReservationSummaries: Array<{ __typename?: 'RoomReservationSummary', endedAt: Date, examCenterCode: string, reservationCount: number, startedAt: Date }> } };

export type ExamRoomDetailFragment = { __typename?: 'Room', id: string, floor: string, name: string, roomNumber: string | null, buildingId: string, seat: number, status: RoomStatus, retiredRemark: string | null, retiredAt: Date | null, createdAt: Date, updatedAt: Date, updatedUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null, examRoomComputerInfo: { __typename?: 'ExamRoomComputerInfo', createdAt: Date, id: string, info: { __typename?: 'ExamRoomComputerInfoAttributes', computerDetails: { __typename?: 'ComputerDetails', sebVersionStatus: string | null, computerSpecImages: Array<string> | null, computerSeatImages: Array<string> | null, monitor: { __typename?: 'WithOtherDetail', value: string | null, otherDetail: string | null } | null, cpu: { __typename?: 'CpuOption', value: string | null, otherDetail: string | null } | null, ram: { __typename?: 'RamSizeOption', value: string | null, otherDetail: string | null } | null, os: { __typename?: 'OsOption', value: string | null, otherDetail: string | null } | null, storage: { __typename?: 'StorageOption', value: string | null, otherDetail: string | null } | null, webBrowser: { __typename?: 'WebBrowserOption', value: string | null, otherDetail: string | null } | null, osUpdateCadence: { __typename?: 'UpdateCadenceOption', value: string | null, otherDetail: string | null } | null } | null, internetDetails: { __typename?: 'InternetDetails', speedTestImages: Array<string> | null, internetSpeed: { __typename?: 'InternetSpeedOption', value: string | null, otherDetail: string | null } | null } | null, securityDetails: { __typename?: 'SecurityDetails', antivirusConfigForSEB: string | null, isSyncedWithThaiServer: boolean | null, timeSyncImages: Array<string> | null, usbPortCheck: string | null, robotTestImages: Array<string> | null, antivirusProgram: { __typename?: 'AntivirusProgramOption', value: string | null, otherDetail: string | null } | null, antivirusUpdateCadence: { __typename?: 'UpdateCadenceOption', value: string | null, otherDetail: string | null } | null } | null } | null } | null, building: { __typename?: 'Building', id: string, nameTh: string, nameEn: string | null, locationId: string, location: { __typename?: 'Location', id: string, nameTh: string, nameEn: string | null, provinceId: string, province: { __typename?: 'Province', id: string, nameTh: string, nameEn: string, code: string, geographyId: string } } }, examRoomPhysicalInfo: { __typename?: 'ExamRoomPhysicalInfo', id: string, createdAt: Date, info: { __typename?: 'ExamRoomPhysicalAttributes', seatSideSpacing: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, screenDistance: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, seatFrontBackSpacing: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, windows: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, storageLocker: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, examineeStorage: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, securityCameras: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, entryExitDoors: { __typename?: 'DoorInfo', numberOfDoors: number | null, images: Array<string> | null } | null, frontOfExamRoom: { __typename?: 'PhotoSet', images: Array<string> | null } | null, insideExamRoom: { __typename?: 'PhotoSet', images: Array<string> | null } | null, registrationArea: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, toilets: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, sharedOpenArea: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null } | null } | null };

export type GetExamRoomByIdQueryVariables = Exact<{
  getExamRoomByIdInput: GetExamRoomByIdInput;
}>;


export type GetExamRoomByIdQuery = { __typename?: 'Query', ecGetExamRoomById: { __typename?: 'GetExamRoomByIdOutput', examRoom: { __typename?: 'Room', id: string, floor: string, name: string, roomNumber: string | null, buildingId: string, seat: number, status: RoomStatus, retiredRemark: string | null, retiredAt: Date | null, createdAt: Date, updatedAt: Date, updatedUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null, examRoomComputerInfo: { __typename?: 'ExamRoomComputerInfo', createdAt: Date, id: string, info: { __typename?: 'ExamRoomComputerInfoAttributes', computerDetails: { __typename?: 'ComputerDetails', sebVersionStatus: string | null, computerSpecImages: Array<string> | null, computerSeatImages: Array<string> | null, monitor: { __typename?: 'WithOtherDetail', value: string | null, otherDetail: string | null } | null, cpu: { __typename?: 'CpuOption', value: string | null, otherDetail: string | null } | null, ram: { __typename?: 'RamSizeOption', value: string | null, otherDetail: string | null } | null, os: { __typename?: 'OsOption', value: string | null, otherDetail: string | null } | null, storage: { __typename?: 'StorageOption', value: string | null, otherDetail: string | null } | null, webBrowser: { __typename?: 'WebBrowserOption', value: string | null, otherDetail: string | null } | null, osUpdateCadence: { __typename?: 'UpdateCadenceOption', value: string | null, otherDetail: string | null } | null } | null, internetDetails: { __typename?: 'InternetDetails', speedTestImages: Array<string> | null, internetSpeed: { __typename?: 'InternetSpeedOption', value: string | null, otherDetail: string | null } | null } | null, securityDetails: { __typename?: 'SecurityDetails', antivirusConfigForSEB: string | null, isSyncedWithThaiServer: boolean | null, timeSyncImages: Array<string> | null, usbPortCheck: string | null, robotTestImages: Array<string> | null, antivirusProgram: { __typename?: 'AntivirusProgramOption', value: string | null, otherDetail: string | null } | null, antivirusUpdateCadence: { __typename?: 'UpdateCadenceOption', value: string | null, otherDetail: string | null } | null } | null } | null } | null, building: { __typename?: 'Building', id: string, nameTh: string, nameEn: string | null, locationId: string, location: { __typename?: 'Location', id: string, nameTh: string, nameEn: string | null, provinceId: string, province: { __typename?: 'Province', id: string, nameTh: string, nameEn: string, code: string, geographyId: string } } }, examRoomPhysicalInfo: { __typename?: 'ExamRoomPhysicalInfo', id: string, createdAt: Date, info: { __typename?: 'ExamRoomPhysicalAttributes', seatSideSpacing: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, screenDistance: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, seatFrontBackSpacing: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, windows: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, storageLocker: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, examineeStorage: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, securityCameras: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, entryExitDoors: { __typename?: 'DoorInfo', numberOfDoors: number | null, images: Array<string> | null } | null, frontOfExamRoom: { __typename?: 'PhotoSet', images: Array<string> | null } | null, insideExamRoom: { __typename?: 'PhotoSet', images: Array<string> | null } | null, registrationArea: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, toilets: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, sharedOpenArea: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null } | null } | null } } };

export type AdminGetExamRoomByIdQueryVariables = Exact<{
  getExamRoomByIdInput: GetExamRoomByIdInput;
}>;


export type AdminGetExamRoomByIdQuery = { __typename?: 'Query', ecAdminGetExamRoomById: { __typename?: 'GetExamRoomByIdOutput', examRoom: { __typename?: 'Room', id: string, floor: string, name: string, roomNumber: string | null, buildingId: string, seat: number, status: RoomStatus, retiredRemark: string | null, retiredAt: Date | null, createdAt: Date, updatedAt: Date, updatedUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null, examRoomComputerInfo: { __typename?: 'ExamRoomComputerInfo', createdAt: Date, id: string, info: { __typename?: 'ExamRoomComputerInfoAttributes', computerDetails: { __typename?: 'ComputerDetails', sebVersionStatus: string | null, computerSpecImages: Array<string> | null, computerSeatImages: Array<string> | null, monitor: { __typename?: 'WithOtherDetail', value: string | null, otherDetail: string | null } | null, cpu: { __typename?: 'CpuOption', value: string | null, otherDetail: string | null } | null, ram: { __typename?: 'RamSizeOption', value: string | null, otherDetail: string | null } | null, os: { __typename?: 'OsOption', value: string | null, otherDetail: string | null } | null, storage: { __typename?: 'StorageOption', value: string | null, otherDetail: string | null } | null, webBrowser: { __typename?: 'WebBrowserOption', value: string | null, otherDetail: string | null } | null, osUpdateCadence: { __typename?: 'UpdateCadenceOption', value: string | null, otherDetail: string | null } | null } | null, internetDetails: { __typename?: 'InternetDetails', speedTestImages: Array<string> | null, internetSpeed: { __typename?: 'InternetSpeedOption', value: string | null, otherDetail: string | null } | null } | null, securityDetails: { __typename?: 'SecurityDetails', antivirusConfigForSEB: string | null, isSyncedWithThaiServer: boolean | null, timeSyncImages: Array<string> | null, usbPortCheck: string | null, robotTestImages: Array<string> | null, antivirusProgram: { __typename?: 'AntivirusProgramOption', value: string | null, otherDetail: string | null } | null, antivirusUpdateCadence: { __typename?: 'UpdateCadenceOption', value: string | null, otherDetail: string | null } | null } | null } | null } | null, building: { __typename?: 'Building', id: string, nameTh: string, nameEn: string | null, locationId: string, location: { __typename?: 'Location', id: string, nameTh: string, nameEn: string | null, provinceId: string, province: { __typename?: 'Province', id: string, nameTh: string, nameEn: string, code: string, geographyId: string } } }, examRoomPhysicalInfo: { __typename?: 'ExamRoomPhysicalInfo', id: string, createdAt: Date, info: { __typename?: 'ExamRoomPhysicalAttributes', seatSideSpacing: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, screenDistance: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, seatFrontBackSpacing: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, windows: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, storageLocker: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, examineeStorage: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, securityCameras: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, entryExitDoors: { __typename?: 'DoorInfo', numberOfDoors: number | null, images: Array<string> | null } | null, frontOfExamRoom: { __typename?: 'PhotoSet', images: Array<string> | null } | null, insideExamRoom: { __typename?: 'PhotoSet', images: Array<string> | null } | null, registrationArea: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, toilets: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null, sharedOpenArea: { __typename?: 'FeatureCheck', valid: boolean | null, additionalInfo: string | null, images: Array<string> | null } | null } | null } | null } } };

export type UpdateExamRoomMutationVariables = Exact<{
  updateExamRoomInput: UpdateExamRoomInput;
}>;


export type UpdateExamRoomMutation = { __typename?: 'Mutation', ecUpdateExamRoom: { __typename?: 'UpdateExamRoomOutput', examRoom: { __typename?: 'Room', id: string, name: string, buildingId: string, floor: string, roomNumber: string | null, seat: number, status: RoomStatus, retiredRemark: string | null, retiredAt: Date | null, updatedAt: Date, retiredByUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null, updatedUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null, building: { __typename?: 'Building', id: string, nameTh: string, nameEn: string | null, locationId: string, location: { __typename?: 'Location', id: string, nameTh: string, nameEn: string | null, provinceId: string, province: { __typename?: 'Province', id: string, nameTh: string, nameEn: string, code: string, geographyId: string } } } } } };

export type GetDownloadSignedUrlForExamRoomComputerInfoQueryVariables = Exact<{
  getDownloadSignedUrlForExamRoomComputerInfoInput: GetDownloadSignedUrlForExamRoomComputerInfoInput;
}>;


export type GetDownloadSignedUrlForExamRoomComputerInfoQuery = { __typename?: 'Query', ecGetDownloadSignedUrlForExamRoomComputerInfo: { __typename?: 'GetDownloadSignedUrlForExamRoomComputerInfoOutput', signedUrls: any } };

export type EcGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables = Exact<{
  getDownloadSignedUrlForExamRoomPhysicalInfoInput: GetDownloadSignedUrlForExamRoomPhysicalInfoInput;
}>;


export type EcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery = { __typename?: 'Query', ecGetDownloadSignedUrlForExamRoomPhysicalInfo: { __typename?: 'GetDownloadSignedUrlForExamRoomPhysicalInfoOutput', signedUrls: any } };

export type CountExamCenterRoomsByProvinceQueryVariables = Exact<{
  countExamCenterRoomsByProvinceInput: CountExamCenterRoomsByProvinceInput;
}>;


export type CountExamCenterRoomsByProvinceQuery = { __typename?: 'Query', ecCountExamCenterRoomsByProvince: { __typename?: 'CountExamCenterRoomsByProvinceOutput', examCenterRoomsCountByProvince: any } };

export type SearchLocationAuditLogQueryVariables = Exact<{
  searchLocationAuditLogInput: SearchLocationAuditLogInput;
}>;


export type SearchLocationAuditLogQuery = { __typename?: 'Query', ecSearchLocationAuditLog: { __typename?: 'SearchLocationAuditLogOutput', total: number, locationAuditLogs: Array<{ __typename?: 'LocationAuditLog', id: string, action: AuditActionType, fullName: string, detail: string, actionTime: Date }> } };

export type SearchExamCenterLocationsUsageQueryVariables = Exact<{
  searchExamCenterLocationsUsageInput: SearchExamCenterLocationsUsageInput;
}>;


export type SearchExamCenterLocationsUsageQuery = { __typename?: 'Query', ecSearchExamCenterLocationsUsage: { __typename?: 'SearchExamCenterLocationsUsageOutput', total: number, examCenterLocations: Array<{ __typename?: 'ExamCenterLocation', id: string, examCenterCode: string, approvedAt: Date, refId: string, examRoomRequestInfo: { __typename?: 'ExamRoomRequestInfo', step: ExamLocationRequestWorkflowStepCode | null, requestedAt: Date | null, examLocationRequestVerdicts: Array<{ __typename?: 'ExamLocationRequestVerdict', requestedAt: Date, submittedAt: Date | null, updatedUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null }> } | null }> } };

export type RevokeExamCenterLocationByIdMutationVariables = Exact<{
  revokeExamCenterLocationByIdInput: RevokeExamCenterLocationByIdInput;
}>;


export type RevokeExamCenterLocationByIdMutation = { __typename?: 'Mutation', ecRevokeExamCenterLocationById: { __typename?: 'RevokeExamCenterLocationByIdOutput', code: RevokeExamCenterLocationByIdResponseCode, message: string, success: boolean } };

export type RetireRoomByIdMutationVariables = Exact<{
  retireRoomByIdInput: RetireRoomByIdInput;
}>;


export type RetireRoomByIdMutation = { __typename?: 'Mutation', ecRetireRoomById: { __typename?: 'RetireRoomByIdOutput', room: { __typename?: 'Room', retiredRemark: string | null, id: string, status: RoomStatus } } };

export type AdminGetDownloadSignedUrlForExamRoomComputerInfoQueryVariables = Exact<{
  getDownloadSignedUrlForExamRoomComputerInfoInput: GetDownloadSignedUrlForExamRoomComputerInfoInput;
}>;


export type AdminGetDownloadSignedUrlForExamRoomComputerInfoQuery = { __typename?: 'Query', ecAdminGetDownloadSignedUrlForExamRoomComputerInfo: { __typename?: 'GetDownloadSignedUrlForExamRoomComputerInfoOutput', signedUrls: any } };

export type AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables = Exact<{
  getDownloadSignedUrlForExamRoomPhysicalInfoInput: GetDownloadSignedUrlForExamRoomPhysicalInfoInput;
}>;


export type AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery = { __typename?: 'Query', ecAdminGetDownloadSignedUrlForExamRoomPhysicalInfo: { __typename?: 'GetDownloadSignedUrlForExamRoomPhysicalInfoOutput', signedUrls: any } };

export type GetExamCenterMembersByExamCenterCodeQueryVariables = Exact<{
  getExamCenterMembersByExamCenterCodeInput: GetExamCenterMembersByExamCenterCodeInput;
}>;


export type GetExamCenterMembersByExamCenterCodeQuery = { __typename?: 'Query', ecGetExamCenterMembersByExamCenterCode: { __typename?: 'GetExamCenterMembersByExamCenterCodeOutput', examCenterMembers: Array<{ __typename?: 'ExamCenterMember', id: string, user: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string, lastLoginAt: string | null, status: string | null, invitationExpireAt: string | null, appRoles: Array<string> } | null }> } };

export type AdminGetExamCenterMembersByExamCenterCodeQueryVariables = Exact<{
  getExamCenterMembersByExamCenterCodeInput: GetExamCenterMembersByExamCenterCodeInput;
}>;


export type AdminGetExamCenterMembersByExamCenterCodeQuery = { __typename?: 'Query', ecAdminGetExamCenterMembersByExamCenterCode: { __typename?: 'GetExamCenterMembersByExamCenterCodeOutput', examCenterMembers: Array<{ __typename?: 'ExamCenterMember', id: string, user: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string, lastLoginAt: string | null, status: string | null, invitationExpireAt: string | null, appRoles: Array<string> } | null }> } };

export type SearchAvailableExamCenterManagerUsersQueryVariables = Exact<{
  searchAvailableExamCenterManagerUsersInput: SearchAvailableExamCenterManagerUsersInput;
}>;


export type SearchAvailableExamCenterManagerUsersQuery = { __typename?: 'Query', ecSearchAvailableExamCenterManagerUsers: { __typename?: 'SearchAvailableExamCenterManagerUsersOutput', total: number, users: Array<{ __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string, appRoles: Array<string>, status: string | null, invitationExpireAt: string | null }> } };

export type GetExamCenterMemberByIdQueryVariables = Exact<{
  getExamCenterMemberByIdInput: GetExamCenterMemberByIdInput;
}>;


export type GetExamCenterMemberByIdQuery = { __typename?: 'Query', ecGetExamCenterMemberById: { __typename?: 'GetExamCenterMemberByIdOutput', examCenterMember: { __typename?: 'ExamCenterMember', user: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string, lastLoginAt: string | null, appRoles: Array<string>, status: string | null, createdAt: string | null } | null } } };

export type AdminGetExamCenterMemberByIdQueryVariables = Exact<{
  getExamCenterMemberByIdInput: GetExamCenterMemberByIdInput;
}>;


export type AdminGetExamCenterMemberByIdQuery = { __typename?: 'Query', ecAdminGetExamCenterMemberById: { __typename?: 'GetExamCenterMemberByIdOutput', examCenterMember: { __typename?: 'ExamCenterMember', user: { __typename?: 'RawUser', id: string, firstname: string, lastname: string, email: string, lastLoginAt: string | null, appRoles: Array<string>, status: string | null, createdAt: string | null } | null } } };

export type AddMembersToExamCenterMutationVariables = Exact<{
  addMembersToExamCenterInput: AddMembersToExamCenterInput;
}>;


export type AddMembersToExamCenterMutation = { __typename?: 'Mutation', ecAddMembersToExamCenter: { __typename?: 'AddMembersToExamCenterOutput', examCenterMembers: Array<{ __typename?: 'ExamCenterMember', id: string }> } };

export type DeleteManagerFromExamCenterMutationVariables = Exact<{
  deleteManagerFromExamCenterInput: DeleteManagerFromExamCenterInput;
}>;


export type DeleteManagerFromExamCenterMutation = { __typename?: 'Mutation', ecDeleteManagerFromExamCenter: { __typename?: 'DeleteMemberFromExamCenterOutput', status: GenericResponseStatus, message: string, data: any | null } };

export type GetMyNotificationsQueryVariables = Exact<{
  getMyNotificationsInput: InputMaybe<GetMyNotificationsInput>;
}>;


export type GetMyNotificationsQuery = { __typename?: 'Query', ecGetMyNotifications: { __typename?: 'GetMyNotificationsOutput', total: number, notificationRecipients: Array<{ __typename?: 'NotificationRecipient', id: string, createdAt: Date, notification: { __typename?: 'Notification', id: string, title: string, message: string, type: NotificationType, ref: NotificationReference, actionUrl: string | null } | null }> } };

export type RawUserFragmentFragment = { __typename?: 'RawUser', id: string, firstname: string, lastname: string };

export type ExamCenterProctorRequestVerdictFragment = { __typename?: 'ExamCenterProctorRequestVerdict', id: string, examCenterProctorRequestId: string, step: ExamCenterProctorRequestVerdictStep, requestedAt: Date, verdict: Verdict | null, comment: string | null, submittedAt: Date | null, updatedBy: string, updatedAt: Date, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null };

export type ExamCenterProctorRequestFragment = { __typename?: 'ExamCenterProctorRequest', id: string, examCenterCode: string, examCenterProctorId: string | null, type: ExamCenterProctorRequestType, step: ExamCenterProctorRequestStep, taskId: string | null, refCode: string | null, titleTh: string, titleEn: string, idNumber: string, firstNameTh: string, firstNameEn: string, middleNameTh: string | null, middleNameEn: string | null, lastNameTh: string, lastNameEn: string, email: string, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, requestedAt: Date | null, requestedBy: string | null, editedBy: string | null, editedAt: Date | null, metadata: { __typename?: 'ExamCenterProctorRequestMetadata', employeeId: string | null, position: string | null, department: string | null } | null, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorRequestStorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }>, personalInfoStorageObjects: Array<{ __typename?: 'ExamCenterProctorRequestStorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }>, editedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null, verdicts: Array<{ __typename?: 'ExamCenterProctorRequestVerdict', id: string, examCenterProctorRequestId: string, step: ExamCenterProctorRequestVerdictStep, requestedAt: Date, verdict: Verdict | null, comment: string | null, submittedAt: Date | null, updatedBy: string, updatedAt: Date, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }> };

export type GetExamCenterProctorRequestByIdQueryVariables = Exact<{
  getExamCenterProctorRequestByIdInput: GetExamCenterProctorRequestByIdInputType;
}>;


export type GetExamCenterProctorRequestByIdQuery = { __typename?: 'Query', ecGetExamCenterProctorRequestById: { __typename?: 'GetExamCenterProctorRequestByIdOutput', examCenterProctorRequest: { __typename?: 'ExamCenterProctorRequest', id: string, examCenterCode: string, examCenterProctorId: string | null, type: ExamCenterProctorRequestType, step: ExamCenterProctorRequestStep, taskId: string | null, refCode: string | null, titleTh: string, titleEn: string, idNumber: string, firstNameTh: string, firstNameEn: string, middleNameTh: string | null, middleNameEn: string | null, lastNameTh: string, lastNameEn: string, email: string, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, requestedAt: Date | null, requestedBy: string | null, editedBy: string | null, editedAt: Date | null, metadata: { __typename?: 'ExamCenterProctorRequestMetadata', employeeId: string | null, position: string | null, department: string | null } | null, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorRequestStorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }>, personalInfoStorageObjects: Array<{ __typename?: 'ExamCenterProctorRequestStorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }>, editedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null, verdicts: Array<{ __typename?: 'ExamCenterProctorRequestVerdict', id: string, examCenterProctorRequestId: string, step: ExamCenterProctorRequestVerdictStep, requestedAt: Date, verdict: Verdict | null, comment: string | null, submittedAt: Date | null, updatedBy: string, updatedAt: Date, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }> } } };

export type AdminGetExamCenterProctorRequestByIdQueryVariables = Exact<{
  adminGetExamCenterProctorRequestByIdInput: AdminGetExamCenterProctorRequestByIdInputType;
}>;


export type AdminGetExamCenterProctorRequestByIdQuery = { __typename?: 'Query', ecAdminGetExamCenterProctorRequestById: { __typename?: 'AdminGetExamCenterProctorRequestByIdOutput', examCenterProctorRequest: { __typename?: 'ExamCenterProctorRequest', id: string, examCenterCode: string, examCenterProctorId: string | null, type: ExamCenterProctorRequestType, step: ExamCenterProctorRequestStep, taskId: string | null, refCode: string | null, titleTh: string, titleEn: string, idNumber: string, firstNameTh: string, firstNameEn: string, middleNameTh: string | null, middleNameEn: string | null, lastNameTh: string, lastNameEn: string, email: string, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, requestedAt: Date | null, requestedBy: string | null, editedBy: string | null, editedAt: Date | null, metadata: { __typename?: 'ExamCenterProctorRequestMetadata', employeeId: string | null, position: string | null, department: string | null } | null, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorRequestStorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }>, personalInfoStorageObjects: Array<{ __typename?: 'ExamCenterProctorRequestStorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }>, editedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null, verdicts: Array<{ __typename?: 'ExamCenterProctorRequestVerdict', id: string, examCenterProctorRequestId: string, step: ExamCenterProctorRequestVerdictStep, requestedAt: Date, verdict: Verdict | null, comment: string | null, submittedAt: Date | null, updatedBy: string, updatedAt: Date, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }> } } };

export type GetExamCenterProctorRequestsCountQueryVariables = Exact<{
  getExamCenterProctorRequestsCountInput: GetExamCenterProctorRequestsCountByExamCenterCodeInput;
}>;


export type GetExamCenterProctorRequestsCountQuery = { __typename?: 'Query', ecGetExamCenterProctorRequestsCountByExamCenterCode: { __typename?: 'GetExamCenterProctorRequestsCountByExamCenterCodeOutput', proctorRequestCountByStatus: { __typename?: 'NumberOfProctorRequestsByStatus', DRAFT: number, IN_REVIEW: number, APPROVED: number, REJECTED: number } } };

export type AdminGetExamCenterProctorRequestsCountQueryVariables = Exact<{
  getExamCenterProctorRequestsCountInput: GetExamCenterProctorRequestsCountByExamCenterCodeInput;
}>;


export type AdminGetExamCenterProctorRequestsCountQuery = { __typename?: 'Query', ecAdminGetExamCenterProctorRequestsCountByExamCenterCode: { __typename?: 'GetExamCenterProctorRequestsCountByExamCenterCodeOutput', proctorRequestCountByStatus: { __typename?: 'NumberOfProctorRequestsByStatus', DRAFT: number, IN_REVIEW: number, APPROVED: number, REJECTED: number } } };

export type CreateOrUpdateExamCenterProctorRequestVerdictMutationVariables = Exact<{
  createOrUpdateExamCenterProctorRequestVerdictInput: CreateOrUpdateExamCenterProctorRequestVerdictInputType;
}>;


export type CreateOrUpdateExamCenterProctorRequestVerdictMutation = { __typename?: 'Mutation', ecCreateOrUpdateExamCenterProctorRequestVerdict: { __typename?: 'CreateOrUpdateExamCenterProctorRequestVerdictOutput', examCenterProctorRequestVerdict: { __typename?: 'ExamCenterProctorRequestVerdict', id: string, examCenterProctorRequestId: string, step: ExamCenterProctorRequestVerdictStep, requestedAt: Date, verdict: Verdict | null, comment: string | null, submittedAt: Date | null, updatedBy: string, updatedAt: Date, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null } } };

export type SubmitExamCenterProctorRequestVerdictMutationVariables = Exact<{
  submitReviewExamCenterProctorRequestInput: SubmitReviewExamCenterProctorRequestInput;
}>;


export type SubmitExamCenterProctorRequestVerdictMutation = { __typename?: 'Mutation', ecSubmitReviewExamCenterProctorRequest: { __typename?: 'SubmitReviewExamCenterProctorRequestOutput', examCenterProctorRequest: { __typename?: 'ExamCenterProctorRequest', id: string, examCenterCode: string, examCenterProctorId: string | null, type: ExamCenterProctorRequestType, step: ExamCenterProctorRequestStep, taskId: string | null, refCode: string | null, titleTh: string, titleEn: string, idNumber: string, firstNameTh: string, firstNameEn: string, middleNameTh: string | null, middleNameEn: string | null, lastNameTh: string, lastNameEn: string, email: string, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, requestedAt: Date | null, requestedBy: string | null, editedBy: string | null, editedAt: Date | null, metadata: { __typename?: 'ExamCenterProctorRequestMetadata', employeeId: string | null, position: string | null, department: string | null } | null, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorRequestStorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }>, personalInfoStorageObjects: Array<{ __typename?: 'ExamCenterProctorRequestStorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }>, editedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null, verdicts: Array<{ __typename?: 'ExamCenterProctorRequestVerdict', id: string, examCenterProctorRequestId: string, step: ExamCenterProctorRequestVerdictStep, requestedAt: Date, verdict: Verdict | null, comment: string | null, submittedAt: Date | null, updatedBy: string, updatedAt: Date, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }> } } };

export type SearchExamCenterProctorRequestsQueryVariables = Exact<{
  searchExamCenterProctorRequestsInput: SearchExamCenterProctorRequestsInput;
}>;


export type SearchExamCenterProctorRequestsQuery = { __typename?: 'Query', ecSearchExamCenterProctorRequests: { __typename?: 'SearchExamCenterProctorRequestsOutput', total: number, examCenterProctorRequests: Array<{ __typename?: 'ExamCenterProctorRequest', id: string, examCenterCode: string, examCenterProctorId: string | null, type: ExamCenterProctorRequestType, step: ExamCenterProctorRequestStep, taskId: string | null, refCode: string | null, titleTh: string, titleEn: string, idNumber: string, firstNameTh: string, firstNameEn: string, middleNameTh: string | null, middleNameEn: string | null, lastNameTh: string, lastNameEn: string, email: string, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, requestedAt: Date | null, requestedBy: string | null, editedBy: string | null, editedAt: Date | null, metadata: { __typename?: 'ExamCenterProctorRequestMetadata', employeeId: string | null, position: string | null, department: string | null } | null, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorRequestStorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }>, personalInfoStorageObjects: Array<{ __typename?: 'ExamCenterProctorRequestStorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }>, editedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null, verdicts: Array<{ __typename?: 'ExamCenterProctorRequestVerdict', id: string, examCenterProctorRequestId: string, step: ExamCenterProctorRequestVerdictStep, requestedAt: Date, verdict: Verdict | null, comment: string | null, submittedAt: Date | null, updatedBy: string, updatedAt: Date, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }> }> } };

export type GetDownloadSignedUrlForExamCenterProctorRequestQueryVariables = Exact<{
  getDownloadSignedUrlForExamCenterProctorRequestInput: GetDownloadSignedUrlForExamCenterProctorRequestInput;
}>;


export type GetDownloadSignedUrlForExamCenterProctorRequestQuery = { __typename?: 'Query', ecGetDownloadSignedUrlForExamCenterProctorRequest: { __typename?: 'GetDownloadSignedUrlForExamCenterProctorRequestOutput', signedUrls: any } };

export type AdminGetDownloadSignedUrlForExamCenterProctorRequestQueryVariables = Exact<{
  getDownloadSignedUrlForExamCenterProctorRequestInput: GetDownloadSignedUrlForExamCenterProctorRequestInput;
}>;


export type AdminGetDownloadSignedUrlForExamCenterProctorRequestQuery = { __typename?: 'Query', ecAdminGetDownloadSignedUrlForExamCenterProctorRequest: { __typename?: 'GetDownloadSignedUrlForExamCenterProctorRequestOutput', signedUrls: any } };

export type SaveExamCenterProctorRequestAsDraftMutationVariables = Exact<{
  saveExamCenterProctorRequestAsDraftInput: SaveExamCenterProctorRequestAsDraftInput;
}>;


export type SaveExamCenterProctorRequestAsDraftMutation = { __typename?: 'Mutation', ecSaveExamCenterProctorRequestAsDraft: { __typename?: 'SaveExamCenterProctorRequestAsDraftOutput', examCenterProctorRequest: { __typename?: 'ExamCenterProctorRequest', id: string } } };

export type AdminSearchMyExamCenterProctorRequestsQueryVariables = Exact<{
  adminSearchExamCenterProctorRequestsInput: AdminSearchMyExamCenterProctorRequestsInput;
}>;


export type AdminSearchMyExamCenterProctorRequestsQuery = { __typename?: 'Query', ecAdminSearchMyExamCenterProctorRequests: { __typename?: 'AdminSearchExamCenterProctorRequestsOutput', total: number, examCenterProctorRequests: Array<{ __typename?: 'ExamCenterProctorRequest', id: string, examCenterCode: string, examCenterProctorId: string | null, type: ExamCenterProctorRequestType, step: ExamCenterProctorRequestStep, taskId: string | null, refCode: string | null, titleTh: string, titleEn: string, idNumber: string, firstNameTh: string, firstNameEn: string, middleNameTh: string | null, middleNameEn: string | null, lastNameTh: string, lastNameEn: string, email: string, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, requestedAt: Date | null, requestedBy: string | null, editedBy: string | null, editedAt: Date | null, metadata: { __typename?: 'ExamCenterProctorRequestMetadata', employeeId: string | null, position: string | null, department: string | null } | null, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorRequestStorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }>, personalInfoStorageObjects: Array<{ __typename?: 'ExamCenterProctorRequestStorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null }>, editedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null, verdicts: Array<{ __typename?: 'ExamCenterProctorRequestVerdict', id: string, examCenterProctorRequestId: string, step: ExamCenterProctorRequestVerdictStep, requestedAt: Date, verdict: Verdict | null, comment: string | null, submittedAt: Date | null, updatedBy: string, updatedAt: Date, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }> }> } };

export type SearchExamCentersQueryVariables = Exact<{
  searchExamCentersInput: SearchExamCentersInput;
}>;


export type SearchExamCentersQuery = { __typename?: 'Query', ecSearchExamCenters: { __typename?: 'SearchExamCentersOutput', examCenters: Array<{ __typename?: 'ExamCenter', id: string, nameTH: string, nameEN: string, code: string, examCenterId: number }> } };

export type CreateExamCenterMutationVariables = Exact<{
  createExamCenterInput: CreateExamCenterInput;
}>;


export type CreateExamCenterMutation = { __typename?: 'Mutation', ecCreateExamCenter: { __typename?: 'CreateExamCenterOutput', examCenter: { __typename?: 'ExamCenter', code: string } } };

export type AdminUpdateExamCenterMutationVariables = Exact<{
  adminUpdateExamCenterInput: AdminUpdateExamCenterInput;
}>;


export type AdminUpdateExamCenterMutation = { __typename?: 'Mutation', ecAdminUpdateExamCenter: { __typename?: 'AdminUpdateExamCenterOutput', examCenter: { __typename?: 'ExamCenter', code: string } } };

export type UpdateExamCenterMutationVariables = Exact<{
  updateExamCenterInput: UpdateExamCenterInput;
}>;


export type UpdateExamCenterMutation = { __typename?: 'Mutation', ecUpdateExamCenter: { __typename?: 'UpdateExamCenterOutput', examCenter: { __typename?: 'ExamCenter', code: string } } };

export type GetExamCenterByExamCenterCodeQueryVariables = Exact<{
  getExamCenterByExamCenterCodeInput: GetExamCenterByExamCenterCodeInput;
}>;


export type GetExamCenterByExamCenterCodeQuery = { __typename?: 'Query', ecGetExamCenterByExamCenterCode: { __typename?: 'GetExamCenterByExamCenterCodeOutput', examCenter: { __typename?: 'ExamCenter', id: string, nameTH: string, nameEN: string, addressTH: string | null, addressEN: string | null, phoneTH: string | null, phoneEN: string | null, website: string | null, email: string | null, examResultRecipientEmail: string | null, code: string, examCenterId: number } } };

export type AdminGetExamCenterByExamCenterCodeQueryVariables = Exact<{
  getExamCenterByExamCenterCodeInput: GetExamCenterByExamCenterCodeInput;
}>;


export type AdminGetExamCenterByExamCenterCodeQuery = { __typename?: 'Query', ecAdminGetExamCenterByExamCenterCode: { __typename?: 'GetExamCenterByExamCenterCodeOutput', examCenter: { __typename?: 'ExamCenter', id: string, nameTH: string, nameEN: string, addressTH: string | null, addressEN: string | null, phoneTH: string | null, phoneEN: string | null, website: string | null, email: string | null, examResultRecipientEmail: string | null, code: string, examCenterId: number } } };

export type GetMyExamCentersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyExamCentersQuery = { __typename?: 'Query', ecGetMyExamCenters: { __typename?: 'GetMyExamCentersOutput', examCenters: Array<{ __typename?: 'ExamCenter', id: string, nameTH: string, code: string, logoSrc: string | null, examCenterId: number }> } };

export type SearchExamCenterCoursesQueryVariables = Exact<{
  searchExamCenterCoursesInput: SearchExamCenterCoursesInput;
}>;


export type SearchExamCenterCoursesQuery = { __typename?: 'Query', ecSearchExamCenterCourses: { __typename?: 'SearchExamCenterCoursesOutput', total: number, examCenterCourses: Array<{ __typename?: 'ExamCenterCourse', id: string, createdAt: Date, examCourse: { __typename?: 'ExamCourse', id: string, examId: number, code: string, name: string, type: ExamCourseType, language: ExamCourseLanguage } }> } };

export type AdminSearchExamCenterCoursesQueryVariables = Exact<{
  searchExamCenterCoursesInput: SearchExamCenterCoursesInput;
}>;


export type AdminSearchExamCenterCoursesQuery = { __typename?: 'Query', ecAdminSearchExamCenterCourses: { __typename?: 'SearchExamCenterCoursesOutput', total: number, examCenterCourses: Array<{ __typename?: 'ExamCenterCourse', id: string, createdAt: Date, examCourse: { __typename?: 'ExamCourse', id: string, examId: number, code: string, name: string, type: ExamCourseType, language: ExamCourseLanguage } }> } };

export type ExportExaminationCodesByExamEventIdQueryVariables = Exact<{
  exportExaminationCodesByExamEventIdInput: ExportExaminationCodesByExamEventIdInput;
}>;


export type ExportExaminationCodesByExamEventIdQuery = { __typename?: 'Query', ecExportExaminationCodesByExamEventId: { __typename?: 'ExportExaminationCodesByExamEventIdOutput', url: string } };

export type ExportExaminationCodeByExamEventExamineeIdQueryVariables = Exact<{
  exportExaminationCodeByExamEventExamineeIdInput: ExportExaminationCodeByExamEventExamineeIdInput;
}>;


export type ExportExaminationCodeByExamEventExamineeIdQuery = { __typename?: 'Query', ecExportExaminationCodeByExamEventExamineeId: { __typename?: 'ExportExaminationCodeByExamEventExamineeIdOutput', url: string } };

export type GetAllExamCentersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllExamCentersQuery = { __typename?: 'Query', ecGetAllExamCenters: { __typename?: 'GetAllExamCentersOutput', examCenters: Array<{ __typename?: 'ExamCenter', id: string, code: string, examCenterId: number }> } };

export type GetExamEventResultSummaryQueryVariables = Exact<{
  getExamEventResultSummaryInput: GetExamEventResultSummaryInput;
}>;


export type GetExamEventResultSummaryQuery = { __typename?: 'Query', ecGetExamEventResultSummary: { __typename?: 'GetExamEventResultSummaryOutput', passed: number, failed: number, absent: number, canceled: number } };

export type SearchExamCoursesQueryVariables = Exact<{
  searchExamCoursesInput: SearchExamCoursesInput;
}>;


export type SearchExamCoursesQuery = { __typename?: 'Query', ecSearchExamCourses: { __typename?: 'SearchExamCoursesOutput', total: number, examCourses: Array<{ __typename?: 'ExamCourse', id: string, examId: number, code: string, name: string, type: ExamCourseType, language: ExamCourseLanguage }> } };

export type EnableExamCourseByIdMutationVariables = Exact<{
  enableExamCourseByIdInput: EnableExamCourseByIdInput;
}>;


export type EnableExamCourseByIdMutation = { __typename?: 'Mutation', ecEnableExamCourseById: { __typename?: 'EnableExamCourseByIdOutput', examCourse: { __typename?: 'ExamCourse', id: string, code: string } } };

export type GetExamCourseByExamCourseCodeQueryVariables = Exact<{
  getExamCourseByExamCourseCodeInput: GetExamCourseByExamCourseCodeInput;
}>;


export type GetExamCourseByExamCourseCodeQuery = { __typename?: 'Query', ecGetExamCourseByExamCourseCode: { __typename?: 'GetExamCourseByExamCourseCodeOutput', examCourse: { __typename?: 'ExamCourse', id: string, name: string, examId: number, type: ExamCourseType, language: ExamCourseLanguage, updatedAt: Date } } };

export type GetExamCourseSettingsByExamCourseCodeQueryVariables = Exact<{
  getExamCourseByExamCourseCodeInput: GetExamCourseByExamCourseCodeInput;
}>;


export type GetExamCourseSettingsByExamCourseCodeQuery = { __typename?: 'Query', ecGetExamCourseByExamCourseCode: { __typename?: 'GetExamCourseByExamCourseCodeOutput', examCourse: { __typename?: 'ExamCourse', type: ExamCourseType, language: ExamCourseLanguage, settings: { __typename?: 'ExamCourseSettings', resultSend: { __typename?: 'ResultSendSettings', portal: boolean }, resultDisplay: { __typename?: 'ResultDisplaySettings', examResult: boolean }, certificate: { __typename?: 'CertificateSettings', averageScoreCondition: ExamCourseCertificateAverageScoreCondition | null, delayedDays: number | null, failedTemplate: ExamCourseCertificateFailedTemplate, passedTemplate: ExamCourseCertificatePassedTemplate, validityDurationYears: number | null } | null, examDuration: { __typename?: 'ExamDurationSettings', type: ExamDurationSessionType, sessions: Array<{ __typename?: 'ExamDurationSession', order: number, value: number }> } | null, questionnaire: { __typename?: 'QuestionnaireSettings', templateId: QuestionnaireTemplateId | null }, attachDocument: { __typename?: 'AttachDocumentSettings', fileName: string | null, key: string } | null } } } };

export type UpdateExamCourseSettingsMutationVariables = Exact<{
  updateExamCourseSettingsInput: UpdateExamCourseSettingsInput;
}>;


export type UpdateExamCourseSettingsMutation = { __typename?: 'Mutation', ecUpdateExamCourseSettings: { __typename?: 'UpdateExamCourseSettingsOutput', examCourse: { __typename?: 'ExamCourse', id: string, settings: { __typename?: 'ExamCourseSettings', resultSend: { __typename?: 'ResultSendSettings', portal: boolean }, resultDisplay: { __typename?: 'ResultDisplaySettings', examResult: boolean }, certificate: { __typename?: 'CertificateSettings', averageScoreCondition: ExamCourseCertificateAverageScoreCondition | null, delayedDays: number | null, failedTemplate: ExamCourseCertificateFailedTemplate, passedTemplate: ExamCourseCertificatePassedTemplate, validityDurationYears: number | null } | null, examDuration: { __typename?: 'ExamDurationSettings', type: ExamDurationSessionType, sessions: Array<{ __typename?: 'ExamDurationSession', order: number, value: number }> } | null, questionnaire: { __typename?: 'QuestionnaireSettings', templateId: QuestionnaireTemplateId | null }, attachDocument: { __typename?: 'AttachDocumentSettings', fileName: string | null, key: string } | null } } } };

export type GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery = { __typename?: 'Query', ecGetAllExamCoursesWithAvailableQSetsAndExamCenterCourses: { __typename?: 'GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesOutput', examCoursesWithAvailableQSetsAndExamCenterCourses: Array<{ __typename?: 'ExamCoursesWithAvailableQSetsAndExamCenterCourses', examId: number, code: string, name: string, settings: { __typename?: 'ExamCourseSettings', examDuration: { __typename?: 'ExamDurationSettings', type: ExamDurationSessionType, sessions: Array<{ __typename?: 'ExamDurationSession', order: number, value: number }> } | null }, availableQSets: Array<{ __typename?: 'QSet', id: string, code: string }>, examCenterCourses: Array<{ __typename?: 'ExamCenterCourse', id: string, examCenterCode: string, examCourseId: string, examCourseCode: string, name: string }> }> } };

export type GetAllEnabledExamCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEnabledExamCoursesQuery = { __typename?: 'Query', ecGetAllEnabledExamCourses: { __typename?: 'GetAllEnabledExamCoursesOutput', examCourses: Array<{ __typename?: 'ExamCourse', id: string, code: string, examId: number, name: string, type: ExamCourseType }> } };

export type GetUploadSignedUrlForExamCourseAttachDocumentQueryVariables = Exact<{
  getUploadSignedUrlForExamCourseAttachDocumentInput: GetUploadSignedUrlForExamCourseAttachDocumentInput;
}>;


export type GetUploadSignedUrlForExamCourseAttachDocumentQuery = { __typename?: 'Query', ecGetUploadSignedUrlForExamCourseAttachDocument: { __typename?: 'GetUploadSignedUrlForExamCourseAttachDocumentOutput', url: string, storageObject: { __typename?: 'StorageObject', fileName: string | null } } };

export type GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables = Exact<{
  getExamCourseByExamCourseCodeInput: GetExamCourseByExamCourseCodeInput;
}>;


export type GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery = { __typename?: 'Query', ecGetExamCourseByExamCourseCode: { __typename?: 'GetExamCourseByExamCourseCodeOutput', examCourse: { __typename?: 'ExamCourse', settings: { __typename?: 'ExamCourseSettings', examDuration: { __typename?: 'ExamDurationSettings', type: ExamDurationSessionType, sessions: Array<{ __typename?: 'ExamDurationSession', order: number, value: number }> } | null } } } };

export type GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables = Exact<{
  getExamCourseByExamCourseCodeInput: GetExamCourseByExamCourseCodeInput;
}>;


export type GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery = { __typename?: 'Query', ecGetExamCourseByExamCourseCode: { __typename?: 'GetExamCourseByExamCourseCodeOutput', examCourse: { __typename?: 'ExamCourse', language: ExamCourseLanguage, type: ExamCourseType, settings: { __typename?: 'ExamCourseSettings', resultSend: { __typename?: 'ResultSendSettings', portal: boolean }, resultDisplay: { __typename?: 'ResultDisplaySettings', examResult: boolean }, certificate: { __typename?: 'CertificateSettings', averageScoreCondition: ExamCourseCertificateAverageScoreCondition | null, delayedDays: number | null, failedTemplate: ExamCourseCertificateFailedTemplate, passedTemplate: ExamCourseCertificatePassedTemplate, validityDurationYears: number | null } | null, questionnaire: { __typename?: 'QuestionnaireSettings', templateId: QuestionnaireTemplateId | null }, attachDocument: { __typename?: 'AttachDocumentSettings', fileName: string | null, key: string } | null } } } };

export type GetExamEventCoursesByExamEventIdsQueryVariables = Exact<{
  input: GetExamEventCoursesByExamEventIdsInput;
}>;


export type GetExamEventCoursesByExamEventIdsQuery = { __typename?: 'Query', ecGetExamEventCoursesByExamEventIds: { __typename?: 'GetExamEventCoursesByExamEventIdsOutput', examEventCourses: Array<{ __typename?: 'ExamEventCourse', id: string, examEventId: string, examCourseId: string, status: ExamEventCourseStatus, qSet: { __typename?: 'QSet', id: string, code: string } | null, examCourse: { __typename?: 'ExamCourse', id: string, code: string, examId: number, name: string } | null }> } };

export type GetExamCoursesByExamEventIdQueryVariables = Exact<{
  input: GetExamCoursesByExamEventIdInput;
}>;


export type GetExamCoursesByExamEventIdQuery = { __typename?: 'Query', ecGetExamCoursesByExamEventId: { __typename?: 'GetExamCoursesByExamEventIdOutput', examCourses: Array<{ __typename?: 'ExamCourse', id: string, code: string, name: string }> } };

export type GetExamEventParticipatedCoursesQueryVariables = Exact<{
  input: GetExamEventParticipatedCoursesInput;
}>;


export type GetExamEventParticipatedCoursesQuery = { __typename?: 'Query', ecGetExamEventParticipatedCourses: { __typename?: 'GetExamEventParticipatedCoursesOutput', examEventCourses: Array<{ __typename?: 'ExamEventCourse', id: string, examEventId: string, examCourseId: string, status: ExamEventCourseStatus, metadata: { __typename?: 'ExamEventCourseMetadata', sessionTimeAdjustments: Array<{ __typename?: 'ExamEventCourseSessionTimeAdjustment', sessionId: string, extendDurationInMs: number, maxExtendableDurationInMs: number }> | null, settings: { __typename?: 'ExamEventCourseSettings', examDuration: { __typename?: 'ExamDurationSettings', type: ExamDurationSessionType, sessions: Array<{ __typename?: 'ExamDurationSession', order: number, value: number }> } | null } } | null, examCourse: { __typename?: 'ExamCourse', id: string, code: string, name: string } | null }> } };

export type ManuallyAssignedExamEventCoursesMutationVariables = Exact<{
  input: ManuallyAssignedExamEventCoursesInput;
}>;


export type ManuallyAssignedExamEventCoursesMutation = { __typename?: 'Mutation', ecManuallyAssignedExamEventCourses: { __typename?: 'ManuallyAssignedExamEventCoursesOutput', examEventCourses: Array<{ __typename?: 'ExamEventCourse', id: string, examEventId: string, examCourseId: string, qSetId: string | null, examId: string | null, status: ExamEventCourseStatus }> } };

export type GetAvailableQSetsByExamEventIdQueryVariables = Exact<{
  input: GetAvailableQSetsByExamEventIdInput;
}>;


export type GetAvailableQSetsByExamEventIdQuery = { __typename?: 'Query', ecGetAvailableQSetsByExamEventId: { __typename?: 'GetAvailableQSetsByExamEventIdOutput', examEventCoursesWithAssignableQSets: Array<{ __typename?: 'ExamEventCourseWithAssignableQSetsObjectType', examEventCourse: { __typename?: 'ExamEventCourse', id: string, status: ExamEventCourseStatus, examCourse: { __typename?: 'ExamCourse', id: string, code: string, examId: number, settings: { __typename?: 'ExamCourseSettings', examDuration: { __typename?: 'ExamDurationSettings', type: ExamDurationSessionType, sessions: Array<{ __typename?: 'ExamDurationSession', order: number, value: number }> } | null } } | null, qSet: { __typename?: 'QSet', id: string, code: string } | null }, availableQSets: Array<{ __typename?: 'QSet', id: string, code: string }> }>, examEvent: { __typename?: 'ExamEvent', id: string, name: string, examCenterCode: string, examStartedAt: Date, examEndedAt: Date, roundNumber: number, registrationType: RegistrationType, sessions: Array<{ __typename?: 'ExamEventSession', id: string, round: number, startedAt: Date, endedAt: Date }>, examLocation: { __typename?: 'Location', nameTh: string, nameEn: string | null, province: { __typename?: 'Province', nameTh: string } } } } };

export type ExamEventDetailsFragment = { __typename?: 'ExamEvent', id: string, name: string, updatedAt: Date, ictExamYear: number, examType: ExamType, status: ExamEventStatus, seat: number, roundNumber: number, registrationType: RegistrationType, registrationStatus: RegistrationStatus, examStartedAt: Date, examEndedAt: Date, postponeStartDurationInMs: number | null, postponeEndDurationInMs: number | null, postponementRemark: string | null, registrationStartedAt: Date, registrationEndedAt: Date, metadata: any, numberOfExaminees: number | null, examLocation: { __typename?: 'Location', id: string, nameTh: string, province: { __typename?: 'Province', id: string, nameTh: string } }, rooms: Array<{ __typename?: 'Room', id: string, name: string, buildingId: string, floor: string, roomNumber: string | null, seat: number, building: { __typename?: 'Building', nameTh: string, id: string } }> | null, proctors: Array<{ __typename?: 'ExamCenterProctor', id: string, examCenterCode: string, type: ExamCenterProctorType, titleTh: string, firstNameTh: string, middleNameTh: string | null, lastNameTh: string }> | null, sessions: Array<{ __typename?: 'ExamEventSession', id: string, examEventId: string, round: number, startedAt: Date, endedAt: Date, proctorStartedAt: Date | null, proctorEndedAt: Date | null, postponeDurationInMs: number | null }>, downloadedUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null };

export type GetAllProvincesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProvincesQuery = { __typename?: 'Query', ecGetAllProvinces: { __typename?: 'GetAllProvincesOutput', provinces: Array<{ __typename?: 'Province', nameTh: string, id: string }> } };

export type GetLocationsByProvinceIdQueryVariables = Exact<{
  getLocationsByProvinceIdInput: GetLocationsByProvinceIdInput;
}>;


export type GetLocationsByProvinceIdQuery = { __typename?: 'Query', ecGetLocationsByProvinceId: { __typename?: 'GetLocationsByProvinceIdOutput', locations: Array<{ __typename?: 'Location', id: string, nameTh: string, nameEn: string | null, provinceId: string }> } };

export type GetAvailableRoomsByLocationIdAndTimeFrameQueryVariables = Exact<{
  getAvailableRoomsByLocationIdAndTimeFrameInput: GetAvailableRoomsByLocationIdAndTimeFrameInput;
}>;


export type GetAvailableRoomsByLocationIdAndTimeFrameQuery = { __typename?: 'Query', ecGetAvailableRoomsByLocationIdAndTimeFrame: { __typename?: 'GetAvailableRoomsByLocationIdAndTimeFrameOutput', rooms: Array<{ __typename?: 'Room', id: string, name: string, buildingId: string, floor: string, roomNumber: string | null, seat: number, building: { __typename?: 'Building', id: string, nameTh: string } }> } };

export type SearchAvailableExamCenterProctorsByTimeFrameQueryVariables = Exact<{
  searchAvailableExamCenterProctorsByTimeFrameInput: SearchAvailableExamCenterProctorsByTimeFrameInput;
}>;


export type SearchAvailableExamCenterProctorsByTimeFrameQuery = { __typename?: 'Query', ecSearchAvailableExamCenterProctorsByTimeFrame: { __typename?: 'SearchAvailableExamCenterProctorsByTimeFrameOutput', total: number, examCenterProctors: Array<{ __typename?: 'ExamCenterProctor', id: string, examCenterCode: string, type: ExamCenterProctorType, titleTh: string, firstNameTh: string, middleNameTh: string | null, lastNameTh: string }> } };

export type CreateExamEventMutationVariables = Exact<{
  createExamEventInput: CreateExamEventInput;
}>;


export type CreateExamEventMutation = { __typename?: 'Mutation', ecCreateExamEvent: { __typename?: 'CreateExamEventOutput', examEvent: { __typename?: 'ExamEvent', id: string } } };

export type GetExamEventByIdQueryVariables = Exact<{
  getExamEventByIdInput: GetExamEventByIdInput;
}>;


export type GetExamEventByIdQuery = { __typename?: 'Query', ecGetExamEventById: { __typename?: 'GetExamEventByIdOutput', examEvent: { __typename?: 'ExamEvent', examCenterCode: string, id: string, name: string, updatedAt: Date, ictExamYear: number, examType: ExamType, status: ExamEventStatus, seat: number, roundNumber: number, registrationType: RegistrationType, registrationStatus: RegistrationStatus, examStartedAt: Date, examEndedAt: Date, postponeStartDurationInMs: number | null, postponeEndDurationInMs: number | null, postponementRemark: string | null, registrationStartedAt: Date, registrationEndedAt: Date, metadata: any, numberOfExaminees: number | null, courses: Array<{ __typename?: 'ExamEventCourse', id: string, status: ExamEventCourseStatus, metadata: { __typename?: 'ExamEventCourseMetadata', settings: { __typename?: 'ExamEventCourseSettings', examDuration: { __typename?: 'ExamDurationSettings', type: ExamDurationSessionType, sessions: Array<{ __typename?: 'ExamDurationSession', order: number, value: number }> } | null }, sessionTimeAdjustments: Array<{ __typename?: 'ExamEventCourseSessionTimeAdjustment', sessionId: string, maxExtendableDurationInMs: number }> | null } | null, examCourse: { __typename?: 'ExamCourse', id: string, name: string, code: string } | null }>, examLocation: { __typename?: 'Location', id: string, nameTh: string, province: { __typename?: 'Province', id: string, nameTh: string } }, rooms: Array<{ __typename?: 'Room', id: string, name: string, buildingId: string, floor: string, roomNumber: string | null, seat: number, building: { __typename?: 'Building', nameTh: string, id: string } }> | null, proctors: Array<{ __typename?: 'ExamCenterProctor', id: string, examCenterCode: string, type: ExamCenterProctorType, titleTh: string, firstNameTh: string, middleNameTh: string | null, lastNameTh: string }> | null, sessions: Array<{ __typename?: 'ExamEventSession', id: string, examEventId: string, round: number, startedAt: Date, endedAt: Date, proctorStartedAt: Date | null, proctorEndedAt: Date | null, postponeDurationInMs: number | null }>, downloadedUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null } } };

export type GetIctExamEventYearsByExamCenterCodeQueryVariables = Exact<{
  getICTExamEventYearsByExamCenterCodeInput: GetIctExamEventYearsByExamCenterCodeInput;
}>;


export type GetIctExamEventYearsByExamCenterCodeQuery = { __typename?: 'Query', ecGetICTExamEventYearsByExamCenterCode: { __typename?: 'GetICTExamEventYearsByExamCenterCodeOutput', ictExamYears: Array<number> } };

export type GetMonthlyExamEventOverviewQueryVariables = Exact<{
  getMonthlyExamEventOverviewInput: GetMonthlyExamEventOverviewInput;
}>;


export type GetMonthlyExamEventOverviewQuery = { __typename?: 'Query', ecGetMonthlyExamEventOverview: { __typename?: 'GetMonthlyExamEventOverviewOutput', overview: Array<{ __typename?: 'MonthlyExamEventResult', month: number, courses: number, events: number }> } };

export type GetAllExamEventsByExamCenterCodeQueryVariables = Exact<{
  getAllExamEventsByExamCenterCodeInput: GetAllExamEventsByExamCenterCodeInput;
}>;


export type GetAllExamEventsByExamCenterCodeQuery = { __typename?: 'Query', ecGetAllExamEventsByExamCenterCode: { __typename?: 'GetAllExamEventsByExamCenterCodeOutput', total: number, examEvents: Array<{ __typename?: 'ExamEvent', id: string, registrationType: RegistrationType, registrationStatus: RegistrationStatus, status: ExamEventStatus, seat: number, roundNumber: number, examStartedAt: Date, examEndedAt: Date, ictExamYear: number, registrationStartedAt: Date, registrationEndedAt: Date, metadata: any, createdAt: Date, numberOfExaminees: number | null, name: string, examCenterCode: string, examLocation: { __typename?: 'Location', id: string, nameTh: string, provinceId: string, province: { __typename?: 'Province', id: string, nameTh: string } } }> } };

export type UpdateExamEventMutationVariables = Exact<{
  updateExamEventInput: UpdateExamEventInput;
}>;


export type UpdateExamEventMutation = { __typename?: 'Mutation', ecUpdateExamEvent: { __typename?: 'UpdateExamEventOutput', examEvent: { __typename?: 'ExamEvent', id: string, name: string, updatedAt: Date, ictExamYear: number, examType: ExamType, status: ExamEventStatus, seat: number, roundNumber: number, registrationType: RegistrationType, registrationStatus: RegistrationStatus, examStartedAt: Date, examEndedAt: Date, postponeStartDurationInMs: number | null, postponeEndDurationInMs: number | null, postponementRemark: string | null, registrationStartedAt: Date, registrationEndedAt: Date, metadata: any, numberOfExaminees: number | null, examLocation: { __typename?: 'Location', id: string, nameTh: string, province: { __typename?: 'Province', id: string, nameTh: string } }, rooms: Array<{ __typename?: 'Room', id: string, name: string, buildingId: string, floor: string, roomNumber: string | null, seat: number, building: { __typename?: 'Building', nameTh: string, id: string } }> | null, proctors: Array<{ __typename?: 'ExamCenterProctor', id: string, examCenterCode: string, type: ExamCenterProctorType, titleTh: string, firstNameTh: string, middleNameTh: string | null, lastNameTh: string }> | null, sessions: Array<{ __typename?: 'ExamEventSession', id: string, examEventId: string, round: number, startedAt: Date, endedAt: Date, proctorStartedAt: Date | null, proctorEndedAt: Date | null, postponeDurationInMs: number | null }>, downloadedUser: { __typename?: 'RawUser', firstname: string, lastname: string } | null } } };

export type UnassignExamsMutationVariables = Exact<{
  unassignExamsInput: UnassignExamsInput;
}>;


export type UnassignExamsMutation = { __typename?: 'Mutation', ecUnassignExams: { __typename?: 'UnassignExamsOutput', message: string, status: GenericResponseStatus } };

export type AssignExamsByExamCourseCodesAndMonthOfYearMutationVariables = Exact<{
  assignExamsByExamCourseCodesAndMonthOfYearInput: AssignExamsByExamCourseCodesAndMonthOfYearInput;
}>;


export type AssignExamsByExamCourseCodesAndMonthOfYearMutation = { __typename?: 'Mutation', ecAssignExamsByExamCourseCodesAndMonthOfYear: { __typename?: 'AssignExamsByExamCourseCodesAndMonthOfYearOutput', examCoursesChosen: number, examEventsAssigned: number } };

export type GetMyProctorExamEventsQueryVariables = Exact<{
  getMyProctorExamEventsInput: GetMyProctorExamEventsInput;
}>;


export type GetMyProctorExamEventsQuery = { __typename?: 'Query', ecGetMyProctorExamEvents: { __typename?: 'GetAllExamEventsByExamCenterCodeOutput', total: number, examEvents: Array<{ __typename?: 'ExamEvent', id: string, registrationType: RegistrationType, registrationStatus: RegistrationStatus, status: ExamEventStatus, seat: number, roundNumber: number, examStartedAt: Date, examEndedAt: Date, ictExamYear: number, registrationStartedAt: Date, registrationEndedAt: Date, metadata: any, createdAt: Date, numberOfExaminees: number | null, name: string, examCenterCode: string, examLocation: { __typename?: 'Location', id: string, nameTh: string, provinceId: string, province: { __typename?: 'Province', id: string, nameTh: string } } }> } };

export type GetExamEventExamineesForMonitoringQueryVariables = Exact<{
  examEventId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  searchExaminee: InputMaybe<SearchExamineeInput>;
  paging: InputMaybe<PagingInput>;
}>;


export type GetExamEventExamineesForMonitoringQuery = { __typename?: 'Query', ecGetExamEventExamineesForSession: { __typename?: 'GetExamEventExamineesForSessionOutput', total: number, result: Array<{ __typename?: 'ExamEventExamineeForSession', examEndedAt: Date | null, examEventExaminee: { __typename?: 'ExamEventExaminee', id: string, seatNumber: number | null, status: ExamEventExamineeStatus, email: string, isExamReady: boolean, certificateStatus: ExamEventExamineeCertificateStatus, registrationStatus: ExamineeRegistrationStatus, sentToSETPortalAt: Date | null, cancelationReason: CancelationReason | null, remark: string | null, examinee: { __typename?: 'Examinee', middleName: string | null, lastName: string, firstName: string, title: string, idNumber: string, eKycStatus: EKycVerificationStatus }, examCourse: { __typename?: 'ExamCourse', id: string, code: string }, examEventExamineeResult: { __typename?: 'ExamEventExamineeResult', result: ExamResult } | null, examEventSessionExaminee: { __typename?: 'ExamEventSessionExaminee', examStartedAt: Date | null, loginStatus: ProgressStatus, examStatus: ProgressStatus, examSubmitStatus: ProgressStatus, questionnaireStatus: ProgressStatus } | null } }> } };

export type GetExamEventSessionByIdQueryVariables = Exact<{
  getExamEventSessionByIdInput: GetExamEventSessionByIdInput;
}>;


export type GetExamEventSessionByIdQuery = { __typename?: 'Query', ecGetExamEventSessionById: { __typename?: 'GetExamEventSessionByIdOutput', examEventSession: { __typename?: 'ExamEventSession', id: string, examEventId: string, round: number, startedAt: Date, endedAt: Date, proctorStartedAt: Date | null, proctorEndedAt: Date | null } } };

export type GenerateSeatNumberMutationVariables = Exact<{
  generateSeatNumberInput: GenerateSeatNumberInput;
}>;


export type GenerateSeatNumberMutation = { __typename?: 'Mutation', ecGenerateSeatNumber: { __typename?: 'GenerateSeatNumberOutput', examEventExaminees: Array<{ __typename?: 'ExamEventExaminee', id: string, seatNumber: number | null }> } };

export type GetAvailableExamEventYearsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableExamEventYearsQuery = { __typename?: 'Query', ecGetAvailableExamEventICTYears: { __typename?: 'GetAvailableExamEventICTYearsOutput', ictExamYears: Array<number> } };

export type GetYearlyExamEventsCountByMonthQueryVariables = Exact<{
  getYearlyExamEventsCountByMonthInput: GetYearlyExamEventsCountByMonthInput;
}>;


export type GetYearlyExamEventsCountByMonthQuery = { __typename?: 'Query', ecGetYearlyExamEventsCountByMonth: { __typename?: 'GetYearlyExamEventsCountByMonthOutput', examEventsCountByMonth: Array<{ __typename?: 'ExamEventsCountByMonth', month: number, examEventsCountByExamCenterCode: any }> } };

export type GetExamEventsByDateRangeQueryVariables = Exact<{
  getExamEventsByDateRangeInput: GetExamEventsByDateRangeInput;
}>;


export type GetExamEventsByDateRangeQuery = { __typename?: 'Query', ecGetExamEventsByDateRange: { __typename?: 'GetExamEventsByDateRangeOutput', examEvents: Array<{ __typename?: 'ExamEvent', id: string, examCenterCode: string, roundNumber: number, registrationType: RegistrationType, registrationStatus: RegistrationStatus, status: ExamEventStatus, examType: ExamType, metadata: any, examStartedAt: Date, examEndedAt: Date, examCenter: { __typename?: 'ExamCenter', examCenterId: number }, examLocation: { __typename?: 'Location', nameTh: string } }> } };

export type GetDipChipDeepLinkUrlQueryVariables = Exact<{
  getDipChipDeepLinkUrlInput: GetDipChipDeepLinkUrlInput;
}>;


export type GetDipChipDeepLinkUrlQuery = { __typename?: 'Query', ecGetDipChipDeepLinkUrl: { __typename?: 'GetDipChipDeepLinkUrlOutput', deepLinkUrl: string } };

export type ValidatedExamEventsQueryVariables = Exact<{
  validateExamEventsCreationInput: ValidateExamEventsCreationInput;
}>;


export type ValidatedExamEventsQuery = { __typename?: 'Query', ecValidateExamEventsCreation: { __typename?: 'ValidateExamEventsCreationOutput', validatedExamEvents: Array<{ __typename?: 'ValidatedExamEvent', registrationStartedAt: Date, registrationEndedAt: Date, examStartedAt: Date, examEndedAt: Date, isValid: boolean, errorCodes: Array<ExamEventErrorCode> }> } };

export type CreateExamEventsMutationVariables = Exact<{
  createExamEventsInput: CreateExamEventsInput;
}>;


export type CreateExamEventsMutation = { __typename?: 'Mutation', ecCreateExamEvents: { __typename?: 'CreateExamEventsOutput', examEvents: Array<{ __typename?: 'ExamEvent', id: string }>, failedExamEvents: Array<{ __typename?: 'FailedExamEvent', requestId: string, errorCodes: Array<ExamEventErrorCode> }> } };

export type EcPostponeExamEventTimeMutationVariables = Exact<{
  postponeExamEventTimeInput: PostponeExamEventTimeInput;
}>;


export type EcPostponeExamEventTimeMutation = { __typename?: 'Mutation', ecPostponeExamEventTime: { __typename?: 'PostponeExamEventTimeOutput', examEvent: { __typename?: 'ExamEvent', id: string } } };

export type ExtendExamEventSessionTimeMutationVariables = Exact<{
  extendExamEventSessionTimeInput: ExtendExamEventSessionTimeInput;
}>;


export type ExtendExamEventSessionTimeMutation = { __typename?: 'Mutation', ecExtendExamEventSessionTime: { __typename?: 'ExtendExamEventSessionTimeOutput', success: boolean } };

export type EcExtendExamEventSessionExamineesTimeMutationVariables = Exact<{
  extendExamEventSessionExamineesTimeInput: ExtendExamEventSessionExamineesTimeInput;
}>;


export type EcExtendExamEventSessionExamineesTimeMutation = { __typename?: 'Mutation', ecExtendExamEventSessionExamineesTime: { __typename?: 'ExtendExamEventSessionExamineesTimeOutput', results: Array<{ __typename?: 'ExtendedExamineeResult', examEventSessionExamineeId: string, extended: boolean, actualExtendedTimeInMs: number, reason: string | null }> } };

export type OverrideExamEventExamineeEmailMutationVariables = Exact<{
  overrideExamEventExamineeEmailInput: OverrideExamEventExamineeEmailInput;
}>;


export type OverrideExamEventExamineeEmailMutation = { __typename?: 'Mutation', ecOverrideExamEventExamineeEmail: { __typename?: 'OverrideExamEventExamineeEmailOutput', examEventExaminee: { __typename?: 'ExamEventExaminee', email: string } } };

export type DownloadExamByExamEventIdMutationVariables = Exact<{
  downloadExamByExamEventIdInput: DownloadExamByExamEventIdInput;
}>;


export type DownloadExamByExamEventIdMutation = { __typename?: 'Mutation', ecDownloadExamByExamEventId: { __typename?: 'DownloadExamByExamEventIdOutput', data: any | null, message: string, status: GenericResponseStatus } };

export type GetUpcomingExamEventsByExamCenterCodeQueryVariables = Exact<{
  getUpcomingExamEventsByExamCenterCodeInput: GetUpcomingExamEventsByExamCenterCodeInput;
}>;


export type GetUpcomingExamEventsByExamCenterCodeQuery = { __typename?: 'Query', ecGetUpcomingExamEventsByExamCenterCode: { __typename?: 'GetUpcomingExamEventsByExamCenterCodeOutput', examEvents: Array<{ __typename?: 'ExamEvent', id: string, registrationType: RegistrationType, registrationStatus: RegistrationStatus, status: ExamEventStatus, seat: number, roundNumber: number, examStartedAt: Date, examEndedAt: Date, metadata: any, numberOfExaminees: number | null, name: string, examCenterCode: string, examLocation: { __typename?: 'Location', id: string, nameTh: string, provinceId: string, province: { __typename?: 'Province', id: string, nameTh: string } } }> } };

export type SearchExamEventsWithQuestionnairesQueryVariables = Exact<{
  searchExamEventsWithQuestionnairesInput: SearchExamEventsWithQuestionnairesInput;
}>;


export type SearchExamEventsWithQuestionnairesQuery = { __typename?: 'Query', ecSearchExamEventsWithQuestionnaires: { __typename?: 'SearchExamEventsWithQuestionnairesOutput', total: number, data: Array<{ __typename?: 'ExamEventWithQuestionnaireCount', questionnaireCount: number, examEvent: { __typename?: 'ExamEvent', id: string, name: string, examEndedAt: Date, examStartedAt: Date, roundNumber: number, registrationType: RegistrationType, examCenter: { __typename?: 'ExamCenter', nameTH: string, code: string }, examLocation: { __typename?: 'Location', nameTh: string, province: { __typename?: 'Province', nameTh: string } } } }> } };

export type SearchExamEventAuditLogQueryVariables = Exact<{
  searchExamEventAuditLogInput: SearchExamEventAuditLogInput;
}>;


export type SearchExamEventAuditLogQuery = { __typename?: 'Query', ecSearchExamEventAuditLog: { __typename?: 'SearchExamEventAuditLogOutput', total: number, examEventAuditLogs: Array<{ __typename?: 'ExamEventAuditLog', id: string, action: AuditActionType, fullName: string, detail: string, actionTime: Date }> } };

export type GetExamCenterEventSummariesQueryVariables = Exact<{
  getExamCenterEventSummariesInput: GetExamCenterEventSummariesInput;
}>;


export type GetExamCenterEventSummariesQuery = { __typename?: 'Query', ecGetExamCenterEventSummaries: { __typename?: 'GetExamCenterEventSummariesOutput', examCenterEventSummaries: { __typename?: 'ExamCenterEventSummaries', publicRoundCount: number, inHouseRoundCount: number, publicSeatCount: number, inHouseSeatCount: number, publicExamEventExamineeCount: number, inHouseExamEventExamineeCount: number, publicAttendedExamineeCount: number, inHouseAttendedExamineeCount: number, publicAbsentExamineeCount: number, inHouseAbsentExamineeCount: number, publicCanceledExamineeCount: number, inHouseCanceledExamineeCount: number } } };

export type GetExamCenterLocationsByProvinceIdQueryVariables = Exact<{
  getExamCenterLocationsByProvinceIdInput: GetExamCenterLocationsByProvinceIdInput;
}>;


export type GetExamCenterLocationsByProvinceIdQuery = { __typename?: 'Query', ecGetExamCenterLocationsByProvinceId: { __typename?: 'GetExamCenterLocationsByProvinceIdOutput', examCenterLocations: Array<{ __typename?: 'ExamCenterLocation', id: string, location: { __typename?: 'Location', id: string, nameTh: string } | null }> } };

export type GetExamEventSessionExamineesForTimeExtensionQueryVariables = Exact<{
  getExamEventSessionExamineesForTimeExtensionInput: GetExamEventSessionExamineesForTimeExtensionInput;
}>;


export type GetExamEventSessionExamineesForTimeExtensionQuery = { __typename?: 'Query', ecGetExamEventSessionExamineesForTimeExtension: { __typename?: 'GetExamEventSessionExamineesForTimeExtensionOutput', total: number, result: Array<{ __typename?: 'ExamEventSessionExamineeForTimeExtension', maxExtendableDurationInMs: number, totalExtendedDurationInMs: number, remainingExtendableTimeInMs: number, examEndedAt: Date | null, manualExtendDurationInMs: number, autoExtendDurationInMs: number, examEventSessionExaminee: { __typename?: 'ExamEventSessionExaminee', id: string, examinee: { __typename?: 'Examinee', middleName: string | null, lastName: string, firstName: string, title: string }, examEventExaminee: { __typename?: 'ExamEventExaminee', seatNumber: number | null, status: ExamEventExamineeStatus, examCourse: { __typename?: 'ExamCourse', id: string, code: string } } } }> } };

export type SearchTimeExtendedExamEventSessionExamineesQueryVariables = Exact<{
  searchTimeExtendedExamEventSessionExamineeInput: SearchTimeExtendedExamEventSessionExamineeInput;
}>;


export type SearchTimeExtendedExamEventSessionExamineesQuery = { __typename?: 'Query', ecSearchTimeExtendedExamEventSessionExaminees: { __typename?: 'SearchTimeExtendedExamEventSessionExamineeOutput', total: number, extendedExamEventSessionExaminees: Array<{ __typename?: 'TimeExtendedExamEventSessionExaminee', examEventSessionId: string, id: string, totalExtendedDurationInMs: number, manualExtendDurationInMs: number | null, autoExtendDurationInMs: number | null, timeExtensionRemark: string | null, examEventExaminee: { __typename?: 'ExamEventExaminee', seatNumber: number | null, examCourseId: string, examCourse: { __typename?: 'ExamCourse', code: string } }, examinee: { __typename?: 'Examinee', title: string, middleName: string | null, lastName: string, firstName: string } }> } };

export type GetUploadSignedUrlForImportExamineesAnswersQueryVariables = Exact<{
  getUploadSignedUrlForImportExamineesAnswersInput: GetUploadSignedUrlForImportExamineesAnswersInput;
}>;


export type GetUploadSignedUrlForImportExamineesAnswersQuery = { __typename?: 'Query', ecGetUploadSignedUrlForImportExamineesAnswers: { __typename?: 'GetUploadSignedUrlForImportExamineesAnswersOutput', signedUrl: string, storageObject: { __typename?: 'StorageObject', fileName: string | null } } };

export type ImportExamineesAnswersSpreadSheetMutationVariables = Exact<{
  importExamineesAnswersSpreadSheetInput: ImportExamineesAnswersSpreadSheetInput;
}>;


export type ImportExamineesAnswersSpreadSheetMutation = { __typename?: 'Mutation', ecImportExamineesAnswersSpreadSheet: { __typename?: 'ImportExamineesAnswersSpreadSheetOutput', status: GenericResponseStatus, data: { __typename?: 'ImportExamineesAnswersSpreadSheetOutputData', examGradingStatus: ExamGradingStatus | null } | null } };

export type ExamineeFragment = { __typename?: 'ExamEventExaminee', id: string, status: ExamEventExamineeStatus, isExamReady: boolean, email: string, remark: string | null, cancelationReason: CancelationReason | null, examCourse: { __typename?: 'ExamCourse', id: string, code: string }, examinee: { __typename?: 'Examinee', id: string, title: string, firstName: string, middleName: string | null, lastName: string, eKycStatus: EKycVerificationStatus } };

export type ExamineeWithCertificateStatusAndExamResultFragment = { __typename?: 'ExamEventExaminee', certificateStatus: ExamEventExamineeCertificateStatus, seatNumber: number | null, id: string, status: ExamEventExamineeStatus, isExamReady: boolean, email: string, remark: string | null, cancelationReason: CancelationReason | null, examEventExamineeResult: { __typename?: 'ExamEventExamineeResult', result: ExamResult } | null, examCourse: { __typename?: 'ExamCourse', id: string, code: string }, examinee: { __typename?: 'Examinee', id: string, title: string, firstName: string, middleName: string | null, lastName: string, eKycStatus: EKycVerificationStatus } };

export type SearchExamEventExamineesQueryVariables = Exact<{
  searchExamEventExaminees: SearchExamEventExamineesInput;
}>;


export type SearchExamEventExamineesQuery = { __typename?: 'Query', ecSearchExamEventExaminees: { __typename?: 'SearchExamEventExamineesOutput', total: number, examEventExaminees: Array<{ __typename?: 'ExamEventExaminee', registrationStatus: ExamineeRegistrationStatus, id: string, status: ExamEventExamineeStatus, isExamReady: boolean, email: string, remark: string | null, cancelationReason: CancelationReason | null, examEventSessionExaminees: Array<{ __typename?: 'ExamEventSessionExaminee', examStartedAt: Date | null }> | null, examCourse: { __typename?: 'ExamCourse', id: string, code: string }, examinee: { __typename?: 'Examinee', id: string, title: string, firstName: string, middleName: string | null, lastName: string, eKycStatus: EKycVerificationStatus } }> } };

export type SearchExamEventExamineesWithCertificateStatusAndResultQueryVariables = Exact<{
  searchExamEventExaminees: SearchExamEventExamineesInput;
}>;


export type SearchExamEventExamineesWithCertificateStatusAndResultQuery = { __typename?: 'Query', ecSearchExamEventExaminees: { __typename?: 'SearchExamEventExamineesOutput', total: number, examEventExaminees: Array<{ __typename?: 'ExamEventExaminee', certificateStatus: ExamEventExamineeCertificateStatus, seatNumber: number | null, id: string, status: ExamEventExamineeStatus, isExamReady: boolean, email: string, remark: string | null, cancelationReason: CancelationReason | null, examEventExamineeResult: { __typename?: 'ExamEventExamineeResult', result: ExamResult } | null, examCourse: { __typename?: 'ExamCourse', id: string, code: string }, examinee: { __typename?: 'Examinee', id: string, title: string, firstName: string, middleName: string | null, lastName: string, eKycStatus: EKycVerificationStatus } }> } };

export type GetExamineeSpreadsheetUploadSignedUrlQueryVariables = Exact<{
  input: GetUploadSignedUrlForImportExamineesInput;
}>;


export type GetExamineeSpreadsheetUploadSignedUrlQuery = { __typename?: 'Query', ecGetUploadSignedUrlForImportExaminees: { __typename?: 'GetUploadSignedUrlForImportExamineesOutput', signedUrl: string, storageObject: { __typename?: 'StorageObject', fileName: string | null } } };

export type ImportExamineesSpreadsheetMutationVariables = Exact<{
  input: ImportExamineesSpreadsheetInput;
}>;


export type ImportExamineesSpreadsheetMutation = { __typename?: 'Mutation', ecImportExamineesSpreadsheet: { __typename?: 'ImportExamineesSpreadsheetOutput', success: boolean, fileName: string } };

export type GetEKycInfoByExamineeIdAndExamEventIdQueryVariables = Exact<{
  getEKycInfoByExamineeIdAndExamEventIdInput: GetEKycInfoByExamineeIdAndExamEventIdInput;
}>;


export type GetEKycInfoByExamineeIdAndExamEventIdQuery = { __typename?: 'Query', ecGetEKycInfoByExamineeIdAndExamEventId: { __typename?: 'GetEKycInfoByExamineeIdAndExamEventIdOutput', eKycInfo: { __typename?: 'EKycInfo', status: EKycVerificationStatus, comment: string | null, email: string, title: string | null, firstname: string | null, middleName: string | null, lastname: string | null, titleEng: string | null, firstnameEng: string | null, lastnameEng: string | null, idType: EKycIdType | null, idNumber: string | null, idCode: string | null, dateOfBirth: Date | null, issuedDate: Date | null, expiryDate: Date | null, address: string | null, faceMatchSimilarity: number | null, frontCardVerified: EKycDocumentVerificationStatus, backCardVerified: EKycDocumentVerificationStatus, cardVerified: EKycDocumentVerificationStatus, faceMatched: EKycDocumentVerificationStatus, id: string, userId: string, createdAt: Date, updatedAt: Date, documents: Array<{ __typename?: 'EKycDocumentObjectType', type: EKycDocumentType, storageObject: { __typename?: 'EKycStorageObjectObjectType', type: StorageObjectProvider, key: string | null, bucket: string | null } }>, reasons: Array<{ __typename?: 'EKycInfoReasonObjectType', id: EKycInfoReasonId, isPassed: boolean }>, verificationCheckList: { __typename?: 'EKycVerificationCheckListObjectType', photoClarity: boolean, photoIdentityMatch: boolean, idPhotoClarity: boolean } | null } } };

export type EcUpdateEKycStatusMutationVariables = Exact<{
  updateEKycStatusInput: UpdateEKycStatusInput;
}>;


export type EcUpdateEKycStatusMutation = { __typename?: 'Mutation', ecUpdateEKycStatus: { __typename?: 'UpdateEKycStatusOutput', eKycInfo: { __typename?: 'EKycInfo', status: EKycVerificationStatus } } };

export type EcGetEKycDocumentDownloadSignedUrlQueryVariables = Exact<{
  getEKycDocumentDownloadSignedUrlInput: GetEKycDocumentDownloadSignedUrlInput;
}>;


export type EcGetEKycDocumentDownloadSignedUrlQuery = { __typename?: 'Query', ecGetEKycDocumentDownloadSignedUrl: { __typename?: 'GetEKycDocumentDownloadSignedUrlOutput', signedUrls: any } };

export type SearchExamineeStatusesInExamEventQueryVariables = Exact<{
  searchExamineeStatusesInExamEvent: SearchExamineeStatusesInExamEventInput;
}>;


export type SearchExamineeStatusesInExamEventQuery = { __typename?: 'Query', ecSearchExamineeStatusesInExamEvent: { __typename?: 'SearchExamineeStatusesInExamEventOutput', total: number, examEventExaminees: Array<{ __typename?: 'ExamEventExaminee', id: string, userId: string, email: string, isExamReady: boolean, seatNumber: number | null, sentToSETPortalAt: Date | null, status: ExamEventExamineeStatus, remark: string | null, cancelationReason: CancelationReason | null, registrationStatus: ExamineeRegistrationStatus, registrationType: ExamineeRegistrationType | null, certificateStatus: ExamEventExamineeCertificateStatus, examinee: { __typename?: 'Examinee', id: string, title: string, firstName: string, middleName: string | null, lastName: string, idNumber: string, eKycStatus: EKycVerificationStatus }, examEventExamineeResult: { __typename?: 'ExamEventExamineeResult', id: string, result: ExamResult } | null, examCourse: { __typename?: 'ExamCourse', id: string, code: string }, examEventSessionExaminees: Array<{ __typename?: 'ExamEventSessionExaminee', examStartedAt: Date | null }> | null }> } };

export type SearchExamineeEKycStatusesInExamEventQueryVariables = Exact<{
  searchExamineeEKycStatusesInExamEvent: SearchExamineeEKycStatusesInExamEventInput;
}>;


export type SearchExamineeEKycStatusesInExamEventQuery = { __typename?: 'Query', ecSearchExamineeEKycStatusesInExamEvent: { __typename?: 'SearchExamineeEKycStatusesInExamEventOutput', total: number, examineeEKycStatuses: Array<{ __typename?: 'ExamineeEKycStatusInExamEvent', sourceEKycStatus: EKycVerificationStatus, examEventExaminee: { __typename?: 'ExamEventExaminee', id: string, email: string, examinee: { __typename?: 'Examinee', id: string, title: string, firstName: string, middleName: string | null, lastName: string } } }> } };

export type SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQueryVariables = Exact<{
  searchExamineeStatusesInExamEvent: SearchExamineeStatusesInExamEventInput;
  examEventSessionId: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery = { __typename?: 'Query', ecSearchExamineeStatusesInExamEvent: { __typename?: 'SearchExamineeStatusesInExamEventOutput', total: number, examEventExaminees: Array<{ __typename?: 'ExamEventExaminee', id: string, userId: string, email: string, isExamReady: boolean, seatNumber: number | null, sentToSETPortalAt: Date | null, status: ExamEventExamineeStatus, remark: string | null, cancelationReason: CancelationReason | null, registrationStatus: ExamineeRegistrationStatus, registrationType: ExamineeRegistrationType | null, certificateStatus: ExamEventExamineeCertificateStatus, examinee: { __typename?: 'Examinee', id: string, title: string, firstName: string, middleName: string | null, lastName: string, idNumber: string, eKycStatus: EKycVerificationStatus }, examEventExamineeResult: { __typename?: 'ExamEventExamineeResult', id: string, result: ExamResult } | null, examEventSessionExaminee: { __typename?: 'ExamEventSessionExaminee', id: string, loginStatus: ProgressStatus, examStatus: ProgressStatus, examSubmitStatus: ProgressStatus, questionnaireStatus: ProgressStatus } | null, examEventSessionExaminees: Array<{ __typename?: 'ExamEventSessionExaminee', examStartedAt: Date | null }> | null, examCourse: { __typename?: 'ExamCourse', id: string, code: string } }> } };

export type RegisterExamineeWithAlternativeDocumentMutationVariables = Exact<{
  registerExamineeWithAlternativeDocumentInput: RegisterExamineeWithAlternativeDocumentInput;
}>;


export type RegisterExamineeWithAlternativeDocumentMutation = { __typename?: 'Mutation', ecRegisterExamineeWithAlternativeDocument: { __typename?: 'RegisterExamineeWithAlternativeDocumentOutput', message: string } };

export type RegisterForeignerExamineeWithAlternativeDocumentMutationVariables = Exact<{
  registerForeignerExamineeWithAlternativeDocumentInput: RegisterForeignerExamineeWithAlternativeDocumentInput;
}>;


export type RegisterForeignerExamineeWithAlternativeDocumentMutation = { __typename?: 'Mutation', ecRegisterForeignerExamineeWithAlternativeDocument: { __typename?: 'RegisterForeignerExamineeWithAlternativeDocument', message: string } };

export type GetUploadSignedUrlForAlternativeRegistrationQueryVariables = Exact<{
  getUploadSignedUrlForAlternativeRegistrationInput: GetUploadSignedUrlForAlternativeRegistrationInput;
}>;


export type GetUploadSignedUrlForAlternativeRegistrationQuery = { __typename?: 'Query', ecGetUploadSignedUrlForAlternativeRegistration: { __typename?: 'GetUploadSignedUrlForAlternativeRegistrationOutput', signedUrl: string, storageObject: { __typename?: 'StorageObject', fileName: string | null } } };

export type GetExamEventExamineeByIdQueryVariables = Exact<{
  getExamEventExamineeByIdInput: GetExamEventExamineeByIdInput;
}>;


export type GetExamEventExamineeByIdQuery = { __typename?: 'Query', ecGetExamEventExamineeById: { __typename?: 'GetExamEventExamineeByIdOutput', examEventExaminee: { __typename?: 'ExamEventExaminee', id: string, seatNumber: number | null, email: string, registrationStatus: ExamineeRegistrationStatus, registrationType: ExamineeRegistrationType | null, registeredAt: Date | null, registeredBy: string | null, reason: string | null, registrationDoc: { __typename?: 'RegistrationDoc', type: RegistrationDocType, fileName: string | null } | null, examinee: { __typename?: 'Examinee', id: string, title: string, firstName: string, middleName: string | null, lastName: string, idType: IdType, idNumber: string, eKycStatus: EKycVerificationStatus, eKycExpiredAt: Date | null, dateOfBirth: Date | null, countryCode: ExamineeCountryCode | null } } } };

export type SyncExamEventExamineeWithWrMutationVariables = Exact<{
  syncExamEventExamineeWithWrInput: SyncExamEventExamineeWithWrInput;
}>;


export type SyncExamEventExamineeWithWrMutation = { __typename?: 'Mutation', ecSyncExamEventExamineeWithWr: { __typename?: 'SyncExamEventExamineeWithWrOutput', success: boolean, summary: { __typename?: 'SyncExamEventExamineeWithWrSummary', validExamineeCount: number, canceledExamineeCount: number }, errors: Array<{ __typename?: 'ExamineeValidationError', id: string, firstName: string, middleName: string | null, lastName: string, idNumber: string, idType: IdType, code: string, property: string | null }> | null } };

export type ResendEKycRequestEmailMutationVariables = Exact<{
  resendEKycRequestEmailInput: ResendEKycRequestEmailInput;
}>;


export type ResendEKycRequestEmailMutation = { __typename?: 'Mutation', ecResendEKycRequestEmail: { __typename?: 'ResendEKycRequestEmailOutput', message: string, status: GenericResponseStatus } };

export type ResendCertificateEmailMutationVariables = Exact<{
  resendCertificateEmailInput: ResendCertificateEmailInput;
}>;


export type ResendCertificateEmailMutation = { __typename?: 'Mutation', ecResendCertificateEmail: { __typename?: 'ResendCertificateEmailOutput', message: string, status: GenericResponseStatus } };

export type GetExamEventExamineeCountSummaryQueryVariables = Exact<{
  getExamEventExamineeCountSummaryInput: GetExamEventExamineeCountSummaryInput;
}>;


export type GetExamEventExamineeCountSummaryQuery = { __typename?: 'Query', ecGetExamEventExamineeCountSummary: { __typename?: 'GetExamEventExamineeCountSummaryOutput', total: number, prepareForExam: number, registered: number, inProgress: number, canceled: number, processing: number, pendingResults: number, completed: number, absent: number, eKyc: number } };

export type GetExamEventExamineeCountSummaryForProctoringQueryVariables = Exact<{
  getExamEventExamineeCountSummaryForProctoringInput: GetExamEventExamineeCountSummaryForProctoringInput;
}>;


export type GetExamEventExamineeCountSummaryForProctoringQuery = { __typename?: 'Query', ecGetExamEventExamineeCountSummaryForProctoring: { __typename?: 'GetExamEventExamineeCountSummaryForProctoringOutput', total: number, eKyc: number, canceled: number, absent: number, passed: number, failed: number, registrationStatusRegistered: number } };

export type GetExamEventExamineeScoreReportsQueryVariables = Exact<{
  getExamEventExamineeScoreReportsInput: GetExamEventExamineeScoreReportsInput;
}>;


export type GetExamEventExamineeScoreReportsQuery = { __typename?: 'Query', ecGetExamEventExamineeScoreReports: { __typename?: 'GetExamEventExamineeScoreReportsOutput', examEventExamineeScoreReports: Array<{ __typename?: 'ExamEventExamineeScoreReport', title: string, firstName: string, middleName: string | null, lastName: string, idNumber: string, totalScore: number, seatNumber: number | null, status: ExamEventExamineeStatus, registrationStatus: ExamineeRegistrationStatus, result: ExamResult | null, resultByTags: Array<{ __typename?: 'ExamEventExamineeScoreReportByTag', refId: string, tagId: string, tagName: string, category: TagCategory, score: number }> }> } };

export type GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQueryVariables = Exact<{
  input: GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdInput;
}>;


export type GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery = { __typename?: 'Query', ecGetQConfigStructuresReorderedByExamEventIdAndExamCourseId: { __typename?: 'GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdOutput', qConfigStructures: Array<{ __typename?: 'ExamEventQConfigStructureReorderedObjectType', calculatedOrder: number, qConfigStructure: { __typename?: 'ExamEventQConfigStructureObjectType', id: string, name: string | null, type: QConfigStructureType, totalQuestions: number, score: number, order: number, parentId: string | null } }> } };

export type ExportExamEventExamineeScoreReportsQueryVariables = Exact<{
  exportExamEventExamineeScoreReportsInput: ExportExamEventExamineeScoreReportsInput;
}>;


export type ExportExamEventExamineeScoreReportsQuery = { __typename?: 'Query', ecExportExamEventExamineeScoreReports: { __typename?: 'ExportExamEventExamineeScoreReportsOutput', status: GenericResponseStatus } };

export type CancelExamEventExamineeMutationVariables = Exact<{
  cancelExamEventExamineeInput: CancelExamEventExamineeInput;
}>;


export type CancelExamEventExamineeMutation = { __typename?: 'Mutation', ecCancelExamEventExaminee: { __typename?: 'CancelExamEventExamineeOutput', examEventExaminee: { __typename?: 'ExamEventExaminee', id: string, status: ExamEventExamineeStatus, remark: string | null, cancelationReason: CancelationReason | null } } };

export type ReinstateExamEventExamineeMutationVariables = Exact<{
  reinstateExamEventExamineeInput: ReinstateExamEventExamineeInput;
}>;


export type ReinstateExamEventExamineeMutation = { __typename?: 'Mutation', ecReinstateExamEventExaminee: { __typename?: 'ReinstateExamEventExamineeOutput', examEventExaminee: { __typename?: 'ExamEventExaminee', id: string, status: ExamEventExamineeStatus, remark: string | null, cancelationReason: CancelationReason | null } } };

export type SearchExamCenterInReviewProctorRequestsQueryVariables = Exact<{
  searchExamCenterProctorRequestsInput: SearchExamCenterProctorRequestsInput;
}>;


export type SearchExamCenterInReviewProctorRequestsQuery = { __typename?: 'Query', ecSearchExamCenterProctorRequests: { __typename?: 'SearchExamCenterProctorRequestsOutput', total: number, examCenterProctorRequests: Array<{ __typename?: 'ExamCenterProctorRequest', id: string, type: ExamCenterProctorRequestType, firstNameTh: string, titleTh: string, middleNameTh: string | null, lastNameTh: string, step: ExamCenterProctorRequestStep, refCode: string | null, requestedAt: Date | null }> } };

export type SearchExamCenterRejectedProctorRequestsQueryVariables = Exact<{
  searchExamCenterProctorRequestsInput: SearchExamCenterProctorRequestsInput;
}>;


export type SearchExamCenterRejectedProctorRequestsQuery = { __typename?: 'Query', ecSearchExamCenterProctorRequests: { __typename?: 'SearchExamCenterProctorRequestsOutput', total: number, examCenterProctorRequests: Array<{ __typename?: 'ExamCenterProctorRequest', id: string, type: ExamCenterProctorRequestType, firstNameTh: string, titleTh: string, middleNameTh: string | null, lastNameTh: string, step: ExamCenterProctorRequestStep, refCode: string | null, verdicts: Array<{ __typename?: 'ExamCenterProctorRequestVerdict', submittedAt: Date | null }> }> } };

export type SearchExamCenterDraftProctorRequestsQueryVariables = Exact<{
  searchExamCenterProctorRequestsInput: SearchExamCenterProctorRequestsInput;
}>;


export type SearchExamCenterDraftProctorRequestsQuery = { __typename?: 'Query', ecSearchExamCenterProctorRequests: { __typename?: 'SearchExamCenterProctorRequestsOutput', total: number, examCenterProctorRequests: Array<{ __typename?: 'ExamCenterProctorRequest', id: string, type: ExamCenterProctorRequestType, firstNameTh: string, titleTh: string, middleNameTh: string | null, lastNameTh: string, step: ExamCenterProctorRequestStep, refCode: string | null, editedAt: Date | null, editedUser: { __typename?: 'RawUser', lastname: string, firstname: string } | null }> } };

export type CreateExamCenterProctorRequestMutationVariables = Exact<{
  createExamCenterProctorRequestInput: CreateExamCenterProctorRequestInput;
}>;


export type CreateExamCenterProctorRequestMutation = { __typename?: 'Mutation', ecCreateExamCenterProctorRequest: { __typename?: 'CreateExamCenterProctorRequestOutput', examCenterProctorRequest: { __typename?: 'ExamCenterProctorRequest', id: string } } };

export type SubmitExamCenterProctorRequestForReviewMutationVariables = Exact<{
  submitExamCenterProctorRequestInput: SubmitExamCenterProctorRequestInput;
}>;


export type SubmitExamCenterProctorRequestForReviewMutation = { __typename?: 'Mutation', ecSubmitExamCenterProctorRequest: { __typename?: 'SubmitExamCenterProctorRequestOutput', examCenterProctorRequest: { __typename?: 'ExamCenterProctorRequest', id: string } } };

export type GetUploadSignedUrlsForExamCenterProctorRequestQueryVariables = Exact<{
  getUploadSignedUrlsForExamCenterProctorRequestInput: GetUploadSignedUrlsForExamCenterProctorRequestInputType;
}>;


export type GetUploadSignedUrlsForExamCenterProctorRequestQuery = { __typename?: 'Query', ecGetUploadSignedUrlsForExamCenterProctorRequest: { __typename?: 'GetUploadSignedUrlsForExamCenterProctorRequestOutput', signedUrls: Array<{ __typename?: 'GetUploadSignedUrlsForExamCenterProctorRequestSignedUrl', url: string, contentType: ExamCenterProctorRequestContentType, storageObject: { __typename?: 'StorageObject', fileName: string | null } }> } };

export type DeleteExamCenterDraftProctorRequestMutationVariables = Exact<{
  deleteExamCenterProctorRequestByIdInput: DeleteExamCenterProctorRequestByIdInput;
}>;


export type DeleteExamCenterDraftProctorRequestMutation = { __typename?: 'Mutation', ecDeleteExamCenterProctorRequestById: { __typename?: 'DeleteExamCenterProctorRequestByIdOutput', status: GenericResponseStatus, message: string, data: any | null } };

export type GetExamCenterProctorRequestVerdictsByIdQueryVariables = Exact<{
  getExamCenterProctorRequestByIdInput: GetExamCenterProctorRequestByIdInputType;
}>;


export type GetExamCenterProctorRequestVerdictsByIdQuery = { __typename?: 'Query', ecGetExamCenterProctorRequestById: { __typename?: 'GetExamCenterProctorRequestByIdOutput', examCenterProctorRequest: { __typename?: 'ExamCenterProctorRequest', verdicts: Array<{ __typename?: 'ExamCenterProctorRequestVerdict', id: string, step: ExamCenterProctorRequestVerdictStep, verdict: Verdict | null, comment: string | null, submittedAt: Date | null, requestedAt: Date }> } } };

export type SaveExamCenterProctorRequestAsRejectedMutationVariables = Exact<{
  saveExamCenterProctorRequestAsRejectedInput: SaveExamCenterProctorRequestAsRejectedInput;
}>;


export type SaveExamCenterProctorRequestAsRejectedMutation = { __typename?: 'Mutation', ecSaveExamCenterProctorRequestAsRejected: { __typename?: 'SaveExamCenterProctorRequestAsRejectedOutput', examCenterProctorRequest: { __typename?: 'ExamCenterProctorRequest', id: string } } };

export type ExamCenterProctorFragment = { __typename?: 'ExamCenterProctor', id: string, examCenterCode: string, type: ExamCenterProctorType, idNumber: string, userId: string | null, titleTh: string, firstNameTh: string, middleNameTh: string | null, lastNameTh: string, titleEn: string | null, firstNameEn: string | null, middleNameEn: string | null, lastNameEn: string | null, email: string | null, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, createdAt: Date, updatedAt: Date, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorStorageObject', key: string, fileName: string | null }> | null, metadata: { __typename?: 'ExamCenterProctorMetadata', employeeId: string | null, position: string | null, department: string | null } | null, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null };

export type CreateExamCenterProctorMutationVariables = Exact<{
  createExamCenterProctorInput: CreateExamCenterProctorInput;
}>;


export type CreateExamCenterProctorMutation = { __typename?: 'Mutation', ecCreateExamCenterProctor: { __typename?: 'CreateExamCenterProctorOutput', examCenterProctor: { __typename?: 'ExamCenterProctor', id: string } } };

export type SearchExamCenterProctorsQueryVariables = Exact<{
  searchExamCenterProctorsInput: SearchExamCenterProctorsInput;
}>;


export type SearchExamCenterProctorsQuery = { __typename?: 'Query', ecSearchExamCenterProctors: { __typename?: 'SearchExamCenterProctorsOutput', total: number, examCenterProctors: Array<{ __typename?: 'ExamCenterProctor', id: string, examCenterCode: string, type: ExamCenterProctorType, idNumber: string, userId: string | null, titleTh: string, firstNameTh: string, middleNameTh: string | null, lastNameTh: string, titleEn: string | null, firstNameEn: string | null, middleNameEn: string | null, lastNameEn: string | null, email: string | null, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, createdAt: Date, updatedAt: Date, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorStorageObject', key: string, fileName: string | null }> | null, metadata: { __typename?: 'ExamCenterProctorMetadata', employeeId: string | null, position: string | null, department: string | null } | null, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }> } };

export type GetExamCenterProctorByIdQueryVariables = Exact<{
  getExamCenterProctorByIdInput: GetExamCenterProctorByIdInput;
}>;


export type GetExamCenterProctorByIdQuery = { __typename?: 'Query', ecGetExamCenterProctorById: { __typename?: 'GetExamCenterProctorByIdOutput', examCenterProctor: { __typename?: 'ExamCenterProctor', id: string, examCenterCode: string, type: ExamCenterProctorType, idNumber: string, userId: string | null, titleTh: string, firstNameTh: string, middleNameTh: string | null, lastNameTh: string, titleEn: string | null, firstNameEn: string | null, middleNameEn: string | null, lastNameEn: string | null, email: string | null, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, createdAt: Date, updatedAt: Date, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorStorageObject', key: string, fileName: string | null }> | null, metadata: { __typename?: 'ExamCenterProctorMetadata', employeeId: string | null, position: string | null, department: string | null } | null, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null } } };

export type AdminSearchExamCenterProctorsQueryVariables = Exact<{
  searchExamCenterProctorsInput: SearchExamCenterProctorsInput;
}>;


export type AdminSearchExamCenterProctorsQuery = { __typename?: 'Query', ecAdminSearchExamCenterProctors: { __typename?: 'SearchExamCenterProctorsOutput', total: number, examCenterProctors: Array<{ __typename?: 'ExamCenterProctor', id: string, examCenterCode: string, type: ExamCenterProctorType, idNumber: string, userId: string | null, titleTh: string, firstNameTh: string, middleNameTh: string | null, lastNameTh: string, titleEn: string | null, firstNameEn: string | null, middleNameEn: string | null, lastNameEn: string | null, email: string | null, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, createdAt: Date, updatedAt: Date, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorStorageObject', key: string, fileName: string | null }> | null, metadata: { __typename?: 'ExamCenterProctorMetadata', employeeId: string | null, position: string | null, department: string | null } | null, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null }> } };

export type AdminGetExamCenterProctorByIdQueryVariables = Exact<{
  getExamCenterProctorByIdInput: GetExamCenterProctorByIdInput;
}>;


export type AdminGetExamCenterProctorByIdQuery = { __typename?: 'Query', ecAdminGetExamCenterProctorById: { __typename?: 'GetExamCenterProctorByIdOutput', examCenterProctor: { __typename?: 'ExamCenterProctor', id: string, examCenterCode: string, type: ExamCenterProctorType, idNumber: string, userId: string | null, titleTh: string, firstNameTh: string, middleNameTh: string | null, lastNameTh: string, titleEn: string | null, firstNameEn: string | null, middleNameEn: string | null, lastNameEn: string | null, email: string | null, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, createdAt: Date, updatedAt: Date, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorStorageObject', key: string, fileName: string | null }> | null, metadata: { __typename?: 'ExamCenterProctorMetadata', employeeId: string | null, position: string | null, department: string | null } | null, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null } } };

export type GetDownloadSignedUrlsForExamCenterProctorQueryVariables = Exact<{
  getDownloadSignedUrlsForExamCenterProctorInput: GetDownloadSignedUrlsForExamCenterProctorInput;
}>;


export type GetDownloadSignedUrlsForExamCenterProctorQuery = { __typename?: 'Query', ecGetDownloadSignedUrlsForExamCenterProctor: { __typename?: 'GetDownloadSignedUrlsForExamCenterProctorOutput', signedUrls: any } };

export type UpdateExamCenterProctorFromExamCenterManagerMutationVariables = Exact<{
  input: UpdateExamCenterProctorFromExamCenterManagerInput;
}>;


export type UpdateExamCenterProctorFromExamCenterManagerMutation = { __typename?: 'Mutation', ecUpdateExamCenterProctorFromExamCenterManager: { __typename?: 'UpdateExamCenterProctorFromExamCenterManagerOutput', examCenterProctor: { __typename?: 'ExamCenterProctor', id: string, examCenterCode: string, type: ExamCenterProctorType, idNumber: string, userId: string | null, titleTh: string, firstNameTh: string, middleNameTh: string | null, lastNameTh: string, titleEn: string | null, firstNameEn: string | null, middleNameEn: string | null, lastNameEn: string | null, email: string | null, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, createdAt: Date, updatedAt: Date, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorStorageObject', key: string, fileName: string | null }> | null, metadata: { __typename?: 'ExamCenterProctorMetadata', employeeId: string | null, position: string | null, department: string | null } | null, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null } } };

export type UpdateExamCenterProctorFromProctorAdminMutationVariables = Exact<{
  updateExamCenterProctorFromProctorAdminInput: UpdateExamCenterProctorFromProctorAdminInput;
}>;


export type UpdateExamCenterProctorFromProctorAdminMutation = { __typename?: 'Mutation', ecUpdateExamCenterProctorFromProctorAdmin: { __typename?: 'UpdateExamCenterProctorFromProctorAdminOutput', examCenterProctor: { __typename?: 'ExamCenterProctor', id: string, examCenterCode: string, type: ExamCenterProctorType, idNumber: string, userId: string | null, titleTh: string, firstNameTh: string, middleNameTh: string | null, lastNameTh: string, titleEn: string | null, firstNameEn: string | null, middleNameEn: string | null, lastNameEn: string | null, email: string | null, phoneNumber: string | null, address: string | null, startedAt: Date, endedAt: Date | null, createdAt: Date, updatedAt: Date, agreementStorageObjects: Array<{ __typename?: 'ExamCenterProctorStorageObject', key: string, fileName: string | null }> | null, metadata: { __typename?: 'ExamCenterProctorMetadata', employeeId: string | null, position: string | null, department: string | null } | null, updatedUser: { __typename?: 'RawUser', id: string, firstname: string, lastname: string } | null } } };

export type GetUploadSignedUrlsForExamCenterProctorQueryVariables = Exact<{
  getUploadSignedUrlsForExamCenterProctorInput: GetUploadSignedUrlsForExamCenterProctorInputType;
}>;


export type GetUploadSignedUrlsForExamCenterProctorQuery = { __typename?: 'Query', ecGetUploadSignedUrlsForExamCenterProctor: { __typename?: 'GetUploadSignedUrlsForExamCenterProctorOutput', signedUrls: Array<{ __typename?: 'GetUploadSignedUrlsForExamCenterProctorSignedUrl', url: string, contentType: ExamCenterProctorContentType, storageObject: { __typename?: 'StorageObject', provider: StorageProvider, bucket: string, key: string, fileName: string | null } }> } };

export type CountActiveExamCenterProctorsByTypeQueryVariables = Exact<{
  countActiveExamCenterProctorsByTypeInput: CountActiveExamCenterProctorsByTypeInput;
}>;


export type CountActiveExamCenterProctorsByTypeQuery = { __typename?: 'Query', ecCountActiveExamCenterProctorsByType: { __typename?: 'CountActiveExamCenterProctorsByTypeOutput', proctorsCountByType: any } };

export type SearchProctorAuditLogQueryVariables = Exact<{
  searchProctorAuditLogInput: SearchProctorAuditLogInput;
}>;


export type SearchProctorAuditLogQuery = { __typename?: 'Query', ecSearchProctorAuditLog: { __typename?: 'SearchProctorAuditLogOutput', total: number, proctorAuditLogs: Array<{ __typename?: 'ProctorAuditLog', id: string, action: AuditActionType, fullName: string, detail: string, actionTime: Date }> } };

export type ExportQuestionnairesQueryVariables = Exact<{
  exportQuestionnairesInput: ExportQuestionnairesInput;
}>;


export type ExportQuestionnairesQuery = { __typename?: 'Query', ecExportQuestionnaires: { __typename?: 'ExportQuestionnairesOutput', status: GenericResponseStatus } };

export type CountExamEventsWithQuestionnairesQueryVariables = Exact<{
  countExamEventsWithQuestionnairesInput: CountExamEventsWithQuestionnairesInput;
}>;


export type CountExamEventsWithQuestionnairesQuery = { __typename?: 'Query', ecCountExamEventsWithQuestionnaires: { __typename?: 'CountExamEventsWithQuestionnairesOutput', total: number } };

export type GetServerTimeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServerTimeQuery = { __typename?: 'Query', ecGetServerTime: { __typename?: 'GetServerTimeOutput', currentTime: Date } };

export type SearchSetPortalExamResultFilesQueryVariables = Exact<{
  searchSetPortalExamResultFilesInput: SearchSetPortalExamResultFilesInput;
}>;


export type SearchSetPortalExamResultFilesQuery = { __typename?: 'Query', ecSearchSETPortalExamResultFiles: { __typename?: 'SearchSETPortalExamResultFilesOutput', total: number, setPortalExamResultFiles: Array<{ __typename?: 'SETPortalExamResultFile', id: string, fileName: string, fileSize: number, createdAt: Date }> } };

export type DownloadSetPortalExamResultFileQueryVariables = Exact<{
  downloadSetPortalExamResultFileInput: DownloadSetPortalExamResultFileInput;
}>;


export type DownloadSetPortalExamResultFileQuery = { __typename?: 'Query', ecDownloadSETPortalExamResultFile: { __typename?: 'DownloadSETPortalExamResultFileOutput', downloadUrl: string } };

export const RoomFragmentDoc = gql`
    fragment Room on Room {
  id
  name
  buildingId
  floor
  roomNumber
  seat
  status
  retiredRemark
  retiredAt
  retiredByUser {
    firstname
    lastname
  }
  updatedAt
  updatedUser {
    firstname
    lastname
  }
  building {
    id
    nameTh
    nameEn
    locationId
    location {
      id
      nameTh
      nameEn
      provinceId
      province {
        id
        nameTh
        nameEn
        code
        geographyId
      }
    }
  }
}
    `;
export const ExamRoomDetailFragmentDoc = gql`
    fragment ExamRoomDetail on Room {
  id
  floor
  name
  roomNumber
  buildingId
  seat
  status
  retiredRemark
  retiredAt
  createdAt
  updatedAt
  updatedUser {
    firstname
    lastname
  }
  examRoomComputerInfo {
    info {
      computerDetails {
        monitor {
          value
          otherDetail
        }
        cpu {
          value
          otherDetail
        }
        ram {
          value
          otherDetail
        }
        os {
          value
          otherDetail
        }
        storage {
          value
          otherDetail
        }
        webBrowser {
          value
          otherDetail
        }
        sebVersionStatus
        osUpdateCadence {
          value
          otherDetail
        }
        computerSpecImages
        computerSeatImages
      }
      internetDetails {
        internetSpeed {
          value
          otherDetail
        }
        speedTestImages
      }
      securityDetails {
        antivirusProgram {
          value
          otherDetail
        }
        antivirusConfigForSEB
        isSyncedWithThaiServer
        timeSyncImages
        usbPortCheck
        antivirusUpdateCadence {
          value
          otherDetail
        }
        robotTestImages
      }
    }
    createdAt
    id
  }
  building {
    id
    nameTh
    nameEn
    locationId
    location {
      id
      nameTh
      nameEn
      provinceId
      province {
        id
        nameTh
        nameEn
        code
        geographyId
      }
    }
  }
  examRoomPhysicalInfo {
    id
    info {
      seatSideSpacing {
        valid
        additionalInfo
        images
      }
      screenDistance {
        valid
        additionalInfo
        images
      }
      seatFrontBackSpacing {
        valid
        additionalInfo
        images
      }
      windows {
        valid
        additionalInfo
        images
      }
      storageLocker {
        valid
        additionalInfo
        images
      }
      examineeStorage {
        valid
        additionalInfo
        images
      }
      securityCameras {
        valid
        additionalInfo
        images
      }
      entryExitDoors {
        numberOfDoors
        images
      }
      frontOfExamRoom {
        images
      }
      insideExamRoom {
        images
      }
      registrationArea {
        valid
        additionalInfo
        images
      }
      toilets {
        valid
        additionalInfo
        images
      }
      sharedOpenArea {
        valid
        additionalInfo
        images
      }
    }
    createdAt
  }
}
    `;
export const RawUserFragmentFragmentDoc = gql`
    fragment RawUserFragment on RawUser {
  id
  firstname
  lastname
}
    `;
export const ExamCenterProctorRequestVerdictFragmentDoc = gql`
    fragment ExamCenterProctorRequestVerdict on ExamCenterProctorRequestVerdict {
  id
  examCenterProctorRequestId
  step
  requestedAt
  verdict
  comment
  submittedAt
  updatedBy
  updatedAt
  updatedUser {
    ...RawUserFragment
  }
}
    ${RawUserFragmentFragmentDoc}`;
export const ExamCenterProctorRequestFragmentDoc = gql`
    fragment ExamCenterProctorRequest on ExamCenterProctorRequest {
  id
  examCenterCode
  examCenterProctorId
  type
  step
  taskId
  refCode
  titleTh
  titleEn
  idNumber
  firstNameTh
  firstNameEn
  middleNameTh
  middleNameEn
  lastNameTh
  lastNameEn
  email
  phoneNumber
  address
  startedAt
  endedAt
  metadata {
    employeeId
    position
    department
  }
  agreementStorageObjects {
    provider
    bucket
    key
    fileName
  }
  personalInfoStorageObjects {
    provider
    bucket
    key
    fileName
  }
  requestedAt
  requestedBy
  editedBy
  editedAt
  editedUser {
    ...RawUserFragment
  }
  agreementStorageObjects {
    key
    fileName
  }
  personalInfoStorageObjects {
    key
    fileName
  }
  verdicts {
    ...ExamCenterProctorRequestVerdict
  }
}
    ${RawUserFragmentFragmentDoc}
${ExamCenterProctorRequestVerdictFragmentDoc}`;
export const ExamEventDetailsFragmentDoc = gql`
    fragment ExamEventDetails on ExamEvent {
  id
  name
  updatedAt
  ictExamYear
  examType
  status
  seat
  roundNumber
  registrationType
  registrationStatus
  examStartedAt
  examEndedAt
  postponeStartDurationInMs
  postponeEndDurationInMs
  postponementRemark
  registrationStartedAt
  registrationEndedAt
  metadata
  numberOfExaminees
  examLocation {
    id
    nameTh
    province {
      id
      nameTh
    }
  }
  rooms {
    id
    name
    buildingId
    floor
    roomNumber
    seat
    building {
      nameTh
      id
    }
  }
  proctors {
    id
    examCenterCode
    type
    titleTh
    firstNameTh
    middleNameTh
    lastNameTh
  }
  sessions {
    id
    examEventId
    round
    startedAt
    endedAt
    proctorStartedAt
    proctorEndedAt
    postponeDurationInMs
  }
  downloadedUser {
    firstname
    lastname
  }
}
    `;
export const ExamineeFragmentDoc = gql`
    fragment Examinee on ExamEventExaminee {
  id
  status
  isExamReady
  email
  remark
  cancelationReason
  examCourse {
    id
    code
  }
  examinee {
    id
    title
    firstName
    middleName
    lastName
    eKycStatus
  }
}
    `;
export const ExamineeWithCertificateStatusAndExamResultFragmentDoc = gql`
    fragment ExamineeWithCertificateStatusAndExamResult on ExamEventExaminee {
  ...Examinee
  examEventExamineeResult {
    result
  }
  certificateStatus
  seatNumber
}
    ${ExamineeFragmentDoc}`;
export const ExamCenterProctorFragmentDoc = gql`
    fragment ExamCenterProctor on ExamCenterProctor {
  id
  examCenterCode
  type
  idNumber
  userId
  titleTh
  firstNameTh
  middleNameTh
  lastNameTh
  titleEn
  firstNameEn
  middleNameEn
  lastNameEn
  email
  phoneNumber
  address
  startedAt
  endedAt
  agreementStorageObjects {
    key
    fileName
  }
  metadata {
    employeeId
    position
    department
  }
  createdAt
  updatedAt
  updatedUser {
    id
    firstname
    lastname
  }
}
    `;
export const CreateAnnouncementDocument = gql`
    mutation createAnnouncement($createAnnouncementInput: CreateAnnouncementInput!) {
  ecCreateAnnouncement(createAnnouncementInput: $createAnnouncementInput) {
    announcement {
      id
      title
      content
      link
      announcedAt
    }
  }
}
    `;
export type CreateAnnouncementMutationFn = Apollo.MutationFunction<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;

/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      createAnnouncementInput: // value for 'createAnnouncementInput'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>(CreateAnnouncementDocument, options);
      }
export type CreateAnnouncementMutationHookResult = ReturnType<typeof useCreateAnnouncementMutation>;
export type CreateAnnouncementMutationResult = Apollo.MutationResult<CreateAnnouncementMutation>;
export type CreateAnnouncementMutationOptions = Apollo.BaseMutationOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;
export const GetAllAnnouncementsDocument = gql`
    query getAllAnnouncements {
  ecGetAllAnnouncements {
    announcements {
      id
      title
      content
      link
      announcedAt
    }
  }
}
    `;

/**
 * __useGetAllAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetAllAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAnnouncementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAnnouncementsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAnnouncementsQuery, GetAllAnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAnnouncementsQuery, GetAllAnnouncementsQueryVariables>(GetAllAnnouncementsDocument, options);
      }
export function useGetAllAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAnnouncementsQuery, GetAllAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAnnouncementsQuery, GetAllAnnouncementsQueryVariables>(GetAllAnnouncementsDocument, options);
        }
export function useGetAllAnnouncementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAnnouncementsQuery, GetAllAnnouncementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAnnouncementsQuery, GetAllAnnouncementsQueryVariables>(GetAllAnnouncementsDocument, options);
        }
export type GetAllAnnouncementsQueryHookResult = ReturnType<typeof useGetAllAnnouncementsQuery>;
export type GetAllAnnouncementsLazyQueryHookResult = ReturnType<typeof useGetAllAnnouncementsLazyQuery>;
export type GetAllAnnouncementsSuspenseQueryHookResult = ReturnType<typeof useGetAllAnnouncementsSuspenseQuery>;
export type GetAllAnnouncementsQueryResult = Apollo.QueryResult<GetAllAnnouncementsQuery, GetAllAnnouncementsQueryVariables>;
export const AddBlockedRecordDocument = gql`
    mutation addBlockedRecord($input: AddBlockedRecordInput!) {
  ecAddBlockedRecord(AddBlockedRecordInput: $input) {
    blockedRecord {
      id
      blockedUserId
    }
  }
}
    `;
export type AddBlockedRecordMutationFn = Apollo.MutationFunction<AddBlockedRecordMutation, AddBlockedRecordMutationVariables>;

/**
 * __useAddBlockedRecordMutation__
 *
 * To run a mutation, you first call `useAddBlockedRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBlockedRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBlockedRecordMutation, { data, loading, error }] = useAddBlockedRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBlockedRecordMutation(baseOptions?: Apollo.MutationHookOptions<AddBlockedRecordMutation, AddBlockedRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBlockedRecordMutation, AddBlockedRecordMutationVariables>(AddBlockedRecordDocument, options);
      }
export type AddBlockedRecordMutationHookResult = ReturnType<typeof useAddBlockedRecordMutation>;
export type AddBlockedRecordMutationResult = Apollo.MutationResult<AddBlockedRecordMutation>;
export type AddBlockedRecordMutationOptions = Apollo.BaseMutationOptions<AddBlockedRecordMutation, AddBlockedRecordMutationVariables>;
export const GetBlockedRecordByBlockedUserIdDocument = gql`
    query getBlockedRecordByBlockedUserId($input: GetBlockedUserByIdInput!) {
  ecGetBlockedUserById(GetBlockedUserByIdInput: $input) {
    blockedUser {
      id
      title
      firstName
      middleName
      lastName
      idNumber
      phoneNumber
      blockedRecords {
        id
        email
        blockedType
        blockedScope
        blockedAt
        blockedUntil
        blockedReason
        examEvent {
          sessions {
            round
            startedAt
            endedAt
          }
        }
        metadata {
          position
          department
          enforcementEndDate
          examSession {
            roundNumber
            startedAt
            endedAt
          }
          documentStorageObjects {
            provider
            bucket
            key
            fileName
          }
        }
        examCenter {
          nameTH
          code
        }
        blockedRecordCourses {
          id
          examCourse {
            code
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBlockedRecordByBlockedUserIdQuery__
 *
 * To run a query within a React component, call `useGetBlockedRecordByBlockedUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockedRecordByBlockedUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockedRecordByBlockedUserIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBlockedRecordByBlockedUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetBlockedRecordByBlockedUserIdQuery, GetBlockedRecordByBlockedUserIdQueryVariables> & ({ variables: GetBlockedRecordByBlockedUserIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlockedRecordByBlockedUserIdQuery, GetBlockedRecordByBlockedUserIdQueryVariables>(GetBlockedRecordByBlockedUserIdDocument, options);
      }
export function useGetBlockedRecordByBlockedUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlockedRecordByBlockedUserIdQuery, GetBlockedRecordByBlockedUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlockedRecordByBlockedUserIdQuery, GetBlockedRecordByBlockedUserIdQueryVariables>(GetBlockedRecordByBlockedUserIdDocument, options);
        }
export function useGetBlockedRecordByBlockedUserIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlockedRecordByBlockedUserIdQuery, GetBlockedRecordByBlockedUserIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlockedRecordByBlockedUserIdQuery, GetBlockedRecordByBlockedUserIdQueryVariables>(GetBlockedRecordByBlockedUserIdDocument, options);
        }
export type GetBlockedRecordByBlockedUserIdQueryHookResult = ReturnType<typeof useGetBlockedRecordByBlockedUserIdQuery>;
export type GetBlockedRecordByBlockedUserIdLazyQueryHookResult = ReturnType<typeof useGetBlockedRecordByBlockedUserIdLazyQuery>;
export type GetBlockedRecordByBlockedUserIdSuspenseQueryHookResult = ReturnType<typeof useGetBlockedRecordByBlockedUserIdSuspenseQuery>;
export type GetBlockedRecordByBlockedUserIdQueryResult = Apollo.QueryResult<GetBlockedRecordByBlockedUserIdQuery, GetBlockedRecordByBlockedUserIdQueryVariables>;
export const UpdateBlockedRecordDocument = gql`
    mutation updateBlockedRecord($input: UpdateBlockedRecordInput!) {
  ecUpdateBlockedRecord(UpdateBlockedRecordInput: $input) {
    blockedRecord {
      id
      blockedReason
    }
  }
}
    `;
export type UpdateBlockedRecordMutationFn = Apollo.MutationFunction<UpdateBlockedRecordMutation, UpdateBlockedRecordMutationVariables>;

/**
 * __useUpdateBlockedRecordMutation__
 *
 * To run a mutation, you first call `useUpdateBlockedRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockedRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockedRecordMutation, { data, loading, error }] = useUpdateBlockedRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBlockedRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockedRecordMutation, UpdateBlockedRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockedRecordMutation, UpdateBlockedRecordMutationVariables>(UpdateBlockedRecordDocument, options);
      }
export type UpdateBlockedRecordMutationHookResult = ReturnType<typeof useUpdateBlockedRecordMutation>;
export type UpdateBlockedRecordMutationResult = Apollo.MutationResult<UpdateBlockedRecordMutation>;
export type UpdateBlockedRecordMutationOptions = Apollo.BaseMutationOptions<UpdateBlockedRecordMutation, UpdateBlockedRecordMutationVariables>;
export const GetUploadSignedUrlsForBlockedRecordDocument = gql`
    query getUploadSignedUrlsForBlockedRecord($getUploadSignedUrlsForBlockedRecordInput: GetUploadSignedUrlsForBlockedRecordInput!) {
  ecGetUploadSignedUrlsForBlockedRecord(
    GetUploadSignedUrlsForBlockedRecordInput: $getUploadSignedUrlsForBlockedRecordInput
  ) {
    signedUrls {
      url
      storageObject {
        fileName
      }
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlsForBlockedRecordQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlsForBlockedRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlsForBlockedRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlsForBlockedRecordQuery({
 *   variables: {
 *      getUploadSignedUrlsForBlockedRecordInput: // value for 'getUploadSignedUrlsForBlockedRecordInput'
 *   },
 * });
 */
export function useGetUploadSignedUrlsForBlockedRecordQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlsForBlockedRecordQuery, GetUploadSignedUrlsForBlockedRecordQueryVariables> & ({ variables: GetUploadSignedUrlsForBlockedRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlsForBlockedRecordQuery, GetUploadSignedUrlsForBlockedRecordQueryVariables>(GetUploadSignedUrlsForBlockedRecordDocument, options);
      }
export function useGetUploadSignedUrlsForBlockedRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlsForBlockedRecordQuery, GetUploadSignedUrlsForBlockedRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlsForBlockedRecordQuery, GetUploadSignedUrlsForBlockedRecordQueryVariables>(GetUploadSignedUrlsForBlockedRecordDocument, options);
        }
export function useGetUploadSignedUrlsForBlockedRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlsForBlockedRecordQuery, GetUploadSignedUrlsForBlockedRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlsForBlockedRecordQuery, GetUploadSignedUrlsForBlockedRecordQueryVariables>(GetUploadSignedUrlsForBlockedRecordDocument, options);
        }
export type GetUploadSignedUrlsForBlockedRecordQueryHookResult = ReturnType<typeof useGetUploadSignedUrlsForBlockedRecordQuery>;
export type GetUploadSignedUrlsForBlockedRecordLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlsForBlockedRecordLazyQuery>;
export type GetUploadSignedUrlsForBlockedRecordSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlsForBlockedRecordSuspenseQuery>;
export type GetUploadSignedUrlsForBlockedRecordQueryResult = Apollo.QueryResult<GetUploadSignedUrlsForBlockedRecordQuery, GetUploadSignedUrlsForBlockedRecordQueryVariables>;
export const GetDownloadSignedUrlForBlockedRecordDocument = gql`
    query getDownloadSignedUrlForBlockedRecord($getDownloadSignedUrlForBlockedRecordInput: GetDownloadSignedUrlForBlockedRecordInput!) {
  ecGetDownloadSignedUrlForBlockedRecord(
    GetDownloadSignedUrlForBlockedRecordInput: $getDownloadSignedUrlForBlockedRecordInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForBlockedRecordQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForBlockedRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForBlockedRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForBlockedRecordQuery({
 *   variables: {
 *      getDownloadSignedUrlForBlockedRecordInput: // value for 'getDownloadSignedUrlForBlockedRecordInput'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForBlockedRecordQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForBlockedRecordQuery, GetDownloadSignedUrlForBlockedRecordQueryVariables> & ({ variables: GetDownloadSignedUrlForBlockedRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForBlockedRecordQuery, GetDownloadSignedUrlForBlockedRecordQueryVariables>(GetDownloadSignedUrlForBlockedRecordDocument, options);
      }
export function useGetDownloadSignedUrlForBlockedRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForBlockedRecordQuery, GetDownloadSignedUrlForBlockedRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForBlockedRecordQuery, GetDownloadSignedUrlForBlockedRecordQueryVariables>(GetDownloadSignedUrlForBlockedRecordDocument, options);
        }
export function useGetDownloadSignedUrlForBlockedRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForBlockedRecordQuery, GetDownloadSignedUrlForBlockedRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForBlockedRecordQuery, GetDownloadSignedUrlForBlockedRecordQueryVariables>(GetDownloadSignedUrlForBlockedRecordDocument, options);
        }
export type GetDownloadSignedUrlForBlockedRecordQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForBlockedRecordQuery>;
export type GetDownloadSignedUrlForBlockedRecordLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForBlockedRecordLazyQuery>;
export type GetDownloadSignedUrlForBlockedRecordSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForBlockedRecordSuspenseQuery>;
export type GetDownloadSignedUrlForBlockedRecordQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForBlockedRecordQuery, GetDownloadSignedUrlForBlockedRecordQueryVariables>;
export const MarkExamPasserAsCheaterDocument = gql`
    mutation markExamPasserAsCheater($markExamPasserAsCheaterInput: MarkExamPasserAsCheaterInput!) {
  ecMarkExamPasserAsCheater(
    MarkExamPasserAsCheaterInput: $markExamPasserAsCheaterInput
  ) {
    status
    message
    data
  }
}
    `;
export type MarkExamPasserAsCheaterMutationFn = Apollo.MutationFunction<MarkExamPasserAsCheaterMutation, MarkExamPasserAsCheaterMutationVariables>;

/**
 * __useMarkExamPasserAsCheaterMutation__
 *
 * To run a mutation, you first call `useMarkExamPasserAsCheaterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkExamPasserAsCheaterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markExamPasserAsCheaterMutation, { data, loading, error }] = useMarkExamPasserAsCheaterMutation({
 *   variables: {
 *      markExamPasserAsCheaterInput: // value for 'markExamPasserAsCheaterInput'
 *   },
 * });
 */
export function useMarkExamPasserAsCheaterMutation(baseOptions?: Apollo.MutationHookOptions<MarkExamPasserAsCheaterMutation, MarkExamPasserAsCheaterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkExamPasserAsCheaterMutation, MarkExamPasserAsCheaterMutationVariables>(MarkExamPasserAsCheaterDocument, options);
      }
export type MarkExamPasserAsCheaterMutationHookResult = ReturnType<typeof useMarkExamPasserAsCheaterMutation>;
export type MarkExamPasserAsCheaterMutationResult = Apollo.MutationResult<MarkExamPasserAsCheaterMutation>;
export type MarkExamPasserAsCheaterMutationOptions = Apollo.BaseMutationOptions<MarkExamPasserAsCheaterMutation, MarkExamPasserAsCheaterMutationVariables>;
export const SearchBlockedUsersDocument = gql`
    query searchBlockedUsers($searchBlockedUsersInput: SearchBlockedUsersInput!) {
  ecSearchBlockedUsers(SearchBlockedUsersInput: $searchBlockedUsersInput) {
    blockedUsers {
      id
      title
      firstName
      middleName
      lastName
      idNumber
      blockedRecords {
        id
        examCenterCode
        blockedType
        blockedAt
        blockedUntil
      }
    }
    total
  }
}
    `;

/**
 * __useSearchBlockedUsersQuery__
 *
 * To run a query within a React component, call `useSearchBlockedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBlockedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBlockedUsersQuery({
 *   variables: {
 *      searchBlockedUsersInput: // value for 'searchBlockedUsersInput'
 *   },
 * });
 */
export function useSearchBlockedUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchBlockedUsersQuery, SearchBlockedUsersQueryVariables> & ({ variables: SearchBlockedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBlockedUsersQuery, SearchBlockedUsersQueryVariables>(SearchBlockedUsersDocument, options);
      }
export function useSearchBlockedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBlockedUsersQuery, SearchBlockedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBlockedUsersQuery, SearchBlockedUsersQueryVariables>(SearchBlockedUsersDocument, options);
        }
export function useSearchBlockedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchBlockedUsersQuery, SearchBlockedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchBlockedUsersQuery, SearchBlockedUsersQueryVariables>(SearchBlockedUsersDocument, options);
        }
export type SearchBlockedUsersQueryHookResult = ReturnType<typeof useSearchBlockedUsersQuery>;
export type SearchBlockedUsersLazyQueryHookResult = ReturnType<typeof useSearchBlockedUsersLazyQuery>;
export type SearchBlockedUsersSuspenseQueryHookResult = ReturnType<typeof useSearchBlockedUsersSuspenseQuery>;
export type SearchBlockedUsersQueryResult = Apollo.QueryResult<SearchBlockedUsersQuery, SearchBlockedUsersQueryVariables>;
export const GetBlockedUserByIdDocument = gql`
    query getBlockedUserById($input: GetBlockedUserByIdInput!) {
  ecGetBlockedUserById(GetBlockedUserByIdInput: $input) {
    blockedUser {
      id
      title
      firstName
      middleName
      lastName
      idNumber
      email
      phoneNumber
      blockedRecords {
        id
        blockedType
        blockedScope
        blockedAt
        blockedUntil
        blockedReason
        metadata {
          position
          department
          enforcementEndDate
          examSession {
            roundNumber
            startedAt
            endedAt
          }
        }
        blockedRecordCourses {
          id
          examCourse {
            code
            name
          }
        }
        examCenter {
          code
          nameTH
        }
        examEvent {
          id
          examStartedAt
          examEndedAt
          roundNumber
        }
      }
    }
  }
}
    `;

/**
 * __useGetBlockedUserByIdQuery__
 *
 * To run a query within a React component, call `useGetBlockedUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockedUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockedUserByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBlockedUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBlockedUserByIdQuery, GetBlockedUserByIdQueryVariables> & ({ variables: GetBlockedUserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlockedUserByIdQuery, GetBlockedUserByIdQueryVariables>(GetBlockedUserByIdDocument, options);
      }
export function useGetBlockedUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlockedUserByIdQuery, GetBlockedUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlockedUserByIdQuery, GetBlockedUserByIdQueryVariables>(GetBlockedUserByIdDocument, options);
        }
export function useGetBlockedUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlockedUserByIdQuery, GetBlockedUserByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlockedUserByIdQuery, GetBlockedUserByIdQueryVariables>(GetBlockedUserByIdDocument, options);
        }
export type GetBlockedUserByIdQueryHookResult = ReturnType<typeof useGetBlockedUserByIdQuery>;
export type GetBlockedUserByIdLazyQueryHookResult = ReturnType<typeof useGetBlockedUserByIdLazyQuery>;
export type GetBlockedUserByIdSuspenseQueryHookResult = ReturnType<typeof useGetBlockedUserByIdSuspenseQuery>;
export type GetBlockedUserByIdQueryResult = Apollo.QueryResult<GetBlockedUserByIdQuery, GetBlockedUserByIdQueryVariables>;
export const UpdateBlockedUserDocument = gql`
    mutation updateBlockedUser($updateBlockedUserInput: UpdateBlockedUserInput!) {
  ecUpdateBlockedUser(UpdateBlockedUserInput: $updateBlockedUserInput) {
    blockedUser {
      id
    }
  }
}
    `;
export type UpdateBlockedUserMutationFn = Apollo.MutationFunction<UpdateBlockedUserMutation, UpdateBlockedUserMutationVariables>;

/**
 * __useUpdateBlockedUserMutation__
 *
 * To run a mutation, you first call `useUpdateBlockedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockedUserMutation, { data, loading, error }] = useUpdateBlockedUserMutation({
 *   variables: {
 *      updateBlockedUserInput: // value for 'updateBlockedUserInput'
 *   },
 * });
 */
export function useUpdateBlockedUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockedUserMutation, UpdateBlockedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockedUserMutation, UpdateBlockedUserMutationVariables>(UpdateBlockedUserDocument, options);
      }
export type UpdateBlockedUserMutationHookResult = ReturnType<typeof useUpdateBlockedUserMutation>;
export type UpdateBlockedUserMutationResult = Apollo.MutationResult<UpdateBlockedUserMutation>;
export type UpdateBlockedUserMutationOptions = Apollo.BaseMutationOptions<UpdateBlockedUserMutation, UpdateBlockedUserMutationVariables>;
export const ExportBlockedUsersDocument = gql`
    query exportBlockedUsers($exportBlockedUsersInput: ExportBlockedUsersInput!) {
  ecExportBlockedUsers(ExportBlockedUsersInput: $exportBlockedUsersInput) {
    signedUrl
  }
}
    `;

/**
 * __useExportBlockedUsersQuery__
 *
 * To run a query within a React component, call `useExportBlockedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportBlockedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportBlockedUsersQuery({
 *   variables: {
 *      exportBlockedUsersInput: // value for 'exportBlockedUsersInput'
 *   },
 * });
 */
export function useExportBlockedUsersQuery(baseOptions: Apollo.QueryHookOptions<ExportBlockedUsersQuery, ExportBlockedUsersQueryVariables> & ({ variables: ExportBlockedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportBlockedUsersQuery, ExportBlockedUsersQueryVariables>(ExportBlockedUsersDocument, options);
      }
export function useExportBlockedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportBlockedUsersQuery, ExportBlockedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportBlockedUsersQuery, ExportBlockedUsersQueryVariables>(ExportBlockedUsersDocument, options);
        }
export function useExportBlockedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportBlockedUsersQuery, ExportBlockedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportBlockedUsersQuery, ExportBlockedUsersQueryVariables>(ExportBlockedUsersDocument, options);
        }
export type ExportBlockedUsersQueryHookResult = ReturnType<typeof useExportBlockedUsersQuery>;
export type ExportBlockedUsersLazyQueryHookResult = ReturnType<typeof useExportBlockedUsersLazyQuery>;
export type ExportBlockedUsersSuspenseQueryHookResult = ReturnType<typeof useExportBlockedUsersSuspenseQuery>;
export type ExportBlockedUsersQueryResult = Apollo.QueryResult<ExportBlockedUsersQuery, ExportBlockedUsersQueryVariables>;
export const SearchAssignableExamCoursesDocument = gql`
    query searchAssignableExamCourses($searchAssignableExamCoursesInput: SearchAssignableExamCoursesInput!) {
  ecSearchAssignableExamCourses(
    searchAssignableExamCoursesInput: $searchAssignableExamCoursesInput
  ) {
    examCourses {
      id
      code
      examId
      name
      type
      language
    }
    total
  }
}
    `;

/**
 * __useSearchAssignableExamCoursesQuery__
 *
 * To run a query within a React component, call `useSearchAssignableExamCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAssignableExamCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAssignableExamCoursesQuery({
 *   variables: {
 *      searchAssignableExamCoursesInput: // value for 'searchAssignableExamCoursesInput'
 *   },
 * });
 */
export function useSearchAssignableExamCoursesQuery(baseOptions: Apollo.QueryHookOptions<SearchAssignableExamCoursesQuery, SearchAssignableExamCoursesQueryVariables> & ({ variables: SearchAssignableExamCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAssignableExamCoursesQuery, SearchAssignableExamCoursesQueryVariables>(SearchAssignableExamCoursesDocument, options);
      }
export function useSearchAssignableExamCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAssignableExamCoursesQuery, SearchAssignableExamCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAssignableExamCoursesQuery, SearchAssignableExamCoursesQueryVariables>(SearchAssignableExamCoursesDocument, options);
        }
export function useSearchAssignableExamCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAssignableExamCoursesQuery, SearchAssignableExamCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAssignableExamCoursesQuery, SearchAssignableExamCoursesQueryVariables>(SearchAssignableExamCoursesDocument, options);
        }
export type SearchAssignableExamCoursesQueryHookResult = ReturnType<typeof useSearchAssignableExamCoursesQuery>;
export type SearchAssignableExamCoursesLazyQueryHookResult = ReturnType<typeof useSearchAssignableExamCoursesLazyQuery>;
export type SearchAssignableExamCoursesSuspenseQueryHookResult = ReturnType<typeof useSearchAssignableExamCoursesSuspenseQuery>;
export type SearchAssignableExamCoursesQueryResult = Apollo.QueryResult<SearchAssignableExamCoursesQuery, SearchAssignableExamCoursesQueryVariables>;
export const AssignExamCoursesToExamCenterDocument = gql`
    mutation assignExamCoursesToExamCenter($assignExamCoursesToExamCenterInput: AssignExamCoursesToExamCenterInput!) {
  ecAssignExamCoursesToExamCenter(
    assignExamCoursesToExamCenterInput: $assignExamCoursesToExamCenterInput
  ) {
    examCourses {
      id
      code
      examId
      name
      type
      language
      enabled
    }
  }
}
    `;
export type AssignExamCoursesToExamCenterMutationFn = Apollo.MutationFunction<AssignExamCoursesToExamCenterMutation, AssignExamCoursesToExamCenterMutationVariables>;

/**
 * __useAssignExamCoursesToExamCenterMutation__
 *
 * To run a mutation, you first call `useAssignExamCoursesToExamCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignExamCoursesToExamCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignExamCoursesToExamCenterMutation, { data, loading, error }] = useAssignExamCoursesToExamCenterMutation({
 *   variables: {
 *      assignExamCoursesToExamCenterInput: // value for 'assignExamCoursesToExamCenterInput'
 *   },
 * });
 */
export function useAssignExamCoursesToExamCenterMutation(baseOptions?: Apollo.MutationHookOptions<AssignExamCoursesToExamCenterMutation, AssignExamCoursesToExamCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignExamCoursesToExamCenterMutation, AssignExamCoursesToExamCenterMutationVariables>(AssignExamCoursesToExamCenterDocument, options);
      }
export type AssignExamCoursesToExamCenterMutationHookResult = ReturnType<typeof useAssignExamCoursesToExamCenterMutation>;
export type AssignExamCoursesToExamCenterMutationResult = Apollo.MutationResult<AssignExamCoursesToExamCenterMutation>;
export type AssignExamCoursesToExamCenterMutationOptions = Apollo.BaseMutationOptions<AssignExamCoursesToExamCenterMutation, AssignExamCoursesToExamCenterMutationVariables>;
export const GetAllExamCenterCoursesDocument = gql`
    query getAllExamCenterCourses($getAllExamCenterCoursesInput: GetAllExamCenterCoursesInput!) {
  ecGetAllExamCenterCourses(
    getAllExamCenterCoursesInput: $getAllExamCenterCoursesInput
  ) {
    examCenterCourses {
      examCourse {
        id
        name
        examId
      }
    }
  }
}
    `;

/**
 * __useGetAllExamCenterCoursesQuery__
 *
 * To run a query within a React component, call `useGetAllExamCenterCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllExamCenterCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllExamCenterCoursesQuery({
 *   variables: {
 *      getAllExamCenterCoursesInput: // value for 'getAllExamCenterCoursesInput'
 *   },
 * });
 */
export function useGetAllExamCenterCoursesQuery(baseOptions: Apollo.QueryHookOptions<GetAllExamCenterCoursesQuery, GetAllExamCenterCoursesQueryVariables> & ({ variables: GetAllExamCenterCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllExamCenterCoursesQuery, GetAllExamCenterCoursesQueryVariables>(GetAllExamCenterCoursesDocument, options);
      }
export function useGetAllExamCenterCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllExamCenterCoursesQuery, GetAllExamCenterCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllExamCenterCoursesQuery, GetAllExamCenterCoursesQueryVariables>(GetAllExamCenterCoursesDocument, options);
        }
export function useGetAllExamCenterCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllExamCenterCoursesQuery, GetAllExamCenterCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllExamCenterCoursesQuery, GetAllExamCenterCoursesQueryVariables>(GetAllExamCenterCoursesDocument, options);
        }
export type GetAllExamCenterCoursesQueryHookResult = ReturnType<typeof useGetAllExamCenterCoursesQuery>;
export type GetAllExamCenterCoursesLazyQueryHookResult = ReturnType<typeof useGetAllExamCenterCoursesLazyQuery>;
export type GetAllExamCenterCoursesSuspenseQueryHookResult = ReturnType<typeof useGetAllExamCenterCoursesSuspenseQuery>;
export type GetAllExamCenterCoursesQueryResult = Apollo.QueryResult<GetAllExamCenterCoursesQuery, GetAllExamCenterCoursesQueryVariables>;
export const CreateExamRoomRequestInfoDocument = gql`
    mutation createExamRoomRequestInfo($createExamRoomRequestInfoInput: CreateExamRoomRequestInfoInputType!) {
  ecCreateExamRoomRequestInfo(
    createExamRoomRequestInfoInput: $createExamRoomRequestInfoInput
  ) {
    examRoomRequestInfo {
      id
      floor
      name
      roomNumber
      seatCount
    }
  }
}
    `;
export type CreateExamRoomRequestInfoMutationFn = Apollo.MutationFunction<CreateExamRoomRequestInfoMutation, CreateExamRoomRequestInfoMutationVariables>;

/**
 * __useCreateExamRoomRequestInfoMutation__
 *
 * To run a mutation, you first call `useCreateExamRoomRequestInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExamRoomRequestInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExamRoomRequestInfoMutation, { data, loading, error }] = useCreateExamRoomRequestInfoMutation({
 *   variables: {
 *      createExamRoomRequestInfoInput: // value for 'createExamRoomRequestInfoInput'
 *   },
 * });
 */
export function useCreateExamRoomRequestInfoMutation(baseOptions?: Apollo.MutationHookOptions<CreateExamRoomRequestInfoMutation, CreateExamRoomRequestInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExamRoomRequestInfoMutation, CreateExamRoomRequestInfoMutationVariables>(CreateExamRoomRequestInfoDocument, options);
      }
export type CreateExamRoomRequestInfoMutationHookResult = ReturnType<typeof useCreateExamRoomRequestInfoMutation>;
export type CreateExamRoomRequestInfoMutationResult = Apollo.MutationResult<CreateExamRoomRequestInfoMutation>;
export type CreateExamRoomRequestInfoMutationOptions = Apollo.BaseMutationOptions<CreateExamRoomRequestInfoMutation, CreateExamRoomRequestInfoMutationVariables>;
export const UpdateExamRoomRequestInfoDocument = gql`
    mutation updateExamRoomRequestInfo($updateExamRoomRequestInfoInput: UpdateExamRoomRequestInfoInputType!) {
  ecUpdateExamRoomRequestInfo(
    updateExamRoomRequestInfoInput: $updateExamRoomRequestInfoInput
  ) {
    examRoomRequestInfo {
      id
      floor
      name
      roomNumber
      seatCount
    }
  }
}
    `;
export type UpdateExamRoomRequestInfoMutationFn = Apollo.MutationFunction<UpdateExamRoomRequestInfoMutation, UpdateExamRoomRequestInfoMutationVariables>;

/**
 * __useUpdateExamRoomRequestInfoMutation__
 *
 * To run a mutation, you first call `useUpdateExamRoomRequestInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamRoomRequestInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamRoomRequestInfoMutation, { data, loading, error }] = useUpdateExamRoomRequestInfoMutation({
 *   variables: {
 *      updateExamRoomRequestInfoInput: // value for 'updateExamRoomRequestInfoInput'
 *   },
 * });
 */
export function useUpdateExamRoomRequestInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExamRoomRequestInfoMutation, UpdateExamRoomRequestInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExamRoomRequestInfoMutation, UpdateExamRoomRequestInfoMutationVariables>(UpdateExamRoomRequestInfoDocument, options);
      }
export type UpdateExamRoomRequestInfoMutationHookResult = ReturnType<typeof useUpdateExamRoomRequestInfoMutation>;
export type UpdateExamRoomRequestInfoMutationResult = Apollo.MutationResult<UpdateExamRoomRequestInfoMutation>;
export type UpdateExamRoomRequestInfoMutationOptions = Apollo.BaseMutationOptions<UpdateExamRoomRequestInfoMutation, UpdateExamRoomRequestInfoMutationVariables>;
export const GetExamRoomRequestInfoByIdDocument = gql`
    query getExamRoomRequestInfoById($getExamRoomRequestInfoByIdInput: GetExamRoomRequestInfoByIdInputType!) {
  ecGetExamRoomRequestInfoById(
    getExamRoomRequestInfoByIdInput: $getExamRoomRequestInfoByIdInput
  ) {
    examRoomRequestInfo {
      id
      examLocationRequestInfoId
      examCenterCode
      floor
      name
      roomNumber
      seatCount
      step
      taskId
      taskCode
      requestedAt
      createdAt
      examLocationRequestInfo {
        id
        provinceId
        province {
          id
          nameTh
        }
        locationId
        nameTh
        nameEn
        buildingId
        buildingName
        building {
          id
          nameTh
          nameEn
          locationId
        }
        editedAt
        editedBy
        editedUser {
          id
          firstname
          lastname
        }
        createdAt
      }
      examRoomRequestComputerInfo {
        info {
          computerDetails {
            monitor {
              value
              otherDetail
            }
            cpu {
              value
              otherDetail
            }
            ram {
              value
              otherDetail
            }
            os {
              value
              otherDetail
            }
            storage {
              value
              otherDetail
            }
            webBrowser {
              value
              otherDetail
            }
            sebVersionStatus
            osUpdateCadence {
              value
              otherDetail
            }
            computerSpecImages
            computerSeatImages
          }
          internetDetails {
            internetSpeed {
              value
              otherDetail
            }
            speedTestImages
          }
          securityDetails {
            antivirusProgram {
              value
              otherDetail
            }
            antivirusConfigForSEB
            isSyncedWithThaiServer
            timeSyncImages
            usbPortCheck
            antivirusUpdateCadence {
              value
              otherDetail
            }
            robotTestImages
          }
        }
        createdAt
        examRoomRequestInfoId
        id
      }
      examRoomRequestPhysicalInfo {
        id
        examRoomRequestInfoId
        info {
          seatSideSpacing {
            valid
            additionalInfo
            images
          }
          screenDistance {
            valid
            additionalInfo
            images
          }
          seatFrontBackSpacing {
            valid
            additionalInfo
            images
          }
          windows {
            valid
            additionalInfo
            images
          }
          storageLocker {
            valid
            additionalInfo
            images
          }
          examineeStorage {
            valid
            additionalInfo
            images
          }
          securityCameras {
            valid
            additionalInfo
            images
          }
          entryExitDoors {
            numberOfDoors
            images
          }
          frontOfExamRoom {
            images
          }
          insideExamRoom {
            images
          }
          registrationArea {
            valid
            additionalInfo
            images
          }
          toilets {
            valid
            additionalInfo
            images
          }
          sharedOpenArea {
            valid
            additionalInfo
            images
          }
        }
        createdAt
      }
      examLocationRequestVerdicts {
        id
        examRoomRequestInfoId
        verdict
        locationId
        requestedAt
        submittedAt
        step
        comment
        updatedBy
        updatedAt
        createdAt
        approvalType
        grantedRoomId
        updatedUser {
          id
          firstname
          lastname
        }
      }
    }
  }
}
    `;

/**
 * __useGetExamRoomRequestInfoByIdQuery__
 *
 * To run a query within a React component, call `useGetExamRoomRequestInfoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamRoomRequestInfoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamRoomRequestInfoByIdQuery({
 *   variables: {
 *      getExamRoomRequestInfoByIdInput: // value for 'getExamRoomRequestInfoByIdInput'
 *   },
 * });
 */
export function useGetExamRoomRequestInfoByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamRoomRequestInfoByIdQuery, GetExamRoomRequestInfoByIdQueryVariables> & ({ variables: GetExamRoomRequestInfoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamRoomRequestInfoByIdQuery, GetExamRoomRequestInfoByIdQueryVariables>(GetExamRoomRequestInfoByIdDocument, options);
      }
export function useGetExamRoomRequestInfoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamRoomRequestInfoByIdQuery, GetExamRoomRequestInfoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamRoomRequestInfoByIdQuery, GetExamRoomRequestInfoByIdQueryVariables>(GetExamRoomRequestInfoByIdDocument, options);
        }
export function useGetExamRoomRequestInfoByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamRoomRequestInfoByIdQuery, GetExamRoomRequestInfoByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamRoomRequestInfoByIdQuery, GetExamRoomRequestInfoByIdQueryVariables>(GetExamRoomRequestInfoByIdDocument, options);
        }
export type GetExamRoomRequestInfoByIdQueryHookResult = ReturnType<typeof useGetExamRoomRequestInfoByIdQuery>;
export type GetExamRoomRequestInfoByIdLazyQueryHookResult = ReturnType<typeof useGetExamRoomRequestInfoByIdLazyQuery>;
export type GetExamRoomRequestInfoByIdSuspenseQueryHookResult = ReturnType<typeof useGetExamRoomRequestInfoByIdSuspenseQuery>;
export type GetExamRoomRequestInfoByIdQueryResult = Apollo.QueryResult<GetExamRoomRequestInfoByIdQuery, GetExamRoomRequestInfoByIdQueryVariables>;
export const CreateExamLocationRequestInfoDocument = gql`
    mutation CreateExamLocationRequestInfo($createExamLocationRequestInfoInput: CreateExamLocationRequestInfoInputType!) {
  ecCreateExamLocationRequestInfo(
    createExamLocationRequestInfoInput: $createExamLocationRequestInfoInput
  ) {
    examLocationRequestInfo {
      id
      provinceId
      locationId
      nameTh
      nameEn
      buildingId
      buildingName
      editedBy
      editedAt
      createdAt
    }
  }
}
    `;
export type CreateExamLocationRequestInfoMutationFn = Apollo.MutationFunction<CreateExamLocationRequestInfoMutation, CreateExamLocationRequestInfoMutationVariables>;

/**
 * __useCreateExamLocationRequestInfoMutation__
 *
 * To run a mutation, you first call `useCreateExamLocationRequestInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExamLocationRequestInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExamLocationRequestInfoMutation, { data, loading, error }] = useCreateExamLocationRequestInfoMutation({
 *   variables: {
 *      createExamLocationRequestInfoInput: // value for 'createExamLocationRequestInfoInput'
 *   },
 * });
 */
export function useCreateExamLocationRequestInfoMutation(baseOptions?: Apollo.MutationHookOptions<CreateExamLocationRequestInfoMutation, CreateExamLocationRequestInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExamLocationRequestInfoMutation, CreateExamLocationRequestInfoMutationVariables>(CreateExamLocationRequestInfoDocument, options);
      }
export type CreateExamLocationRequestInfoMutationHookResult = ReturnType<typeof useCreateExamLocationRequestInfoMutation>;
export type CreateExamLocationRequestInfoMutationResult = Apollo.MutationResult<CreateExamLocationRequestInfoMutation>;
export type CreateExamLocationRequestInfoMutationOptions = Apollo.BaseMutationOptions<CreateExamLocationRequestInfoMutation, CreateExamLocationRequestInfoMutationVariables>;
export const GetExamLocationRequestInfoDocument = gql`
    query GetExamLocationRequestInfo($getExamLocationRequestInfoByIdInput: GetExamLocationRequestInfoByIdInputType!) {
  ecGetExamLocationRequestInfoById(
    getExamLocationRequestInfoByIdInput: $getExamLocationRequestInfoByIdInput
  ) {
    examLocationRequestInfo {
      id
      examCenterCode
      provinceId
      locationId
      nameTh
      nameEn
      buildingId
      buildingName
      editedUser {
        id
        firstname
        lastname
      }
      editedAt
      createdAt
      examRoomRequestInfos {
        id
        examLocationRequestInfoId
        floor
        name
        roomNumber
        seatCount
        step
        taskId
        taskCode
        requestedAt
        createdAt
        examRoomRequestComputerInfo {
          id
          examRoomRequestInfoId
          createdAt
        }
        examRoomRequestPhysicalInfo {
          id
          examRoomRequestInfoId
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetExamLocationRequestInfoQuery__
 *
 * To run a query within a React component, call `useGetExamLocationRequestInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamLocationRequestInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamLocationRequestInfoQuery({
 *   variables: {
 *      getExamLocationRequestInfoByIdInput: // value for 'getExamLocationRequestInfoByIdInput'
 *   },
 * });
 */
export function useGetExamLocationRequestInfoQuery(baseOptions: Apollo.QueryHookOptions<GetExamLocationRequestInfoQuery, GetExamLocationRequestInfoQueryVariables> & ({ variables: GetExamLocationRequestInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamLocationRequestInfoQuery, GetExamLocationRequestInfoQueryVariables>(GetExamLocationRequestInfoDocument, options);
      }
export function useGetExamLocationRequestInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamLocationRequestInfoQuery, GetExamLocationRequestInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamLocationRequestInfoQuery, GetExamLocationRequestInfoQueryVariables>(GetExamLocationRequestInfoDocument, options);
        }
export function useGetExamLocationRequestInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamLocationRequestInfoQuery, GetExamLocationRequestInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamLocationRequestInfoQuery, GetExamLocationRequestInfoQueryVariables>(GetExamLocationRequestInfoDocument, options);
        }
export type GetExamLocationRequestInfoQueryHookResult = ReturnType<typeof useGetExamLocationRequestInfoQuery>;
export type GetExamLocationRequestInfoLazyQueryHookResult = ReturnType<typeof useGetExamLocationRequestInfoLazyQuery>;
export type GetExamLocationRequestInfoSuspenseQueryHookResult = ReturnType<typeof useGetExamLocationRequestInfoSuspenseQuery>;
export type GetExamLocationRequestInfoQueryResult = Apollo.QueryResult<GetExamLocationRequestInfoQuery, GetExamLocationRequestInfoQueryVariables>;
export const UpdateExamLocationRequestInfoDocument = gql`
    mutation updateExamLocationRequestInfo($updateExamLocationRequestInfoInput: UpdateExamLocationRequestInfoInputType!) {
  ecUpdateExamLocationRequestInfo(
    updateExamLocationRequestInfoInput: $updateExamLocationRequestInfoInput
  ) {
    examLocationRequestInfo {
      id
      provinceId
      examCenterCode
      locationId
      nameTh
      nameEn
      buildingId
      buildingName
      editedBy
      editedAt
      createdAt
    }
  }
}
    `;
export type UpdateExamLocationRequestInfoMutationFn = Apollo.MutationFunction<UpdateExamLocationRequestInfoMutation, UpdateExamLocationRequestInfoMutationVariables>;

/**
 * __useUpdateExamLocationRequestInfoMutation__
 *
 * To run a mutation, you first call `useUpdateExamLocationRequestInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamLocationRequestInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamLocationRequestInfoMutation, { data, loading, error }] = useUpdateExamLocationRequestInfoMutation({
 *   variables: {
 *      updateExamLocationRequestInfoInput: // value for 'updateExamLocationRequestInfoInput'
 *   },
 * });
 */
export function useUpdateExamLocationRequestInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExamLocationRequestInfoMutation, UpdateExamLocationRequestInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExamLocationRequestInfoMutation, UpdateExamLocationRequestInfoMutationVariables>(UpdateExamLocationRequestInfoDocument, options);
      }
export type UpdateExamLocationRequestInfoMutationHookResult = ReturnType<typeof useUpdateExamLocationRequestInfoMutation>;
export type UpdateExamLocationRequestInfoMutationResult = Apollo.MutationResult<UpdateExamLocationRequestInfoMutation>;
export type UpdateExamLocationRequestInfoMutationOptions = Apollo.BaseMutationOptions<UpdateExamLocationRequestInfoMutation, UpdateExamLocationRequestInfoMutationVariables>;
export const CreateOrUpdateExamRoomRequestPhysicalInfoDocument = gql`
    mutation CreateOrUpdateExamRoomRequestPhysicalInfo($createOrUpdateExamRoomRequestPhysicalInfoInput: CreateOrUpdateExamRoomRequestPhysicalInfoInputType!) {
  ecCreateOrUpdateExamRoomRequestPhysicalInfo(
    createOrUpdateExamRoomRequestPhysicalInfoInput: $createOrUpdateExamRoomRequestPhysicalInfoInput
  ) {
    examRoomRequestPhysicalInfo {
      id
      examRoomRequestInfoId
      createdAt
    }
  }
}
    `;
export type CreateOrUpdateExamRoomRequestPhysicalInfoMutationFn = Apollo.MutationFunction<CreateOrUpdateExamRoomRequestPhysicalInfoMutation, CreateOrUpdateExamRoomRequestPhysicalInfoMutationVariables>;

/**
 * __useCreateOrUpdateExamRoomRequestPhysicalInfoMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateExamRoomRequestPhysicalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateExamRoomRequestPhysicalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateExamRoomRequestPhysicalInfoMutation, { data, loading, error }] = useCreateOrUpdateExamRoomRequestPhysicalInfoMutation({
 *   variables: {
 *      createOrUpdateExamRoomRequestPhysicalInfoInput: // value for 'createOrUpdateExamRoomRequestPhysicalInfoInput'
 *   },
 * });
 */
export function useCreateOrUpdateExamRoomRequestPhysicalInfoMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateExamRoomRequestPhysicalInfoMutation, CreateOrUpdateExamRoomRequestPhysicalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateExamRoomRequestPhysicalInfoMutation, CreateOrUpdateExamRoomRequestPhysicalInfoMutationVariables>(CreateOrUpdateExamRoomRequestPhysicalInfoDocument, options);
      }
export type CreateOrUpdateExamRoomRequestPhysicalInfoMutationHookResult = ReturnType<typeof useCreateOrUpdateExamRoomRequestPhysicalInfoMutation>;
export type CreateOrUpdateExamRoomRequestPhysicalInfoMutationResult = Apollo.MutationResult<CreateOrUpdateExamRoomRequestPhysicalInfoMutation>;
export type CreateOrUpdateExamRoomRequestPhysicalInfoMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateExamRoomRequestPhysicalInfoMutation, CreateOrUpdateExamRoomRequestPhysicalInfoMutationVariables>;
export const CreateOrUpdateExamRoomRequestComputerInfoDocument = gql`
    mutation CreateOrUpdateExamRoomRequestComputerInfo($createOrUpdateExamRoomRequestComputerInfoInput: CreateOrUpdateExamRoomRequestComputerInfoInputType!) {
  ecCreateOrUpdateExamRoomRequestComputerInfo(
    createOrUpdateExamRoomRequestComputerInfoInput: $createOrUpdateExamRoomRequestComputerInfoInput
  ) {
    examRoomRequestComputerInfo {
      id
      examRoomRequestInfoId
      createdAt
    }
  }
}
    `;
export type CreateOrUpdateExamRoomRequestComputerInfoMutationFn = Apollo.MutationFunction<CreateOrUpdateExamRoomRequestComputerInfoMutation, CreateOrUpdateExamRoomRequestComputerInfoMutationVariables>;

/**
 * __useCreateOrUpdateExamRoomRequestComputerInfoMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateExamRoomRequestComputerInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateExamRoomRequestComputerInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateExamRoomRequestComputerInfoMutation, { data, loading, error }] = useCreateOrUpdateExamRoomRequestComputerInfoMutation({
 *   variables: {
 *      createOrUpdateExamRoomRequestComputerInfoInput: // value for 'createOrUpdateExamRoomRequestComputerInfoInput'
 *   },
 * });
 */
export function useCreateOrUpdateExamRoomRequestComputerInfoMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateExamRoomRequestComputerInfoMutation, CreateOrUpdateExamRoomRequestComputerInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateExamRoomRequestComputerInfoMutation, CreateOrUpdateExamRoomRequestComputerInfoMutationVariables>(CreateOrUpdateExamRoomRequestComputerInfoDocument, options);
      }
export type CreateOrUpdateExamRoomRequestComputerInfoMutationHookResult = ReturnType<typeof useCreateOrUpdateExamRoomRequestComputerInfoMutation>;
export type CreateOrUpdateExamRoomRequestComputerInfoMutationResult = Apollo.MutationResult<CreateOrUpdateExamRoomRequestComputerInfoMutation>;
export type CreateOrUpdateExamRoomRequestComputerInfoMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateExamRoomRequestComputerInfoMutation, CreateOrUpdateExamRoomRequestComputerInfoMutationVariables>;
export const GetUploadSignedUrlForExamRoomRequestPhysicalInfoDocument = gql`
    query GetUploadSignedUrlForExamRoomRequestPhysicalInfo($getUploadSignedUrlForExamRoomRequestPhysicalInfoInput: GetUploadSignedUrlForExamRoomRequestPhysicalInfoInputType!) {
  ecGetUploadSignedUrlForExamRoomRequestPhysicalInfo(
    GetUploadSignedUrlForExamRoomRequestPhysicalInfoInput: $getUploadSignedUrlForExamRoomRequestPhysicalInfoInput
  ) {
    signedUrls {
      url
      storageObject {
        provider
        bucket
        key
        fileName
      }
      contentType
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery({
 *   variables: {
 *      getUploadSignedUrlForExamRoomRequestPhysicalInfoInput: // value for 'getUploadSignedUrlForExamRoomRequestPhysicalInfoInput'
 *   },
 * });
 */
export function useGetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetUploadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables> & ({ variables: GetUploadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetUploadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables>(GetUploadSignedUrlForExamRoomRequestPhysicalInfoDocument, options);
      }
export function useGetUploadSignedUrlForExamRoomRequestPhysicalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetUploadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetUploadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables>(GetUploadSignedUrlForExamRoomRequestPhysicalInfoDocument, options);
        }
export function useGetUploadSignedUrlForExamRoomRequestPhysicalInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetUploadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetUploadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables>(GetUploadSignedUrlForExamRoomRequestPhysicalInfoDocument, options);
        }
export type GetUploadSignedUrlForExamRoomRequestPhysicalInfoQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery>;
export type GetUploadSignedUrlForExamRoomRequestPhysicalInfoLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForExamRoomRequestPhysicalInfoLazyQuery>;
export type GetUploadSignedUrlForExamRoomRequestPhysicalInfoSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForExamRoomRequestPhysicalInfoSuspenseQuery>;
export type GetUploadSignedUrlForExamRoomRequestPhysicalInfoQueryResult = Apollo.QueryResult<GetUploadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetUploadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables>;
export const GetUploadSignedUrlForExamRoomRequestComputerInfoDocument = gql`
    query GetUploadSignedUrlForExamRoomRequestComputerInfo($getUploadSignedUrlForExamRoomRequestComputerInfoInput: GetUploadSignedUrlForExamRoomRequestComputerInfoInputType!) {
  ecGetUploadSignedUrlForExamRoomRequestComputerInfo(
    GetUploadSignedUrlForExamRoomRequestComputerInfoInput: $getUploadSignedUrlForExamRoomRequestComputerInfoInput
  ) {
    signedUrls {
      url
      storageObject {
        provider
        bucket
        key
        fileName
      }
      contentType
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlForExamRoomRequestComputerInfoQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlForExamRoomRequestComputerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlForExamRoomRequestComputerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlForExamRoomRequestComputerInfoQuery({
 *   variables: {
 *      getUploadSignedUrlForExamRoomRequestComputerInfoInput: // value for 'getUploadSignedUrlForExamRoomRequestComputerInfoInput'
 *   },
 * });
 */
export function useGetUploadSignedUrlForExamRoomRequestComputerInfoQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlForExamRoomRequestComputerInfoQuery, GetUploadSignedUrlForExamRoomRequestComputerInfoQueryVariables> & ({ variables: GetUploadSignedUrlForExamRoomRequestComputerInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlForExamRoomRequestComputerInfoQuery, GetUploadSignedUrlForExamRoomRequestComputerInfoQueryVariables>(GetUploadSignedUrlForExamRoomRequestComputerInfoDocument, options);
      }
export function useGetUploadSignedUrlForExamRoomRequestComputerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlForExamRoomRequestComputerInfoQuery, GetUploadSignedUrlForExamRoomRequestComputerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlForExamRoomRequestComputerInfoQuery, GetUploadSignedUrlForExamRoomRequestComputerInfoQueryVariables>(GetUploadSignedUrlForExamRoomRequestComputerInfoDocument, options);
        }
export function useGetUploadSignedUrlForExamRoomRequestComputerInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForExamRoomRequestComputerInfoQuery, GetUploadSignedUrlForExamRoomRequestComputerInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlForExamRoomRequestComputerInfoQuery, GetUploadSignedUrlForExamRoomRequestComputerInfoQueryVariables>(GetUploadSignedUrlForExamRoomRequestComputerInfoDocument, options);
        }
export type GetUploadSignedUrlForExamRoomRequestComputerInfoQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForExamRoomRequestComputerInfoQuery>;
export type GetUploadSignedUrlForExamRoomRequestComputerInfoLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForExamRoomRequestComputerInfoLazyQuery>;
export type GetUploadSignedUrlForExamRoomRequestComputerInfoSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForExamRoomRequestComputerInfoSuspenseQuery>;
export type GetUploadSignedUrlForExamRoomRequestComputerInfoQueryResult = Apollo.QueryResult<GetUploadSignedUrlForExamRoomRequestComputerInfoQuery, GetUploadSignedUrlForExamRoomRequestComputerInfoQueryVariables>;
export const GetDownloadSignedUrlForExamRoomRequestPhysicalInfoDocument = gql`
    query GetDownloadSignedUrlForExamRoomRequestPhysicalInfo($getDownloadSignedUrlForExamRoomRequestPhysicalInfoInput: GetDownloadSignedUrlForExamRoomRequestPhysicalInfoInputType!) {
  ecGetDownloadSignedUrlForExamRoomRequestPhysicalInfo(
    GetDownloadSignedUrlForExamRoomRequestPhysicalInfoInput: $getDownloadSignedUrlForExamRoomRequestPhysicalInfoInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery({
 *   variables: {
 *      getDownloadSignedUrlForExamRoomRequestPhysicalInfoInput: // value for 'getDownloadSignedUrlForExamRoomRequestPhysicalInfoInput'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables> & ({ variables: GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables>(GetDownloadSignedUrlForExamRoomRequestPhysicalInfoDocument, options);
      }
export function useGetDownloadSignedUrlForExamRoomRequestPhysicalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables>(GetDownloadSignedUrlForExamRoomRequestPhysicalInfoDocument, options);
        }
export function useGetDownloadSignedUrlForExamRoomRequestPhysicalInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables>(GetDownloadSignedUrlForExamRoomRequestPhysicalInfoDocument, options);
        }
export type GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery>;
export type GetDownloadSignedUrlForExamRoomRequestPhysicalInfoLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamRoomRequestPhysicalInfoLazyQuery>;
export type GetDownloadSignedUrlForExamRoomRequestPhysicalInfoSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamRoomRequestPhysicalInfoSuspenseQuery>;
export type GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQuery, GetDownloadSignedUrlForExamRoomRequestPhysicalInfoQueryVariables>;
export const GetDownloadSignedUrlForExamRoomRequestComputerInfoDocument = gql`
    query GetDownloadSignedUrlForExamRoomRequestComputerInfo($getDownloadSignedUrlForExamRoomRequestComputerInfoInput: GetDownloadSignedUrlForExamRoomRequestComputerInfoInputType!) {
  ecGetDownloadSignedUrlForExamRoomRequestComputerInfo(
    GetDownloadSignedUrlForExamRoomRequestComputerInfoInput: $getDownloadSignedUrlForExamRoomRequestComputerInfoInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForExamRoomRequestComputerInfoQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForExamRoomRequestComputerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForExamRoomRequestComputerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForExamRoomRequestComputerInfoQuery({
 *   variables: {
 *      getDownloadSignedUrlForExamRoomRequestComputerInfoInput: // value for 'getDownloadSignedUrlForExamRoomRequestComputerInfoInput'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForExamRoomRequestComputerInfoQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForExamRoomRequestComputerInfoQuery, GetDownloadSignedUrlForExamRoomRequestComputerInfoQueryVariables> & ({ variables: GetDownloadSignedUrlForExamRoomRequestComputerInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForExamRoomRequestComputerInfoQuery, GetDownloadSignedUrlForExamRoomRequestComputerInfoQueryVariables>(GetDownloadSignedUrlForExamRoomRequestComputerInfoDocument, options);
      }
export function useGetDownloadSignedUrlForExamRoomRequestComputerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForExamRoomRequestComputerInfoQuery, GetDownloadSignedUrlForExamRoomRequestComputerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForExamRoomRequestComputerInfoQuery, GetDownloadSignedUrlForExamRoomRequestComputerInfoQueryVariables>(GetDownloadSignedUrlForExamRoomRequestComputerInfoDocument, options);
        }
export function useGetDownloadSignedUrlForExamRoomRequestComputerInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForExamRoomRequestComputerInfoQuery, GetDownloadSignedUrlForExamRoomRequestComputerInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForExamRoomRequestComputerInfoQuery, GetDownloadSignedUrlForExamRoomRequestComputerInfoQueryVariables>(GetDownloadSignedUrlForExamRoomRequestComputerInfoDocument, options);
        }
export type GetDownloadSignedUrlForExamRoomRequestComputerInfoQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamRoomRequestComputerInfoQuery>;
export type GetDownloadSignedUrlForExamRoomRequestComputerInfoLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamRoomRequestComputerInfoLazyQuery>;
export type GetDownloadSignedUrlForExamRoomRequestComputerInfoSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamRoomRequestComputerInfoSuspenseQuery>;
export type GetDownloadSignedUrlForExamRoomRequestComputerInfoQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForExamRoomRequestComputerInfoQuery, GetDownloadSignedUrlForExamRoomRequestComputerInfoQueryVariables>;
export const GetBuildingsByLocationIdDocument = gql`
    query GetBuildingsByLocationId($getBuildingsByLocationIdInput: GetBuildingsByLocationIdInput!) {
  ecGetBuildingsByLocationId(
    getBuildingsByLocationIdInput: $getBuildingsByLocationIdInput
  ) {
    buildings {
      id
      nameTh
      nameEn
    }
  }
}
    `;

/**
 * __useGetBuildingsByLocationIdQuery__
 *
 * To run a query within a React component, call `useGetBuildingsByLocationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingsByLocationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingsByLocationIdQuery({
 *   variables: {
 *      getBuildingsByLocationIdInput: // value for 'getBuildingsByLocationIdInput'
 *   },
 * });
 */
export function useGetBuildingsByLocationIdQuery(baseOptions: Apollo.QueryHookOptions<GetBuildingsByLocationIdQuery, GetBuildingsByLocationIdQueryVariables> & ({ variables: GetBuildingsByLocationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingsByLocationIdQuery, GetBuildingsByLocationIdQueryVariables>(GetBuildingsByLocationIdDocument, options);
      }
export function useGetBuildingsByLocationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingsByLocationIdQuery, GetBuildingsByLocationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingsByLocationIdQuery, GetBuildingsByLocationIdQueryVariables>(GetBuildingsByLocationIdDocument, options);
        }
export function useGetBuildingsByLocationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBuildingsByLocationIdQuery, GetBuildingsByLocationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuildingsByLocationIdQuery, GetBuildingsByLocationIdQueryVariables>(GetBuildingsByLocationIdDocument, options);
        }
export type GetBuildingsByLocationIdQueryHookResult = ReturnType<typeof useGetBuildingsByLocationIdQuery>;
export type GetBuildingsByLocationIdLazyQueryHookResult = ReturnType<typeof useGetBuildingsByLocationIdLazyQuery>;
export type GetBuildingsByLocationIdSuspenseQueryHookResult = ReturnType<typeof useGetBuildingsByLocationIdSuspenseQuery>;
export type GetBuildingsByLocationIdQueryResult = Apollo.QueryResult<GetBuildingsByLocationIdQuery, GetBuildingsByLocationIdQueryVariables>;
export const SearchExamLocationRequestInfosDocument = gql`
    query SearchExamLocationRequestInfos($searchExamLocationRequestInfosInput: SearchExamLocationRequestInfosInputType!) {
  ecSearchExamLocationRequestInfos(
    searchExamLocationRequestInfosInput: $searchExamLocationRequestInfosInput
  ) {
    total
    examLocationRequestInfos {
      id
      building {
        id
        nameTh
        nameEn
        locationId
      }
      buildingName
      editedAt
      editedUser {
        firstname
        lastname
      }
      nameTh
      province {
        nameTh
      }
      location {
        nameTh
      }
    }
  }
}
    `;

/**
 * __useSearchExamLocationRequestInfosQuery__
 *
 * To run a query within a React component, call `useSearchExamLocationRequestInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamLocationRequestInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamLocationRequestInfosQuery({
 *   variables: {
 *      searchExamLocationRequestInfosInput: // value for 'searchExamLocationRequestInfosInput'
 *   },
 * });
 */
export function useSearchExamLocationRequestInfosQuery(baseOptions: Apollo.QueryHookOptions<SearchExamLocationRequestInfosQuery, SearchExamLocationRequestInfosQueryVariables> & ({ variables: SearchExamLocationRequestInfosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamLocationRequestInfosQuery, SearchExamLocationRequestInfosQueryVariables>(SearchExamLocationRequestInfosDocument, options);
      }
export function useSearchExamLocationRequestInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamLocationRequestInfosQuery, SearchExamLocationRequestInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamLocationRequestInfosQuery, SearchExamLocationRequestInfosQueryVariables>(SearchExamLocationRequestInfosDocument, options);
        }
export function useSearchExamLocationRequestInfosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamLocationRequestInfosQuery, SearchExamLocationRequestInfosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamLocationRequestInfosQuery, SearchExamLocationRequestInfosQueryVariables>(SearchExamLocationRequestInfosDocument, options);
        }
export type SearchExamLocationRequestInfosQueryHookResult = ReturnType<typeof useSearchExamLocationRequestInfosQuery>;
export type SearchExamLocationRequestInfosLazyQueryHookResult = ReturnType<typeof useSearchExamLocationRequestInfosLazyQuery>;
export type SearchExamLocationRequestInfosSuspenseQueryHookResult = ReturnType<typeof useSearchExamLocationRequestInfosSuspenseQuery>;
export type SearchExamLocationRequestInfosQueryResult = Apollo.QueryResult<SearchExamLocationRequestInfosQuery, SearchExamLocationRequestInfosQueryVariables>;
export const GetExamLocationRequestInfoCountByStatusDocument = gql`
    query GetExamLocationRequestInfoCountByStatus($getExamLocationRequestInfoCountByExamCenterCodeInput: GetExamLocationRequestInfoCountByExamCenterCodeInputType!) {
  ecGetExamLocationRequestInfoCountByExamCenterCode(
    getExamLocationRequestInfoCountByExamCenterCodeInput: $getExamLocationRequestInfoCountByExamCenterCodeInput
  ) {
    examLocationRequestInfoCountByStatus {
      draft
      inReview
      rejected
    }
  }
}
    `;

/**
 * __useGetExamLocationRequestInfoCountByStatusQuery__
 *
 * To run a query within a React component, call `useGetExamLocationRequestInfoCountByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamLocationRequestInfoCountByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamLocationRequestInfoCountByStatusQuery({
 *   variables: {
 *      getExamLocationRequestInfoCountByExamCenterCodeInput: // value for 'getExamLocationRequestInfoCountByExamCenterCodeInput'
 *   },
 * });
 */
export function useGetExamLocationRequestInfoCountByStatusQuery(baseOptions: Apollo.QueryHookOptions<GetExamLocationRequestInfoCountByStatusQuery, GetExamLocationRequestInfoCountByStatusQueryVariables> & ({ variables: GetExamLocationRequestInfoCountByStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamLocationRequestInfoCountByStatusQuery, GetExamLocationRequestInfoCountByStatusQueryVariables>(GetExamLocationRequestInfoCountByStatusDocument, options);
      }
export function useGetExamLocationRequestInfoCountByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamLocationRequestInfoCountByStatusQuery, GetExamLocationRequestInfoCountByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamLocationRequestInfoCountByStatusQuery, GetExamLocationRequestInfoCountByStatusQueryVariables>(GetExamLocationRequestInfoCountByStatusDocument, options);
        }
export function useGetExamLocationRequestInfoCountByStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamLocationRequestInfoCountByStatusQuery, GetExamLocationRequestInfoCountByStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamLocationRequestInfoCountByStatusQuery, GetExamLocationRequestInfoCountByStatusQueryVariables>(GetExamLocationRequestInfoCountByStatusDocument, options);
        }
export type GetExamLocationRequestInfoCountByStatusQueryHookResult = ReturnType<typeof useGetExamLocationRequestInfoCountByStatusQuery>;
export type GetExamLocationRequestInfoCountByStatusLazyQueryHookResult = ReturnType<typeof useGetExamLocationRequestInfoCountByStatusLazyQuery>;
export type GetExamLocationRequestInfoCountByStatusSuspenseQueryHookResult = ReturnType<typeof useGetExamLocationRequestInfoCountByStatusSuspenseQuery>;
export type GetExamLocationRequestInfoCountByStatusQueryResult = Apollo.QueryResult<GetExamLocationRequestInfoCountByStatusQuery, GetExamLocationRequestInfoCountByStatusQueryVariables>;
export const SubmitExamLocationRequestInfoDocument = gql`
    mutation submitExamLocationRequestInfo($submitExamLocationRequestInfoInput: SubmitExamLocationRequestInfoInputType!) {
  ecSubmitExamLocationRequestInfo(
    submitExamLocationRequestInfoInput: $submitExamLocationRequestInfoInput
  ) {
    isSuccess
    details
  }
}
    `;
export type SubmitExamLocationRequestInfoMutationFn = Apollo.MutationFunction<SubmitExamLocationRequestInfoMutation, SubmitExamLocationRequestInfoMutationVariables>;

/**
 * __useSubmitExamLocationRequestInfoMutation__
 *
 * To run a mutation, you first call `useSubmitExamLocationRequestInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitExamLocationRequestInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitExamLocationRequestInfoMutation, { data, loading, error }] = useSubmitExamLocationRequestInfoMutation({
 *   variables: {
 *      submitExamLocationRequestInfoInput: // value for 'submitExamLocationRequestInfoInput'
 *   },
 * });
 */
export function useSubmitExamLocationRequestInfoMutation(baseOptions?: Apollo.MutationHookOptions<SubmitExamLocationRequestInfoMutation, SubmitExamLocationRequestInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitExamLocationRequestInfoMutation, SubmitExamLocationRequestInfoMutationVariables>(SubmitExamLocationRequestInfoDocument, options);
      }
export type SubmitExamLocationRequestInfoMutationHookResult = ReturnType<typeof useSubmitExamLocationRequestInfoMutation>;
export type SubmitExamLocationRequestInfoMutationResult = Apollo.MutationResult<SubmitExamLocationRequestInfoMutation>;
export type SubmitExamLocationRequestInfoMutationOptions = Apollo.BaseMutationOptions<SubmitExamLocationRequestInfoMutation, SubmitExamLocationRequestInfoMutationVariables>;
export const AdminSearchMyExamRoomRequestInfosDocument = gql`
    query AdminSearchMyExamRoomRequestInfos($adminSearchMyExamRoomRequestInfosInput: AdminSearchMyExamRoomRequestInfosInput!) {
  ecAdminSearchMyExamRoomRequestInfos(
    adminSearchMyExamRoomRequestInfosInput: $adminSearchMyExamRoomRequestInfosInput
  ) {
    total
    examRoomRequestInfos {
      id
      taskCode
      floor
      name
      roomNumber
      examCenterCode
      requestedAt
      step
      examLocationRequestInfo {
        nameTh
        building {
          nameTh
        }
        buildingName
        province {
          nameTh
        }
      }
      examLocationRequestVerdicts {
        step
        verdict
        submittedAt
        requestedAt
      }
    }
  }
}
    `;

/**
 * __useAdminSearchMyExamRoomRequestInfosQuery__
 *
 * To run a query within a React component, call `useAdminSearchMyExamRoomRequestInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSearchMyExamRoomRequestInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSearchMyExamRoomRequestInfosQuery({
 *   variables: {
 *      adminSearchMyExamRoomRequestInfosInput: // value for 'adminSearchMyExamRoomRequestInfosInput'
 *   },
 * });
 */
export function useAdminSearchMyExamRoomRequestInfosQuery(baseOptions: Apollo.QueryHookOptions<AdminSearchMyExamRoomRequestInfosQuery, AdminSearchMyExamRoomRequestInfosQueryVariables> & ({ variables: AdminSearchMyExamRoomRequestInfosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSearchMyExamRoomRequestInfosQuery, AdminSearchMyExamRoomRequestInfosQueryVariables>(AdminSearchMyExamRoomRequestInfosDocument, options);
      }
export function useAdminSearchMyExamRoomRequestInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSearchMyExamRoomRequestInfosQuery, AdminSearchMyExamRoomRequestInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSearchMyExamRoomRequestInfosQuery, AdminSearchMyExamRoomRequestInfosQueryVariables>(AdminSearchMyExamRoomRequestInfosDocument, options);
        }
export function useAdminSearchMyExamRoomRequestInfosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminSearchMyExamRoomRequestInfosQuery, AdminSearchMyExamRoomRequestInfosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSearchMyExamRoomRequestInfosQuery, AdminSearchMyExamRoomRequestInfosQueryVariables>(AdminSearchMyExamRoomRequestInfosDocument, options);
        }
export type AdminSearchMyExamRoomRequestInfosQueryHookResult = ReturnType<typeof useAdminSearchMyExamRoomRequestInfosQuery>;
export type AdminSearchMyExamRoomRequestInfosLazyQueryHookResult = ReturnType<typeof useAdminSearchMyExamRoomRequestInfosLazyQuery>;
export type AdminSearchMyExamRoomRequestInfosSuspenseQueryHookResult = ReturnType<typeof useAdminSearchMyExamRoomRequestInfosSuspenseQuery>;
export type AdminSearchMyExamRoomRequestInfosQueryResult = Apollo.QueryResult<AdminSearchMyExamRoomRequestInfosQuery, AdminSearchMyExamRoomRequestInfosQueryVariables>;
export const SearchExamRoomRequestInfosDocument = gql`
    query SearchExamRoomRequestInfos($searchExamRoomRequestInfosInput: SearchExamRoomRequestInfosInputType!) {
  ecSearchExamRoomRequestInfos(
    searchExamRoomRequestInfosInput: $searchExamRoomRequestInfosInput
  ) {
    examRoomRequestInfos {
      id
      floor
      name
      roomNumber
      taskCode
      examCenterCode
      requestedAt
      createdAt
      step
      examLocationRequestVerdicts {
        id
        verdict
        locationId
        requestedAt
        submittedAt
        step
        comment
        updatedBy
        updatedAt
        createdAt
        updatedUser {
          id
          firstname
          lastname
        }
      }
      examLocationRequestInfo {
        buildingName
        building {
          nameTh
        }
        province {
          nameTh
        }
        nameTh
      }
    }
    total
  }
}
    `;

/**
 * __useSearchExamRoomRequestInfosQuery__
 *
 * To run a query within a React component, call `useSearchExamRoomRequestInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamRoomRequestInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamRoomRequestInfosQuery({
 *   variables: {
 *      searchExamRoomRequestInfosInput: // value for 'searchExamRoomRequestInfosInput'
 *   },
 * });
 */
export function useSearchExamRoomRequestInfosQuery(baseOptions: Apollo.QueryHookOptions<SearchExamRoomRequestInfosQuery, SearchExamRoomRequestInfosQueryVariables> & ({ variables: SearchExamRoomRequestInfosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamRoomRequestInfosQuery, SearchExamRoomRequestInfosQueryVariables>(SearchExamRoomRequestInfosDocument, options);
      }
export function useSearchExamRoomRequestInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamRoomRequestInfosQuery, SearchExamRoomRequestInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamRoomRequestInfosQuery, SearchExamRoomRequestInfosQueryVariables>(SearchExamRoomRequestInfosDocument, options);
        }
export function useSearchExamRoomRequestInfosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamRoomRequestInfosQuery, SearchExamRoomRequestInfosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamRoomRequestInfosQuery, SearchExamRoomRequestInfosQueryVariables>(SearchExamRoomRequestInfosDocument, options);
        }
export type SearchExamRoomRequestInfosQueryHookResult = ReturnType<typeof useSearchExamRoomRequestInfosQuery>;
export type SearchExamRoomRequestInfosLazyQueryHookResult = ReturnType<typeof useSearchExamRoomRequestInfosLazyQuery>;
export type SearchExamRoomRequestInfosSuspenseQueryHookResult = ReturnType<typeof useSearchExamRoomRequestInfosSuspenseQuery>;
export type SearchExamRoomRequestInfosQueryResult = Apollo.QueryResult<SearchExamRoomRequestInfosQuery, SearchExamRoomRequestInfosQueryVariables>;
export const AdminSearchRoomByLocationNameDocument = gql`
    query adminSearchRoomByLocationName($adminSearchRoomByLocationNameInput: AdminSearchRoomByLocationNameInput!) {
  ecAdminSearchRoomByLocationName(
    AdminSearchRoomByLocationNameInput: $adminSearchRoomByLocationNameInput
  ) {
    rooms {
      id
      name
      buildingId
      floor
      roomNumber
      seat
      status
      retiredRemark
      retiredAt
      building {
        id
        nameTh
        nameEn
        locationId
        location {
          id
          nameTh
          nameEn
          provinceId
          province {
            id
            nameTh
            nameEn
            code
            geographyId
          }
        }
      }
      updatedAt
    }
    total
  }
}
    `;

/**
 * __useAdminSearchRoomByLocationNameQuery__
 *
 * To run a query within a React component, call `useAdminSearchRoomByLocationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSearchRoomByLocationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSearchRoomByLocationNameQuery({
 *   variables: {
 *      adminSearchRoomByLocationNameInput: // value for 'adminSearchRoomByLocationNameInput'
 *   },
 * });
 */
export function useAdminSearchRoomByLocationNameQuery(baseOptions: Apollo.QueryHookOptions<AdminSearchRoomByLocationNameQuery, AdminSearchRoomByLocationNameQueryVariables> & ({ variables: AdminSearchRoomByLocationNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSearchRoomByLocationNameQuery, AdminSearchRoomByLocationNameQueryVariables>(AdminSearchRoomByLocationNameDocument, options);
      }
export function useAdminSearchRoomByLocationNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSearchRoomByLocationNameQuery, AdminSearchRoomByLocationNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSearchRoomByLocationNameQuery, AdminSearchRoomByLocationNameQueryVariables>(AdminSearchRoomByLocationNameDocument, options);
        }
export function useAdminSearchRoomByLocationNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminSearchRoomByLocationNameQuery, AdminSearchRoomByLocationNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSearchRoomByLocationNameQuery, AdminSearchRoomByLocationNameQueryVariables>(AdminSearchRoomByLocationNameDocument, options);
        }
export type AdminSearchRoomByLocationNameQueryHookResult = ReturnType<typeof useAdminSearchRoomByLocationNameQuery>;
export type AdminSearchRoomByLocationNameLazyQueryHookResult = ReturnType<typeof useAdminSearchRoomByLocationNameLazyQuery>;
export type AdminSearchRoomByLocationNameSuspenseQueryHookResult = ReturnType<typeof useAdminSearchRoomByLocationNameSuspenseQuery>;
export type AdminSearchRoomByLocationNameQueryResult = Apollo.QueryResult<AdminSearchRoomByLocationNameQuery, AdminSearchRoomByLocationNameQueryVariables>;
export const CreateOrUpdateExamLocationRequestVerdictDocument = gql`
    mutation CreateOrUpdateExamLocationRequestVerdict($createOrUpdateExamLocationRequestVerdictInput: CreateOrUpdateExamLocationRequestVerdictInputType!) {
  ecCreateOrUpdateExamLocationRequestVerdict(
    createOrUpdateExamLocationRequestVerdictInput: $createOrUpdateExamLocationRequestVerdictInput
  ) {
    examLocationVerdict {
      id
      examRoomRequestInfoId
      verdict
      locationId
      requestedAt
      submittedAt
      step
      comment
      approvalType
      grantedRoomId
      updatedBy
      updatedAt
      createdAt
    }
  }
}
    `;
export type CreateOrUpdateExamLocationRequestVerdictMutationFn = Apollo.MutationFunction<CreateOrUpdateExamLocationRequestVerdictMutation, CreateOrUpdateExamLocationRequestVerdictMutationVariables>;

/**
 * __useCreateOrUpdateExamLocationRequestVerdictMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateExamLocationRequestVerdictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateExamLocationRequestVerdictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateExamLocationRequestVerdictMutation, { data, loading, error }] = useCreateOrUpdateExamLocationRequestVerdictMutation({
 *   variables: {
 *      createOrUpdateExamLocationRequestVerdictInput: // value for 'createOrUpdateExamLocationRequestVerdictInput'
 *   },
 * });
 */
export function useCreateOrUpdateExamLocationRequestVerdictMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateExamLocationRequestVerdictMutation, CreateOrUpdateExamLocationRequestVerdictMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateExamLocationRequestVerdictMutation, CreateOrUpdateExamLocationRequestVerdictMutationVariables>(CreateOrUpdateExamLocationRequestVerdictDocument, options);
      }
export type CreateOrUpdateExamLocationRequestVerdictMutationHookResult = ReturnType<typeof useCreateOrUpdateExamLocationRequestVerdictMutation>;
export type CreateOrUpdateExamLocationRequestVerdictMutationResult = Apollo.MutationResult<CreateOrUpdateExamLocationRequestVerdictMutation>;
export type CreateOrUpdateExamLocationRequestVerdictMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateExamLocationRequestVerdictMutation, CreateOrUpdateExamLocationRequestVerdictMutationVariables>;
export const SubmitReviewExamRoomRequestInfoDocument = gql`
    mutation SubmitReviewExamRoomRequestInfo($submitReviewExamRoomRequestInfoInput: SubmitReviewExamRoomRequestInfoInputType!) {
  ecSubmitReviewExamRoomRequestInfo(
    submitReviewExamRoomRequestInfoInput: $submitReviewExamRoomRequestInfoInput
  ) {
    examRoomRequestInfo {
      id
      examLocationRequestInfoId
      examCenterCode
      floor
      name
      roomNumber
      seatCount
      step
      taskId
      taskCode
      requestedAt
      editedBy
      editedAt
      createdAt
    }
  }
}
    `;
export type SubmitReviewExamRoomRequestInfoMutationFn = Apollo.MutationFunction<SubmitReviewExamRoomRequestInfoMutation, SubmitReviewExamRoomRequestInfoMutationVariables>;

/**
 * __useSubmitReviewExamRoomRequestInfoMutation__
 *
 * To run a mutation, you first call `useSubmitReviewExamRoomRequestInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitReviewExamRoomRequestInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitReviewExamRoomRequestInfoMutation, { data, loading, error }] = useSubmitReviewExamRoomRequestInfoMutation({
 *   variables: {
 *      submitReviewExamRoomRequestInfoInput: // value for 'submitReviewExamRoomRequestInfoInput'
 *   },
 * });
 */
export function useSubmitReviewExamRoomRequestInfoMutation(baseOptions?: Apollo.MutationHookOptions<SubmitReviewExamRoomRequestInfoMutation, SubmitReviewExamRoomRequestInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitReviewExamRoomRequestInfoMutation, SubmitReviewExamRoomRequestInfoMutationVariables>(SubmitReviewExamRoomRequestInfoDocument, options);
      }
export type SubmitReviewExamRoomRequestInfoMutationHookResult = ReturnType<typeof useSubmitReviewExamRoomRequestInfoMutation>;
export type SubmitReviewExamRoomRequestInfoMutationResult = Apollo.MutationResult<SubmitReviewExamRoomRequestInfoMutation>;
export type SubmitReviewExamRoomRequestInfoMutationOptions = Apollo.BaseMutationOptions<SubmitReviewExamRoomRequestInfoMutation, SubmitReviewExamRoomRequestInfoMutationVariables>;
export const SubmitExamRoomRequestDocument = gql`
    mutation SubmitExamRoomRequest($submitExamRoomRequestInput: SubmitExamRoomRequestInputType!) {
  ecSubmitExamRoomRequest(submitExamRoomRequestInput: $submitExamRoomRequestInput) {
    hasComputerInfoError
    hasPhysicalInfoError
    isSuccess
  }
}
    `;
export type SubmitExamRoomRequestMutationFn = Apollo.MutationFunction<SubmitExamRoomRequestMutation, SubmitExamRoomRequestMutationVariables>;

/**
 * __useSubmitExamRoomRequestMutation__
 *
 * To run a mutation, you first call `useSubmitExamRoomRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitExamRoomRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitExamRoomRequestMutation, { data, loading, error }] = useSubmitExamRoomRequestMutation({
 *   variables: {
 *      submitExamRoomRequestInput: // value for 'submitExamRoomRequestInput'
 *   },
 * });
 */
export function useSubmitExamRoomRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitExamRoomRequestMutation, SubmitExamRoomRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitExamRoomRequestMutation, SubmitExamRoomRequestMutationVariables>(SubmitExamRoomRequestDocument, options);
      }
export type SubmitExamRoomRequestMutationHookResult = ReturnType<typeof useSubmitExamRoomRequestMutation>;
export type SubmitExamRoomRequestMutationResult = Apollo.MutationResult<SubmitExamRoomRequestMutation>;
export type SubmitExamRoomRequestMutationOptions = Apollo.BaseMutationOptions<SubmitExamRoomRequestMutation, SubmitExamRoomRequestMutationVariables>;
export const AdminGetExamRoomRequestInfoByIdDocument = gql`
    query AdminGetExamRoomRequestInfoById($adminGetExamRoomRequestInfoByIdInput: AdminGetExamRoomRequestInfoByIdInputType!) {
  ecAdminGetExamRoomRequestInfoById(
    adminGetExamRoomRequestInfoByIdInput: $adminGetExamRoomRequestInfoByIdInput
  ) {
    examRoomRequestInfo {
      id
      examLocationRequestInfoId
      examCenterCode
      floor
      name
      roomNumber
      seatCount
      step
      taskId
      taskCode
      requestedAt
      createdAt
      examLocationRequestInfo {
        id
        provinceId
        province {
          id
          nameTh
        }
        locationId
        nameTh
        nameEn
        buildingId
        buildingName
        building {
          id
          nameTh
          nameEn
          locationId
        }
        editedAt
        editedBy
        editedUser {
          id
          firstname
          lastname
        }
        createdAt
      }
      examRoomRequestComputerInfo {
        info {
          computerDetails {
            monitor {
              value
              otherDetail
            }
            cpu {
              value
              otherDetail
            }
            ram {
              value
              otherDetail
            }
            os {
              value
              otherDetail
            }
            storage {
              value
              otherDetail
            }
            webBrowser {
              value
              otherDetail
            }
            sebVersionStatus
            osUpdateCadence {
              value
              otherDetail
            }
            computerSpecImages
            computerSeatImages
          }
          internetDetails {
            internetSpeed {
              value
              otherDetail
            }
            speedTestImages
          }
          securityDetails {
            antivirusProgram {
              value
              otherDetail
            }
            antivirusConfigForSEB
            isSyncedWithThaiServer
            timeSyncImages
            usbPortCheck
            antivirusUpdateCadence {
              value
              otherDetail
            }
            robotTestImages
          }
        }
        createdAt
        examRoomRequestInfoId
        id
      }
      examRoomRequestPhysicalInfo {
        id
        examRoomRequestInfoId
        info {
          seatSideSpacing {
            valid
            additionalInfo
            images
          }
          screenDistance {
            valid
            additionalInfo
            images
          }
          seatFrontBackSpacing {
            valid
            additionalInfo
            images
          }
          windows {
            valid
            additionalInfo
            images
          }
          storageLocker {
            valid
            additionalInfo
            images
          }
          examineeStorage {
            valid
            additionalInfo
            images
          }
          securityCameras {
            valid
            additionalInfo
            images
          }
          entryExitDoors {
            numberOfDoors
            images
          }
          frontOfExamRoom {
            images
          }
          insideExamRoom {
            images
          }
          registrationArea {
            valid
            additionalInfo
            images
          }
          toilets {
            valid
            additionalInfo
            images
          }
          sharedOpenArea {
            valid
            additionalInfo
            images
          }
        }
        createdAt
      }
      examLocationRequestVerdicts {
        id
        examRoomRequestInfoId
        verdict
        locationId
        requestedAt
        submittedAt
        step
        comment
        updatedBy
        updatedAt
        createdAt
        approvalType
        grantedRoomId
        updatedUser {
          id
          firstname
          lastname
        }
      }
    }
  }
}
    `;

/**
 * __useAdminGetExamRoomRequestInfoByIdQuery__
 *
 * To run a query within a React component, call `useAdminGetExamRoomRequestInfoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetExamRoomRequestInfoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetExamRoomRequestInfoByIdQuery({
 *   variables: {
 *      adminGetExamRoomRequestInfoByIdInput: // value for 'adminGetExamRoomRequestInfoByIdInput'
 *   },
 * });
 */
export function useAdminGetExamRoomRequestInfoByIdQuery(baseOptions: Apollo.QueryHookOptions<AdminGetExamRoomRequestInfoByIdQuery, AdminGetExamRoomRequestInfoByIdQueryVariables> & ({ variables: AdminGetExamRoomRequestInfoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetExamRoomRequestInfoByIdQuery, AdminGetExamRoomRequestInfoByIdQueryVariables>(AdminGetExamRoomRequestInfoByIdDocument, options);
      }
export function useAdminGetExamRoomRequestInfoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetExamRoomRequestInfoByIdQuery, AdminGetExamRoomRequestInfoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetExamRoomRequestInfoByIdQuery, AdminGetExamRoomRequestInfoByIdQueryVariables>(AdminGetExamRoomRequestInfoByIdDocument, options);
        }
export function useAdminGetExamRoomRequestInfoByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetExamRoomRequestInfoByIdQuery, AdminGetExamRoomRequestInfoByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetExamRoomRequestInfoByIdQuery, AdminGetExamRoomRequestInfoByIdQueryVariables>(AdminGetExamRoomRequestInfoByIdDocument, options);
        }
export type AdminGetExamRoomRequestInfoByIdQueryHookResult = ReturnType<typeof useAdminGetExamRoomRequestInfoByIdQuery>;
export type AdminGetExamRoomRequestInfoByIdLazyQueryHookResult = ReturnType<typeof useAdminGetExamRoomRequestInfoByIdLazyQuery>;
export type AdminGetExamRoomRequestInfoByIdSuspenseQueryHookResult = ReturnType<typeof useAdminGetExamRoomRequestInfoByIdSuspenseQuery>;
export type AdminGetExamRoomRequestInfoByIdQueryResult = Apollo.QueryResult<AdminGetExamRoomRequestInfoByIdQuery, AdminGetExamRoomRequestInfoByIdQueryVariables>;
export const AdminGetExamRoomRequestInfoCountDocument = gql`
    query AdminGetExamRoomRequestInfoCount {
  ecAdminGetExamRoomRequestInfoCount {
    examRoomRequestInfoCountByStatus {
      inReview
      rejected
    }
  }
}
    `;

/**
 * __useAdminGetExamRoomRequestInfoCountQuery__
 *
 * To run a query within a React component, call `useAdminGetExamRoomRequestInfoCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetExamRoomRequestInfoCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetExamRoomRequestInfoCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminGetExamRoomRequestInfoCountQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetExamRoomRequestInfoCountQuery, AdminGetExamRoomRequestInfoCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetExamRoomRequestInfoCountQuery, AdminGetExamRoomRequestInfoCountQueryVariables>(AdminGetExamRoomRequestInfoCountDocument, options);
      }
export function useAdminGetExamRoomRequestInfoCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetExamRoomRequestInfoCountQuery, AdminGetExamRoomRequestInfoCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetExamRoomRequestInfoCountQuery, AdminGetExamRoomRequestInfoCountQueryVariables>(AdminGetExamRoomRequestInfoCountDocument, options);
        }
export function useAdminGetExamRoomRequestInfoCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetExamRoomRequestInfoCountQuery, AdminGetExamRoomRequestInfoCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetExamRoomRequestInfoCountQuery, AdminGetExamRoomRequestInfoCountQueryVariables>(AdminGetExamRoomRequestInfoCountDocument, options);
        }
export type AdminGetExamRoomRequestInfoCountQueryHookResult = ReturnType<typeof useAdminGetExamRoomRequestInfoCountQuery>;
export type AdminGetExamRoomRequestInfoCountLazyQueryHookResult = ReturnType<typeof useAdminGetExamRoomRequestInfoCountLazyQuery>;
export type AdminGetExamRoomRequestInfoCountSuspenseQueryHookResult = ReturnType<typeof useAdminGetExamRoomRequestInfoCountSuspenseQuery>;
export type AdminGetExamRoomRequestInfoCountQueryResult = Apollo.QueryResult<AdminGetExamRoomRequestInfoCountQuery, AdminGetExamRoomRequestInfoCountQueryVariables>;
export const DeleteExamRoomRequestInfoByIdDocument = gql`
    mutation DeleteExamRoomRequestInfoById($deleteExamRoomRequestInfoByIdInput: DeleteExamRoomRequestInfoByIdInputType!) {
  ecDeleteExamRoomRequestInfoById(
    deleteExamRoomRequestInfoByIdInput: $deleteExamRoomRequestInfoByIdInput
  ) {
    status
    message
    data
  }
}
    `;
export type DeleteExamRoomRequestInfoByIdMutationFn = Apollo.MutationFunction<DeleteExamRoomRequestInfoByIdMutation, DeleteExamRoomRequestInfoByIdMutationVariables>;

/**
 * __useDeleteExamRoomRequestInfoByIdMutation__
 *
 * To run a mutation, you first call `useDeleteExamRoomRequestInfoByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExamRoomRequestInfoByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExamRoomRequestInfoByIdMutation, { data, loading, error }] = useDeleteExamRoomRequestInfoByIdMutation({
 *   variables: {
 *      deleteExamRoomRequestInfoByIdInput: // value for 'deleteExamRoomRequestInfoByIdInput'
 *   },
 * });
 */
export function useDeleteExamRoomRequestInfoByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExamRoomRequestInfoByIdMutation, DeleteExamRoomRequestInfoByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExamRoomRequestInfoByIdMutation, DeleteExamRoomRequestInfoByIdMutationVariables>(DeleteExamRoomRequestInfoByIdDocument, options);
      }
export type DeleteExamRoomRequestInfoByIdMutationHookResult = ReturnType<typeof useDeleteExamRoomRequestInfoByIdMutation>;
export type DeleteExamRoomRequestInfoByIdMutationResult = Apollo.MutationResult<DeleteExamRoomRequestInfoByIdMutation>;
export type DeleteExamRoomRequestInfoByIdMutationOptions = Apollo.BaseMutationOptions<DeleteExamRoomRequestInfoByIdMutation, DeleteExamRoomRequestInfoByIdMutationVariables>;
export const DuplicateExamRoomRequestInfoDocument = gql`
    mutation DuplicateExamRoomRequestInfo($duplicateExamRoomRequestInfoInput: DuplicateExamRoomRequestInfoInputType!) {
  ecDuplicateExamRoomRequestInfo(
    duplicateExamRoomRequestInfoInput: $duplicateExamRoomRequestInfoInput
  ) {
    examRoomRequestInfo {
      id
    }
  }
}
    `;
export type DuplicateExamRoomRequestInfoMutationFn = Apollo.MutationFunction<DuplicateExamRoomRequestInfoMutation, DuplicateExamRoomRequestInfoMutationVariables>;

/**
 * __useDuplicateExamRoomRequestInfoMutation__
 *
 * To run a mutation, you first call `useDuplicateExamRoomRequestInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateExamRoomRequestInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateExamRoomRequestInfoMutation, { data, loading, error }] = useDuplicateExamRoomRequestInfoMutation({
 *   variables: {
 *      duplicateExamRoomRequestInfoInput: // value for 'duplicateExamRoomRequestInfoInput'
 *   },
 * });
 */
export function useDuplicateExamRoomRequestInfoMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateExamRoomRequestInfoMutation, DuplicateExamRoomRequestInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateExamRoomRequestInfoMutation, DuplicateExamRoomRequestInfoMutationVariables>(DuplicateExamRoomRequestInfoDocument, options);
      }
export type DuplicateExamRoomRequestInfoMutationHookResult = ReturnType<typeof useDuplicateExamRoomRequestInfoMutation>;
export type DuplicateExamRoomRequestInfoMutationResult = Apollo.MutationResult<DuplicateExamRoomRequestInfoMutation>;
export type DuplicateExamRoomRequestInfoMutationOptions = Apollo.BaseMutationOptions<DuplicateExamRoomRequestInfoMutation, DuplicateExamRoomRequestInfoMutationVariables>;
export const DeleteExamLocationRequestInfoByIdDocument = gql`
    mutation DeleteExamLocationRequestInfoById($deleteExamLocationRequestInfoByIdInput: DeleteExamLocationRequestInfoByIdInputType!) {
  ecDeleteExamLocationRequestInfoById(
    deleteExamLocationRequestInfoByIdInput: $deleteExamLocationRequestInfoByIdInput
  ) {
    status
    message
    data
  }
}
    `;
export type DeleteExamLocationRequestInfoByIdMutationFn = Apollo.MutationFunction<DeleteExamLocationRequestInfoByIdMutation, DeleteExamLocationRequestInfoByIdMutationVariables>;

/**
 * __useDeleteExamLocationRequestInfoByIdMutation__
 *
 * To run a mutation, you first call `useDeleteExamLocationRequestInfoByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExamLocationRequestInfoByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExamLocationRequestInfoByIdMutation, { data, loading, error }] = useDeleteExamLocationRequestInfoByIdMutation({
 *   variables: {
 *      deleteExamLocationRequestInfoByIdInput: // value for 'deleteExamLocationRequestInfoByIdInput'
 *   },
 * });
 */
export function useDeleteExamLocationRequestInfoByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExamLocationRequestInfoByIdMutation, DeleteExamLocationRequestInfoByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExamLocationRequestInfoByIdMutation, DeleteExamLocationRequestInfoByIdMutationVariables>(DeleteExamLocationRequestInfoByIdDocument, options);
      }
export type DeleteExamLocationRequestInfoByIdMutationHookResult = ReturnType<typeof useDeleteExamLocationRequestInfoByIdMutation>;
export type DeleteExamLocationRequestInfoByIdMutationResult = Apollo.MutationResult<DeleteExamLocationRequestInfoByIdMutation>;
export type DeleteExamLocationRequestInfoByIdMutationOptions = Apollo.BaseMutationOptions<DeleteExamLocationRequestInfoByIdMutation, DeleteExamLocationRequestInfoByIdMutationVariables>;
export const SearchExamCenterRoomsDocument = gql`
    query searchExamCenterRooms($searchExamCenterRoomsInput: SearchExamCenterRoomsInput!) {
  ecSearchExamCenterRooms(SearchExamCenterRoomsInput: $searchExamCenterRoomsInput) {
    rooms {
      approvedAt
      room {
        ...Room
      }
    }
    total
  }
}
    ${RoomFragmentDoc}`;

/**
 * __useSearchExamCenterRoomsQuery__
 *
 * To run a query within a React component, call `useSearchExamCenterRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamCenterRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamCenterRoomsQuery({
 *   variables: {
 *      searchExamCenterRoomsInput: // value for 'searchExamCenterRoomsInput'
 *   },
 * });
 */
export function useSearchExamCenterRoomsQuery(baseOptions: Apollo.QueryHookOptions<SearchExamCenterRoomsQuery, SearchExamCenterRoomsQueryVariables> & ({ variables: SearchExamCenterRoomsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamCenterRoomsQuery, SearchExamCenterRoomsQueryVariables>(SearchExamCenterRoomsDocument, options);
      }
export function useSearchExamCenterRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamCenterRoomsQuery, SearchExamCenterRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamCenterRoomsQuery, SearchExamCenterRoomsQueryVariables>(SearchExamCenterRoomsDocument, options);
        }
export function useSearchExamCenterRoomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCenterRoomsQuery, SearchExamCenterRoomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamCenterRoomsQuery, SearchExamCenterRoomsQueryVariables>(SearchExamCenterRoomsDocument, options);
        }
export type SearchExamCenterRoomsQueryHookResult = ReturnType<typeof useSearchExamCenterRoomsQuery>;
export type SearchExamCenterRoomsLazyQueryHookResult = ReturnType<typeof useSearchExamCenterRoomsLazyQuery>;
export type SearchExamCenterRoomsSuspenseQueryHookResult = ReturnType<typeof useSearchExamCenterRoomsSuspenseQuery>;
export type SearchExamCenterRoomsQueryResult = Apollo.QueryResult<SearchExamCenterRoomsQuery, SearchExamCenterRoomsQueryVariables>;
export const AdminSearchRoomsDocument = gql`
    query adminSearchRooms($searchRoomsInput: SearchRoomsInput!) {
  ecAdminSearchRooms(SearchRoomsInput: $searchRoomsInput) {
    rooms {
      ...Room
    }
    total
  }
}
    ${RoomFragmentDoc}`;

/**
 * __useAdminSearchRoomsQuery__
 *
 * To run a query within a React component, call `useAdminSearchRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSearchRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSearchRoomsQuery({
 *   variables: {
 *      searchRoomsInput: // value for 'searchRoomsInput'
 *   },
 * });
 */
export function useAdminSearchRoomsQuery(baseOptions: Apollo.QueryHookOptions<AdminSearchRoomsQuery, AdminSearchRoomsQueryVariables> & ({ variables: AdminSearchRoomsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSearchRoomsQuery, AdminSearchRoomsQueryVariables>(AdminSearchRoomsDocument, options);
      }
export function useAdminSearchRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSearchRoomsQuery, AdminSearchRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSearchRoomsQuery, AdminSearchRoomsQueryVariables>(AdminSearchRoomsDocument, options);
        }
export function useAdminSearchRoomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminSearchRoomsQuery, AdminSearchRoomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSearchRoomsQuery, AdminSearchRoomsQueryVariables>(AdminSearchRoomsDocument, options);
        }
export type AdminSearchRoomsQueryHookResult = ReturnType<typeof useAdminSearchRoomsQuery>;
export type AdminSearchRoomsLazyQueryHookResult = ReturnType<typeof useAdminSearchRoomsLazyQuery>;
export type AdminSearchRoomsSuspenseQueryHookResult = ReturnType<typeof useAdminSearchRoomsSuspenseQuery>;
export type AdminSearchRoomsQueryResult = Apollo.QueryResult<AdminSearchRoomsQuery, AdminSearchRoomsQueryVariables>;
export const GetUpcomingRoomReservationSummaryDocument = gql`
    query getUpcomingRoomReservationSummary($getUpcomingRoomReservationSummaryInput: GetUpcomingRoomReservationSummaryInput!) {
  ecGetUpcomingRoomReservationSummary(
    GetUpcomingRoomReservationSummaryInput: $getUpcomingRoomReservationSummaryInput
  ) {
    roomId
    roomReservationSummaries {
      endedAt
      examCenterCode
      reservationCount
      startedAt
    }
  }
}
    `;

/**
 * __useGetUpcomingRoomReservationSummaryQuery__
 *
 * To run a query within a React component, call `useGetUpcomingRoomReservationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingRoomReservationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingRoomReservationSummaryQuery({
 *   variables: {
 *      getUpcomingRoomReservationSummaryInput: // value for 'getUpcomingRoomReservationSummaryInput'
 *   },
 * });
 */
export function useGetUpcomingRoomReservationSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetUpcomingRoomReservationSummaryQuery, GetUpcomingRoomReservationSummaryQueryVariables> & ({ variables: GetUpcomingRoomReservationSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpcomingRoomReservationSummaryQuery, GetUpcomingRoomReservationSummaryQueryVariables>(GetUpcomingRoomReservationSummaryDocument, options);
      }
export function useGetUpcomingRoomReservationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpcomingRoomReservationSummaryQuery, GetUpcomingRoomReservationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpcomingRoomReservationSummaryQuery, GetUpcomingRoomReservationSummaryQueryVariables>(GetUpcomingRoomReservationSummaryDocument, options);
        }
export function useGetUpcomingRoomReservationSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUpcomingRoomReservationSummaryQuery, GetUpcomingRoomReservationSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUpcomingRoomReservationSummaryQuery, GetUpcomingRoomReservationSummaryQueryVariables>(GetUpcomingRoomReservationSummaryDocument, options);
        }
export type GetUpcomingRoomReservationSummaryQueryHookResult = ReturnType<typeof useGetUpcomingRoomReservationSummaryQuery>;
export type GetUpcomingRoomReservationSummaryLazyQueryHookResult = ReturnType<typeof useGetUpcomingRoomReservationSummaryLazyQuery>;
export type GetUpcomingRoomReservationSummarySuspenseQueryHookResult = ReturnType<typeof useGetUpcomingRoomReservationSummarySuspenseQuery>;
export type GetUpcomingRoomReservationSummaryQueryResult = Apollo.QueryResult<GetUpcomingRoomReservationSummaryQuery, GetUpcomingRoomReservationSummaryQueryVariables>;
export const AdminGetUpcomingRoomReservationSummaryDocument = gql`
    query adminGetUpcomingRoomReservationSummary($getUpcomingRoomReservationSummaryInput: GetUpcomingRoomReservationSummaryInput!) {
  ecAdminGetUpcomingRoomReservationSummary(
    GetUpcomingRoomReservationSummaryInput: $getUpcomingRoomReservationSummaryInput
  ) {
    roomId
    roomReservationSummaries {
      endedAt
      examCenterCode
      reservationCount
      startedAt
    }
  }
}
    `;

/**
 * __useAdminGetUpcomingRoomReservationSummaryQuery__
 *
 * To run a query within a React component, call `useAdminGetUpcomingRoomReservationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetUpcomingRoomReservationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetUpcomingRoomReservationSummaryQuery({
 *   variables: {
 *      getUpcomingRoomReservationSummaryInput: // value for 'getUpcomingRoomReservationSummaryInput'
 *   },
 * });
 */
export function useAdminGetUpcomingRoomReservationSummaryQuery(baseOptions: Apollo.QueryHookOptions<AdminGetUpcomingRoomReservationSummaryQuery, AdminGetUpcomingRoomReservationSummaryQueryVariables> & ({ variables: AdminGetUpcomingRoomReservationSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetUpcomingRoomReservationSummaryQuery, AdminGetUpcomingRoomReservationSummaryQueryVariables>(AdminGetUpcomingRoomReservationSummaryDocument, options);
      }
export function useAdminGetUpcomingRoomReservationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetUpcomingRoomReservationSummaryQuery, AdminGetUpcomingRoomReservationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetUpcomingRoomReservationSummaryQuery, AdminGetUpcomingRoomReservationSummaryQueryVariables>(AdminGetUpcomingRoomReservationSummaryDocument, options);
        }
export function useAdminGetUpcomingRoomReservationSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetUpcomingRoomReservationSummaryQuery, AdminGetUpcomingRoomReservationSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetUpcomingRoomReservationSummaryQuery, AdminGetUpcomingRoomReservationSummaryQueryVariables>(AdminGetUpcomingRoomReservationSummaryDocument, options);
        }
export type AdminGetUpcomingRoomReservationSummaryQueryHookResult = ReturnType<typeof useAdminGetUpcomingRoomReservationSummaryQuery>;
export type AdminGetUpcomingRoomReservationSummaryLazyQueryHookResult = ReturnType<typeof useAdminGetUpcomingRoomReservationSummaryLazyQuery>;
export type AdminGetUpcomingRoomReservationSummarySuspenseQueryHookResult = ReturnType<typeof useAdminGetUpcomingRoomReservationSummarySuspenseQuery>;
export type AdminGetUpcomingRoomReservationSummaryQueryResult = Apollo.QueryResult<AdminGetUpcomingRoomReservationSummaryQuery, AdminGetUpcomingRoomReservationSummaryQueryVariables>;
export const GetExamRoomByIdDocument = gql`
    query getExamRoomById($getExamRoomByIdInput: GetExamRoomByIdInput!) {
  ecGetExamRoomById(GetExamRoomByIdInput: $getExamRoomByIdInput) {
    examRoom {
      ...ExamRoomDetail
    }
  }
}
    ${ExamRoomDetailFragmentDoc}`;

/**
 * __useGetExamRoomByIdQuery__
 *
 * To run a query within a React component, call `useGetExamRoomByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamRoomByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamRoomByIdQuery({
 *   variables: {
 *      getExamRoomByIdInput: // value for 'getExamRoomByIdInput'
 *   },
 * });
 */
export function useGetExamRoomByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamRoomByIdQuery, GetExamRoomByIdQueryVariables> & ({ variables: GetExamRoomByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamRoomByIdQuery, GetExamRoomByIdQueryVariables>(GetExamRoomByIdDocument, options);
      }
export function useGetExamRoomByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamRoomByIdQuery, GetExamRoomByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamRoomByIdQuery, GetExamRoomByIdQueryVariables>(GetExamRoomByIdDocument, options);
        }
export function useGetExamRoomByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamRoomByIdQuery, GetExamRoomByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamRoomByIdQuery, GetExamRoomByIdQueryVariables>(GetExamRoomByIdDocument, options);
        }
export type GetExamRoomByIdQueryHookResult = ReturnType<typeof useGetExamRoomByIdQuery>;
export type GetExamRoomByIdLazyQueryHookResult = ReturnType<typeof useGetExamRoomByIdLazyQuery>;
export type GetExamRoomByIdSuspenseQueryHookResult = ReturnType<typeof useGetExamRoomByIdSuspenseQuery>;
export type GetExamRoomByIdQueryResult = Apollo.QueryResult<GetExamRoomByIdQuery, GetExamRoomByIdQueryVariables>;
export const AdminGetExamRoomByIdDocument = gql`
    query adminGetExamRoomById($getExamRoomByIdInput: GetExamRoomByIdInput!) {
  ecAdminGetExamRoomById(GetExamRoomByIdInput: $getExamRoomByIdInput) {
    examRoom {
      ...ExamRoomDetail
    }
  }
}
    ${ExamRoomDetailFragmentDoc}`;

/**
 * __useAdminGetExamRoomByIdQuery__
 *
 * To run a query within a React component, call `useAdminGetExamRoomByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetExamRoomByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetExamRoomByIdQuery({
 *   variables: {
 *      getExamRoomByIdInput: // value for 'getExamRoomByIdInput'
 *   },
 * });
 */
export function useAdminGetExamRoomByIdQuery(baseOptions: Apollo.QueryHookOptions<AdminGetExamRoomByIdQuery, AdminGetExamRoomByIdQueryVariables> & ({ variables: AdminGetExamRoomByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetExamRoomByIdQuery, AdminGetExamRoomByIdQueryVariables>(AdminGetExamRoomByIdDocument, options);
      }
export function useAdminGetExamRoomByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetExamRoomByIdQuery, AdminGetExamRoomByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetExamRoomByIdQuery, AdminGetExamRoomByIdQueryVariables>(AdminGetExamRoomByIdDocument, options);
        }
export function useAdminGetExamRoomByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetExamRoomByIdQuery, AdminGetExamRoomByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetExamRoomByIdQuery, AdminGetExamRoomByIdQueryVariables>(AdminGetExamRoomByIdDocument, options);
        }
export type AdminGetExamRoomByIdQueryHookResult = ReturnType<typeof useAdminGetExamRoomByIdQuery>;
export type AdminGetExamRoomByIdLazyQueryHookResult = ReturnType<typeof useAdminGetExamRoomByIdLazyQuery>;
export type AdminGetExamRoomByIdSuspenseQueryHookResult = ReturnType<typeof useAdminGetExamRoomByIdSuspenseQuery>;
export type AdminGetExamRoomByIdQueryResult = Apollo.QueryResult<AdminGetExamRoomByIdQuery, AdminGetExamRoomByIdQueryVariables>;
export const UpdateExamRoomDocument = gql`
    mutation updateExamRoom($updateExamRoomInput: UpdateExamRoomInput!) {
  ecUpdateExamRoom(UpdateExamRoomInput: $updateExamRoomInput) {
    examRoom {
      ...Room
    }
  }
}
    ${RoomFragmentDoc}`;
export type UpdateExamRoomMutationFn = Apollo.MutationFunction<UpdateExamRoomMutation, UpdateExamRoomMutationVariables>;

/**
 * __useUpdateExamRoomMutation__
 *
 * To run a mutation, you first call `useUpdateExamRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamRoomMutation, { data, loading, error }] = useUpdateExamRoomMutation({
 *   variables: {
 *      updateExamRoomInput: // value for 'updateExamRoomInput'
 *   },
 * });
 */
export function useUpdateExamRoomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExamRoomMutation, UpdateExamRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExamRoomMutation, UpdateExamRoomMutationVariables>(UpdateExamRoomDocument, options);
      }
export type UpdateExamRoomMutationHookResult = ReturnType<typeof useUpdateExamRoomMutation>;
export type UpdateExamRoomMutationResult = Apollo.MutationResult<UpdateExamRoomMutation>;
export type UpdateExamRoomMutationOptions = Apollo.BaseMutationOptions<UpdateExamRoomMutation, UpdateExamRoomMutationVariables>;
export const GetDownloadSignedUrlForExamRoomComputerInfoDocument = gql`
    query GetDownloadSignedUrlForExamRoomComputerInfo($getDownloadSignedUrlForExamRoomComputerInfoInput: GetDownloadSignedUrlForExamRoomComputerInfoInput!) {
  ecGetDownloadSignedUrlForExamRoomComputerInfo(
    GetDownloadSignedUrlForExamRoomComputerInfoInput: $getDownloadSignedUrlForExamRoomComputerInfoInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForExamRoomComputerInfoQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForExamRoomComputerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForExamRoomComputerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForExamRoomComputerInfoQuery({
 *   variables: {
 *      getDownloadSignedUrlForExamRoomComputerInfoInput: // value for 'getDownloadSignedUrlForExamRoomComputerInfoInput'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForExamRoomComputerInfoQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForExamRoomComputerInfoQuery, GetDownloadSignedUrlForExamRoomComputerInfoQueryVariables> & ({ variables: GetDownloadSignedUrlForExamRoomComputerInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForExamRoomComputerInfoQuery, GetDownloadSignedUrlForExamRoomComputerInfoQueryVariables>(GetDownloadSignedUrlForExamRoomComputerInfoDocument, options);
      }
export function useGetDownloadSignedUrlForExamRoomComputerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForExamRoomComputerInfoQuery, GetDownloadSignedUrlForExamRoomComputerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForExamRoomComputerInfoQuery, GetDownloadSignedUrlForExamRoomComputerInfoQueryVariables>(GetDownloadSignedUrlForExamRoomComputerInfoDocument, options);
        }
export function useGetDownloadSignedUrlForExamRoomComputerInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForExamRoomComputerInfoQuery, GetDownloadSignedUrlForExamRoomComputerInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForExamRoomComputerInfoQuery, GetDownloadSignedUrlForExamRoomComputerInfoQueryVariables>(GetDownloadSignedUrlForExamRoomComputerInfoDocument, options);
        }
export type GetDownloadSignedUrlForExamRoomComputerInfoQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamRoomComputerInfoQuery>;
export type GetDownloadSignedUrlForExamRoomComputerInfoLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamRoomComputerInfoLazyQuery>;
export type GetDownloadSignedUrlForExamRoomComputerInfoSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamRoomComputerInfoSuspenseQuery>;
export type GetDownloadSignedUrlForExamRoomComputerInfoQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForExamRoomComputerInfoQuery, GetDownloadSignedUrlForExamRoomComputerInfoQueryVariables>;
export const EcGetDownloadSignedUrlForExamRoomPhysicalInfoDocument = gql`
    query EcGetDownloadSignedUrlForExamRoomPhysicalInfo($getDownloadSignedUrlForExamRoomPhysicalInfoInput: GetDownloadSignedUrlForExamRoomPhysicalInfoInput!) {
  ecGetDownloadSignedUrlForExamRoomPhysicalInfo(
    GetDownloadSignedUrlForExamRoomPhysicalInfoInput: $getDownloadSignedUrlForExamRoomPhysicalInfoInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useEcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery__
 *
 * To run a query within a React component, call `useEcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery({
 *   variables: {
 *      getDownloadSignedUrlForExamRoomPhysicalInfoInput: // value for 'getDownloadSignedUrlForExamRoomPhysicalInfoInput'
 *   },
 * });
 */
export function useEcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery(baseOptions: Apollo.QueryHookOptions<EcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, EcGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables> & ({ variables: EcGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, EcGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables>(EcGetDownloadSignedUrlForExamRoomPhysicalInfoDocument, options);
      }
export function useEcGetDownloadSignedUrlForExamRoomPhysicalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, EcGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, EcGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables>(EcGetDownloadSignedUrlForExamRoomPhysicalInfoDocument, options);
        }
export function useEcGetDownloadSignedUrlForExamRoomPhysicalInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, EcGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, EcGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables>(EcGetDownloadSignedUrlForExamRoomPhysicalInfoDocument, options);
        }
export type EcGetDownloadSignedUrlForExamRoomPhysicalInfoQueryHookResult = ReturnType<typeof useEcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery>;
export type EcGetDownloadSignedUrlForExamRoomPhysicalInfoLazyQueryHookResult = ReturnType<typeof useEcGetDownloadSignedUrlForExamRoomPhysicalInfoLazyQuery>;
export type EcGetDownloadSignedUrlForExamRoomPhysicalInfoSuspenseQueryHookResult = ReturnType<typeof useEcGetDownloadSignedUrlForExamRoomPhysicalInfoSuspenseQuery>;
export type EcGetDownloadSignedUrlForExamRoomPhysicalInfoQueryResult = Apollo.QueryResult<EcGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, EcGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables>;
export const CountExamCenterRoomsByProvinceDocument = gql`
    query countExamCenterRoomsByProvince($countExamCenterRoomsByProvinceInput: CountExamCenterRoomsByProvinceInput!) {
  ecCountExamCenterRoomsByProvince(
    CountExamCenterRoomsByProvinceInput: $countExamCenterRoomsByProvinceInput
  ) {
    examCenterRoomsCountByProvince
  }
}
    `;

/**
 * __useCountExamCenterRoomsByProvinceQuery__
 *
 * To run a query within a React component, call `useCountExamCenterRoomsByProvinceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountExamCenterRoomsByProvinceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountExamCenterRoomsByProvinceQuery({
 *   variables: {
 *      countExamCenterRoomsByProvinceInput: // value for 'countExamCenterRoomsByProvinceInput'
 *   },
 * });
 */
export function useCountExamCenterRoomsByProvinceQuery(baseOptions: Apollo.QueryHookOptions<CountExamCenterRoomsByProvinceQuery, CountExamCenterRoomsByProvinceQueryVariables> & ({ variables: CountExamCenterRoomsByProvinceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountExamCenterRoomsByProvinceQuery, CountExamCenterRoomsByProvinceQueryVariables>(CountExamCenterRoomsByProvinceDocument, options);
      }
export function useCountExamCenterRoomsByProvinceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountExamCenterRoomsByProvinceQuery, CountExamCenterRoomsByProvinceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountExamCenterRoomsByProvinceQuery, CountExamCenterRoomsByProvinceQueryVariables>(CountExamCenterRoomsByProvinceDocument, options);
        }
export function useCountExamCenterRoomsByProvinceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountExamCenterRoomsByProvinceQuery, CountExamCenterRoomsByProvinceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountExamCenterRoomsByProvinceQuery, CountExamCenterRoomsByProvinceQueryVariables>(CountExamCenterRoomsByProvinceDocument, options);
        }
export type CountExamCenterRoomsByProvinceQueryHookResult = ReturnType<typeof useCountExamCenterRoomsByProvinceQuery>;
export type CountExamCenterRoomsByProvinceLazyQueryHookResult = ReturnType<typeof useCountExamCenterRoomsByProvinceLazyQuery>;
export type CountExamCenterRoomsByProvinceSuspenseQueryHookResult = ReturnType<typeof useCountExamCenterRoomsByProvinceSuspenseQuery>;
export type CountExamCenterRoomsByProvinceQueryResult = Apollo.QueryResult<CountExamCenterRoomsByProvinceQuery, CountExamCenterRoomsByProvinceQueryVariables>;
export const SearchLocationAuditLogDocument = gql`
    query SearchLocationAuditLog($searchLocationAuditLogInput: SearchLocationAuditLogInput!) {
  ecSearchLocationAuditLog(
    SearchLocationAuditLogInput: $searchLocationAuditLogInput
  ) {
    locationAuditLogs {
      id
      action
      fullName
      detail
      actionTime
    }
    total
  }
}
    `;

/**
 * __useSearchLocationAuditLogQuery__
 *
 * To run a query within a React component, call `useSearchLocationAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLocationAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLocationAuditLogQuery({
 *   variables: {
 *      searchLocationAuditLogInput: // value for 'searchLocationAuditLogInput'
 *   },
 * });
 */
export function useSearchLocationAuditLogQuery(baseOptions: Apollo.QueryHookOptions<SearchLocationAuditLogQuery, SearchLocationAuditLogQueryVariables> & ({ variables: SearchLocationAuditLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLocationAuditLogQuery, SearchLocationAuditLogQueryVariables>(SearchLocationAuditLogDocument, options);
      }
export function useSearchLocationAuditLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLocationAuditLogQuery, SearchLocationAuditLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLocationAuditLogQuery, SearchLocationAuditLogQueryVariables>(SearchLocationAuditLogDocument, options);
        }
export function useSearchLocationAuditLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchLocationAuditLogQuery, SearchLocationAuditLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchLocationAuditLogQuery, SearchLocationAuditLogQueryVariables>(SearchLocationAuditLogDocument, options);
        }
export type SearchLocationAuditLogQueryHookResult = ReturnType<typeof useSearchLocationAuditLogQuery>;
export type SearchLocationAuditLogLazyQueryHookResult = ReturnType<typeof useSearchLocationAuditLogLazyQuery>;
export type SearchLocationAuditLogSuspenseQueryHookResult = ReturnType<typeof useSearchLocationAuditLogSuspenseQuery>;
export type SearchLocationAuditLogQueryResult = Apollo.QueryResult<SearchLocationAuditLogQuery, SearchLocationAuditLogQueryVariables>;
export const SearchExamCenterLocationsUsageDocument = gql`
    query searchExamCenterLocationsUsage($searchExamCenterLocationsUsageInput: SearchExamCenterLocationsUsageInput!) {
  ecSearchExamCenterLocationsUsage(
    searchExamCenterLocationsUsageInput: $searchExamCenterLocationsUsageInput
  ) {
    total
    examCenterLocations {
      id
      examCenterCode
      approvedAt
      refId
      examRoomRequestInfo {
        step
        requestedAt
        examLocationRequestVerdicts {
          requestedAt
          submittedAt
          updatedUser {
            firstname
            lastname
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchExamCenterLocationsUsageQuery__
 *
 * To run a query within a React component, call `useSearchExamCenterLocationsUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamCenterLocationsUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamCenterLocationsUsageQuery({
 *   variables: {
 *      searchExamCenterLocationsUsageInput: // value for 'searchExamCenterLocationsUsageInput'
 *   },
 * });
 */
export function useSearchExamCenterLocationsUsageQuery(baseOptions: Apollo.QueryHookOptions<SearchExamCenterLocationsUsageQuery, SearchExamCenterLocationsUsageQueryVariables> & ({ variables: SearchExamCenterLocationsUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamCenterLocationsUsageQuery, SearchExamCenterLocationsUsageQueryVariables>(SearchExamCenterLocationsUsageDocument, options);
      }
export function useSearchExamCenterLocationsUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamCenterLocationsUsageQuery, SearchExamCenterLocationsUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamCenterLocationsUsageQuery, SearchExamCenterLocationsUsageQueryVariables>(SearchExamCenterLocationsUsageDocument, options);
        }
export function useSearchExamCenterLocationsUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCenterLocationsUsageQuery, SearchExamCenterLocationsUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamCenterLocationsUsageQuery, SearchExamCenterLocationsUsageQueryVariables>(SearchExamCenterLocationsUsageDocument, options);
        }
export type SearchExamCenterLocationsUsageQueryHookResult = ReturnType<typeof useSearchExamCenterLocationsUsageQuery>;
export type SearchExamCenterLocationsUsageLazyQueryHookResult = ReturnType<typeof useSearchExamCenterLocationsUsageLazyQuery>;
export type SearchExamCenterLocationsUsageSuspenseQueryHookResult = ReturnType<typeof useSearchExamCenterLocationsUsageSuspenseQuery>;
export type SearchExamCenterLocationsUsageQueryResult = Apollo.QueryResult<SearchExamCenterLocationsUsageQuery, SearchExamCenterLocationsUsageQueryVariables>;
export const RevokeExamCenterLocationByIdDocument = gql`
    mutation revokeExamCenterLocationById($revokeExamCenterLocationByIdInput: RevokeExamCenterLocationByIdInput!) {
  ecRevokeExamCenterLocationById(
    revokeExamCenterLocationByIdInput: $revokeExamCenterLocationByIdInput
  ) {
    code
    message
    success
  }
}
    `;
export type RevokeExamCenterLocationByIdMutationFn = Apollo.MutationFunction<RevokeExamCenterLocationByIdMutation, RevokeExamCenterLocationByIdMutationVariables>;

/**
 * __useRevokeExamCenterLocationByIdMutation__
 *
 * To run a mutation, you first call `useRevokeExamCenterLocationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeExamCenterLocationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeExamCenterLocationByIdMutation, { data, loading, error }] = useRevokeExamCenterLocationByIdMutation({
 *   variables: {
 *      revokeExamCenterLocationByIdInput: // value for 'revokeExamCenterLocationByIdInput'
 *   },
 * });
 */
export function useRevokeExamCenterLocationByIdMutation(baseOptions?: Apollo.MutationHookOptions<RevokeExamCenterLocationByIdMutation, RevokeExamCenterLocationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeExamCenterLocationByIdMutation, RevokeExamCenterLocationByIdMutationVariables>(RevokeExamCenterLocationByIdDocument, options);
      }
export type RevokeExamCenterLocationByIdMutationHookResult = ReturnType<typeof useRevokeExamCenterLocationByIdMutation>;
export type RevokeExamCenterLocationByIdMutationResult = Apollo.MutationResult<RevokeExamCenterLocationByIdMutation>;
export type RevokeExamCenterLocationByIdMutationOptions = Apollo.BaseMutationOptions<RevokeExamCenterLocationByIdMutation, RevokeExamCenterLocationByIdMutationVariables>;
export const RetireRoomByIdDocument = gql`
    mutation retireRoomById($retireRoomByIdInput: RetireRoomByIdInput!) {
  ecRetireRoomById(RetireRoomByIdInput: $retireRoomByIdInput) {
    room {
      retiredRemark
      id
      status
    }
  }
}
    `;
export type RetireRoomByIdMutationFn = Apollo.MutationFunction<RetireRoomByIdMutation, RetireRoomByIdMutationVariables>;

/**
 * __useRetireRoomByIdMutation__
 *
 * To run a mutation, you first call `useRetireRoomByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetireRoomByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retireRoomByIdMutation, { data, loading, error }] = useRetireRoomByIdMutation({
 *   variables: {
 *      retireRoomByIdInput: // value for 'retireRoomByIdInput'
 *   },
 * });
 */
export function useRetireRoomByIdMutation(baseOptions?: Apollo.MutationHookOptions<RetireRoomByIdMutation, RetireRoomByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetireRoomByIdMutation, RetireRoomByIdMutationVariables>(RetireRoomByIdDocument, options);
      }
export type RetireRoomByIdMutationHookResult = ReturnType<typeof useRetireRoomByIdMutation>;
export type RetireRoomByIdMutationResult = Apollo.MutationResult<RetireRoomByIdMutation>;
export type RetireRoomByIdMutationOptions = Apollo.BaseMutationOptions<RetireRoomByIdMutation, RetireRoomByIdMutationVariables>;
export const AdminGetDownloadSignedUrlForExamRoomComputerInfoDocument = gql`
    query AdminGetDownloadSignedUrlForExamRoomComputerInfo($getDownloadSignedUrlForExamRoomComputerInfoInput: GetDownloadSignedUrlForExamRoomComputerInfoInput!) {
  ecAdminGetDownloadSignedUrlForExamRoomComputerInfo(
    GetDownloadSignedUrlForExamRoomComputerInfoInput: $getDownloadSignedUrlForExamRoomComputerInfoInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useAdminGetDownloadSignedUrlForExamRoomComputerInfoQuery__
 *
 * To run a query within a React component, call `useAdminGetDownloadSignedUrlForExamRoomComputerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetDownloadSignedUrlForExamRoomComputerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetDownloadSignedUrlForExamRoomComputerInfoQuery({
 *   variables: {
 *      getDownloadSignedUrlForExamRoomComputerInfoInput: // value for 'getDownloadSignedUrlForExamRoomComputerInfoInput'
 *   },
 * });
 */
export function useAdminGetDownloadSignedUrlForExamRoomComputerInfoQuery(baseOptions: Apollo.QueryHookOptions<AdminGetDownloadSignedUrlForExamRoomComputerInfoQuery, AdminGetDownloadSignedUrlForExamRoomComputerInfoQueryVariables> & ({ variables: AdminGetDownloadSignedUrlForExamRoomComputerInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetDownloadSignedUrlForExamRoomComputerInfoQuery, AdminGetDownloadSignedUrlForExamRoomComputerInfoQueryVariables>(AdminGetDownloadSignedUrlForExamRoomComputerInfoDocument, options);
      }
export function useAdminGetDownloadSignedUrlForExamRoomComputerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetDownloadSignedUrlForExamRoomComputerInfoQuery, AdminGetDownloadSignedUrlForExamRoomComputerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetDownloadSignedUrlForExamRoomComputerInfoQuery, AdminGetDownloadSignedUrlForExamRoomComputerInfoQueryVariables>(AdminGetDownloadSignedUrlForExamRoomComputerInfoDocument, options);
        }
export function useAdminGetDownloadSignedUrlForExamRoomComputerInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetDownloadSignedUrlForExamRoomComputerInfoQuery, AdminGetDownloadSignedUrlForExamRoomComputerInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetDownloadSignedUrlForExamRoomComputerInfoQuery, AdminGetDownloadSignedUrlForExamRoomComputerInfoQueryVariables>(AdminGetDownloadSignedUrlForExamRoomComputerInfoDocument, options);
        }
export type AdminGetDownloadSignedUrlForExamRoomComputerInfoQueryHookResult = ReturnType<typeof useAdminGetDownloadSignedUrlForExamRoomComputerInfoQuery>;
export type AdminGetDownloadSignedUrlForExamRoomComputerInfoLazyQueryHookResult = ReturnType<typeof useAdminGetDownloadSignedUrlForExamRoomComputerInfoLazyQuery>;
export type AdminGetDownloadSignedUrlForExamRoomComputerInfoSuspenseQueryHookResult = ReturnType<typeof useAdminGetDownloadSignedUrlForExamRoomComputerInfoSuspenseQuery>;
export type AdminGetDownloadSignedUrlForExamRoomComputerInfoQueryResult = Apollo.QueryResult<AdminGetDownloadSignedUrlForExamRoomComputerInfoQuery, AdminGetDownloadSignedUrlForExamRoomComputerInfoQueryVariables>;
export const AdminGetDownloadSignedUrlForExamRoomPhysicalInfoDocument = gql`
    query AdminGetDownloadSignedUrlForExamRoomPhysicalInfo($getDownloadSignedUrlForExamRoomPhysicalInfoInput: GetDownloadSignedUrlForExamRoomPhysicalInfoInput!) {
  ecAdminGetDownloadSignedUrlForExamRoomPhysicalInfo(
    GetDownloadSignedUrlForExamRoomPhysicalInfoInput: $getDownloadSignedUrlForExamRoomPhysicalInfoInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useAdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery__
 *
 * To run a query within a React component, call `useAdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery({
 *   variables: {
 *      getDownloadSignedUrlForExamRoomPhysicalInfoInput: // value for 'getDownloadSignedUrlForExamRoomPhysicalInfoInput'
 *   },
 * });
 */
export function useAdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery(baseOptions: Apollo.QueryHookOptions<AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables> & ({ variables: AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables>(AdminGetDownloadSignedUrlForExamRoomPhysicalInfoDocument, options);
      }
export function useAdminGetDownloadSignedUrlForExamRoomPhysicalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables>(AdminGetDownloadSignedUrlForExamRoomPhysicalInfoDocument, options);
        }
export function useAdminGetDownloadSignedUrlForExamRoomPhysicalInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables>(AdminGetDownloadSignedUrlForExamRoomPhysicalInfoDocument, options);
        }
export type AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQueryHookResult = ReturnType<typeof useAdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery>;
export type AdminGetDownloadSignedUrlForExamRoomPhysicalInfoLazyQueryHookResult = ReturnType<typeof useAdminGetDownloadSignedUrlForExamRoomPhysicalInfoLazyQuery>;
export type AdminGetDownloadSignedUrlForExamRoomPhysicalInfoSuspenseQueryHookResult = ReturnType<typeof useAdminGetDownloadSignedUrlForExamRoomPhysicalInfoSuspenseQuery>;
export type AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQueryResult = Apollo.QueryResult<AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQuery, AdminGetDownloadSignedUrlForExamRoomPhysicalInfoQueryVariables>;
export const GetExamCenterMembersByExamCenterCodeDocument = gql`
    query getExamCenterMembersByExamCenterCode($getExamCenterMembersByExamCenterCodeInput: GetExamCenterMembersByExamCenterCodeInput!) {
  ecGetExamCenterMembersByExamCenterCode(
    getExamCenterMembersByExamCenterCodeInput: $getExamCenterMembersByExamCenterCodeInput
  ) {
    examCenterMembers {
      id
      user {
        id
        firstname
        lastname
        email
        lastLoginAt
        status
        invitationExpireAt
        appRoles
      }
    }
  }
}
    `;

/**
 * __useGetExamCenterMembersByExamCenterCodeQuery__
 *
 * To run a query within a React component, call `useGetExamCenterMembersByExamCenterCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCenterMembersByExamCenterCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCenterMembersByExamCenterCodeQuery({
 *   variables: {
 *      getExamCenterMembersByExamCenterCodeInput: // value for 'getExamCenterMembersByExamCenterCodeInput'
 *   },
 * });
 */
export function useGetExamCenterMembersByExamCenterCodeQuery(baseOptions: Apollo.QueryHookOptions<GetExamCenterMembersByExamCenterCodeQuery, GetExamCenterMembersByExamCenterCodeQueryVariables> & ({ variables: GetExamCenterMembersByExamCenterCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCenterMembersByExamCenterCodeQuery, GetExamCenterMembersByExamCenterCodeQueryVariables>(GetExamCenterMembersByExamCenterCodeDocument, options);
      }
export function useGetExamCenterMembersByExamCenterCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCenterMembersByExamCenterCodeQuery, GetExamCenterMembersByExamCenterCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCenterMembersByExamCenterCodeQuery, GetExamCenterMembersByExamCenterCodeQueryVariables>(GetExamCenterMembersByExamCenterCodeDocument, options);
        }
export function useGetExamCenterMembersByExamCenterCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCenterMembersByExamCenterCodeQuery, GetExamCenterMembersByExamCenterCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCenterMembersByExamCenterCodeQuery, GetExamCenterMembersByExamCenterCodeQueryVariables>(GetExamCenterMembersByExamCenterCodeDocument, options);
        }
export type GetExamCenterMembersByExamCenterCodeQueryHookResult = ReturnType<typeof useGetExamCenterMembersByExamCenterCodeQuery>;
export type GetExamCenterMembersByExamCenterCodeLazyQueryHookResult = ReturnType<typeof useGetExamCenterMembersByExamCenterCodeLazyQuery>;
export type GetExamCenterMembersByExamCenterCodeSuspenseQueryHookResult = ReturnType<typeof useGetExamCenterMembersByExamCenterCodeSuspenseQuery>;
export type GetExamCenterMembersByExamCenterCodeQueryResult = Apollo.QueryResult<GetExamCenterMembersByExamCenterCodeQuery, GetExamCenterMembersByExamCenterCodeQueryVariables>;
export const AdminGetExamCenterMembersByExamCenterCodeDocument = gql`
    query adminGetExamCenterMembersByExamCenterCode($getExamCenterMembersByExamCenterCodeInput: GetExamCenterMembersByExamCenterCodeInput!) {
  ecAdminGetExamCenterMembersByExamCenterCode(
    getExamCenterMembersByExamCenterCodeInput: $getExamCenterMembersByExamCenterCodeInput
  ) {
    examCenterMembers {
      id
      user {
        id
        firstname
        lastname
        email
        lastLoginAt
        status
        invitationExpireAt
        appRoles
      }
    }
  }
}
    `;

/**
 * __useAdminGetExamCenterMembersByExamCenterCodeQuery__
 *
 * To run a query within a React component, call `useAdminGetExamCenterMembersByExamCenterCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetExamCenterMembersByExamCenterCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetExamCenterMembersByExamCenterCodeQuery({
 *   variables: {
 *      getExamCenterMembersByExamCenterCodeInput: // value for 'getExamCenterMembersByExamCenterCodeInput'
 *   },
 * });
 */
export function useAdminGetExamCenterMembersByExamCenterCodeQuery(baseOptions: Apollo.QueryHookOptions<AdminGetExamCenterMembersByExamCenterCodeQuery, AdminGetExamCenterMembersByExamCenterCodeQueryVariables> & ({ variables: AdminGetExamCenterMembersByExamCenterCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetExamCenterMembersByExamCenterCodeQuery, AdminGetExamCenterMembersByExamCenterCodeQueryVariables>(AdminGetExamCenterMembersByExamCenterCodeDocument, options);
      }
export function useAdminGetExamCenterMembersByExamCenterCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetExamCenterMembersByExamCenterCodeQuery, AdminGetExamCenterMembersByExamCenterCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetExamCenterMembersByExamCenterCodeQuery, AdminGetExamCenterMembersByExamCenterCodeQueryVariables>(AdminGetExamCenterMembersByExamCenterCodeDocument, options);
        }
export function useAdminGetExamCenterMembersByExamCenterCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetExamCenterMembersByExamCenterCodeQuery, AdminGetExamCenterMembersByExamCenterCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetExamCenterMembersByExamCenterCodeQuery, AdminGetExamCenterMembersByExamCenterCodeQueryVariables>(AdminGetExamCenterMembersByExamCenterCodeDocument, options);
        }
export type AdminGetExamCenterMembersByExamCenterCodeQueryHookResult = ReturnType<typeof useAdminGetExamCenterMembersByExamCenterCodeQuery>;
export type AdminGetExamCenterMembersByExamCenterCodeLazyQueryHookResult = ReturnType<typeof useAdminGetExamCenterMembersByExamCenterCodeLazyQuery>;
export type AdminGetExamCenterMembersByExamCenterCodeSuspenseQueryHookResult = ReturnType<typeof useAdminGetExamCenterMembersByExamCenterCodeSuspenseQuery>;
export type AdminGetExamCenterMembersByExamCenterCodeQueryResult = Apollo.QueryResult<AdminGetExamCenterMembersByExamCenterCodeQuery, AdminGetExamCenterMembersByExamCenterCodeQueryVariables>;
export const SearchAvailableExamCenterManagerUsersDocument = gql`
    query searchAvailableExamCenterManagerUsers($searchAvailableExamCenterManagerUsersInput: SearchAvailableExamCenterManagerUsersInput!) {
  ecSearchAvailableExamCenterManagerUsers(
    searchAvailableExamCenterManagerUsersInput: $searchAvailableExamCenterManagerUsersInput
  ) {
    users {
      id
      firstname
      lastname
      email
      appRoles
      status
      invitationExpireAt
    }
    total
  }
}
    `;

/**
 * __useSearchAvailableExamCenterManagerUsersQuery__
 *
 * To run a query within a React component, call `useSearchAvailableExamCenterManagerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAvailableExamCenterManagerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAvailableExamCenterManagerUsersQuery({
 *   variables: {
 *      searchAvailableExamCenterManagerUsersInput: // value for 'searchAvailableExamCenterManagerUsersInput'
 *   },
 * });
 */
export function useSearchAvailableExamCenterManagerUsersQuery(baseOptions: Apollo.QueryHookOptions<SearchAvailableExamCenterManagerUsersQuery, SearchAvailableExamCenterManagerUsersQueryVariables> & ({ variables: SearchAvailableExamCenterManagerUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAvailableExamCenterManagerUsersQuery, SearchAvailableExamCenterManagerUsersQueryVariables>(SearchAvailableExamCenterManagerUsersDocument, options);
      }
export function useSearchAvailableExamCenterManagerUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAvailableExamCenterManagerUsersQuery, SearchAvailableExamCenterManagerUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAvailableExamCenterManagerUsersQuery, SearchAvailableExamCenterManagerUsersQueryVariables>(SearchAvailableExamCenterManagerUsersDocument, options);
        }
export function useSearchAvailableExamCenterManagerUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAvailableExamCenterManagerUsersQuery, SearchAvailableExamCenterManagerUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAvailableExamCenterManagerUsersQuery, SearchAvailableExamCenterManagerUsersQueryVariables>(SearchAvailableExamCenterManagerUsersDocument, options);
        }
export type SearchAvailableExamCenterManagerUsersQueryHookResult = ReturnType<typeof useSearchAvailableExamCenterManagerUsersQuery>;
export type SearchAvailableExamCenterManagerUsersLazyQueryHookResult = ReturnType<typeof useSearchAvailableExamCenterManagerUsersLazyQuery>;
export type SearchAvailableExamCenterManagerUsersSuspenseQueryHookResult = ReturnType<typeof useSearchAvailableExamCenterManagerUsersSuspenseQuery>;
export type SearchAvailableExamCenterManagerUsersQueryResult = Apollo.QueryResult<SearchAvailableExamCenterManagerUsersQuery, SearchAvailableExamCenterManagerUsersQueryVariables>;
export const GetExamCenterMemberByIdDocument = gql`
    query getExamCenterMemberById($getExamCenterMemberByIdInput: GetExamCenterMemberByIdInput!) {
  ecGetExamCenterMemberById(
    getExamCenterMemberByIdInput: $getExamCenterMemberByIdInput
  ) {
    examCenterMember {
      user {
        id
        firstname
        lastname
        email
        lastLoginAt
        appRoles
        status
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetExamCenterMemberByIdQuery__
 *
 * To run a query within a React component, call `useGetExamCenterMemberByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCenterMemberByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCenterMemberByIdQuery({
 *   variables: {
 *      getExamCenterMemberByIdInput: // value for 'getExamCenterMemberByIdInput'
 *   },
 * });
 */
export function useGetExamCenterMemberByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamCenterMemberByIdQuery, GetExamCenterMemberByIdQueryVariables> & ({ variables: GetExamCenterMemberByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCenterMemberByIdQuery, GetExamCenterMemberByIdQueryVariables>(GetExamCenterMemberByIdDocument, options);
      }
export function useGetExamCenterMemberByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCenterMemberByIdQuery, GetExamCenterMemberByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCenterMemberByIdQuery, GetExamCenterMemberByIdQueryVariables>(GetExamCenterMemberByIdDocument, options);
        }
export function useGetExamCenterMemberByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCenterMemberByIdQuery, GetExamCenterMemberByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCenterMemberByIdQuery, GetExamCenterMemberByIdQueryVariables>(GetExamCenterMemberByIdDocument, options);
        }
export type GetExamCenterMemberByIdQueryHookResult = ReturnType<typeof useGetExamCenterMemberByIdQuery>;
export type GetExamCenterMemberByIdLazyQueryHookResult = ReturnType<typeof useGetExamCenterMemberByIdLazyQuery>;
export type GetExamCenterMemberByIdSuspenseQueryHookResult = ReturnType<typeof useGetExamCenterMemberByIdSuspenseQuery>;
export type GetExamCenterMemberByIdQueryResult = Apollo.QueryResult<GetExamCenterMemberByIdQuery, GetExamCenterMemberByIdQueryVariables>;
export const AdminGetExamCenterMemberByIdDocument = gql`
    query adminGetExamCenterMemberById($getExamCenterMemberByIdInput: GetExamCenterMemberByIdInput!) {
  ecAdminGetExamCenterMemberById(
    getExamCenterMemberByIdInput: $getExamCenterMemberByIdInput
  ) {
    examCenterMember {
      user {
        id
        firstname
        lastname
        email
        lastLoginAt
        appRoles
        status
        createdAt
      }
    }
  }
}
    `;

/**
 * __useAdminGetExamCenterMemberByIdQuery__
 *
 * To run a query within a React component, call `useAdminGetExamCenterMemberByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetExamCenterMemberByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetExamCenterMemberByIdQuery({
 *   variables: {
 *      getExamCenterMemberByIdInput: // value for 'getExamCenterMemberByIdInput'
 *   },
 * });
 */
export function useAdminGetExamCenterMemberByIdQuery(baseOptions: Apollo.QueryHookOptions<AdminGetExamCenterMemberByIdQuery, AdminGetExamCenterMemberByIdQueryVariables> & ({ variables: AdminGetExamCenterMemberByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetExamCenterMemberByIdQuery, AdminGetExamCenterMemberByIdQueryVariables>(AdminGetExamCenterMemberByIdDocument, options);
      }
export function useAdminGetExamCenterMemberByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetExamCenterMemberByIdQuery, AdminGetExamCenterMemberByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetExamCenterMemberByIdQuery, AdminGetExamCenterMemberByIdQueryVariables>(AdminGetExamCenterMemberByIdDocument, options);
        }
export function useAdminGetExamCenterMemberByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetExamCenterMemberByIdQuery, AdminGetExamCenterMemberByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetExamCenterMemberByIdQuery, AdminGetExamCenterMemberByIdQueryVariables>(AdminGetExamCenterMemberByIdDocument, options);
        }
export type AdminGetExamCenterMemberByIdQueryHookResult = ReturnType<typeof useAdminGetExamCenterMemberByIdQuery>;
export type AdminGetExamCenterMemberByIdLazyQueryHookResult = ReturnType<typeof useAdminGetExamCenterMemberByIdLazyQuery>;
export type AdminGetExamCenterMemberByIdSuspenseQueryHookResult = ReturnType<typeof useAdminGetExamCenterMemberByIdSuspenseQuery>;
export type AdminGetExamCenterMemberByIdQueryResult = Apollo.QueryResult<AdminGetExamCenterMemberByIdQuery, AdminGetExamCenterMemberByIdQueryVariables>;
export const AddMembersToExamCenterDocument = gql`
    mutation addMembersToExamCenter($addMembersToExamCenterInput: AddMembersToExamCenterInput!) {
  ecAddMembersToExamCenter(
    addMembersToExamCenterInput: $addMembersToExamCenterInput
  ) {
    examCenterMembers {
      id
    }
  }
}
    `;
export type AddMembersToExamCenterMutationFn = Apollo.MutationFunction<AddMembersToExamCenterMutation, AddMembersToExamCenterMutationVariables>;

/**
 * __useAddMembersToExamCenterMutation__
 *
 * To run a mutation, you first call `useAddMembersToExamCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMembersToExamCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMembersToExamCenterMutation, { data, loading, error }] = useAddMembersToExamCenterMutation({
 *   variables: {
 *      addMembersToExamCenterInput: // value for 'addMembersToExamCenterInput'
 *   },
 * });
 */
export function useAddMembersToExamCenterMutation(baseOptions?: Apollo.MutationHookOptions<AddMembersToExamCenterMutation, AddMembersToExamCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMembersToExamCenterMutation, AddMembersToExamCenterMutationVariables>(AddMembersToExamCenterDocument, options);
      }
export type AddMembersToExamCenterMutationHookResult = ReturnType<typeof useAddMembersToExamCenterMutation>;
export type AddMembersToExamCenterMutationResult = Apollo.MutationResult<AddMembersToExamCenterMutation>;
export type AddMembersToExamCenterMutationOptions = Apollo.BaseMutationOptions<AddMembersToExamCenterMutation, AddMembersToExamCenterMutationVariables>;
export const DeleteManagerFromExamCenterDocument = gql`
    mutation deleteManagerFromExamCenter($deleteManagerFromExamCenterInput: DeleteManagerFromExamCenterInput!) {
  ecDeleteManagerFromExamCenter(
    deleteManagerFromExamCenterInput: $deleteManagerFromExamCenterInput
  ) {
    status
    message
    data
  }
}
    `;
export type DeleteManagerFromExamCenterMutationFn = Apollo.MutationFunction<DeleteManagerFromExamCenterMutation, DeleteManagerFromExamCenterMutationVariables>;

/**
 * __useDeleteManagerFromExamCenterMutation__
 *
 * To run a mutation, you first call `useDeleteManagerFromExamCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManagerFromExamCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManagerFromExamCenterMutation, { data, loading, error }] = useDeleteManagerFromExamCenterMutation({
 *   variables: {
 *      deleteManagerFromExamCenterInput: // value for 'deleteManagerFromExamCenterInput'
 *   },
 * });
 */
export function useDeleteManagerFromExamCenterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManagerFromExamCenterMutation, DeleteManagerFromExamCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManagerFromExamCenterMutation, DeleteManagerFromExamCenterMutationVariables>(DeleteManagerFromExamCenterDocument, options);
      }
export type DeleteManagerFromExamCenterMutationHookResult = ReturnType<typeof useDeleteManagerFromExamCenterMutation>;
export type DeleteManagerFromExamCenterMutationResult = Apollo.MutationResult<DeleteManagerFromExamCenterMutation>;
export type DeleteManagerFromExamCenterMutationOptions = Apollo.BaseMutationOptions<DeleteManagerFromExamCenterMutation, DeleteManagerFromExamCenterMutationVariables>;
export const GetMyNotificationsDocument = gql`
    query getMyNotifications($getMyNotificationsInput: GetMyNotificationsInput) {
  ecGetMyNotifications(GetMyNotificationsInput: $getMyNotificationsInput) {
    notificationRecipients {
      id
      createdAt
      notification {
        id
        title
        message
        type
        ref
        actionUrl
      }
    }
    total
  }
}
    `;

/**
 * __useGetMyNotificationsQuery__
 *
 * To run a query within a React component, call `useGetMyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotificationsQuery({
 *   variables: {
 *      getMyNotificationsInput: // value for 'getMyNotificationsInput'
 *   },
 * });
 */
export function useGetMyNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
      }
export function useGetMyNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
        }
export function useGetMyNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
        }
export type GetMyNotificationsQueryHookResult = ReturnType<typeof useGetMyNotificationsQuery>;
export type GetMyNotificationsLazyQueryHookResult = ReturnType<typeof useGetMyNotificationsLazyQuery>;
export type GetMyNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetMyNotificationsSuspenseQuery>;
export type GetMyNotificationsQueryResult = Apollo.QueryResult<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>;
export const GetExamCenterProctorRequestByIdDocument = gql`
    query getExamCenterProctorRequestById($getExamCenterProctorRequestByIdInput: GetExamCenterProctorRequestByIdInputType!) {
  ecGetExamCenterProctorRequestById(
    getExamCenterProctorRequestByIdInput: $getExamCenterProctorRequestByIdInput
  ) {
    examCenterProctorRequest {
      ...ExamCenterProctorRequest
    }
  }
}
    ${ExamCenterProctorRequestFragmentDoc}`;

/**
 * __useGetExamCenterProctorRequestByIdQuery__
 *
 * To run a query within a React component, call `useGetExamCenterProctorRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCenterProctorRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCenterProctorRequestByIdQuery({
 *   variables: {
 *      getExamCenterProctorRequestByIdInput: // value for 'getExamCenterProctorRequestByIdInput'
 *   },
 * });
 */
export function useGetExamCenterProctorRequestByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamCenterProctorRequestByIdQuery, GetExamCenterProctorRequestByIdQueryVariables> & ({ variables: GetExamCenterProctorRequestByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCenterProctorRequestByIdQuery, GetExamCenterProctorRequestByIdQueryVariables>(GetExamCenterProctorRequestByIdDocument, options);
      }
export function useGetExamCenterProctorRequestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCenterProctorRequestByIdQuery, GetExamCenterProctorRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCenterProctorRequestByIdQuery, GetExamCenterProctorRequestByIdQueryVariables>(GetExamCenterProctorRequestByIdDocument, options);
        }
export function useGetExamCenterProctorRequestByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCenterProctorRequestByIdQuery, GetExamCenterProctorRequestByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCenterProctorRequestByIdQuery, GetExamCenterProctorRequestByIdQueryVariables>(GetExamCenterProctorRequestByIdDocument, options);
        }
export type GetExamCenterProctorRequestByIdQueryHookResult = ReturnType<typeof useGetExamCenterProctorRequestByIdQuery>;
export type GetExamCenterProctorRequestByIdLazyQueryHookResult = ReturnType<typeof useGetExamCenterProctorRequestByIdLazyQuery>;
export type GetExamCenterProctorRequestByIdSuspenseQueryHookResult = ReturnType<typeof useGetExamCenterProctorRequestByIdSuspenseQuery>;
export type GetExamCenterProctorRequestByIdQueryResult = Apollo.QueryResult<GetExamCenterProctorRequestByIdQuery, GetExamCenterProctorRequestByIdQueryVariables>;
export const AdminGetExamCenterProctorRequestByIdDocument = gql`
    query adminGetExamCenterProctorRequestById($adminGetExamCenterProctorRequestByIdInput: AdminGetExamCenterProctorRequestByIdInputType!) {
  ecAdminGetExamCenterProctorRequestById(
    adminGetExamCenterProctorRequestByIdInput: $adminGetExamCenterProctorRequestByIdInput
  ) {
    examCenterProctorRequest {
      ...ExamCenterProctorRequest
    }
  }
}
    ${ExamCenterProctorRequestFragmentDoc}`;

/**
 * __useAdminGetExamCenterProctorRequestByIdQuery__
 *
 * To run a query within a React component, call `useAdminGetExamCenterProctorRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetExamCenterProctorRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetExamCenterProctorRequestByIdQuery({
 *   variables: {
 *      adminGetExamCenterProctorRequestByIdInput: // value for 'adminGetExamCenterProctorRequestByIdInput'
 *   },
 * });
 */
export function useAdminGetExamCenterProctorRequestByIdQuery(baseOptions: Apollo.QueryHookOptions<AdminGetExamCenterProctorRequestByIdQuery, AdminGetExamCenterProctorRequestByIdQueryVariables> & ({ variables: AdminGetExamCenterProctorRequestByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetExamCenterProctorRequestByIdQuery, AdminGetExamCenterProctorRequestByIdQueryVariables>(AdminGetExamCenterProctorRequestByIdDocument, options);
      }
export function useAdminGetExamCenterProctorRequestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetExamCenterProctorRequestByIdQuery, AdminGetExamCenterProctorRequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetExamCenterProctorRequestByIdQuery, AdminGetExamCenterProctorRequestByIdQueryVariables>(AdminGetExamCenterProctorRequestByIdDocument, options);
        }
export function useAdminGetExamCenterProctorRequestByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetExamCenterProctorRequestByIdQuery, AdminGetExamCenterProctorRequestByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetExamCenterProctorRequestByIdQuery, AdminGetExamCenterProctorRequestByIdQueryVariables>(AdminGetExamCenterProctorRequestByIdDocument, options);
        }
export type AdminGetExamCenterProctorRequestByIdQueryHookResult = ReturnType<typeof useAdminGetExamCenterProctorRequestByIdQuery>;
export type AdminGetExamCenterProctorRequestByIdLazyQueryHookResult = ReturnType<typeof useAdminGetExamCenterProctorRequestByIdLazyQuery>;
export type AdminGetExamCenterProctorRequestByIdSuspenseQueryHookResult = ReturnType<typeof useAdminGetExamCenterProctorRequestByIdSuspenseQuery>;
export type AdminGetExamCenterProctorRequestByIdQueryResult = Apollo.QueryResult<AdminGetExamCenterProctorRequestByIdQuery, AdminGetExamCenterProctorRequestByIdQueryVariables>;
export const GetExamCenterProctorRequestsCountDocument = gql`
    query getExamCenterProctorRequestsCount($getExamCenterProctorRequestsCountInput: GetExamCenterProctorRequestsCountByExamCenterCodeInput!) {
  ecGetExamCenterProctorRequestsCountByExamCenterCode(
    getExamCenterProctorRequestsCountByExamCenterCodeInput: $getExamCenterProctorRequestsCountInput
  ) {
    proctorRequestCountByStatus {
      DRAFT
      IN_REVIEW
      APPROVED
      REJECTED
    }
  }
}
    `;

/**
 * __useGetExamCenterProctorRequestsCountQuery__
 *
 * To run a query within a React component, call `useGetExamCenterProctorRequestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCenterProctorRequestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCenterProctorRequestsCountQuery({
 *   variables: {
 *      getExamCenterProctorRequestsCountInput: // value for 'getExamCenterProctorRequestsCountInput'
 *   },
 * });
 */
export function useGetExamCenterProctorRequestsCountQuery(baseOptions: Apollo.QueryHookOptions<GetExamCenterProctorRequestsCountQuery, GetExamCenterProctorRequestsCountQueryVariables> & ({ variables: GetExamCenterProctorRequestsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCenterProctorRequestsCountQuery, GetExamCenterProctorRequestsCountQueryVariables>(GetExamCenterProctorRequestsCountDocument, options);
      }
export function useGetExamCenterProctorRequestsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCenterProctorRequestsCountQuery, GetExamCenterProctorRequestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCenterProctorRequestsCountQuery, GetExamCenterProctorRequestsCountQueryVariables>(GetExamCenterProctorRequestsCountDocument, options);
        }
export function useGetExamCenterProctorRequestsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCenterProctorRequestsCountQuery, GetExamCenterProctorRequestsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCenterProctorRequestsCountQuery, GetExamCenterProctorRequestsCountQueryVariables>(GetExamCenterProctorRequestsCountDocument, options);
        }
export type GetExamCenterProctorRequestsCountQueryHookResult = ReturnType<typeof useGetExamCenterProctorRequestsCountQuery>;
export type GetExamCenterProctorRequestsCountLazyQueryHookResult = ReturnType<typeof useGetExamCenterProctorRequestsCountLazyQuery>;
export type GetExamCenterProctorRequestsCountSuspenseQueryHookResult = ReturnType<typeof useGetExamCenterProctorRequestsCountSuspenseQuery>;
export type GetExamCenterProctorRequestsCountQueryResult = Apollo.QueryResult<GetExamCenterProctorRequestsCountQuery, GetExamCenterProctorRequestsCountQueryVariables>;
export const AdminGetExamCenterProctorRequestsCountDocument = gql`
    query adminGetExamCenterProctorRequestsCount($getExamCenterProctorRequestsCountInput: GetExamCenterProctorRequestsCountByExamCenterCodeInput!) {
  ecAdminGetExamCenterProctorRequestsCountByExamCenterCode(
    getExamCenterProctorRequestsCountByExamCenterCodeInput: $getExamCenterProctorRequestsCountInput
  ) {
    proctorRequestCountByStatus {
      DRAFT
      IN_REVIEW
      APPROVED
      REJECTED
    }
  }
}
    `;

/**
 * __useAdminGetExamCenterProctorRequestsCountQuery__
 *
 * To run a query within a React component, call `useAdminGetExamCenterProctorRequestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetExamCenterProctorRequestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetExamCenterProctorRequestsCountQuery({
 *   variables: {
 *      getExamCenterProctorRequestsCountInput: // value for 'getExamCenterProctorRequestsCountInput'
 *   },
 * });
 */
export function useAdminGetExamCenterProctorRequestsCountQuery(baseOptions: Apollo.QueryHookOptions<AdminGetExamCenterProctorRequestsCountQuery, AdminGetExamCenterProctorRequestsCountQueryVariables> & ({ variables: AdminGetExamCenterProctorRequestsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetExamCenterProctorRequestsCountQuery, AdminGetExamCenterProctorRequestsCountQueryVariables>(AdminGetExamCenterProctorRequestsCountDocument, options);
      }
export function useAdminGetExamCenterProctorRequestsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetExamCenterProctorRequestsCountQuery, AdminGetExamCenterProctorRequestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetExamCenterProctorRequestsCountQuery, AdminGetExamCenterProctorRequestsCountQueryVariables>(AdminGetExamCenterProctorRequestsCountDocument, options);
        }
export function useAdminGetExamCenterProctorRequestsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetExamCenterProctorRequestsCountQuery, AdminGetExamCenterProctorRequestsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetExamCenterProctorRequestsCountQuery, AdminGetExamCenterProctorRequestsCountQueryVariables>(AdminGetExamCenterProctorRequestsCountDocument, options);
        }
export type AdminGetExamCenterProctorRequestsCountQueryHookResult = ReturnType<typeof useAdminGetExamCenterProctorRequestsCountQuery>;
export type AdminGetExamCenterProctorRequestsCountLazyQueryHookResult = ReturnType<typeof useAdminGetExamCenterProctorRequestsCountLazyQuery>;
export type AdminGetExamCenterProctorRequestsCountSuspenseQueryHookResult = ReturnType<typeof useAdminGetExamCenterProctorRequestsCountSuspenseQuery>;
export type AdminGetExamCenterProctorRequestsCountQueryResult = Apollo.QueryResult<AdminGetExamCenterProctorRequestsCountQuery, AdminGetExamCenterProctorRequestsCountQueryVariables>;
export const CreateOrUpdateExamCenterProctorRequestVerdictDocument = gql`
    mutation createOrUpdateExamCenterProctorRequestVerdict($createOrUpdateExamCenterProctorRequestVerdictInput: CreateOrUpdateExamCenterProctorRequestVerdictInputType!) {
  ecCreateOrUpdateExamCenterProctorRequestVerdict(
    createOrUpdateExamCenterProctorRequestVerdictInput: $createOrUpdateExamCenterProctorRequestVerdictInput
  ) {
    examCenterProctorRequestVerdict {
      ...ExamCenterProctorRequestVerdict
    }
  }
}
    ${ExamCenterProctorRequestVerdictFragmentDoc}`;
export type CreateOrUpdateExamCenterProctorRequestVerdictMutationFn = Apollo.MutationFunction<CreateOrUpdateExamCenterProctorRequestVerdictMutation, CreateOrUpdateExamCenterProctorRequestVerdictMutationVariables>;

/**
 * __useCreateOrUpdateExamCenterProctorRequestVerdictMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateExamCenterProctorRequestVerdictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateExamCenterProctorRequestVerdictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateExamCenterProctorRequestVerdictMutation, { data, loading, error }] = useCreateOrUpdateExamCenterProctorRequestVerdictMutation({
 *   variables: {
 *      createOrUpdateExamCenterProctorRequestVerdictInput: // value for 'createOrUpdateExamCenterProctorRequestVerdictInput'
 *   },
 * });
 */
export function useCreateOrUpdateExamCenterProctorRequestVerdictMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateExamCenterProctorRequestVerdictMutation, CreateOrUpdateExamCenterProctorRequestVerdictMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateExamCenterProctorRequestVerdictMutation, CreateOrUpdateExamCenterProctorRequestVerdictMutationVariables>(CreateOrUpdateExamCenterProctorRequestVerdictDocument, options);
      }
export type CreateOrUpdateExamCenterProctorRequestVerdictMutationHookResult = ReturnType<typeof useCreateOrUpdateExamCenterProctorRequestVerdictMutation>;
export type CreateOrUpdateExamCenterProctorRequestVerdictMutationResult = Apollo.MutationResult<CreateOrUpdateExamCenterProctorRequestVerdictMutation>;
export type CreateOrUpdateExamCenterProctorRequestVerdictMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateExamCenterProctorRequestVerdictMutation, CreateOrUpdateExamCenterProctorRequestVerdictMutationVariables>;
export const SubmitExamCenterProctorRequestVerdictDocument = gql`
    mutation submitExamCenterProctorRequestVerdict($submitReviewExamCenterProctorRequestInput: SubmitReviewExamCenterProctorRequestInput!) {
  ecSubmitReviewExamCenterProctorRequest(
    submitReviewExamCenterProctorRequestInput: $submitReviewExamCenterProctorRequestInput
  ) {
    examCenterProctorRequest {
      ...ExamCenterProctorRequest
    }
  }
}
    ${ExamCenterProctorRequestFragmentDoc}`;
export type SubmitExamCenterProctorRequestVerdictMutationFn = Apollo.MutationFunction<SubmitExamCenterProctorRequestVerdictMutation, SubmitExamCenterProctorRequestVerdictMutationVariables>;

/**
 * __useSubmitExamCenterProctorRequestVerdictMutation__
 *
 * To run a mutation, you first call `useSubmitExamCenterProctorRequestVerdictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitExamCenterProctorRequestVerdictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitExamCenterProctorRequestVerdictMutation, { data, loading, error }] = useSubmitExamCenterProctorRequestVerdictMutation({
 *   variables: {
 *      submitReviewExamCenterProctorRequestInput: // value for 'submitReviewExamCenterProctorRequestInput'
 *   },
 * });
 */
export function useSubmitExamCenterProctorRequestVerdictMutation(baseOptions?: Apollo.MutationHookOptions<SubmitExamCenterProctorRequestVerdictMutation, SubmitExamCenterProctorRequestVerdictMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitExamCenterProctorRequestVerdictMutation, SubmitExamCenterProctorRequestVerdictMutationVariables>(SubmitExamCenterProctorRequestVerdictDocument, options);
      }
export type SubmitExamCenterProctorRequestVerdictMutationHookResult = ReturnType<typeof useSubmitExamCenterProctorRequestVerdictMutation>;
export type SubmitExamCenterProctorRequestVerdictMutationResult = Apollo.MutationResult<SubmitExamCenterProctorRequestVerdictMutation>;
export type SubmitExamCenterProctorRequestVerdictMutationOptions = Apollo.BaseMutationOptions<SubmitExamCenterProctorRequestVerdictMutation, SubmitExamCenterProctorRequestVerdictMutationVariables>;
export const SearchExamCenterProctorRequestsDocument = gql`
    query searchExamCenterProctorRequests($searchExamCenterProctorRequestsInput: SearchExamCenterProctorRequestsInput!) {
  ecSearchExamCenterProctorRequests(
    searchExamCenterProctorRequestsInput: $searchExamCenterProctorRequestsInput
  ) {
    examCenterProctorRequests {
      ...ExamCenterProctorRequest
    }
    total
  }
}
    ${ExamCenterProctorRequestFragmentDoc}`;

/**
 * __useSearchExamCenterProctorRequestsQuery__
 *
 * To run a query within a React component, call `useSearchExamCenterProctorRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamCenterProctorRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamCenterProctorRequestsQuery({
 *   variables: {
 *      searchExamCenterProctorRequestsInput: // value for 'searchExamCenterProctorRequestsInput'
 *   },
 * });
 */
export function useSearchExamCenterProctorRequestsQuery(baseOptions: Apollo.QueryHookOptions<SearchExamCenterProctorRequestsQuery, SearchExamCenterProctorRequestsQueryVariables> & ({ variables: SearchExamCenterProctorRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamCenterProctorRequestsQuery, SearchExamCenterProctorRequestsQueryVariables>(SearchExamCenterProctorRequestsDocument, options);
      }
export function useSearchExamCenterProctorRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamCenterProctorRequestsQuery, SearchExamCenterProctorRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamCenterProctorRequestsQuery, SearchExamCenterProctorRequestsQueryVariables>(SearchExamCenterProctorRequestsDocument, options);
        }
export function useSearchExamCenterProctorRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCenterProctorRequestsQuery, SearchExamCenterProctorRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamCenterProctorRequestsQuery, SearchExamCenterProctorRequestsQueryVariables>(SearchExamCenterProctorRequestsDocument, options);
        }
export type SearchExamCenterProctorRequestsQueryHookResult = ReturnType<typeof useSearchExamCenterProctorRequestsQuery>;
export type SearchExamCenterProctorRequestsLazyQueryHookResult = ReturnType<typeof useSearchExamCenterProctorRequestsLazyQuery>;
export type SearchExamCenterProctorRequestsSuspenseQueryHookResult = ReturnType<typeof useSearchExamCenterProctorRequestsSuspenseQuery>;
export type SearchExamCenterProctorRequestsQueryResult = Apollo.QueryResult<SearchExamCenterProctorRequestsQuery, SearchExamCenterProctorRequestsQueryVariables>;
export const GetDownloadSignedUrlForExamCenterProctorRequestDocument = gql`
    query getDownloadSignedUrlForExamCenterProctorRequest($getDownloadSignedUrlForExamCenterProctorRequestInput: GetDownloadSignedUrlForExamCenterProctorRequestInput!) {
  ecGetDownloadSignedUrlForExamCenterProctorRequest(
    getDownloadSignedUrlForExamCenterProctorRequestInput: $getDownloadSignedUrlForExamCenterProctorRequestInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlForExamCenterProctorRequestQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlForExamCenterProctorRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlForExamCenterProctorRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlForExamCenterProctorRequestQuery({
 *   variables: {
 *      getDownloadSignedUrlForExamCenterProctorRequestInput: // value for 'getDownloadSignedUrlForExamCenterProctorRequestInput'
 *   },
 * });
 */
export function useGetDownloadSignedUrlForExamCenterProctorRequestQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlForExamCenterProctorRequestQuery, GetDownloadSignedUrlForExamCenterProctorRequestQueryVariables> & ({ variables: GetDownloadSignedUrlForExamCenterProctorRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlForExamCenterProctorRequestQuery, GetDownloadSignedUrlForExamCenterProctorRequestQueryVariables>(GetDownloadSignedUrlForExamCenterProctorRequestDocument, options);
      }
export function useGetDownloadSignedUrlForExamCenterProctorRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlForExamCenterProctorRequestQuery, GetDownloadSignedUrlForExamCenterProctorRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlForExamCenterProctorRequestQuery, GetDownloadSignedUrlForExamCenterProctorRequestQueryVariables>(GetDownloadSignedUrlForExamCenterProctorRequestDocument, options);
        }
export function useGetDownloadSignedUrlForExamCenterProctorRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlForExamCenterProctorRequestQuery, GetDownloadSignedUrlForExamCenterProctorRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlForExamCenterProctorRequestQuery, GetDownloadSignedUrlForExamCenterProctorRequestQueryVariables>(GetDownloadSignedUrlForExamCenterProctorRequestDocument, options);
        }
export type GetDownloadSignedUrlForExamCenterProctorRequestQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamCenterProctorRequestQuery>;
export type GetDownloadSignedUrlForExamCenterProctorRequestLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamCenterProctorRequestLazyQuery>;
export type GetDownloadSignedUrlForExamCenterProctorRequestSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlForExamCenterProctorRequestSuspenseQuery>;
export type GetDownloadSignedUrlForExamCenterProctorRequestQueryResult = Apollo.QueryResult<GetDownloadSignedUrlForExamCenterProctorRequestQuery, GetDownloadSignedUrlForExamCenterProctorRequestQueryVariables>;
export const AdminGetDownloadSignedUrlForExamCenterProctorRequestDocument = gql`
    query adminGetDownloadSignedUrlForExamCenterProctorRequest($getDownloadSignedUrlForExamCenterProctorRequestInput: GetDownloadSignedUrlForExamCenterProctorRequestInput!) {
  ecAdminGetDownloadSignedUrlForExamCenterProctorRequest(
    getDownloadSignedUrlForExamCenterProctorRequestInput: $getDownloadSignedUrlForExamCenterProctorRequestInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useAdminGetDownloadSignedUrlForExamCenterProctorRequestQuery__
 *
 * To run a query within a React component, call `useAdminGetDownloadSignedUrlForExamCenterProctorRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetDownloadSignedUrlForExamCenterProctorRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetDownloadSignedUrlForExamCenterProctorRequestQuery({
 *   variables: {
 *      getDownloadSignedUrlForExamCenterProctorRequestInput: // value for 'getDownloadSignedUrlForExamCenterProctorRequestInput'
 *   },
 * });
 */
export function useAdminGetDownloadSignedUrlForExamCenterProctorRequestQuery(baseOptions: Apollo.QueryHookOptions<AdminGetDownloadSignedUrlForExamCenterProctorRequestQuery, AdminGetDownloadSignedUrlForExamCenterProctorRequestQueryVariables> & ({ variables: AdminGetDownloadSignedUrlForExamCenterProctorRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetDownloadSignedUrlForExamCenterProctorRequestQuery, AdminGetDownloadSignedUrlForExamCenterProctorRequestQueryVariables>(AdminGetDownloadSignedUrlForExamCenterProctorRequestDocument, options);
      }
export function useAdminGetDownloadSignedUrlForExamCenterProctorRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetDownloadSignedUrlForExamCenterProctorRequestQuery, AdminGetDownloadSignedUrlForExamCenterProctorRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetDownloadSignedUrlForExamCenterProctorRequestQuery, AdminGetDownloadSignedUrlForExamCenterProctorRequestQueryVariables>(AdminGetDownloadSignedUrlForExamCenterProctorRequestDocument, options);
        }
export function useAdminGetDownloadSignedUrlForExamCenterProctorRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetDownloadSignedUrlForExamCenterProctorRequestQuery, AdminGetDownloadSignedUrlForExamCenterProctorRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetDownloadSignedUrlForExamCenterProctorRequestQuery, AdminGetDownloadSignedUrlForExamCenterProctorRequestQueryVariables>(AdminGetDownloadSignedUrlForExamCenterProctorRequestDocument, options);
        }
export type AdminGetDownloadSignedUrlForExamCenterProctorRequestQueryHookResult = ReturnType<typeof useAdminGetDownloadSignedUrlForExamCenterProctorRequestQuery>;
export type AdminGetDownloadSignedUrlForExamCenterProctorRequestLazyQueryHookResult = ReturnType<typeof useAdminGetDownloadSignedUrlForExamCenterProctorRequestLazyQuery>;
export type AdminGetDownloadSignedUrlForExamCenterProctorRequestSuspenseQueryHookResult = ReturnType<typeof useAdminGetDownloadSignedUrlForExamCenterProctorRequestSuspenseQuery>;
export type AdminGetDownloadSignedUrlForExamCenterProctorRequestQueryResult = Apollo.QueryResult<AdminGetDownloadSignedUrlForExamCenterProctorRequestQuery, AdminGetDownloadSignedUrlForExamCenterProctorRequestQueryVariables>;
export const SaveExamCenterProctorRequestAsDraftDocument = gql`
    mutation saveExamCenterProctorRequestAsDraft($saveExamCenterProctorRequestAsDraftInput: SaveExamCenterProctorRequestAsDraftInput!) {
  ecSaveExamCenterProctorRequestAsDraft(
    saveExamCenterProctorRequestAsDraftInput: $saveExamCenterProctorRequestAsDraftInput
  ) {
    examCenterProctorRequest {
      id
    }
  }
}
    `;
export type SaveExamCenterProctorRequestAsDraftMutationFn = Apollo.MutationFunction<SaveExamCenterProctorRequestAsDraftMutation, SaveExamCenterProctorRequestAsDraftMutationVariables>;

/**
 * __useSaveExamCenterProctorRequestAsDraftMutation__
 *
 * To run a mutation, you first call `useSaveExamCenterProctorRequestAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveExamCenterProctorRequestAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveExamCenterProctorRequestAsDraftMutation, { data, loading, error }] = useSaveExamCenterProctorRequestAsDraftMutation({
 *   variables: {
 *      saveExamCenterProctorRequestAsDraftInput: // value for 'saveExamCenterProctorRequestAsDraftInput'
 *   },
 * });
 */
export function useSaveExamCenterProctorRequestAsDraftMutation(baseOptions?: Apollo.MutationHookOptions<SaveExamCenterProctorRequestAsDraftMutation, SaveExamCenterProctorRequestAsDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveExamCenterProctorRequestAsDraftMutation, SaveExamCenterProctorRequestAsDraftMutationVariables>(SaveExamCenterProctorRequestAsDraftDocument, options);
      }
export type SaveExamCenterProctorRequestAsDraftMutationHookResult = ReturnType<typeof useSaveExamCenterProctorRequestAsDraftMutation>;
export type SaveExamCenterProctorRequestAsDraftMutationResult = Apollo.MutationResult<SaveExamCenterProctorRequestAsDraftMutation>;
export type SaveExamCenterProctorRequestAsDraftMutationOptions = Apollo.BaseMutationOptions<SaveExamCenterProctorRequestAsDraftMutation, SaveExamCenterProctorRequestAsDraftMutationVariables>;
export const AdminSearchMyExamCenterProctorRequestsDocument = gql`
    query adminSearchMyExamCenterProctorRequests($adminSearchExamCenterProctorRequestsInput: AdminSearchMyExamCenterProctorRequestsInput!) {
  ecAdminSearchMyExamCenterProctorRequests(
    adminSearchExamCenterProctorRequestsInput: $adminSearchExamCenterProctorRequestsInput
  ) {
    examCenterProctorRequests {
      ...ExamCenterProctorRequest
    }
    total
  }
}
    ${ExamCenterProctorRequestFragmentDoc}`;

/**
 * __useAdminSearchMyExamCenterProctorRequestsQuery__
 *
 * To run a query within a React component, call `useAdminSearchMyExamCenterProctorRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSearchMyExamCenterProctorRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSearchMyExamCenterProctorRequestsQuery({
 *   variables: {
 *      adminSearchExamCenterProctorRequestsInput: // value for 'adminSearchExamCenterProctorRequestsInput'
 *   },
 * });
 */
export function useAdminSearchMyExamCenterProctorRequestsQuery(baseOptions: Apollo.QueryHookOptions<AdminSearchMyExamCenterProctorRequestsQuery, AdminSearchMyExamCenterProctorRequestsQueryVariables> & ({ variables: AdminSearchMyExamCenterProctorRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSearchMyExamCenterProctorRequestsQuery, AdminSearchMyExamCenterProctorRequestsQueryVariables>(AdminSearchMyExamCenterProctorRequestsDocument, options);
      }
export function useAdminSearchMyExamCenterProctorRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSearchMyExamCenterProctorRequestsQuery, AdminSearchMyExamCenterProctorRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSearchMyExamCenterProctorRequestsQuery, AdminSearchMyExamCenterProctorRequestsQueryVariables>(AdminSearchMyExamCenterProctorRequestsDocument, options);
        }
export function useAdminSearchMyExamCenterProctorRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminSearchMyExamCenterProctorRequestsQuery, AdminSearchMyExamCenterProctorRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSearchMyExamCenterProctorRequestsQuery, AdminSearchMyExamCenterProctorRequestsQueryVariables>(AdminSearchMyExamCenterProctorRequestsDocument, options);
        }
export type AdminSearchMyExamCenterProctorRequestsQueryHookResult = ReturnType<typeof useAdminSearchMyExamCenterProctorRequestsQuery>;
export type AdminSearchMyExamCenterProctorRequestsLazyQueryHookResult = ReturnType<typeof useAdminSearchMyExamCenterProctorRequestsLazyQuery>;
export type AdminSearchMyExamCenterProctorRequestsSuspenseQueryHookResult = ReturnType<typeof useAdminSearchMyExamCenterProctorRequestsSuspenseQuery>;
export type AdminSearchMyExamCenterProctorRequestsQueryResult = Apollo.QueryResult<AdminSearchMyExamCenterProctorRequestsQuery, AdminSearchMyExamCenterProctorRequestsQueryVariables>;
export const SearchExamCentersDocument = gql`
    query searchExamCenters($searchExamCentersInput: SearchExamCentersInput!) {
  ecSearchExamCenters(searchExamCentersInput: $searchExamCentersInput) {
    examCenters {
      id
      nameTH
      nameEN
      code
      examCenterId
    }
  }
}
    `;

/**
 * __useSearchExamCentersQuery__
 *
 * To run a query within a React component, call `useSearchExamCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamCentersQuery({
 *   variables: {
 *      searchExamCentersInput: // value for 'searchExamCentersInput'
 *   },
 * });
 */
export function useSearchExamCentersQuery(baseOptions: Apollo.QueryHookOptions<SearchExamCentersQuery, SearchExamCentersQueryVariables> & ({ variables: SearchExamCentersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamCentersQuery, SearchExamCentersQueryVariables>(SearchExamCentersDocument, options);
      }
export function useSearchExamCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamCentersQuery, SearchExamCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamCentersQuery, SearchExamCentersQueryVariables>(SearchExamCentersDocument, options);
        }
export function useSearchExamCentersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCentersQuery, SearchExamCentersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamCentersQuery, SearchExamCentersQueryVariables>(SearchExamCentersDocument, options);
        }
export type SearchExamCentersQueryHookResult = ReturnType<typeof useSearchExamCentersQuery>;
export type SearchExamCentersLazyQueryHookResult = ReturnType<typeof useSearchExamCentersLazyQuery>;
export type SearchExamCentersSuspenseQueryHookResult = ReturnType<typeof useSearchExamCentersSuspenseQuery>;
export type SearchExamCentersQueryResult = Apollo.QueryResult<SearchExamCentersQuery, SearchExamCentersQueryVariables>;
export const CreateExamCenterDocument = gql`
    mutation createExamCenter($createExamCenterInput: CreateExamCenterInput!) {
  ecCreateExamCenter(createExamCenterInput: $createExamCenterInput) {
    examCenter {
      code
    }
  }
}
    `;
export type CreateExamCenterMutationFn = Apollo.MutationFunction<CreateExamCenterMutation, CreateExamCenterMutationVariables>;

/**
 * __useCreateExamCenterMutation__
 *
 * To run a mutation, you first call `useCreateExamCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExamCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExamCenterMutation, { data, loading, error }] = useCreateExamCenterMutation({
 *   variables: {
 *      createExamCenterInput: // value for 'createExamCenterInput'
 *   },
 * });
 */
export function useCreateExamCenterMutation(baseOptions?: Apollo.MutationHookOptions<CreateExamCenterMutation, CreateExamCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExamCenterMutation, CreateExamCenterMutationVariables>(CreateExamCenterDocument, options);
      }
export type CreateExamCenterMutationHookResult = ReturnType<typeof useCreateExamCenterMutation>;
export type CreateExamCenterMutationResult = Apollo.MutationResult<CreateExamCenterMutation>;
export type CreateExamCenterMutationOptions = Apollo.BaseMutationOptions<CreateExamCenterMutation, CreateExamCenterMutationVariables>;
export const AdminUpdateExamCenterDocument = gql`
    mutation adminUpdateExamCenter($adminUpdateExamCenterInput: AdminUpdateExamCenterInput!) {
  ecAdminUpdateExamCenter(adminUpdateExamCenterInput: $adminUpdateExamCenterInput) {
    examCenter {
      code
    }
  }
}
    `;
export type AdminUpdateExamCenterMutationFn = Apollo.MutationFunction<AdminUpdateExamCenterMutation, AdminUpdateExamCenterMutationVariables>;

/**
 * __useAdminUpdateExamCenterMutation__
 *
 * To run a mutation, you first call `useAdminUpdateExamCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateExamCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateExamCenterMutation, { data, loading, error }] = useAdminUpdateExamCenterMutation({
 *   variables: {
 *      adminUpdateExamCenterInput: // value for 'adminUpdateExamCenterInput'
 *   },
 * });
 */
export function useAdminUpdateExamCenterMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateExamCenterMutation, AdminUpdateExamCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateExamCenterMutation, AdminUpdateExamCenterMutationVariables>(AdminUpdateExamCenterDocument, options);
      }
export type AdminUpdateExamCenterMutationHookResult = ReturnType<typeof useAdminUpdateExamCenterMutation>;
export type AdminUpdateExamCenterMutationResult = Apollo.MutationResult<AdminUpdateExamCenterMutation>;
export type AdminUpdateExamCenterMutationOptions = Apollo.BaseMutationOptions<AdminUpdateExamCenterMutation, AdminUpdateExamCenterMutationVariables>;
export const UpdateExamCenterDocument = gql`
    mutation updateExamCenter($updateExamCenterInput: UpdateExamCenterInput!) {
  ecUpdateExamCenter(updateExamCenterInput: $updateExamCenterInput) {
    examCenter {
      code
    }
  }
}
    `;
export type UpdateExamCenterMutationFn = Apollo.MutationFunction<UpdateExamCenterMutation, UpdateExamCenterMutationVariables>;

/**
 * __useUpdateExamCenterMutation__
 *
 * To run a mutation, you first call `useUpdateExamCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamCenterMutation, { data, loading, error }] = useUpdateExamCenterMutation({
 *   variables: {
 *      updateExamCenterInput: // value for 'updateExamCenterInput'
 *   },
 * });
 */
export function useUpdateExamCenterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExamCenterMutation, UpdateExamCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExamCenterMutation, UpdateExamCenterMutationVariables>(UpdateExamCenterDocument, options);
      }
export type UpdateExamCenterMutationHookResult = ReturnType<typeof useUpdateExamCenterMutation>;
export type UpdateExamCenterMutationResult = Apollo.MutationResult<UpdateExamCenterMutation>;
export type UpdateExamCenterMutationOptions = Apollo.BaseMutationOptions<UpdateExamCenterMutation, UpdateExamCenterMutationVariables>;
export const GetExamCenterByExamCenterCodeDocument = gql`
    query getExamCenterByExamCenterCode($getExamCenterByExamCenterCodeInput: GetExamCenterByExamCenterCodeInput!) {
  ecGetExamCenterByExamCenterCode(
    getExamCenterByExamCenterCodeInput: $getExamCenterByExamCenterCodeInput
  ) {
    examCenter {
      id
      nameTH
      nameEN
      addressTH
      addressEN
      phoneTH
      phoneEN
      website
      email
      examResultRecipientEmail
      code
      examCenterId
    }
  }
}
    `;

/**
 * __useGetExamCenterByExamCenterCodeQuery__
 *
 * To run a query within a React component, call `useGetExamCenterByExamCenterCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCenterByExamCenterCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCenterByExamCenterCodeQuery({
 *   variables: {
 *      getExamCenterByExamCenterCodeInput: // value for 'getExamCenterByExamCenterCodeInput'
 *   },
 * });
 */
export function useGetExamCenterByExamCenterCodeQuery(baseOptions: Apollo.QueryHookOptions<GetExamCenterByExamCenterCodeQuery, GetExamCenterByExamCenterCodeQueryVariables> & ({ variables: GetExamCenterByExamCenterCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCenterByExamCenterCodeQuery, GetExamCenterByExamCenterCodeQueryVariables>(GetExamCenterByExamCenterCodeDocument, options);
      }
export function useGetExamCenterByExamCenterCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCenterByExamCenterCodeQuery, GetExamCenterByExamCenterCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCenterByExamCenterCodeQuery, GetExamCenterByExamCenterCodeQueryVariables>(GetExamCenterByExamCenterCodeDocument, options);
        }
export function useGetExamCenterByExamCenterCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCenterByExamCenterCodeQuery, GetExamCenterByExamCenterCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCenterByExamCenterCodeQuery, GetExamCenterByExamCenterCodeQueryVariables>(GetExamCenterByExamCenterCodeDocument, options);
        }
export type GetExamCenterByExamCenterCodeQueryHookResult = ReturnType<typeof useGetExamCenterByExamCenterCodeQuery>;
export type GetExamCenterByExamCenterCodeLazyQueryHookResult = ReturnType<typeof useGetExamCenterByExamCenterCodeLazyQuery>;
export type GetExamCenterByExamCenterCodeSuspenseQueryHookResult = ReturnType<typeof useGetExamCenterByExamCenterCodeSuspenseQuery>;
export type GetExamCenterByExamCenterCodeQueryResult = Apollo.QueryResult<GetExamCenterByExamCenterCodeQuery, GetExamCenterByExamCenterCodeQueryVariables>;
export const AdminGetExamCenterByExamCenterCodeDocument = gql`
    query adminGetExamCenterByExamCenterCode($getExamCenterByExamCenterCodeInput: GetExamCenterByExamCenterCodeInput!) {
  ecAdminGetExamCenterByExamCenterCode(
    getExamCenterByExamCenterCodeInput: $getExamCenterByExamCenterCodeInput
  ) {
    examCenter {
      id
      nameTH
      nameEN
      addressTH
      addressEN
      phoneTH
      phoneEN
      website
      email
      examResultRecipientEmail
      code
      examCenterId
    }
  }
}
    `;

/**
 * __useAdminGetExamCenterByExamCenterCodeQuery__
 *
 * To run a query within a React component, call `useAdminGetExamCenterByExamCenterCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetExamCenterByExamCenterCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetExamCenterByExamCenterCodeQuery({
 *   variables: {
 *      getExamCenterByExamCenterCodeInput: // value for 'getExamCenterByExamCenterCodeInput'
 *   },
 * });
 */
export function useAdminGetExamCenterByExamCenterCodeQuery(baseOptions: Apollo.QueryHookOptions<AdminGetExamCenterByExamCenterCodeQuery, AdminGetExamCenterByExamCenterCodeQueryVariables> & ({ variables: AdminGetExamCenterByExamCenterCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetExamCenterByExamCenterCodeQuery, AdminGetExamCenterByExamCenterCodeQueryVariables>(AdminGetExamCenterByExamCenterCodeDocument, options);
      }
export function useAdminGetExamCenterByExamCenterCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetExamCenterByExamCenterCodeQuery, AdminGetExamCenterByExamCenterCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetExamCenterByExamCenterCodeQuery, AdminGetExamCenterByExamCenterCodeQueryVariables>(AdminGetExamCenterByExamCenterCodeDocument, options);
        }
export function useAdminGetExamCenterByExamCenterCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetExamCenterByExamCenterCodeQuery, AdminGetExamCenterByExamCenterCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetExamCenterByExamCenterCodeQuery, AdminGetExamCenterByExamCenterCodeQueryVariables>(AdminGetExamCenterByExamCenterCodeDocument, options);
        }
export type AdminGetExamCenterByExamCenterCodeQueryHookResult = ReturnType<typeof useAdminGetExamCenterByExamCenterCodeQuery>;
export type AdminGetExamCenterByExamCenterCodeLazyQueryHookResult = ReturnType<typeof useAdminGetExamCenterByExamCenterCodeLazyQuery>;
export type AdminGetExamCenterByExamCenterCodeSuspenseQueryHookResult = ReturnType<typeof useAdminGetExamCenterByExamCenterCodeSuspenseQuery>;
export type AdminGetExamCenterByExamCenterCodeQueryResult = Apollo.QueryResult<AdminGetExamCenterByExamCenterCodeQuery, AdminGetExamCenterByExamCenterCodeQueryVariables>;
export const GetMyExamCentersDocument = gql`
    query getMyExamCenters {
  ecGetMyExamCenters {
    examCenters {
      id
      nameTH
      code
      logoSrc
      examCenterId
    }
  }
}
    `;

/**
 * __useGetMyExamCentersQuery__
 *
 * To run a query within a React component, call `useGetMyExamCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyExamCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyExamCentersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyExamCentersQuery(baseOptions?: Apollo.QueryHookOptions<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>(GetMyExamCentersDocument, options);
      }
export function useGetMyExamCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>(GetMyExamCentersDocument, options);
        }
export function useGetMyExamCentersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>(GetMyExamCentersDocument, options);
        }
export type GetMyExamCentersQueryHookResult = ReturnType<typeof useGetMyExamCentersQuery>;
export type GetMyExamCentersLazyQueryHookResult = ReturnType<typeof useGetMyExamCentersLazyQuery>;
export type GetMyExamCentersSuspenseQueryHookResult = ReturnType<typeof useGetMyExamCentersSuspenseQuery>;
export type GetMyExamCentersQueryResult = Apollo.QueryResult<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>;
export const SearchExamCenterCoursesDocument = gql`
    query searchExamCenterCourses($searchExamCenterCoursesInput: SearchExamCenterCoursesInput!) {
  ecSearchExamCenterCourses(
    searchExamCenterCoursesInput: $searchExamCenterCoursesInput
  ) {
    examCenterCourses {
      id
      createdAt
      examCourse {
        id
        examId
        code
        name
        type
        language
      }
    }
    total
  }
}
    `;

/**
 * __useSearchExamCenterCoursesQuery__
 *
 * To run a query within a React component, call `useSearchExamCenterCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamCenterCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamCenterCoursesQuery({
 *   variables: {
 *      searchExamCenterCoursesInput: // value for 'searchExamCenterCoursesInput'
 *   },
 * });
 */
export function useSearchExamCenterCoursesQuery(baseOptions: Apollo.QueryHookOptions<SearchExamCenterCoursesQuery, SearchExamCenterCoursesQueryVariables> & ({ variables: SearchExamCenterCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamCenterCoursesQuery, SearchExamCenterCoursesQueryVariables>(SearchExamCenterCoursesDocument, options);
      }
export function useSearchExamCenterCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamCenterCoursesQuery, SearchExamCenterCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamCenterCoursesQuery, SearchExamCenterCoursesQueryVariables>(SearchExamCenterCoursesDocument, options);
        }
export function useSearchExamCenterCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCenterCoursesQuery, SearchExamCenterCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamCenterCoursesQuery, SearchExamCenterCoursesQueryVariables>(SearchExamCenterCoursesDocument, options);
        }
export type SearchExamCenterCoursesQueryHookResult = ReturnType<typeof useSearchExamCenterCoursesQuery>;
export type SearchExamCenterCoursesLazyQueryHookResult = ReturnType<typeof useSearchExamCenterCoursesLazyQuery>;
export type SearchExamCenterCoursesSuspenseQueryHookResult = ReturnType<typeof useSearchExamCenterCoursesSuspenseQuery>;
export type SearchExamCenterCoursesQueryResult = Apollo.QueryResult<SearchExamCenterCoursesQuery, SearchExamCenterCoursesQueryVariables>;
export const AdminSearchExamCenterCoursesDocument = gql`
    query adminSearchExamCenterCourses($searchExamCenterCoursesInput: SearchExamCenterCoursesInput!) {
  ecAdminSearchExamCenterCourses(
    searchExamCenterCoursesInput: $searchExamCenterCoursesInput
  ) {
    examCenterCourses {
      id
      createdAt
      examCourse {
        id
        examId
        code
        name
        type
        language
      }
    }
    total
  }
}
    `;

/**
 * __useAdminSearchExamCenterCoursesQuery__
 *
 * To run a query within a React component, call `useAdminSearchExamCenterCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSearchExamCenterCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSearchExamCenterCoursesQuery({
 *   variables: {
 *      searchExamCenterCoursesInput: // value for 'searchExamCenterCoursesInput'
 *   },
 * });
 */
export function useAdminSearchExamCenterCoursesQuery(baseOptions: Apollo.QueryHookOptions<AdminSearchExamCenterCoursesQuery, AdminSearchExamCenterCoursesQueryVariables> & ({ variables: AdminSearchExamCenterCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSearchExamCenterCoursesQuery, AdminSearchExamCenterCoursesQueryVariables>(AdminSearchExamCenterCoursesDocument, options);
      }
export function useAdminSearchExamCenterCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSearchExamCenterCoursesQuery, AdminSearchExamCenterCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSearchExamCenterCoursesQuery, AdminSearchExamCenterCoursesQueryVariables>(AdminSearchExamCenterCoursesDocument, options);
        }
export function useAdminSearchExamCenterCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminSearchExamCenterCoursesQuery, AdminSearchExamCenterCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSearchExamCenterCoursesQuery, AdminSearchExamCenterCoursesQueryVariables>(AdminSearchExamCenterCoursesDocument, options);
        }
export type AdminSearchExamCenterCoursesQueryHookResult = ReturnType<typeof useAdminSearchExamCenterCoursesQuery>;
export type AdminSearchExamCenterCoursesLazyQueryHookResult = ReturnType<typeof useAdminSearchExamCenterCoursesLazyQuery>;
export type AdminSearchExamCenterCoursesSuspenseQueryHookResult = ReturnType<typeof useAdminSearchExamCenterCoursesSuspenseQuery>;
export type AdminSearchExamCenterCoursesQueryResult = Apollo.QueryResult<AdminSearchExamCenterCoursesQuery, AdminSearchExamCenterCoursesQueryVariables>;
export const ExportExaminationCodesByExamEventIdDocument = gql`
    query exportExaminationCodesByExamEventId($exportExaminationCodesByExamEventIdInput: ExportExaminationCodesByExamEventIdInput!) {
  ecExportExaminationCodesByExamEventId(
    exportExaminationCodesByExamEventIdInput: $exportExaminationCodesByExamEventIdInput
  ) {
    url
  }
}
    `;

/**
 * __useExportExaminationCodesByExamEventIdQuery__
 *
 * To run a query within a React component, call `useExportExaminationCodesByExamEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportExaminationCodesByExamEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportExaminationCodesByExamEventIdQuery({
 *   variables: {
 *      exportExaminationCodesByExamEventIdInput: // value for 'exportExaminationCodesByExamEventIdInput'
 *   },
 * });
 */
export function useExportExaminationCodesByExamEventIdQuery(baseOptions: Apollo.QueryHookOptions<ExportExaminationCodesByExamEventIdQuery, ExportExaminationCodesByExamEventIdQueryVariables> & ({ variables: ExportExaminationCodesByExamEventIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportExaminationCodesByExamEventIdQuery, ExportExaminationCodesByExamEventIdQueryVariables>(ExportExaminationCodesByExamEventIdDocument, options);
      }
export function useExportExaminationCodesByExamEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportExaminationCodesByExamEventIdQuery, ExportExaminationCodesByExamEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportExaminationCodesByExamEventIdQuery, ExportExaminationCodesByExamEventIdQueryVariables>(ExportExaminationCodesByExamEventIdDocument, options);
        }
export function useExportExaminationCodesByExamEventIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportExaminationCodesByExamEventIdQuery, ExportExaminationCodesByExamEventIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportExaminationCodesByExamEventIdQuery, ExportExaminationCodesByExamEventIdQueryVariables>(ExportExaminationCodesByExamEventIdDocument, options);
        }
export type ExportExaminationCodesByExamEventIdQueryHookResult = ReturnType<typeof useExportExaminationCodesByExamEventIdQuery>;
export type ExportExaminationCodesByExamEventIdLazyQueryHookResult = ReturnType<typeof useExportExaminationCodesByExamEventIdLazyQuery>;
export type ExportExaminationCodesByExamEventIdSuspenseQueryHookResult = ReturnType<typeof useExportExaminationCodesByExamEventIdSuspenseQuery>;
export type ExportExaminationCodesByExamEventIdQueryResult = Apollo.QueryResult<ExportExaminationCodesByExamEventIdQuery, ExportExaminationCodesByExamEventIdQueryVariables>;
export const ExportExaminationCodeByExamEventExamineeIdDocument = gql`
    query exportExaminationCodeByExamEventExamineeId($exportExaminationCodeByExamEventExamineeIdInput: ExportExaminationCodeByExamEventExamineeIdInput!) {
  ecExportExaminationCodeByExamEventExamineeId(
    exportExaminationCodeByExamEventExamineeIdInput: $exportExaminationCodeByExamEventExamineeIdInput
  ) {
    url
  }
}
    `;

/**
 * __useExportExaminationCodeByExamEventExamineeIdQuery__
 *
 * To run a query within a React component, call `useExportExaminationCodeByExamEventExamineeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportExaminationCodeByExamEventExamineeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportExaminationCodeByExamEventExamineeIdQuery({
 *   variables: {
 *      exportExaminationCodeByExamEventExamineeIdInput: // value for 'exportExaminationCodeByExamEventExamineeIdInput'
 *   },
 * });
 */
export function useExportExaminationCodeByExamEventExamineeIdQuery(baseOptions: Apollo.QueryHookOptions<ExportExaminationCodeByExamEventExamineeIdQuery, ExportExaminationCodeByExamEventExamineeIdQueryVariables> & ({ variables: ExportExaminationCodeByExamEventExamineeIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportExaminationCodeByExamEventExamineeIdQuery, ExportExaminationCodeByExamEventExamineeIdQueryVariables>(ExportExaminationCodeByExamEventExamineeIdDocument, options);
      }
export function useExportExaminationCodeByExamEventExamineeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportExaminationCodeByExamEventExamineeIdQuery, ExportExaminationCodeByExamEventExamineeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportExaminationCodeByExamEventExamineeIdQuery, ExportExaminationCodeByExamEventExamineeIdQueryVariables>(ExportExaminationCodeByExamEventExamineeIdDocument, options);
        }
export function useExportExaminationCodeByExamEventExamineeIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportExaminationCodeByExamEventExamineeIdQuery, ExportExaminationCodeByExamEventExamineeIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportExaminationCodeByExamEventExamineeIdQuery, ExportExaminationCodeByExamEventExamineeIdQueryVariables>(ExportExaminationCodeByExamEventExamineeIdDocument, options);
        }
export type ExportExaminationCodeByExamEventExamineeIdQueryHookResult = ReturnType<typeof useExportExaminationCodeByExamEventExamineeIdQuery>;
export type ExportExaminationCodeByExamEventExamineeIdLazyQueryHookResult = ReturnType<typeof useExportExaminationCodeByExamEventExamineeIdLazyQuery>;
export type ExportExaminationCodeByExamEventExamineeIdSuspenseQueryHookResult = ReturnType<typeof useExportExaminationCodeByExamEventExamineeIdSuspenseQuery>;
export type ExportExaminationCodeByExamEventExamineeIdQueryResult = Apollo.QueryResult<ExportExaminationCodeByExamEventExamineeIdQuery, ExportExaminationCodeByExamEventExamineeIdQueryVariables>;
export const GetAllExamCentersDocument = gql`
    query getAllExamCenters {
  ecGetAllExamCenters {
    examCenters {
      id
      code
      examCenterId
    }
  }
}
    `;

/**
 * __useGetAllExamCentersQuery__
 *
 * To run a query within a React component, call `useGetAllExamCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllExamCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllExamCentersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllExamCentersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>(GetAllExamCentersDocument, options);
      }
export function useGetAllExamCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>(GetAllExamCentersDocument, options);
        }
export function useGetAllExamCentersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>(GetAllExamCentersDocument, options);
        }
export type GetAllExamCentersQueryHookResult = ReturnType<typeof useGetAllExamCentersQuery>;
export type GetAllExamCentersLazyQueryHookResult = ReturnType<typeof useGetAllExamCentersLazyQuery>;
export type GetAllExamCentersSuspenseQueryHookResult = ReturnType<typeof useGetAllExamCentersSuspenseQuery>;
export type GetAllExamCentersQueryResult = Apollo.QueryResult<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>;
export const GetExamEventResultSummaryDocument = gql`
    query getExamEventResultSummary($getExamEventResultSummaryInput: GetExamEventResultSummaryInput!) {
  ecGetExamEventResultSummary(
    GetExamEventResultSummaryInput: $getExamEventResultSummaryInput
  ) {
    passed
    failed
    absent
    canceled
  }
}
    `;

/**
 * __useGetExamEventResultSummaryQuery__
 *
 * To run a query within a React component, call `useGetExamEventResultSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamEventResultSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamEventResultSummaryQuery({
 *   variables: {
 *      getExamEventResultSummaryInput: // value for 'getExamEventResultSummaryInput'
 *   },
 * });
 */
export function useGetExamEventResultSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetExamEventResultSummaryQuery, GetExamEventResultSummaryQueryVariables> & ({ variables: GetExamEventResultSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamEventResultSummaryQuery, GetExamEventResultSummaryQueryVariables>(GetExamEventResultSummaryDocument, options);
      }
export function useGetExamEventResultSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamEventResultSummaryQuery, GetExamEventResultSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamEventResultSummaryQuery, GetExamEventResultSummaryQueryVariables>(GetExamEventResultSummaryDocument, options);
        }
export function useGetExamEventResultSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamEventResultSummaryQuery, GetExamEventResultSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamEventResultSummaryQuery, GetExamEventResultSummaryQueryVariables>(GetExamEventResultSummaryDocument, options);
        }
export type GetExamEventResultSummaryQueryHookResult = ReturnType<typeof useGetExamEventResultSummaryQuery>;
export type GetExamEventResultSummaryLazyQueryHookResult = ReturnType<typeof useGetExamEventResultSummaryLazyQuery>;
export type GetExamEventResultSummarySuspenseQueryHookResult = ReturnType<typeof useGetExamEventResultSummarySuspenseQuery>;
export type GetExamEventResultSummaryQueryResult = Apollo.QueryResult<GetExamEventResultSummaryQuery, GetExamEventResultSummaryQueryVariables>;
export const SearchExamCoursesDocument = gql`
    query searchExamCourses($searchExamCoursesInput: SearchExamCoursesInput!) {
  ecSearchExamCourses(searchExamCoursesInput: $searchExamCoursesInput) {
    examCourses {
      id
      examId
      code
      name
      type
      language
    }
    total
  }
}
    `;

/**
 * __useSearchExamCoursesQuery__
 *
 * To run a query within a React component, call `useSearchExamCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamCoursesQuery({
 *   variables: {
 *      searchExamCoursesInput: // value for 'searchExamCoursesInput'
 *   },
 * });
 */
export function useSearchExamCoursesQuery(baseOptions: Apollo.QueryHookOptions<SearchExamCoursesQuery, SearchExamCoursesQueryVariables> & ({ variables: SearchExamCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>(SearchExamCoursesDocument, options);
      }
export function useSearchExamCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>(SearchExamCoursesDocument, options);
        }
export function useSearchExamCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>(SearchExamCoursesDocument, options);
        }
export type SearchExamCoursesQueryHookResult = ReturnType<typeof useSearchExamCoursesQuery>;
export type SearchExamCoursesLazyQueryHookResult = ReturnType<typeof useSearchExamCoursesLazyQuery>;
export type SearchExamCoursesSuspenseQueryHookResult = ReturnType<typeof useSearchExamCoursesSuspenseQuery>;
export type SearchExamCoursesQueryResult = Apollo.QueryResult<SearchExamCoursesQuery, SearchExamCoursesQueryVariables>;
export const EnableExamCourseByIdDocument = gql`
    mutation enableExamCourseById($enableExamCourseByIdInput: EnableExamCourseByIdInput!) {
  ecEnableExamCourseById(enableExamCourseByIdInput: $enableExamCourseByIdInput) {
    examCourse {
      id
      code
    }
  }
}
    `;
export type EnableExamCourseByIdMutationFn = Apollo.MutationFunction<EnableExamCourseByIdMutation, EnableExamCourseByIdMutationVariables>;

/**
 * __useEnableExamCourseByIdMutation__
 *
 * To run a mutation, you first call `useEnableExamCourseByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableExamCourseByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableExamCourseByIdMutation, { data, loading, error }] = useEnableExamCourseByIdMutation({
 *   variables: {
 *      enableExamCourseByIdInput: // value for 'enableExamCourseByIdInput'
 *   },
 * });
 */
export function useEnableExamCourseByIdMutation(baseOptions?: Apollo.MutationHookOptions<EnableExamCourseByIdMutation, EnableExamCourseByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableExamCourseByIdMutation, EnableExamCourseByIdMutationVariables>(EnableExamCourseByIdDocument, options);
      }
export type EnableExamCourseByIdMutationHookResult = ReturnType<typeof useEnableExamCourseByIdMutation>;
export type EnableExamCourseByIdMutationResult = Apollo.MutationResult<EnableExamCourseByIdMutation>;
export type EnableExamCourseByIdMutationOptions = Apollo.BaseMutationOptions<EnableExamCourseByIdMutation, EnableExamCourseByIdMutationVariables>;
export const GetExamCourseByExamCourseCodeDocument = gql`
    query getExamCourseByExamCourseCode($getExamCourseByExamCourseCodeInput: GetExamCourseByExamCourseCodeInput!) {
  ecGetExamCourseByExamCourseCode(
    getExamCourseByExamCourseCodeInput: $getExamCourseByExamCourseCodeInput
  ) {
    examCourse {
      id
      name
      examId
      type
      language
      updatedAt
    }
  }
}
    `;

/**
 * __useGetExamCourseByExamCourseCodeQuery__
 *
 * To run a query within a React component, call `useGetExamCourseByExamCourseCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCourseByExamCourseCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCourseByExamCourseCodeQuery({
 *   variables: {
 *      getExamCourseByExamCourseCodeInput: // value for 'getExamCourseByExamCourseCodeInput'
 *   },
 * });
 */
export function useGetExamCourseByExamCourseCodeQuery(baseOptions: Apollo.QueryHookOptions<GetExamCourseByExamCourseCodeQuery, GetExamCourseByExamCourseCodeQueryVariables> & ({ variables: GetExamCourseByExamCourseCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCourseByExamCourseCodeQuery, GetExamCourseByExamCourseCodeQueryVariables>(GetExamCourseByExamCourseCodeDocument, options);
      }
export function useGetExamCourseByExamCourseCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCourseByExamCourseCodeQuery, GetExamCourseByExamCourseCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCourseByExamCourseCodeQuery, GetExamCourseByExamCourseCodeQueryVariables>(GetExamCourseByExamCourseCodeDocument, options);
        }
export function useGetExamCourseByExamCourseCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseByExamCourseCodeQuery, GetExamCourseByExamCourseCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCourseByExamCourseCodeQuery, GetExamCourseByExamCourseCodeQueryVariables>(GetExamCourseByExamCourseCodeDocument, options);
        }
export type GetExamCourseByExamCourseCodeQueryHookResult = ReturnType<typeof useGetExamCourseByExamCourseCodeQuery>;
export type GetExamCourseByExamCourseCodeLazyQueryHookResult = ReturnType<typeof useGetExamCourseByExamCourseCodeLazyQuery>;
export type GetExamCourseByExamCourseCodeSuspenseQueryHookResult = ReturnType<typeof useGetExamCourseByExamCourseCodeSuspenseQuery>;
export type GetExamCourseByExamCourseCodeQueryResult = Apollo.QueryResult<GetExamCourseByExamCourseCodeQuery, GetExamCourseByExamCourseCodeQueryVariables>;
export const GetExamCourseSettingsByExamCourseCodeDocument = gql`
    query getExamCourseSettingsByExamCourseCode($getExamCourseByExamCourseCodeInput: GetExamCourseByExamCourseCodeInput!) {
  ecGetExamCourseByExamCourseCode(
    getExamCourseByExamCourseCodeInput: $getExamCourseByExamCourseCodeInput
  ) {
    examCourse {
      type
      language
      settings {
        resultSend {
          portal
        }
        resultDisplay {
          examResult
        }
        certificate {
          averageScoreCondition
          delayedDays
          failedTemplate
          passedTemplate
          validityDurationYears
        }
        examDuration {
          type
          sessions {
            order
            value
          }
        }
        questionnaire {
          templateId
        }
        attachDocument {
          fileName
          key
        }
      }
    }
  }
}
    `;

/**
 * __useGetExamCourseSettingsByExamCourseCodeQuery__
 *
 * To run a query within a React component, call `useGetExamCourseSettingsByExamCourseCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCourseSettingsByExamCourseCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCourseSettingsByExamCourseCodeQuery({
 *   variables: {
 *      getExamCourseByExamCourseCodeInput: // value for 'getExamCourseByExamCourseCodeInput'
 *   },
 * });
 */
export function useGetExamCourseSettingsByExamCourseCodeQuery(baseOptions: Apollo.QueryHookOptions<GetExamCourseSettingsByExamCourseCodeQuery, GetExamCourseSettingsByExamCourseCodeQueryVariables> & ({ variables: GetExamCourseSettingsByExamCourseCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCourseSettingsByExamCourseCodeQuery, GetExamCourseSettingsByExamCourseCodeQueryVariables>(GetExamCourseSettingsByExamCourseCodeDocument, options);
      }
export function useGetExamCourseSettingsByExamCourseCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCourseSettingsByExamCourseCodeQuery, GetExamCourseSettingsByExamCourseCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCourseSettingsByExamCourseCodeQuery, GetExamCourseSettingsByExamCourseCodeQueryVariables>(GetExamCourseSettingsByExamCourseCodeDocument, options);
        }
export function useGetExamCourseSettingsByExamCourseCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseSettingsByExamCourseCodeQuery, GetExamCourseSettingsByExamCourseCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCourseSettingsByExamCourseCodeQuery, GetExamCourseSettingsByExamCourseCodeQueryVariables>(GetExamCourseSettingsByExamCourseCodeDocument, options);
        }
export type GetExamCourseSettingsByExamCourseCodeQueryHookResult = ReturnType<typeof useGetExamCourseSettingsByExamCourseCodeQuery>;
export type GetExamCourseSettingsByExamCourseCodeLazyQueryHookResult = ReturnType<typeof useGetExamCourseSettingsByExamCourseCodeLazyQuery>;
export type GetExamCourseSettingsByExamCourseCodeSuspenseQueryHookResult = ReturnType<typeof useGetExamCourseSettingsByExamCourseCodeSuspenseQuery>;
export type GetExamCourseSettingsByExamCourseCodeQueryResult = Apollo.QueryResult<GetExamCourseSettingsByExamCourseCodeQuery, GetExamCourseSettingsByExamCourseCodeQueryVariables>;
export const UpdateExamCourseSettingsDocument = gql`
    mutation updateExamCourseSettings($updateExamCourseSettingsInput: UpdateExamCourseSettingsInput!) {
  ecUpdateExamCourseSettings(
    updateExamCourseSettingsInput: $updateExamCourseSettingsInput
  ) {
    examCourse {
      id
      settings {
        resultSend {
          portal
        }
        resultDisplay {
          examResult
        }
        certificate {
          averageScoreCondition
          delayedDays
          failedTemplate
          passedTemplate
          validityDurationYears
        }
        examDuration {
          type
          sessions {
            order
            value
          }
        }
        questionnaire {
          templateId
        }
        attachDocument {
          fileName
          key
        }
      }
    }
  }
}
    `;
export type UpdateExamCourseSettingsMutationFn = Apollo.MutationFunction<UpdateExamCourseSettingsMutation, UpdateExamCourseSettingsMutationVariables>;

/**
 * __useUpdateExamCourseSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateExamCourseSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamCourseSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamCourseSettingsMutation, { data, loading, error }] = useUpdateExamCourseSettingsMutation({
 *   variables: {
 *      updateExamCourseSettingsInput: // value for 'updateExamCourseSettingsInput'
 *   },
 * });
 */
export function useUpdateExamCourseSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExamCourseSettingsMutation, UpdateExamCourseSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExamCourseSettingsMutation, UpdateExamCourseSettingsMutationVariables>(UpdateExamCourseSettingsDocument, options);
      }
export type UpdateExamCourseSettingsMutationHookResult = ReturnType<typeof useUpdateExamCourseSettingsMutation>;
export type UpdateExamCourseSettingsMutationResult = Apollo.MutationResult<UpdateExamCourseSettingsMutation>;
export type UpdateExamCourseSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateExamCourseSettingsMutation, UpdateExamCourseSettingsMutationVariables>;
export const GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesDocument = gql`
    query getAllExamCoursesWithAvailableQSetsAndExamCenterCourses {
  ecGetAllExamCoursesWithAvailableQSetsAndExamCenterCourses {
    examCoursesWithAvailableQSetsAndExamCenterCourses {
      examId
      code
      name
      settings {
        examDuration {
          type
          sessions {
            order
            value
          }
        }
      }
      availableQSets {
        id
        code
      }
      examCenterCourses {
        id
        examCenterCode
        examCourseId
        examCourseCode
        name
      }
    }
  }
}
    `;

/**
 * __useGetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery__
 *
 * To run a query within a React component, call `useGetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery, GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery, GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQueryVariables>(GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesDocument, options);
      }
export function useGetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery, GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery, GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQueryVariables>(GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesDocument, options);
        }
export function useGetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery, GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery, GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQueryVariables>(GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesDocument, options);
        }
export type GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQueryHookResult = ReturnType<typeof useGetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery>;
export type GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesLazyQueryHookResult = ReturnType<typeof useGetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesLazyQuery>;
export type GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesSuspenseQueryHookResult = ReturnType<typeof useGetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesSuspenseQuery>;
export type GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQueryResult = Apollo.QueryResult<GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQuery, GetAllExamCoursesWithAvailableQSetsAndExamCenterCoursesQueryVariables>;
export const GetAllEnabledExamCoursesDocument = gql`
    query getAllEnabledExamCourses {
  ecGetAllEnabledExamCourses {
    examCourses {
      id
      code
      examId
      name
      type
    }
  }
}
    `;

/**
 * __useGetAllEnabledExamCoursesQuery__
 *
 * To run a query within a React component, call `useGetAllEnabledExamCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEnabledExamCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEnabledExamCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEnabledExamCoursesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEnabledExamCoursesQuery, GetAllEnabledExamCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEnabledExamCoursesQuery, GetAllEnabledExamCoursesQueryVariables>(GetAllEnabledExamCoursesDocument, options);
      }
export function useGetAllEnabledExamCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEnabledExamCoursesQuery, GetAllEnabledExamCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEnabledExamCoursesQuery, GetAllEnabledExamCoursesQueryVariables>(GetAllEnabledExamCoursesDocument, options);
        }
export function useGetAllEnabledExamCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEnabledExamCoursesQuery, GetAllEnabledExamCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllEnabledExamCoursesQuery, GetAllEnabledExamCoursesQueryVariables>(GetAllEnabledExamCoursesDocument, options);
        }
export type GetAllEnabledExamCoursesQueryHookResult = ReturnType<typeof useGetAllEnabledExamCoursesQuery>;
export type GetAllEnabledExamCoursesLazyQueryHookResult = ReturnType<typeof useGetAllEnabledExamCoursesLazyQuery>;
export type GetAllEnabledExamCoursesSuspenseQueryHookResult = ReturnType<typeof useGetAllEnabledExamCoursesSuspenseQuery>;
export type GetAllEnabledExamCoursesQueryResult = Apollo.QueryResult<GetAllEnabledExamCoursesQuery, GetAllEnabledExamCoursesQueryVariables>;
export const GetUploadSignedUrlForExamCourseAttachDocumentDocument = gql`
    query getUploadSignedUrlForExamCourseAttachDocument($getUploadSignedUrlForExamCourseAttachDocumentInput: GetUploadSignedUrlForExamCourseAttachDocumentInput!) {
  ecGetUploadSignedUrlForExamCourseAttachDocument(
    getUploadSignedUrlForExamCourseAttachDocumentInput: $getUploadSignedUrlForExamCourseAttachDocumentInput
  ) {
    url
    storageObject {
      fileName
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlForExamCourseAttachDocumentQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlForExamCourseAttachDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlForExamCourseAttachDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlForExamCourseAttachDocumentQuery({
 *   variables: {
 *      getUploadSignedUrlForExamCourseAttachDocumentInput: // value for 'getUploadSignedUrlForExamCourseAttachDocumentInput'
 *   },
 * });
 */
export function useGetUploadSignedUrlForExamCourseAttachDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlForExamCourseAttachDocumentQuery, GetUploadSignedUrlForExamCourseAttachDocumentQueryVariables> & ({ variables: GetUploadSignedUrlForExamCourseAttachDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlForExamCourseAttachDocumentQuery, GetUploadSignedUrlForExamCourseAttachDocumentQueryVariables>(GetUploadSignedUrlForExamCourseAttachDocumentDocument, options);
      }
export function useGetUploadSignedUrlForExamCourseAttachDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlForExamCourseAttachDocumentQuery, GetUploadSignedUrlForExamCourseAttachDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlForExamCourseAttachDocumentQuery, GetUploadSignedUrlForExamCourseAttachDocumentQueryVariables>(GetUploadSignedUrlForExamCourseAttachDocumentDocument, options);
        }
export function useGetUploadSignedUrlForExamCourseAttachDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForExamCourseAttachDocumentQuery, GetUploadSignedUrlForExamCourseAttachDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlForExamCourseAttachDocumentQuery, GetUploadSignedUrlForExamCourseAttachDocumentQueryVariables>(GetUploadSignedUrlForExamCourseAttachDocumentDocument, options);
        }
export type GetUploadSignedUrlForExamCourseAttachDocumentQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForExamCourseAttachDocumentQuery>;
export type GetUploadSignedUrlForExamCourseAttachDocumentLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForExamCourseAttachDocumentLazyQuery>;
export type GetUploadSignedUrlForExamCourseAttachDocumentSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForExamCourseAttachDocumentSuspenseQuery>;
export type GetUploadSignedUrlForExamCourseAttachDocumentQueryResult = Apollo.QueryResult<GetUploadSignedUrlForExamCourseAttachDocumentQuery, GetUploadSignedUrlForExamCourseAttachDocumentQueryVariables>;
export const GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeDocument = gql`
    query getPreExamSettingsFromExamCourseSettingsByExamCourseCode($getExamCourseByExamCourseCodeInput: GetExamCourseByExamCourseCodeInput!) {
  ecGetExamCourseByExamCourseCode(
    getExamCourseByExamCourseCodeInput: $getExamCourseByExamCourseCodeInput
  ) {
    examCourse {
      settings {
        examDuration {
          type
          sessions {
            order
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery__
 *
 * To run a query within a React component, call `useGetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery({
 *   variables: {
 *      getExamCourseByExamCourseCodeInput: // value for 'getExamCourseByExamCourseCodeInput'
 *   },
 * });
 */
export function useGetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery(baseOptions: Apollo.QueryHookOptions<GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables> & ({ variables: GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables>(GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeDocument, options);
      }
export function useGetPreExamSettingsFromExamCourseSettingsByExamCourseCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables>(GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeDocument, options);
        }
export function useGetPreExamSettingsFromExamCourseSettingsByExamCourseCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables>(GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeDocument, options);
        }
export type GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQueryHookResult = ReturnType<typeof useGetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery>;
export type GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeLazyQueryHookResult = ReturnType<typeof useGetPreExamSettingsFromExamCourseSettingsByExamCourseCodeLazyQuery>;
export type GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeSuspenseQueryHookResult = ReturnType<typeof useGetPreExamSettingsFromExamCourseSettingsByExamCourseCodeSuspenseQuery>;
export type GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQueryResult = Apollo.QueryResult<GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetPreExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables>;
export const GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeDocument = gql`
    query getDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCode($getExamCourseByExamCourseCodeInput: GetExamCourseByExamCourseCodeInput!) {
  ecGetExamCourseByExamCourseCode(
    getExamCourseByExamCourseCodeInput: $getExamCourseByExamCourseCodeInput
  ) {
    examCourse {
      language
      type
      settings {
        resultSend {
          portal
        }
        resultDisplay {
          examResult
        }
        certificate {
          averageScoreCondition
          delayedDays
          failedTemplate
          passedTemplate
          validityDurationYears
        }
        questionnaire {
          templateId
        }
        attachDocument {
          fileName
          key
        }
      }
    }
  }
}
    `;

/**
 * __useGetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery__
 *
 * To run a query within a React component, call `useGetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery({
 *   variables: {
 *      getExamCourseByExamCourseCodeInput: // value for 'getExamCourseByExamCourseCodeInput'
 *   },
 * });
 */
export function useGetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery(baseOptions: Apollo.QueryHookOptions<GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables> & ({ variables: GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables>(GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeDocument, options);
      }
export function useGetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables>(GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeDocument, options);
        }
export function useGetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables>(GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeDocument, options);
        }
export type GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQueryHookResult = ReturnType<typeof useGetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery>;
export type GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeLazyQueryHookResult = ReturnType<typeof useGetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeLazyQuery>;
export type GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeSuspenseQueryHookResult = ReturnType<typeof useGetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeSuspenseQuery>;
export type GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQueryResult = Apollo.QueryResult<GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQuery, GetDuringAndPostExamSettingsFromExamCourseSettingsByExamCourseCodeQueryVariables>;
export const GetExamEventCoursesByExamEventIdsDocument = gql`
    query getExamEventCoursesByExamEventIds($input: GetExamEventCoursesByExamEventIdsInput!) {
  ecGetExamEventCoursesByExamEventIds(input: $input) {
    examEventCourses {
      id
      examEventId
      examCourseId
      qSet {
        id
        code
      }
      examCourse {
        id
        code
        examId
        name
      }
      status
    }
  }
}
    `;

/**
 * __useGetExamEventCoursesByExamEventIdsQuery__
 *
 * To run a query within a React component, call `useGetExamEventCoursesByExamEventIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamEventCoursesByExamEventIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamEventCoursesByExamEventIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetExamEventCoursesByExamEventIdsQuery(baseOptions: Apollo.QueryHookOptions<GetExamEventCoursesByExamEventIdsQuery, GetExamEventCoursesByExamEventIdsQueryVariables> & ({ variables: GetExamEventCoursesByExamEventIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamEventCoursesByExamEventIdsQuery, GetExamEventCoursesByExamEventIdsQueryVariables>(GetExamEventCoursesByExamEventIdsDocument, options);
      }
export function useGetExamEventCoursesByExamEventIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamEventCoursesByExamEventIdsQuery, GetExamEventCoursesByExamEventIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamEventCoursesByExamEventIdsQuery, GetExamEventCoursesByExamEventIdsQueryVariables>(GetExamEventCoursesByExamEventIdsDocument, options);
        }
export function useGetExamEventCoursesByExamEventIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamEventCoursesByExamEventIdsQuery, GetExamEventCoursesByExamEventIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamEventCoursesByExamEventIdsQuery, GetExamEventCoursesByExamEventIdsQueryVariables>(GetExamEventCoursesByExamEventIdsDocument, options);
        }
export type GetExamEventCoursesByExamEventIdsQueryHookResult = ReturnType<typeof useGetExamEventCoursesByExamEventIdsQuery>;
export type GetExamEventCoursesByExamEventIdsLazyQueryHookResult = ReturnType<typeof useGetExamEventCoursesByExamEventIdsLazyQuery>;
export type GetExamEventCoursesByExamEventIdsSuspenseQueryHookResult = ReturnType<typeof useGetExamEventCoursesByExamEventIdsSuspenseQuery>;
export type GetExamEventCoursesByExamEventIdsQueryResult = Apollo.QueryResult<GetExamEventCoursesByExamEventIdsQuery, GetExamEventCoursesByExamEventIdsQueryVariables>;
export const GetExamCoursesByExamEventIdDocument = gql`
    query getExamCoursesByExamEventId($input: GetExamCoursesByExamEventIdInput!) {
  ecGetExamCoursesByExamEventId(input: $input) {
    examCourses {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useGetExamCoursesByExamEventIdQuery__
 *
 * To run a query within a React component, call `useGetExamCoursesByExamEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCoursesByExamEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCoursesByExamEventIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetExamCoursesByExamEventIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamCoursesByExamEventIdQuery, GetExamCoursesByExamEventIdQueryVariables> & ({ variables: GetExamCoursesByExamEventIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCoursesByExamEventIdQuery, GetExamCoursesByExamEventIdQueryVariables>(GetExamCoursesByExamEventIdDocument, options);
      }
export function useGetExamCoursesByExamEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCoursesByExamEventIdQuery, GetExamCoursesByExamEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCoursesByExamEventIdQuery, GetExamCoursesByExamEventIdQueryVariables>(GetExamCoursesByExamEventIdDocument, options);
        }
export function useGetExamCoursesByExamEventIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCoursesByExamEventIdQuery, GetExamCoursesByExamEventIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCoursesByExamEventIdQuery, GetExamCoursesByExamEventIdQueryVariables>(GetExamCoursesByExamEventIdDocument, options);
        }
export type GetExamCoursesByExamEventIdQueryHookResult = ReturnType<typeof useGetExamCoursesByExamEventIdQuery>;
export type GetExamCoursesByExamEventIdLazyQueryHookResult = ReturnType<typeof useGetExamCoursesByExamEventIdLazyQuery>;
export type GetExamCoursesByExamEventIdSuspenseQueryHookResult = ReturnType<typeof useGetExamCoursesByExamEventIdSuspenseQuery>;
export type GetExamCoursesByExamEventIdQueryResult = Apollo.QueryResult<GetExamCoursesByExamEventIdQuery, GetExamCoursesByExamEventIdQueryVariables>;
export const GetExamEventParticipatedCoursesDocument = gql`
    query getExamEventParticipatedCourses($input: GetExamEventParticipatedCoursesInput!) {
  ecGetExamEventParticipatedCourses(input: $input) {
    examEventCourses {
      id
      examEventId
      examCourseId
      status
      metadata {
        sessionTimeAdjustments {
          sessionId
          extendDurationInMs
          maxExtendableDurationInMs
        }
        settings {
          examDuration {
            type
            sessions {
              order
              value
            }
          }
        }
      }
      examCourse {
        id
        code
        name
      }
    }
  }
}
    `;

/**
 * __useGetExamEventParticipatedCoursesQuery__
 *
 * To run a query within a React component, call `useGetExamEventParticipatedCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamEventParticipatedCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamEventParticipatedCoursesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetExamEventParticipatedCoursesQuery(baseOptions: Apollo.QueryHookOptions<GetExamEventParticipatedCoursesQuery, GetExamEventParticipatedCoursesQueryVariables> & ({ variables: GetExamEventParticipatedCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamEventParticipatedCoursesQuery, GetExamEventParticipatedCoursesQueryVariables>(GetExamEventParticipatedCoursesDocument, options);
      }
export function useGetExamEventParticipatedCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamEventParticipatedCoursesQuery, GetExamEventParticipatedCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamEventParticipatedCoursesQuery, GetExamEventParticipatedCoursesQueryVariables>(GetExamEventParticipatedCoursesDocument, options);
        }
export function useGetExamEventParticipatedCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamEventParticipatedCoursesQuery, GetExamEventParticipatedCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamEventParticipatedCoursesQuery, GetExamEventParticipatedCoursesQueryVariables>(GetExamEventParticipatedCoursesDocument, options);
        }
export type GetExamEventParticipatedCoursesQueryHookResult = ReturnType<typeof useGetExamEventParticipatedCoursesQuery>;
export type GetExamEventParticipatedCoursesLazyQueryHookResult = ReturnType<typeof useGetExamEventParticipatedCoursesLazyQuery>;
export type GetExamEventParticipatedCoursesSuspenseQueryHookResult = ReturnType<typeof useGetExamEventParticipatedCoursesSuspenseQuery>;
export type GetExamEventParticipatedCoursesQueryResult = Apollo.QueryResult<GetExamEventParticipatedCoursesQuery, GetExamEventParticipatedCoursesQueryVariables>;
export const ManuallyAssignedExamEventCoursesDocument = gql`
    mutation manuallyAssignedExamEventCourses($input: ManuallyAssignedExamEventCoursesInput!) {
  ecManuallyAssignedExamEventCourses(input: $input) {
    examEventCourses {
      id
      examEventId
      examCourseId
      qSetId
      examId
      status
    }
  }
}
    `;
export type ManuallyAssignedExamEventCoursesMutationFn = Apollo.MutationFunction<ManuallyAssignedExamEventCoursesMutation, ManuallyAssignedExamEventCoursesMutationVariables>;

/**
 * __useManuallyAssignedExamEventCoursesMutation__
 *
 * To run a mutation, you first call `useManuallyAssignedExamEventCoursesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManuallyAssignedExamEventCoursesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manuallyAssignedExamEventCoursesMutation, { data, loading, error }] = useManuallyAssignedExamEventCoursesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManuallyAssignedExamEventCoursesMutation(baseOptions?: Apollo.MutationHookOptions<ManuallyAssignedExamEventCoursesMutation, ManuallyAssignedExamEventCoursesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManuallyAssignedExamEventCoursesMutation, ManuallyAssignedExamEventCoursesMutationVariables>(ManuallyAssignedExamEventCoursesDocument, options);
      }
export type ManuallyAssignedExamEventCoursesMutationHookResult = ReturnType<typeof useManuallyAssignedExamEventCoursesMutation>;
export type ManuallyAssignedExamEventCoursesMutationResult = Apollo.MutationResult<ManuallyAssignedExamEventCoursesMutation>;
export type ManuallyAssignedExamEventCoursesMutationOptions = Apollo.BaseMutationOptions<ManuallyAssignedExamEventCoursesMutation, ManuallyAssignedExamEventCoursesMutationVariables>;
export const GetAvailableQSetsByExamEventIdDocument = gql`
    query getAvailableQSetsByExamEventId($input: GetAvailableQSetsByExamEventIdInput!) {
  ecGetAvailableQSetsByExamEventId(input: $input) {
    examEventCoursesWithAssignableQSets {
      examEventCourse {
        id
        status
        examCourse {
          id
          code
          examId
          settings {
            examDuration {
              type
              sessions {
                order
                value
              }
            }
          }
        }
        qSet {
          id
          code
        }
      }
      availableQSets {
        id
        code
      }
    }
    examEvent {
      id
      name
      examCenterCode
      sessions {
        id
        round
        startedAt
        endedAt
      }
      examLocation {
        province {
          nameTh
        }
        nameTh
        nameEn
      }
      examStartedAt
      examEndedAt
      roundNumber
      registrationType
    }
  }
}
    `;

/**
 * __useGetAvailableQSetsByExamEventIdQuery__
 *
 * To run a query within a React component, call `useGetAvailableQSetsByExamEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableQSetsByExamEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableQSetsByExamEventIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAvailableQSetsByExamEventIdQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableQSetsByExamEventIdQuery, GetAvailableQSetsByExamEventIdQueryVariables> & ({ variables: GetAvailableQSetsByExamEventIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableQSetsByExamEventIdQuery, GetAvailableQSetsByExamEventIdQueryVariables>(GetAvailableQSetsByExamEventIdDocument, options);
      }
export function useGetAvailableQSetsByExamEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableQSetsByExamEventIdQuery, GetAvailableQSetsByExamEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableQSetsByExamEventIdQuery, GetAvailableQSetsByExamEventIdQueryVariables>(GetAvailableQSetsByExamEventIdDocument, options);
        }
export function useGetAvailableQSetsByExamEventIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableQSetsByExamEventIdQuery, GetAvailableQSetsByExamEventIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableQSetsByExamEventIdQuery, GetAvailableQSetsByExamEventIdQueryVariables>(GetAvailableQSetsByExamEventIdDocument, options);
        }
export type GetAvailableQSetsByExamEventIdQueryHookResult = ReturnType<typeof useGetAvailableQSetsByExamEventIdQuery>;
export type GetAvailableQSetsByExamEventIdLazyQueryHookResult = ReturnType<typeof useGetAvailableQSetsByExamEventIdLazyQuery>;
export type GetAvailableQSetsByExamEventIdSuspenseQueryHookResult = ReturnType<typeof useGetAvailableQSetsByExamEventIdSuspenseQuery>;
export type GetAvailableQSetsByExamEventIdQueryResult = Apollo.QueryResult<GetAvailableQSetsByExamEventIdQuery, GetAvailableQSetsByExamEventIdQueryVariables>;
export const GetAllProvincesDocument = gql`
    query getAllProvinces {
  ecGetAllProvinces {
    provinces {
      nameTh
      id
    }
  }
}
    `;

/**
 * __useGetAllProvincesQuery__
 *
 * To run a query within a React component, call `useGetAllProvincesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProvincesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProvincesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProvincesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProvincesQuery, GetAllProvincesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProvincesQuery, GetAllProvincesQueryVariables>(GetAllProvincesDocument, options);
      }
export function useGetAllProvincesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProvincesQuery, GetAllProvincesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProvincesQuery, GetAllProvincesQueryVariables>(GetAllProvincesDocument, options);
        }
export function useGetAllProvincesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProvincesQuery, GetAllProvincesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProvincesQuery, GetAllProvincesQueryVariables>(GetAllProvincesDocument, options);
        }
export type GetAllProvincesQueryHookResult = ReturnType<typeof useGetAllProvincesQuery>;
export type GetAllProvincesLazyQueryHookResult = ReturnType<typeof useGetAllProvincesLazyQuery>;
export type GetAllProvincesSuspenseQueryHookResult = ReturnType<typeof useGetAllProvincesSuspenseQuery>;
export type GetAllProvincesQueryResult = Apollo.QueryResult<GetAllProvincesQuery, GetAllProvincesQueryVariables>;
export const GetLocationsByProvinceIdDocument = gql`
    query getLocationsByProvinceId($getLocationsByProvinceIdInput: GetLocationsByProvinceIdInput!) {
  ecGetLocationsByProvinceId(
    GetLocationsByProvinceIdInput: $getLocationsByProvinceIdInput
  ) {
    locations {
      id
      nameTh
      nameEn
      provinceId
    }
  }
}
    `;

/**
 * __useGetLocationsByProvinceIdQuery__
 *
 * To run a query within a React component, call `useGetLocationsByProvinceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsByProvinceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsByProvinceIdQuery({
 *   variables: {
 *      getLocationsByProvinceIdInput: // value for 'getLocationsByProvinceIdInput'
 *   },
 * });
 */
export function useGetLocationsByProvinceIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocationsByProvinceIdQuery, GetLocationsByProvinceIdQueryVariables> & ({ variables: GetLocationsByProvinceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsByProvinceIdQuery, GetLocationsByProvinceIdQueryVariables>(GetLocationsByProvinceIdDocument, options);
      }
export function useGetLocationsByProvinceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsByProvinceIdQuery, GetLocationsByProvinceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsByProvinceIdQuery, GetLocationsByProvinceIdQueryVariables>(GetLocationsByProvinceIdDocument, options);
        }
export function useGetLocationsByProvinceIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationsByProvinceIdQuery, GetLocationsByProvinceIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationsByProvinceIdQuery, GetLocationsByProvinceIdQueryVariables>(GetLocationsByProvinceIdDocument, options);
        }
export type GetLocationsByProvinceIdQueryHookResult = ReturnType<typeof useGetLocationsByProvinceIdQuery>;
export type GetLocationsByProvinceIdLazyQueryHookResult = ReturnType<typeof useGetLocationsByProvinceIdLazyQuery>;
export type GetLocationsByProvinceIdSuspenseQueryHookResult = ReturnType<typeof useGetLocationsByProvinceIdSuspenseQuery>;
export type GetLocationsByProvinceIdQueryResult = Apollo.QueryResult<GetLocationsByProvinceIdQuery, GetLocationsByProvinceIdQueryVariables>;
export const GetAvailableRoomsByLocationIdAndTimeFrameDocument = gql`
    query getAvailableRoomsByLocationIdAndTimeFrame($getAvailableRoomsByLocationIdAndTimeFrameInput: GetAvailableRoomsByLocationIdAndTimeFrameInput!) {
  ecGetAvailableRoomsByLocationIdAndTimeFrame(
    GetAvailableRoomsByLocationIdAndTimeFrameInput: $getAvailableRoomsByLocationIdAndTimeFrameInput
  ) {
    rooms {
      id
      name
      buildingId
      building {
        id
        nameTh
      }
      floor
      roomNumber
      seat
    }
  }
}
    `;

/**
 * __useGetAvailableRoomsByLocationIdAndTimeFrameQuery__
 *
 * To run a query within a React component, call `useGetAvailableRoomsByLocationIdAndTimeFrameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableRoomsByLocationIdAndTimeFrameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableRoomsByLocationIdAndTimeFrameQuery({
 *   variables: {
 *      getAvailableRoomsByLocationIdAndTimeFrameInput: // value for 'getAvailableRoomsByLocationIdAndTimeFrameInput'
 *   },
 * });
 */
export function useGetAvailableRoomsByLocationIdAndTimeFrameQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableRoomsByLocationIdAndTimeFrameQuery, GetAvailableRoomsByLocationIdAndTimeFrameQueryVariables> & ({ variables: GetAvailableRoomsByLocationIdAndTimeFrameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableRoomsByLocationIdAndTimeFrameQuery, GetAvailableRoomsByLocationIdAndTimeFrameQueryVariables>(GetAvailableRoomsByLocationIdAndTimeFrameDocument, options);
      }
export function useGetAvailableRoomsByLocationIdAndTimeFrameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableRoomsByLocationIdAndTimeFrameQuery, GetAvailableRoomsByLocationIdAndTimeFrameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableRoomsByLocationIdAndTimeFrameQuery, GetAvailableRoomsByLocationIdAndTimeFrameQueryVariables>(GetAvailableRoomsByLocationIdAndTimeFrameDocument, options);
        }
export function useGetAvailableRoomsByLocationIdAndTimeFrameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableRoomsByLocationIdAndTimeFrameQuery, GetAvailableRoomsByLocationIdAndTimeFrameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableRoomsByLocationIdAndTimeFrameQuery, GetAvailableRoomsByLocationIdAndTimeFrameQueryVariables>(GetAvailableRoomsByLocationIdAndTimeFrameDocument, options);
        }
export type GetAvailableRoomsByLocationIdAndTimeFrameQueryHookResult = ReturnType<typeof useGetAvailableRoomsByLocationIdAndTimeFrameQuery>;
export type GetAvailableRoomsByLocationIdAndTimeFrameLazyQueryHookResult = ReturnType<typeof useGetAvailableRoomsByLocationIdAndTimeFrameLazyQuery>;
export type GetAvailableRoomsByLocationIdAndTimeFrameSuspenseQueryHookResult = ReturnType<typeof useGetAvailableRoomsByLocationIdAndTimeFrameSuspenseQuery>;
export type GetAvailableRoomsByLocationIdAndTimeFrameQueryResult = Apollo.QueryResult<GetAvailableRoomsByLocationIdAndTimeFrameQuery, GetAvailableRoomsByLocationIdAndTimeFrameQueryVariables>;
export const SearchAvailableExamCenterProctorsByTimeFrameDocument = gql`
    query searchAvailableExamCenterProctorsByTimeFrame($searchAvailableExamCenterProctorsByTimeFrameInput: SearchAvailableExamCenterProctorsByTimeFrameInput!) {
  ecSearchAvailableExamCenterProctorsByTimeFrame(
    SearchAvailableExamCenterProctorsByTimeFrameInput: $searchAvailableExamCenterProctorsByTimeFrameInput
  ) {
    examCenterProctors {
      id
      examCenterCode
      type
      titleTh
      firstNameTh
      middleNameTh
      lastNameTh
    }
    total
  }
}
    `;

/**
 * __useSearchAvailableExamCenterProctorsByTimeFrameQuery__
 *
 * To run a query within a React component, call `useSearchAvailableExamCenterProctorsByTimeFrameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAvailableExamCenterProctorsByTimeFrameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAvailableExamCenterProctorsByTimeFrameQuery({
 *   variables: {
 *      searchAvailableExamCenterProctorsByTimeFrameInput: // value for 'searchAvailableExamCenterProctorsByTimeFrameInput'
 *   },
 * });
 */
export function useSearchAvailableExamCenterProctorsByTimeFrameQuery(baseOptions: Apollo.QueryHookOptions<SearchAvailableExamCenterProctorsByTimeFrameQuery, SearchAvailableExamCenterProctorsByTimeFrameQueryVariables> & ({ variables: SearchAvailableExamCenterProctorsByTimeFrameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAvailableExamCenterProctorsByTimeFrameQuery, SearchAvailableExamCenterProctorsByTimeFrameQueryVariables>(SearchAvailableExamCenterProctorsByTimeFrameDocument, options);
      }
export function useSearchAvailableExamCenterProctorsByTimeFrameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAvailableExamCenterProctorsByTimeFrameQuery, SearchAvailableExamCenterProctorsByTimeFrameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAvailableExamCenterProctorsByTimeFrameQuery, SearchAvailableExamCenterProctorsByTimeFrameQueryVariables>(SearchAvailableExamCenterProctorsByTimeFrameDocument, options);
        }
export function useSearchAvailableExamCenterProctorsByTimeFrameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAvailableExamCenterProctorsByTimeFrameQuery, SearchAvailableExamCenterProctorsByTimeFrameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAvailableExamCenterProctorsByTimeFrameQuery, SearchAvailableExamCenterProctorsByTimeFrameQueryVariables>(SearchAvailableExamCenterProctorsByTimeFrameDocument, options);
        }
export type SearchAvailableExamCenterProctorsByTimeFrameQueryHookResult = ReturnType<typeof useSearchAvailableExamCenterProctorsByTimeFrameQuery>;
export type SearchAvailableExamCenterProctorsByTimeFrameLazyQueryHookResult = ReturnType<typeof useSearchAvailableExamCenterProctorsByTimeFrameLazyQuery>;
export type SearchAvailableExamCenterProctorsByTimeFrameSuspenseQueryHookResult = ReturnType<typeof useSearchAvailableExamCenterProctorsByTimeFrameSuspenseQuery>;
export type SearchAvailableExamCenterProctorsByTimeFrameQueryResult = Apollo.QueryResult<SearchAvailableExamCenterProctorsByTimeFrameQuery, SearchAvailableExamCenterProctorsByTimeFrameQueryVariables>;
export const CreateExamEventDocument = gql`
    mutation createExamEvent($createExamEventInput: CreateExamEventInput!) {
  ecCreateExamEvent(CreateExamEventInput: $createExamEventInput) {
    examEvent {
      id
    }
  }
}
    `;
export type CreateExamEventMutationFn = Apollo.MutationFunction<CreateExamEventMutation, CreateExamEventMutationVariables>;

/**
 * __useCreateExamEventMutation__
 *
 * To run a mutation, you first call `useCreateExamEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExamEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExamEventMutation, { data, loading, error }] = useCreateExamEventMutation({
 *   variables: {
 *      createExamEventInput: // value for 'createExamEventInput'
 *   },
 * });
 */
export function useCreateExamEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateExamEventMutation, CreateExamEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExamEventMutation, CreateExamEventMutationVariables>(CreateExamEventDocument, options);
      }
export type CreateExamEventMutationHookResult = ReturnType<typeof useCreateExamEventMutation>;
export type CreateExamEventMutationResult = Apollo.MutationResult<CreateExamEventMutation>;
export type CreateExamEventMutationOptions = Apollo.BaseMutationOptions<CreateExamEventMutation, CreateExamEventMutationVariables>;
export const GetExamEventByIdDocument = gql`
    query getExamEventById($getExamEventByIdInput: GetExamEventByIdInput!) {
  ecGetExamEventById(GetExamEventByIdInput: $getExamEventByIdInput) {
    examEvent {
      ...ExamEventDetails
      examCenterCode
      courses {
        id
        status
        metadata {
          settings {
            examDuration {
              type
              sessions {
                order
                value
              }
            }
          }
          sessionTimeAdjustments {
            sessionId
            maxExtendableDurationInMs
          }
        }
        examCourse {
          id
          name
          code
        }
      }
    }
  }
}
    ${ExamEventDetailsFragmentDoc}`;

/**
 * __useGetExamEventByIdQuery__
 *
 * To run a query within a React component, call `useGetExamEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamEventByIdQuery({
 *   variables: {
 *      getExamEventByIdInput: // value for 'getExamEventByIdInput'
 *   },
 * });
 */
export function useGetExamEventByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamEventByIdQuery, GetExamEventByIdQueryVariables> & ({ variables: GetExamEventByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamEventByIdQuery, GetExamEventByIdQueryVariables>(GetExamEventByIdDocument, options);
      }
export function useGetExamEventByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamEventByIdQuery, GetExamEventByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamEventByIdQuery, GetExamEventByIdQueryVariables>(GetExamEventByIdDocument, options);
        }
export function useGetExamEventByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamEventByIdQuery, GetExamEventByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamEventByIdQuery, GetExamEventByIdQueryVariables>(GetExamEventByIdDocument, options);
        }
export type GetExamEventByIdQueryHookResult = ReturnType<typeof useGetExamEventByIdQuery>;
export type GetExamEventByIdLazyQueryHookResult = ReturnType<typeof useGetExamEventByIdLazyQuery>;
export type GetExamEventByIdSuspenseQueryHookResult = ReturnType<typeof useGetExamEventByIdSuspenseQuery>;
export type GetExamEventByIdQueryResult = Apollo.QueryResult<GetExamEventByIdQuery, GetExamEventByIdQueryVariables>;
export const GetIctExamEventYearsByExamCenterCodeDocument = gql`
    query getICTExamEventYearsByExamCenterCode($getICTExamEventYearsByExamCenterCodeInput: GetICTExamEventYearsByExamCenterCodeInput!) {
  ecGetICTExamEventYearsByExamCenterCode(
    getICTExamEventYearsByExamCenterCodeInput: $getICTExamEventYearsByExamCenterCodeInput
  ) {
    ictExamYears
  }
}
    `;

/**
 * __useGetIctExamEventYearsByExamCenterCodeQuery__
 *
 * To run a query within a React component, call `useGetIctExamEventYearsByExamCenterCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIctExamEventYearsByExamCenterCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIctExamEventYearsByExamCenterCodeQuery({
 *   variables: {
 *      getICTExamEventYearsByExamCenterCodeInput: // value for 'getICTExamEventYearsByExamCenterCodeInput'
 *   },
 * });
 */
export function useGetIctExamEventYearsByExamCenterCodeQuery(baseOptions: Apollo.QueryHookOptions<GetIctExamEventYearsByExamCenterCodeQuery, GetIctExamEventYearsByExamCenterCodeQueryVariables> & ({ variables: GetIctExamEventYearsByExamCenterCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIctExamEventYearsByExamCenterCodeQuery, GetIctExamEventYearsByExamCenterCodeQueryVariables>(GetIctExamEventYearsByExamCenterCodeDocument, options);
      }
export function useGetIctExamEventYearsByExamCenterCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIctExamEventYearsByExamCenterCodeQuery, GetIctExamEventYearsByExamCenterCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIctExamEventYearsByExamCenterCodeQuery, GetIctExamEventYearsByExamCenterCodeQueryVariables>(GetIctExamEventYearsByExamCenterCodeDocument, options);
        }
export function useGetIctExamEventYearsByExamCenterCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIctExamEventYearsByExamCenterCodeQuery, GetIctExamEventYearsByExamCenterCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIctExamEventYearsByExamCenterCodeQuery, GetIctExamEventYearsByExamCenterCodeQueryVariables>(GetIctExamEventYearsByExamCenterCodeDocument, options);
        }
export type GetIctExamEventYearsByExamCenterCodeQueryHookResult = ReturnType<typeof useGetIctExamEventYearsByExamCenterCodeQuery>;
export type GetIctExamEventYearsByExamCenterCodeLazyQueryHookResult = ReturnType<typeof useGetIctExamEventYearsByExamCenterCodeLazyQuery>;
export type GetIctExamEventYearsByExamCenterCodeSuspenseQueryHookResult = ReturnType<typeof useGetIctExamEventYearsByExamCenterCodeSuspenseQuery>;
export type GetIctExamEventYearsByExamCenterCodeQueryResult = Apollo.QueryResult<GetIctExamEventYearsByExamCenterCodeQuery, GetIctExamEventYearsByExamCenterCodeQueryVariables>;
export const GetMonthlyExamEventOverviewDocument = gql`
    query getMonthlyExamEventOverview($getMonthlyExamEventOverviewInput: GetMonthlyExamEventOverviewInput!) {
  ecGetMonthlyExamEventOverview(
    getMonthlyExamEventOverviewInput: $getMonthlyExamEventOverviewInput
  ) {
    overview {
      month
      courses
      events
    }
  }
}
    `;

/**
 * __useGetMonthlyExamEventOverviewQuery__
 *
 * To run a query within a React component, call `useGetMonthlyExamEventOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonthlyExamEventOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonthlyExamEventOverviewQuery({
 *   variables: {
 *      getMonthlyExamEventOverviewInput: // value for 'getMonthlyExamEventOverviewInput'
 *   },
 * });
 */
export function useGetMonthlyExamEventOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetMonthlyExamEventOverviewQuery, GetMonthlyExamEventOverviewQueryVariables> & ({ variables: GetMonthlyExamEventOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonthlyExamEventOverviewQuery, GetMonthlyExamEventOverviewQueryVariables>(GetMonthlyExamEventOverviewDocument, options);
      }
export function useGetMonthlyExamEventOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonthlyExamEventOverviewQuery, GetMonthlyExamEventOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonthlyExamEventOverviewQuery, GetMonthlyExamEventOverviewQueryVariables>(GetMonthlyExamEventOverviewDocument, options);
        }
export function useGetMonthlyExamEventOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMonthlyExamEventOverviewQuery, GetMonthlyExamEventOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMonthlyExamEventOverviewQuery, GetMonthlyExamEventOverviewQueryVariables>(GetMonthlyExamEventOverviewDocument, options);
        }
export type GetMonthlyExamEventOverviewQueryHookResult = ReturnType<typeof useGetMonthlyExamEventOverviewQuery>;
export type GetMonthlyExamEventOverviewLazyQueryHookResult = ReturnType<typeof useGetMonthlyExamEventOverviewLazyQuery>;
export type GetMonthlyExamEventOverviewSuspenseQueryHookResult = ReturnType<typeof useGetMonthlyExamEventOverviewSuspenseQuery>;
export type GetMonthlyExamEventOverviewQueryResult = Apollo.QueryResult<GetMonthlyExamEventOverviewQuery, GetMonthlyExamEventOverviewQueryVariables>;
export const GetAllExamEventsByExamCenterCodeDocument = gql`
    query getAllExamEventsByExamCenterCode($getAllExamEventsByExamCenterCodeInput: GetAllExamEventsByExamCenterCodeInput!) {
  ecGetAllExamEventsByExamCenterCode(
    GetAllExamEventsByExamCenterCodeInput: $getAllExamEventsByExamCenterCodeInput
  ) {
    examEvents {
      id
      registrationType
      registrationStatus
      status
      seat
      roundNumber
      examStartedAt
      examEndedAt
      ictExamYear
      registrationStartedAt
      registrationEndedAt
      metadata
      createdAt
      numberOfExaminees
      examLocation {
        id
        nameTh
        provinceId
        province {
          id
          nameTh
        }
      }
      name
      examCenterCode
    }
    total
  }
}
    `;

/**
 * __useGetAllExamEventsByExamCenterCodeQuery__
 *
 * To run a query within a React component, call `useGetAllExamEventsByExamCenterCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllExamEventsByExamCenterCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllExamEventsByExamCenterCodeQuery({
 *   variables: {
 *      getAllExamEventsByExamCenterCodeInput: // value for 'getAllExamEventsByExamCenterCodeInput'
 *   },
 * });
 */
export function useGetAllExamEventsByExamCenterCodeQuery(baseOptions: Apollo.QueryHookOptions<GetAllExamEventsByExamCenterCodeQuery, GetAllExamEventsByExamCenterCodeQueryVariables> & ({ variables: GetAllExamEventsByExamCenterCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllExamEventsByExamCenterCodeQuery, GetAllExamEventsByExamCenterCodeQueryVariables>(GetAllExamEventsByExamCenterCodeDocument, options);
      }
export function useGetAllExamEventsByExamCenterCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllExamEventsByExamCenterCodeQuery, GetAllExamEventsByExamCenterCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllExamEventsByExamCenterCodeQuery, GetAllExamEventsByExamCenterCodeQueryVariables>(GetAllExamEventsByExamCenterCodeDocument, options);
        }
export function useGetAllExamEventsByExamCenterCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllExamEventsByExamCenterCodeQuery, GetAllExamEventsByExamCenterCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllExamEventsByExamCenterCodeQuery, GetAllExamEventsByExamCenterCodeQueryVariables>(GetAllExamEventsByExamCenterCodeDocument, options);
        }
export type GetAllExamEventsByExamCenterCodeQueryHookResult = ReturnType<typeof useGetAllExamEventsByExamCenterCodeQuery>;
export type GetAllExamEventsByExamCenterCodeLazyQueryHookResult = ReturnType<typeof useGetAllExamEventsByExamCenterCodeLazyQuery>;
export type GetAllExamEventsByExamCenterCodeSuspenseQueryHookResult = ReturnType<typeof useGetAllExamEventsByExamCenterCodeSuspenseQuery>;
export type GetAllExamEventsByExamCenterCodeQueryResult = Apollo.QueryResult<GetAllExamEventsByExamCenterCodeQuery, GetAllExamEventsByExamCenterCodeQueryVariables>;
export const UpdateExamEventDocument = gql`
    mutation updateExamEvent($updateExamEventInput: UpdateExamEventInput!) {
  ecUpdateExamEvent(UpdateExamEventInput: $updateExamEventInput) {
    examEvent {
      ...ExamEventDetails
    }
  }
}
    ${ExamEventDetailsFragmentDoc}`;
export type UpdateExamEventMutationFn = Apollo.MutationFunction<UpdateExamEventMutation, UpdateExamEventMutationVariables>;

/**
 * __useUpdateExamEventMutation__
 *
 * To run a mutation, you first call `useUpdateExamEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamEventMutation, { data, loading, error }] = useUpdateExamEventMutation({
 *   variables: {
 *      updateExamEventInput: // value for 'updateExamEventInput'
 *   },
 * });
 */
export function useUpdateExamEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExamEventMutation, UpdateExamEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExamEventMutation, UpdateExamEventMutationVariables>(UpdateExamEventDocument, options);
      }
export type UpdateExamEventMutationHookResult = ReturnType<typeof useUpdateExamEventMutation>;
export type UpdateExamEventMutationResult = Apollo.MutationResult<UpdateExamEventMutation>;
export type UpdateExamEventMutationOptions = Apollo.BaseMutationOptions<UpdateExamEventMutation, UpdateExamEventMutationVariables>;
export const UnassignExamsDocument = gql`
    mutation unassignExams($unassignExamsInput: UnassignExamsInput!) {
  ecUnassignExams(UnassignExamsInput: $unassignExamsInput) {
    message
    status
  }
}
    `;
export type UnassignExamsMutationFn = Apollo.MutationFunction<UnassignExamsMutation, UnassignExamsMutationVariables>;

/**
 * __useUnassignExamsMutation__
 *
 * To run a mutation, you first call `useUnassignExamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignExamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignExamsMutation, { data, loading, error }] = useUnassignExamsMutation({
 *   variables: {
 *      unassignExamsInput: // value for 'unassignExamsInput'
 *   },
 * });
 */
export function useUnassignExamsMutation(baseOptions?: Apollo.MutationHookOptions<UnassignExamsMutation, UnassignExamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignExamsMutation, UnassignExamsMutationVariables>(UnassignExamsDocument, options);
      }
export type UnassignExamsMutationHookResult = ReturnType<typeof useUnassignExamsMutation>;
export type UnassignExamsMutationResult = Apollo.MutationResult<UnassignExamsMutation>;
export type UnassignExamsMutationOptions = Apollo.BaseMutationOptions<UnassignExamsMutation, UnassignExamsMutationVariables>;
export const AssignExamsByExamCourseCodesAndMonthOfYearDocument = gql`
    mutation assignExamsByExamCourseCodesAndMonthOfYear($assignExamsByExamCourseCodesAndMonthOfYearInput: AssignExamsByExamCourseCodesAndMonthOfYearInput!) {
  ecAssignExamsByExamCourseCodesAndMonthOfYear(
    input: $assignExamsByExamCourseCodesAndMonthOfYearInput
  ) {
    examCoursesChosen
    examEventsAssigned
  }
}
    `;
export type AssignExamsByExamCourseCodesAndMonthOfYearMutationFn = Apollo.MutationFunction<AssignExamsByExamCourseCodesAndMonthOfYearMutation, AssignExamsByExamCourseCodesAndMonthOfYearMutationVariables>;

/**
 * __useAssignExamsByExamCourseCodesAndMonthOfYearMutation__
 *
 * To run a mutation, you first call `useAssignExamsByExamCourseCodesAndMonthOfYearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignExamsByExamCourseCodesAndMonthOfYearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignExamsByExamCourseCodesAndMonthOfYearMutation, { data, loading, error }] = useAssignExamsByExamCourseCodesAndMonthOfYearMutation({
 *   variables: {
 *      assignExamsByExamCourseCodesAndMonthOfYearInput: // value for 'assignExamsByExamCourseCodesAndMonthOfYearInput'
 *   },
 * });
 */
export function useAssignExamsByExamCourseCodesAndMonthOfYearMutation(baseOptions?: Apollo.MutationHookOptions<AssignExamsByExamCourseCodesAndMonthOfYearMutation, AssignExamsByExamCourseCodesAndMonthOfYearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignExamsByExamCourseCodesAndMonthOfYearMutation, AssignExamsByExamCourseCodesAndMonthOfYearMutationVariables>(AssignExamsByExamCourseCodesAndMonthOfYearDocument, options);
      }
export type AssignExamsByExamCourseCodesAndMonthOfYearMutationHookResult = ReturnType<typeof useAssignExamsByExamCourseCodesAndMonthOfYearMutation>;
export type AssignExamsByExamCourseCodesAndMonthOfYearMutationResult = Apollo.MutationResult<AssignExamsByExamCourseCodesAndMonthOfYearMutation>;
export type AssignExamsByExamCourseCodesAndMonthOfYearMutationOptions = Apollo.BaseMutationOptions<AssignExamsByExamCourseCodesAndMonthOfYearMutation, AssignExamsByExamCourseCodesAndMonthOfYearMutationVariables>;
export const GetMyProctorExamEventsDocument = gql`
    query getMyProctorExamEvents($getMyProctorExamEventsInput: GetMyProctorExamEventsInput!) {
  ecGetMyProctorExamEvents(
    GetMyProctorExamEventsInput: $getMyProctorExamEventsInput
  ) {
    examEvents {
      id
      registrationType
      registrationStatus
      status
      seat
      roundNumber
      examStartedAt
      examEndedAt
      ictExamYear
      registrationStartedAt
      registrationEndedAt
      metadata
      createdAt
      numberOfExaminees
      examLocation {
        id
        nameTh
        provinceId
        province {
          id
          nameTh
        }
      }
      name
      examCenterCode
    }
    total
  }
}
    `;

/**
 * __useGetMyProctorExamEventsQuery__
 *
 * To run a query within a React component, call `useGetMyProctorExamEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProctorExamEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProctorExamEventsQuery({
 *   variables: {
 *      getMyProctorExamEventsInput: // value for 'getMyProctorExamEventsInput'
 *   },
 * });
 */
export function useGetMyProctorExamEventsQuery(baseOptions: Apollo.QueryHookOptions<GetMyProctorExamEventsQuery, GetMyProctorExamEventsQueryVariables> & ({ variables: GetMyProctorExamEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProctorExamEventsQuery, GetMyProctorExamEventsQueryVariables>(GetMyProctorExamEventsDocument, options);
      }
export function useGetMyProctorExamEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProctorExamEventsQuery, GetMyProctorExamEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProctorExamEventsQuery, GetMyProctorExamEventsQueryVariables>(GetMyProctorExamEventsDocument, options);
        }
export function useGetMyProctorExamEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyProctorExamEventsQuery, GetMyProctorExamEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyProctorExamEventsQuery, GetMyProctorExamEventsQueryVariables>(GetMyProctorExamEventsDocument, options);
        }
export type GetMyProctorExamEventsQueryHookResult = ReturnType<typeof useGetMyProctorExamEventsQuery>;
export type GetMyProctorExamEventsLazyQueryHookResult = ReturnType<typeof useGetMyProctorExamEventsLazyQuery>;
export type GetMyProctorExamEventsSuspenseQueryHookResult = ReturnType<typeof useGetMyProctorExamEventsSuspenseQuery>;
export type GetMyProctorExamEventsQueryResult = Apollo.QueryResult<GetMyProctorExamEventsQuery, GetMyProctorExamEventsQueryVariables>;
export const GetExamEventExamineesForMonitoringDocument = gql`
    query getExamEventExamineesForMonitoring($examEventId: String!, $sessionId: String!, $searchExaminee: SearchExamineeInput, $paging: PagingInput) {
  ecGetExamEventExamineesForSession(
    GetExamEventExamineesForSessionInput: {examEventId: $examEventId, sessionId: $sessionId, searchExaminee: $searchExaminee, paging: $paging}
  ) {
    result {
      examEndedAt
      examEventExaminee {
        id
        seatNumber
        status
        email
        isExamReady
        certificateStatus
        registrationStatus
        sentToSETPortalAt
        cancelationReason
        remark
        examinee {
          middleName
          lastName
          firstName
          title
          idNumber
          eKycStatus
        }
        examCourse {
          id
          code
        }
        examEventExamineeResult {
          result
        }
        examEventSessionExaminee(examEventSessionId: $sessionId) {
          examStartedAt
          loginStatus
          examStatus
          examSubmitStatus
          questionnaireStatus
        }
      }
    }
    total
  }
}
    `;

/**
 * __useGetExamEventExamineesForMonitoringQuery__
 *
 * To run a query within a React component, call `useGetExamEventExamineesForMonitoringQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamEventExamineesForMonitoringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamEventExamineesForMonitoringQuery({
 *   variables: {
 *      examEventId: // value for 'examEventId'
 *      sessionId: // value for 'sessionId'
 *      searchExaminee: // value for 'searchExaminee'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useGetExamEventExamineesForMonitoringQuery(baseOptions: Apollo.QueryHookOptions<GetExamEventExamineesForMonitoringQuery, GetExamEventExamineesForMonitoringQueryVariables> & ({ variables: GetExamEventExamineesForMonitoringQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamEventExamineesForMonitoringQuery, GetExamEventExamineesForMonitoringQueryVariables>(GetExamEventExamineesForMonitoringDocument, options);
      }
export function useGetExamEventExamineesForMonitoringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamEventExamineesForMonitoringQuery, GetExamEventExamineesForMonitoringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamEventExamineesForMonitoringQuery, GetExamEventExamineesForMonitoringQueryVariables>(GetExamEventExamineesForMonitoringDocument, options);
        }
export function useGetExamEventExamineesForMonitoringSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamEventExamineesForMonitoringQuery, GetExamEventExamineesForMonitoringQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamEventExamineesForMonitoringQuery, GetExamEventExamineesForMonitoringQueryVariables>(GetExamEventExamineesForMonitoringDocument, options);
        }
export type GetExamEventExamineesForMonitoringQueryHookResult = ReturnType<typeof useGetExamEventExamineesForMonitoringQuery>;
export type GetExamEventExamineesForMonitoringLazyQueryHookResult = ReturnType<typeof useGetExamEventExamineesForMonitoringLazyQuery>;
export type GetExamEventExamineesForMonitoringSuspenseQueryHookResult = ReturnType<typeof useGetExamEventExamineesForMonitoringSuspenseQuery>;
export type GetExamEventExamineesForMonitoringQueryResult = Apollo.QueryResult<GetExamEventExamineesForMonitoringQuery, GetExamEventExamineesForMonitoringQueryVariables>;
export const GetExamEventSessionByIdDocument = gql`
    query getExamEventSessionById($getExamEventSessionByIdInput: GetExamEventSessionByIdInput!) {
  ecGetExamEventSessionById(
    GetExamEventSessionByIdInput: $getExamEventSessionByIdInput
  ) {
    examEventSession {
      id
      examEventId
      round
      startedAt
      endedAt
      proctorStartedAt
      proctorEndedAt
    }
  }
}
    `;

/**
 * __useGetExamEventSessionByIdQuery__
 *
 * To run a query within a React component, call `useGetExamEventSessionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamEventSessionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamEventSessionByIdQuery({
 *   variables: {
 *      getExamEventSessionByIdInput: // value for 'getExamEventSessionByIdInput'
 *   },
 * });
 */
export function useGetExamEventSessionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamEventSessionByIdQuery, GetExamEventSessionByIdQueryVariables> & ({ variables: GetExamEventSessionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamEventSessionByIdQuery, GetExamEventSessionByIdQueryVariables>(GetExamEventSessionByIdDocument, options);
      }
export function useGetExamEventSessionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamEventSessionByIdQuery, GetExamEventSessionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamEventSessionByIdQuery, GetExamEventSessionByIdQueryVariables>(GetExamEventSessionByIdDocument, options);
        }
export function useGetExamEventSessionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamEventSessionByIdQuery, GetExamEventSessionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamEventSessionByIdQuery, GetExamEventSessionByIdQueryVariables>(GetExamEventSessionByIdDocument, options);
        }
export type GetExamEventSessionByIdQueryHookResult = ReturnType<typeof useGetExamEventSessionByIdQuery>;
export type GetExamEventSessionByIdLazyQueryHookResult = ReturnType<typeof useGetExamEventSessionByIdLazyQuery>;
export type GetExamEventSessionByIdSuspenseQueryHookResult = ReturnType<typeof useGetExamEventSessionByIdSuspenseQuery>;
export type GetExamEventSessionByIdQueryResult = Apollo.QueryResult<GetExamEventSessionByIdQuery, GetExamEventSessionByIdQueryVariables>;
export const GenerateSeatNumberDocument = gql`
    mutation generateSeatNumber($generateSeatNumberInput: GenerateSeatNumberInput!) {
  ecGenerateSeatNumber(generateSeatNumberInput: $generateSeatNumberInput) {
    examEventExaminees {
      id
      seatNumber
    }
  }
}
    `;
export type GenerateSeatNumberMutationFn = Apollo.MutationFunction<GenerateSeatNumberMutation, GenerateSeatNumberMutationVariables>;

/**
 * __useGenerateSeatNumberMutation__
 *
 * To run a mutation, you first call `useGenerateSeatNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSeatNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSeatNumberMutation, { data, loading, error }] = useGenerateSeatNumberMutation({
 *   variables: {
 *      generateSeatNumberInput: // value for 'generateSeatNumberInput'
 *   },
 * });
 */
export function useGenerateSeatNumberMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSeatNumberMutation, GenerateSeatNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSeatNumberMutation, GenerateSeatNumberMutationVariables>(GenerateSeatNumberDocument, options);
      }
export type GenerateSeatNumberMutationHookResult = ReturnType<typeof useGenerateSeatNumberMutation>;
export type GenerateSeatNumberMutationResult = Apollo.MutationResult<GenerateSeatNumberMutation>;
export type GenerateSeatNumberMutationOptions = Apollo.BaseMutationOptions<GenerateSeatNumberMutation, GenerateSeatNumberMutationVariables>;
export const GetAvailableExamEventYearsDocument = gql`
    query getAvailableExamEventYears {
  ecGetAvailableExamEventICTYears {
    ictExamYears
  }
}
    `;

/**
 * __useGetAvailableExamEventYearsQuery__
 *
 * To run a query within a React component, call `useGetAvailableExamEventYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableExamEventYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableExamEventYearsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableExamEventYearsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableExamEventYearsQuery, GetAvailableExamEventYearsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableExamEventYearsQuery, GetAvailableExamEventYearsQueryVariables>(GetAvailableExamEventYearsDocument, options);
      }
export function useGetAvailableExamEventYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableExamEventYearsQuery, GetAvailableExamEventYearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableExamEventYearsQuery, GetAvailableExamEventYearsQueryVariables>(GetAvailableExamEventYearsDocument, options);
        }
export function useGetAvailableExamEventYearsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableExamEventYearsQuery, GetAvailableExamEventYearsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableExamEventYearsQuery, GetAvailableExamEventYearsQueryVariables>(GetAvailableExamEventYearsDocument, options);
        }
export type GetAvailableExamEventYearsQueryHookResult = ReturnType<typeof useGetAvailableExamEventYearsQuery>;
export type GetAvailableExamEventYearsLazyQueryHookResult = ReturnType<typeof useGetAvailableExamEventYearsLazyQuery>;
export type GetAvailableExamEventYearsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableExamEventYearsSuspenseQuery>;
export type GetAvailableExamEventYearsQueryResult = Apollo.QueryResult<GetAvailableExamEventYearsQuery, GetAvailableExamEventYearsQueryVariables>;
export const GetYearlyExamEventsCountByMonthDocument = gql`
    query getYearlyExamEventsCountByMonth($getYearlyExamEventsCountByMonthInput: GetYearlyExamEventsCountByMonthInput!) {
  ecGetYearlyExamEventsCountByMonth(
    GetYearlyExamEventsCountByMonthInput: $getYearlyExamEventsCountByMonthInput
  ) {
    examEventsCountByMonth {
      month
      examEventsCountByExamCenterCode
    }
  }
}
    `;

/**
 * __useGetYearlyExamEventsCountByMonthQuery__
 *
 * To run a query within a React component, call `useGetYearlyExamEventsCountByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYearlyExamEventsCountByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYearlyExamEventsCountByMonthQuery({
 *   variables: {
 *      getYearlyExamEventsCountByMonthInput: // value for 'getYearlyExamEventsCountByMonthInput'
 *   },
 * });
 */
export function useGetYearlyExamEventsCountByMonthQuery(baseOptions: Apollo.QueryHookOptions<GetYearlyExamEventsCountByMonthQuery, GetYearlyExamEventsCountByMonthQueryVariables> & ({ variables: GetYearlyExamEventsCountByMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYearlyExamEventsCountByMonthQuery, GetYearlyExamEventsCountByMonthQueryVariables>(GetYearlyExamEventsCountByMonthDocument, options);
      }
export function useGetYearlyExamEventsCountByMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYearlyExamEventsCountByMonthQuery, GetYearlyExamEventsCountByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYearlyExamEventsCountByMonthQuery, GetYearlyExamEventsCountByMonthQueryVariables>(GetYearlyExamEventsCountByMonthDocument, options);
        }
export function useGetYearlyExamEventsCountByMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetYearlyExamEventsCountByMonthQuery, GetYearlyExamEventsCountByMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetYearlyExamEventsCountByMonthQuery, GetYearlyExamEventsCountByMonthQueryVariables>(GetYearlyExamEventsCountByMonthDocument, options);
        }
export type GetYearlyExamEventsCountByMonthQueryHookResult = ReturnType<typeof useGetYearlyExamEventsCountByMonthQuery>;
export type GetYearlyExamEventsCountByMonthLazyQueryHookResult = ReturnType<typeof useGetYearlyExamEventsCountByMonthLazyQuery>;
export type GetYearlyExamEventsCountByMonthSuspenseQueryHookResult = ReturnType<typeof useGetYearlyExamEventsCountByMonthSuspenseQuery>;
export type GetYearlyExamEventsCountByMonthQueryResult = Apollo.QueryResult<GetYearlyExamEventsCountByMonthQuery, GetYearlyExamEventsCountByMonthQueryVariables>;
export const GetExamEventsByDateRangeDocument = gql`
    query getExamEventsByDateRange($getExamEventsByDateRangeInput: GetExamEventsByDateRangeInput!) {
  ecGetExamEventsByDateRange(
    GetExamEventsByDateRangeInput: $getExamEventsByDateRangeInput
  ) {
    examEvents {
      id
      examCenterCode
      roundNumber
      registrationType
      registrationStatus
      status
      examType
      metadata
      examStartedAt
      examEndedAt
      examCenter {
        examCenterId
      }
      examLocation {
        nameTh
      }
    }
  }
}
    `;

/**
 * __useGetExamEventsByDateRangeQuery__
 *
 * To run a query within a React component, call `useGetExamEventsByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamEventsByDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamEventsByDateRangeQuery({
 *   variables: {
 *      getExamEventsByDateRangeInput: // value for 'getExamEventsByDateRangeInput'
 *   },
 * });
 */
export function useGetExamEventsByDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetExamEventsByDateRangeQuery, GetExamEventsByDateRangeQueryVariables> & ({ variables: GetExamEventsByDateRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamEventsByDateRangeQuery, GetExamEventsByDateRangeQueryVariables>(GetExamEventsByDateRangeDocument, options);
      }
export function useGetExamEventsByDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamEventsByDateRangeQuery, GetExamEventsByDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamEventsByDateRangeQuery, GetExamEventsByDateRangeQueryVariables>(GetExamEventsByDateRangeDocument, options);
        }
export function useGetExamEventsByDateRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamEventsByDateRangeQuery, GetExamEventsByDateRangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamEventsByDateRangeQuery, GetExamEventsByDateRangeQueryVariables>(GetExamEventsByDateRangeDocument, options);
        }
export type GetExamEventsByDateRangeQueryHookResult = ReturnType<typeof useGetExamEventsByDateRangeQuery>;
export type GetExamEventsByDateRangeLazyQueryHookResult = ReturnType<typeof useGetExamEventsByDateRangeLazyQuery>;
export type GetExamEventsByDateRangeSuspenseQueryHookResult = ReturnType<typeof useGetExamEventsByDateRangeSuspenseQuery>;
export type GetExamEventsByDateRangeQueryResult = Apollo.QueryResult<GetExamEventsByDateRangeQuery, GetExamEventsByDateRangeQueryVariables>;
export const GetDipChipDeepLinkUrlDocument = gql`
    query GetDipChipDeepLinkUrl($getDipChipDeepLinkUrlInput: GetDipChipDeepLinkUrlInput!) {
  ecGetDipChipDeepLinkUrl(GetDipChipDeepLinkUrlInput: $getDipChipDeepLinkUrlInput) {
    deepLinkUrl
  }
}
    `;

/**
 * __useGetDipChipDeepLinkUrlQuery__
 *
 * To run a query within a React component, call `useGetDipChipDeepLinkUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDipChipDeepLinkUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDipChipDeepLinkUrlQuery({
 *   variables: {
 *      getDipChipDeepLinkUrlInput: // value for 'getDipChipDeepLinkUrlInput'
 *   },
 * });
 */
export function useGetDipChipDeepLinkUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDipChipDeepLinkUrlQuery, GetDipChipDeepLinkUrlQueryVariables> & ({ variables: GetDipChipDeepLinkUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDipChipDeepLinkUrlQuery, GetDipChipDeepLinkUrlQueryVariables>(GetDipChipDeepLinkUrlDocument, options);
      }
export function useGetDipChipDeepLinkUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDipChipDeepLinkUrlQuery, GetDipChipDeepLinkUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDipChipDeepLinkUrlQuery, GetDipChipDeepLinkUrlQueryVariables>(GetDipChipDeepLinkUrlDocument, options);
        }
export function useGetDipChipDeepLinkUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDipChipDeepLinkUrlQuery, GetDipChipDeepLinkUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDipChipDeepLinkUrlQuery, GetDipChipDeepLinkUrlQueryVariables>(GetDipChipDeepLinkUrlDocument, options);
        }
export type GetDipChipDeepLinkUrlQueryHookResult = ReturnType<typeof useGetDipChipDeepLinkUrlQuery>;
export type GetDipChipDeepLinkUrlLazyQueryHookResult = ReturnType<typeof useGetDipChipDeepLinkUrlLazyQuery>;
export type GetDipChipDeepLinkUrlSuspenseQueryHookResult = ReturnType<typeof useGetDipChipDeepLinkUrlSuspenseQuery>;
export type GetDipChipDeepLinkUrlQueryResult = Apollo.QueryResult<GetDipChipDeepLinkUrlQuery, GetDipChipDeepLinkUrlQueryVariables>;
export const ValidatedExamEventsDocument = gql`
    query validatedExamEvents($validateExamEventsCreationInput: ValidateExamEventsCreationInput!) {
  ecValidateExamEventsCreation(
    ValidateExamEventsCreationInput: $validateExamEventsCreationInput
  ) {
    validatedExamEvents {
      registrationStartedAt
      registrationEndedAt
      examStartedAt
      examEndedAt
      isValid
      errorCodes
    }
  }
}
    `;

/**
 * __useValidatedExamEventsQuery__
 *
 * To run a query within a React component, call `useValidatedExamEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatedExamEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatedExamEventsQuery({
 *   variables: {
 *      validateExamEventsCreationInput: // value for 'validateExamEventsCreationInput'
 *   },
 * });
 */
export function useValidatedExamEventsQuery(baseOptions: Apollo.QueryHookOptions<ValidatedExamEventsQuery, ValidatedExamEventsQueryVariables> & ({ variables: ValidatedExamEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidatedExamEventsQuery, ValidatedExamEventsQueryVariables>(ValidatedExamEventsDocument, options);
      }
export function useValidatedExamEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatedExamEventsQuery, ValidatedExamEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidatedExamEventsQuery, ValidatedExamEventsQueryVariables>(ValidatedExamEventsDocument, options);
        }
export function useValidatedExamEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidatedExamEventsQuery, ValidatedExamEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidatedExamEventsQuery, ValidatedExamEventsQueryVariables>(ValidatedExamEventsDocument, options);
        }
export type ValidatedExamEventsQueryHookResult = ReturnType<typeof useValidatedExamEventsQuery>;
export type ValidatedExamEventsLazyQueryHookResult = ReturnType<typeof useValidatedExamEventsLazyQuery>;
export type ValidatedExamEventsSuspenseQueryHookResult = ReturnType<typeof useValidatedExamEventsSuspenseQuery>;
export type ValidatedExamEventsQueryResult = Apollo.QueryResult<ValidatedExamEventsQuery, ValidatedExamEventsQueryVariables>;
export const CreateExamEventsDocument = gql`
    mutation createExamEvents($createExamEventsInput: CreateExamEventsInput!) {
  ecCreateExamEvents(CreateExamEventsInput: $createExamEventsInput) {
    examEvents {
      id
    }
    failedExamEvents {
      requestId
      errorCodes
    }
  }
}
    `;
export type CreateExamEventsMutationFn = Apollo.MutationFunction<CreateExamEventsMutation, CreateExamEventsMutationVariables>;

/**
 * __useCreateExamEventsMutation__
 *
 * To run a mutation, you first call `useCreateExamEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExamEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExamEventsMutation, { data, loading, error }] = useCreateExamEventsMutation({
 *   variables: {
 *      createExamEventsInput: // value for 'createExamEventsInput'
 *   },
 * });
 */
export function useCreateExamEventsMutation(baseOptions?: Apollo.MutationHookOptions<CreateExamEventsMutation, CreateExamEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExamEventsMutation, CreateExamEventsMutationVariables>(CreateExamEventsDocument, options);
      }
export type CreateExamEventsMutationHookResult = ReturnType<typeof useCreateExamEventsMutation>;
export type CreateExamEventsMutationResult = Apollo.MutationResult<CreateExamEventsMutation>;
export type CreateExamEventsMutationOptions = Apollo.BaseMutationOptions<CreateExamEventsMutation, CreateExamEventsMutationVariables>;
export const EcPostponeExamEventTimeDocument = gql`
    mutation EcPostponeExamEventTime($postponeExamEventTimeInput: PostponeExamEventTimeInput!) {
  ecPostponeExamEventTime(PostponeExamEventTimeInput: $postponeExamEventTimeInput) {
    examEvent {
      id
    }
  }
}
    `;
export type EcPostponeExamEventTimeMutationFn = Apollo.MutationFunction<EcPostponeExamEventTimeMutation, EcPostponeExamEventTimeMutationVariables>;

/**
 * __useEcPostponeExamEventTimeMutation__
 *
 * To run a mutation, you first call `useEcPostponeExamEventTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcPostponeExamEventTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecPostponeExamEventTimeMutation, { data, loading, error }] = useEcPostponeExamEventTimeMutation({
 *   variables: {
 *      postponeExamEventTimeInput: // value for 'postponeExamEventTimeInput'
 *   },
 * });
 */
export function useEcPostponeExamEventTimeMutation(baseOptions?: Apollo.MutationHookOptions<EcPostponeExamEventTimeMutation, EcPostponeExamEventTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcPostponeExamEventTimeMutation, EcPostponeExamEventTimeMutationVariables>(EcPostponeExamEventTimeDocument, options);
      }
export type EcPostponeExamEventTimeMutationHookResult = ReturnType<typeof useEcPostponeExamEventTimeMutation>;
export type EcPostponeExamEventTimeMutationResult = Apollo.MutationResult<EcPostponeExamEventTimeMutation>;
export type EcPostponeExamEventTimeMutationOptions = Apollo.BaseMutationOptions<EcPostponeExamEventTimeMutation, EcPostponeExamEventTimeMutationVariables>;
export const ExtendExamEventSessionTimeDocument = gql`
    mutation extendExamEventSessionTime($extendExamEventSessionTimeInput: ExtendExamEventSessionTimeInput!) {
  ecExtendExamEventSessionTime(
    ExtendExamEventSessionTimeInput: $extendExamEventSessionTimeInput
  ) {
    success
  }
}
    `;
export type ExtendExamEventSessionTimeMutationFn = Apollo.MutationFunction<ExtendExamEventSessionTimeMutation, ExtendExamEventSessionTimeMutationVariables>;

/**
 * __useExtendExamEventSessionTimeMutation__
 *
 * To run a mutation, you first call `useExtendExamEventSessionTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendExamEventSessionTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendExamEventSessionTimeMutation, { data, loading, error }] = useExtendExamEventSessionTimeMutation({
 *   variables: {
 *      extendExamEventSessionTimeInput: // value for 'extendExamEventSessionTimeInput'
 *   },
 * });
 */
export function useExtendExamEventSessionTimeMutation(baseOptions?: Apollo.MutationHookOptions<ExtendExamEventSessionTimeMutation, ExtendExamEventSessionTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtendExamEventSessionTimeMutation, ExtendExamEventSessionTimeMutationVariables>(ExtendExamEventSessionTimeDocument, options);
      }
export type ExtendExamEventSessionTimeMutationHookResult = ReturnType<typeof useExtendExamEventSessionTimeMutation>;
export type ExtendExamEventSessionTimeMutationResult = Apollo.MutationResult<ExtendExamEventSessionTimeMutation>;
export type ExtendExamEventSessionTimeMutationOptions = Apollo.BaseMutationOptions<ExtendExamEventSessionTimeMutation, ExtendExamEventSessionTimeMutationVariables>;
export const EcExtendExamEventSessionExamineesTimeDocument = gql`
    mutation EcExtendExamEventSessionExamineesTime($extendExamEventSessionExamineesTimeInput: ExtendExamEventSessionExamineesTimeInput!) {
  ecExtendExamEventSessionExamineesTime(
    ExtendExamEventSessionExamineesTimeInput: $extendExamEventSessionExamineesTimeInput
  ) {
    results {
      examEventSessionExamineeId
      extended
      actualExtendedTimeInMs
      reason
    }
  }
}
    `;
export type EcExtendExamEventSessionExamineesTimeMutationFn = Apollo.MutationFunction<EcExtendExamEventSessionExamineesTimeMutation, EcExtendExamEventSessionExamineesTimeMutationVariables>;

/**
 * __useEcExtendExamEventSessionExamineesTimeMutation__
 *
 * To run a mutation, you first call `useEcExtendExamEventSessionExamineesTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcExtendExamEventSessionExamineesTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecExtendExamEventSessionExamineesTimeMutation, { data, loading, error }] = useEcExtendExamEventSessionExamineesTimeMutation({
 *   variables: {
 *      extendExamEventSessionExamineesTimeInput: // value for 'extendExamEventSessionExamineesTimeInput'
 *   },
 * });
 */
export function useEcExtendExamEventSessionExamineesTimeMutation(baseOptions?: Apollo.MutationHookOptions<EcExtendExamEventSessionExamineesTimeMutation, EcExtendExamEventSessionExamineesTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcExtendExamEventSessionExamineesTimeMutation, EcExtendExamEventSessionExamineesTimeMutationVariables>(EcExtendExamEventSessionExamineesTimeDocument, options);
      }
export type EcExtendExamEventSessionExamineesTimeMutationHookResult = ReturnType<typeof useEcExtendExamEventSessionExamineesTimeMutation>;
export type EcExtendExamEventSessionExamineesTimeMutationResult = Apollo.MutationResult<EcExtendExamEventSessionExamineesTimeMutation>;
export type EcExtendExamEventSessionExamineesTimeMutationOptions = Apollo.BaseMutationOptions<EcExtendExamEventSessionExamineesTimeMutation, EcExtendExamEventSessionExamineesTimeMutationVariables>;
export const OverrideExamEventExamineeEmailDocument = gql`
    mutation overrideExamEventExamineeEmail($overrideExamEventExamineeEmailInput: OverrideExamEventExamineeEmailInput!) {
  ecOverrideExamEventExamineeEmail(
    overrideExamEventExamineeEmailInput: $overrideExamEventExamineeEmailInput
  ) {
    examEventExaminee {
      email
    }
  }
}
    `;
export type OverrideExamEventExamineeEmailMutationFn = Apollo.MutationFunction<OverrideExamEventExamineeEmailMutation, OverrideExamEventExamineeEmailMutationVariables>;

/**
 * __useOverrideExamEventExamineeEmailMutation__
 *
 * To run a mutation, you first call `useOverrideExamEventExamineeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideExamEventExamineeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideExamEventExamineeEmailMutation, { data, loading, error }] = useOverrideExamEventExamineeEmailMutation({
 *   variables: {
 *      overrideExamEventExamineeEmailInput: // value for 'overrideExamEventExamineeEmailInput'
 *   },
 * });
 */
export function useOverrideExamEventExamineeEmailMutation(baseOptions?: Apollo.MutationHookOptions<OverrideExamEventExamineeEmailMutation, OverrideExamEventExamineeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideExamEventExamineeEmailMutation, OverrideExamEventExamineeEmailMutationVariables>(OverrideExamEventExamineeEmailDocument, options);
      }
export type OverrideExamEventExamineeEmailMutationHookResult = ReturnType<typeof useOverrideExamEventExamineeEmailMutation>;
export type OverrideExamEventExamineeEmailMutationResult = Apollo.MutationResult<OverrideExamEventExamineeEmailMutation>;
export type OverrideExamEventExamineeEmailMutationOptions = Apollo.BaseMutationOptions<OverrideExamEventExamineeEmailMutation, OverrideExamEventExamineeEmailMutationVariables>;
export const DownloadExamByExamEventIdDocument = gql`
    mutation downloadExamByExamEventId($downloadExamByExamEventIdInput: DownloadExamByExamEventIdInput!) {
  ecDownloadExamByExamEventId(
    DownloadExamByExamEventIdInput: $downloadExamByExamEventIdInput
  ) {
    data
    message
    status
  }
}
    `;
export type DownloadExamByExamEventIdMutationFn = Apollo.MutationFunction<DownloadExamByExamEventIdMutation, DownloadExamByExamEventIdMutationVariables>;

/**
 * __useDownloadExamByExamEventIdMutation__
 *
 * To run a mutation, you first call `useDownloadExamByExamEventIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadExamByExamEventIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadExamByExamEventIdMutation, { data, loading, error }] = useDownloadExamByExamEventIdMutation({
 *   variables: {
 *      downloadExamByExamEventIdInput: // value for 'downloadExamByExamEventIdInput'
 *   },
 * });
 */
export function useDownloadExamByExamEventIdMutation(baseOptions?: Apollo.MutationHookOptions<DownloadExamByExamEventIdMutation, DownloadExamByExamEventIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadExamByExamEventIdMutation, DownloadExamByExamEventIdMutationVariables>(DownloadExamByExamEventIdDocument, options);
      }
export type DownloadExamByExamEventIdMutationHookResult = ReturnType<typeof useDownloadExamByExamEventIdMutation>;
export type DownloadExamByExamEventIdMutationResult = Apollo.MutationResult<DownloadExamByExamEventIdMutation>;
export type DownloadExamByExamEventIdMutationOptions = Apollo.BaseMutationOptions<DownloadExamByExamEventIdMutation, DownloadExamByExamEventIdMutationVariables>;
export const GetUpcomingExamEventsByExamCenterCodeDocument = gql`
    query getUpcomingExamEventsByExamCenterCode($getUpcomingExamEventsByExamCenterCodeInput: GetUpcomingExamEventsByExamCenterCodeInput!) {
  ecGetUpcomingExamEventsByExamCenterCode(
    GetUpcomingExamEventsByExamCenterCodeInput: $getUpcomingExamEventsByExamCenterCodeInput
  ) {
    examEvents {
      id
      registrationType
      registrationStatus
      status
      seat
      roundNumber
      examStartedAt
      examEndedAt
      metadata
      numberOfExaminees
      examLocation {
        id
        nameTh
        provinceId
        province {
          id
          nameTh
        }
      }
      name
      examCenterCode
    }
  }
}
    `;

/**
 * __useGetUpcomingExamEventsByExamCenterCodeQuery__
 *
 * To run a query within a React component, call `useGetUpcomingExamEventsByExamCenterCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingExamEventsByExamCenterCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingExamEventsByExamCenterCodeQuery({
 *   variables: {
 *      getUpcomingExamEventsByExamCenterCodeInput: // value for 'getUpcomingExamEventsByExamCenterCodeInput'
 *   },
 * });
 */
export function useGetUpcomingExamEventsByExamCenterCodeQuery(baseOptions: Apollo.QueryHookOptions<GetUpcomingExamEventsByExamCenterCodeQuery, GetUpcomingExamEventsByExamCenterCodeQueryVariables> & ({ variables: GetUpcomingExamEventsByExamCenterCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpcomingExamEventsByExamCenterCodeQuery, GetUpcomingExamEventsByExamCenterCodeQueryVariables>(GetUpcomingExamEventsByExamCenterCodeDocument, options);
      }
export function useGetUpcomingExamEventsByExamCenterCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpcomingExamEventsByExamCenterCodeQuery, GetUpcomingExamEventsByExamCenterCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpcomingExamEventsByExamCenterCodeQuery, GetUpcomingExamEventsByExamCenterCodeQueryVariables>(GetUpcomingExamEventsByExamCenterCodeDocument, options);
        }
export function useGetUpcomingExamEventsByExamCenterCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUpcomingExamEventsByExamCenterCodeQuery, GetUpcomingExamEventsByExamCenterCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUpcomingExamEventsByExamCenterCodeQuery, GetUpcomingExamEventsByExamCenterCodeQueryVariables>(GetUpcomingExamEventsByExamCenterCodeDocument, options);
        }
export type GetUpcomingExamEventsByExamCenterCodeQueryHookResult = ReturnType<typeof useGetUpcomingExamEventsByExamCenterCodeQuery>;
export type GetUpcomingExamEventsByExamCenterCodeLazyQueryHookResult = ReturnType<typeof useGetUpcomingExamEventsByExamCenterCodeLazyQuery>;
export type GetUpcomingExamEventsByExamCenterCodeSuspenseQueryHookResult = ReturnType<typeof useGetUpcomingExamEventsByExamCenterCodeSuspenseQuery>;
export type GetUpcomingExamEventsByExamCenterCodeQueryResult = Apollo.QueryResult<GetUpcomingExamEventsByExamCenterCodeQuery, GetUpcomingExamEventsByExamCenterCodeQueryVariables>;
export const SearchExamEventsWithQuestionnairesDocument = gql`
    query searchExamEventsWithQuestionnaires($searchExamEventsWithQuestionnairesInput: SearchExamEventsWithQuestionnairesInput!) {
  ecSearchExamEventsWithQuestionnaires(
    SearchExamEventsWithQuestionnairesInput: $searchExamEventsWithQuestionnairesInput
  ) {
    total
    data {
      questionnaireCount
      examEvent {
        id
        name
        examEndedAt
        examStartedAt
        roundNumber
        registrationType
        examCenter {
          nameTH
          code
        }
        examLocation {
          nameTh
          province {
            nameTh
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchExamEventsWithQuestionnairesQuery__
 *
 * To run a query within a React component, call `useSearchExamEventsWithQuestionnairesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamEventsWithQuestionnairesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamEventsWithQuestionnairesQuery({
 *   variables: {
 *      searchExamEventsWithQuestionnairesInput: // value for 'searchExamEventsWithQuestionnairesInput'
 *   },
 * });
 */
export function useSearchExamEventsWithQuestionnairesQuery(baseOptions: Apollo.QueryHookOptions<SearchExamEventsWithQuestionnairesQuery, SearchExamEventsWithQuestionnairesQueryVariables> & ({ variables: SearchExamEventsWithQuestionnairesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamEventsWithQuestionnairesQuery, SearchExamEventsWithQuestionnairesQueryVariables>(SearchExamEventsWithQuestionnairesDocument, options);
      }
export function useSearchExamEventsWithQuestionnairesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamEventsWithQuestionnairesQuery, SearchExamEventsWithQuestionnairesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamEventsWithQuestionnairesQuery, SearchExamEventsWithQuestionnairesQueryVariables>(SearchExamEventsWithQuestionnairesDocument, options);
        }
export function useSearchExamEventsWithQuestionnairesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamEventsWithQuestionnairesQuery, SearchExamEventsWithQuestionnairesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamEventsWithQuestionnairesQuery, SearchExamEventsWithQuestionnairesQueryVariables>(SearchExamEventsWithQuestionnairesDocument, options);
        }
export type SearchExamEventsWithQuestionnairesQueryHookResult = ReturnType<typeof useSearchExamEventsWithQuestionnairesQuery>;
export type SearchExamEventsWithQuestionnairesLazyQueryHookResult = ReturnType<typeof useSearchExamEventsWithQuestionnairesLazyQuery>;
export type SearchExamEventsWithQuestionnairesSuspenseQueryHookResult = ReturnType<typeof useSearchExamEventsWithQuestionnairesSuspenseQuery>;
export type SearchExamEventsWithQuestionnairesQueryResult = Apollo.QueryResult<SearchExamEventsWithQuestionnairesQuery, SearchExamEventsWithQuestionnairesQueryVariables>;
export const SearchExamEventAuditLogDocument = gql`
    query SearchExamEventAuditLog($searchExamEventAuditLogInput: SearchExamEventAuditLogInput!) {
  ecSearchExamEventAuditLog(
    SearchExamEventAuditLogInput: $searchExamEventAuditLogInput
  ) {
    examEventAuditLogs {
      id
      action
      fullName
      detail
      actionTime
    }
    total
  }
}
    `;

/**
 * __useSearchExamEventAuditLogQuery__
 *
 * To run a query within a React component, call `useSearchExamEventAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamEventAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamEventAuditLogQuery({
 *   variables: {
 *      searchExamEventAuditLogInput: // value for 'searchExamEventAuditLogInput'
 *   },
 * });
 */
export function useSearchExamEventAuditLogQuery(baseOptions: Apollo.QueryHookOptions<SearchExamEventAuditLogQuery, SearchExamEventAuditLogQueryVariables> & ({ variables: SearchExamEventAuditLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamEventAuditLogQuery, SearchExamEventAuditLogQueryVariables>(SearchExamEventAuditLogDocument, options);
      }
export function useSearchExamEventAuditLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamEventAuditLogQuery, SearchExamEventAuditLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamEventAuditLogQuery, SearchExamEventAuditLogQueryVariables>(SearchExamEventAuditLogDocument, options);
        }
export function useSearchExamEventAuditLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamEventAuditLogQuery, SearchExamEventAuditLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamEventAuditLogQuery, SearchExamEventAuditLogQueryVariables>(SearchExamEventAuditLogDocument, options);
        }
export type SearchExamEventAuditLogQueryHookResult = ReturnType<typeof useSearchExamEventAuditLogQuery>;
export type SearchExamEventAuditLogLazyQueryHookResult = ReturnType<typeof useSearchExamEventAuditLogLazyQuery>;
export type SearchExamEventAuditLogSuspenseQueryHookResult = ReturnType<typeof useSearchExamEventAuditLogSuspenseQuery>;
export type SearchExamEventAuditLogQueryResult = Apollo.QueryResult<SearchExamEventAuditLogQuery, SearchExamEventAuditLogQueryVariables>;
export const GetExamCenterEventSummariesDocument = gql`
    query getExamCenterEventSummaries($getExamCenterEventSummariesInput: GetExamCenterEventSummariesInput!) {
  ecGetExamCenterEventSummaries(
    GetExamCenterEventSummariesInput: $getExamCenterEventSummariesInput
  ) {
    examCenterEventSummaries {
      publicRoundCount
      inHouseRoundCount
      publicSeatCount
      inHouseSeatCount
      publicExamEventExamineeCount
      inHouseExamEventExamineeCount
      publicAttendedExamineeCount
      inHouseAttendedExamineeCount
      publicAbsentExamineeCount
      inHouseAbsentExamineeCount
      publicCanceledExamineeCount
      inHouseCanceledExamineeCount
    }
  }
}
    `;

/**
 * __useGetExamCenterEventSummariesQuery__
 *
 * To run a query within a React component, call `useGetExamCenterEventSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCenterEventSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCenterEventSummariesQuery({
 *   variables: {
 *      getExamCenterEventSummariesInput: // value for 'getExamCenterEventSummariesInput'
 *   },
 * });
 */
export function useGetExamCenterEventSummariesQuery(baseOptions: Apollo.QueryHookOptions<GetExamCenterEventSummariesQuery, GetExamCenterEventSummariesQueryVariables> & ({ variables: GetExamCenterEventSummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCenterEventSummariesQuery, GetExamCenterEventSummariesQueryVariables>(GetExamCenterEventSummariesDocument, options);
      }
export function useGetExamCenterEventSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCenterEventSummariesQuery, GetExamCenterEventSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCenterEventSummariesQuery, GetExamCenterEventSummariesQueryVariables>(GetExamCenterEventSummariesDocument, options);
        }
export function useGetExamCenterEventSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCenterEventSummariesQuery, GetExamCenterEventSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCenterEventSummariesQuery, GetExamCenterEventSummariesQueryVariables>(GetExamCenterEventSummariesDocument, options);
        }
export type GetExamCenterEventSummariesQueryHookResult = ReturnType<typeof useGetExamCenterEventSummariesQuery>;
export type GetExamCenterEventSummariesLazyQueryHookResult = ReturnType<typeof useGetExamCenterEventSummariesLazyQuery>;
export type GetExamCenterEventSummariesSuspenseQueryHookResult = ReturnType<typeof useGetExamCenterEventSummariesSuspenseQuery>;
export type GetExamCenterEventSummariesQueryResult = Apollo.QueryResult<GetExamCenterEventSummariesQuery, GetExamCenterEventSummariesQueryVariables>;
export const GetExamCenterLocationsByProvinceIdDocument = gql`
    query getExamCenterLocationsByProvinceId($getExamCenterLocationsByProvinceIdInput: GetExamCenterLocationsByProvinceIdInput!) {
  ecGetExamCenterLocationsByProvinceId(
    getExamCenterLocationsByProvinceIdInput: $getExamCenterLocationsByProvinceIdInput
  ) {
    examCenterLocations {
      id
      location {
        id
        nameTh
      }
    }
  }
}
    `;

/**
 * __useGetExamCenterLocationsByProvinceIdQuery__
 *
 * To run a query within a React component, call `useGetExamCenterLocationsByProvinceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCenterLocationsByProvinceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCenterLocationsByProvinceIdQuery({
 *   variables: {
 *      getExamCenterLocationsByProvinceIdInput: // value for 'getExamCenterLocationsByProvinceIdInput'
 *   },
 * });
 */
export function useGetExamCenterLocationsByProvinceIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamCenterLocationsByProvinceIdQuery, GetExamCenterLocationsByProvinceIdQueryVariables> & ({ variables: GetExamCenterLocationsByProvinceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCenterLocationsByProvinceIdQuery, GetExamCenterLocationsByProvinceIdQueryVariables>(GetExamCenterLocationsByProvinceIdDocument, options);
      }
export function useGetExamCenterLocationsByProvinceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCenterLocationsByProvinceIdQuery, GetExamCenterLocationsByProvinceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCenterLocationsByProvinceIdQuery, GetExamCenterLocationsByProvinceIdQueryVariables>(GetExamCenterLocationsByProvinceIdDocument, options);
        }
export function useGetExamCenterLocationsByProvinceIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCenterLocationsByProvinceIdQuery, GetExamCenterLocationsByProvinceIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCenterLocationsByProvinceIdQuery, GetExamCenterLocationsByProvinceIdQueryVariables>(GetExamCenterLocationsByProvinceIdDocument, options);
        }
export type GetExamCenterLocationsByProvinceIdQueryHookResult = ReturnType<typeof useGetExamCenterLocationsByProvinceIdQuery>;
export type GetExamCenterLocationsByProvinceIdLazyQueryHookResult = ReturnType<typeof useGetExamCenterLocationsByProvinceIdLazyQuery>;
export type GetExamCenterLocationsByProvinceIdSuspenseQueryHookResult = ReturnType<typeof useGetExamCenterLocationsByProvinceIdSuspenseQuery>;
export type GetExamCenterLocationsByProvinceIdQueryResult = Apollo.QueryResult<GetExamCenterLocationsByProvinceIdQuery, GetExamCenterLocationsByProvinceIdQueryVariables>;
export const GetExamEventSessionExamineesForTimeExtensionDocument = gql`
    query getExamEventSessionExamineesForTimeExtension($getExamEventSessionExamineesForTimeExtensionInput: GetExamEventSessionExamineesForTimeExtensionInput!) {
  ecGetExamEventSessionExamineesForTimeExtension(
    GetExamEventSessionExamineesForTimeExtensionInput: $getExamEventSessionExamineesForTimeExtensionInput
  ) {
    result {
      examEventSessionExaminee {
        id
        examinee {
          middleName
          lastName
          firstName
          title
        }
        examEventExaminee {
          seatNumber
          status
          examCourse {
            id
            code
          }
        }
      }
      maxExtendableDurationInMs
      totalExtendedDurationInMs
      remainingExtendableTimeInMs
      examEndedAt
      manualExtendDurationInMs
      autoExtendDurationInMs
    }
    total
  }
}
    `;

/**
 * __useGetExamEventSessionExamineesForTimeExtensionQuery__
 *
 * To run a query within a React component, call `useGetExamEventSessionExamineesForTimeExtensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamEventSessionExamineesForTimeExtensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamEventSessionExamineesForTimeExtensionQuery({
 *   variables: {
 *      getExamEventSessionExamineesForTimeExtensionInput: // value for 'getExamEventSessionExamineesForTimeExtensionInput'
 *   },
 * });
 */
export function useGetExamEventSessionExamineesForTimeExtensionQuery(baseOptions: Apollo.QueryHookOptions<GetExamEventSessionExamineesForTimeExtensionQuery, GetExamEventSessionExamineesForTimeExtensionQueryVariables> & ({ variables: GetExamEventSessionExamineesForTimeExtensionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamEventSessionExamineesForTimeExtensionQuery, GetExamEventSessionExamineesForTimeExtensionQueryVariables>(GetExamEventSessionExamineesForTimeExtensionDocument, options);
      }
export function useGetExamEventSessionExamineesForTimeExtensionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamEventSessionExamineesForTimeExtensionQuery, GetExamEventSessionExamineesForTimeExtensionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamEventSessionExamineesForTimeExtensionQuery, GetExamEventSessionExamineesForTimeExtensionQueryVariables>(GetExamEventSessionExamineesForTimeExtensionDocument, options);
        }
export function useGetExamEventSessionExamineesForTimeExtensionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamEventSessionExamineesForTimeExtensionQuery, GetExamEventSessionExamineesForTimeExtensionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamEventSessionExamineesForTimeExtensionQuery, GetExamEventSessionExamineesForTimeExtensionQueryVariables>(GetExamEventSessionExamineesForTimeExtensionDocument, options);
        }
export type GetExamEventSessionExamineesForTimeExtensionQueryHookResult = ReturnType<typeof useGetExamEventSessionExamineesForTimeExtensionQuery>;
export type GetExamEventSessionExamineesForTimeExtensionLazyQueryHookResult = ReturnType<typeof useGetExamEventSessionExamineesForTimeExtensionLazyQuery>;
export type GetExamEventSessionExamineesForTimeExtensionSuspenseQueryHookResult = ReturnType<typeof useGetExamEventSessionExamineesForTimeExtensionSuspenseQuery>;
export type GetExamEventSessionExamineesForTimeExtensionQueryResult = Apollo.QueryResult<GetExamEventSessionExamineesForTimeExtensionQuery, GetExamEventSessionExamineesForTimeExtensionQueryVariables>;
export const SearchTimeExtendedExamEventSessionExamineesDocument = gql`
    query searchTimeExtendedExamEventSessionExaminees($searchTimeExtendedExamEventSessionExamineeInput: SearchTimeExtendedExamEventSessionExamineeInput!) {
  ecSearchTimeExtendedExamEventSessionExaminees(
    SearchTimeExtendedExamEventSessionExamineeInput: $searchTimeExtendedExamEventSessionExamineeInput
  ) {
    total
    extendedExamEventSessionExaminees {
      examEventExaminee {
        seatNumber
        examCourseId
        examCourse {
          code
        }
      }
      examEventSessionId
      examinee {
        title
        middleName
        lastName
        firstName
      }
      id
      totalExtendedDurationInMs
      manualExtendDurationInMs
      autoExtendDurationInMs
      timeExtensionRemark
    }
  }
}
    `;

/**
 * __useSearchTimeExtendedExamEventSessionExamineesQuery__
 *
 * To run a query within a React component, call `useSearchTimeExtendedExamEventSessionExamineesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTimeExtendedExamEventSessionExamineesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTimeExtendedExamEventSessionExamineesQuery({
 *   variables: {
 *      searchTimeExtendedExamEventSessionExamineeInput: // value for 'searchTimeExtendedExamEventSessionExamineeInput'
 *   },
 * });
 */
export function useSearchTimeExtendedExamEventSessionExamineesQuery(baseOptions: Apollo.QueryHookOptions<SearchTimeExtendedExamEventSessionExamineesQuery, SearchTimeExtendedExamEventSessionExamineesQueryVariables> & ({ variables: SearchTimeExtendedExamEventSessionExamineesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTimeExtendedExamEventSessionExamineesQuery, SearchTimeExtendedExamEventSessionExamineesQueryVariables>(SearchTimeExtendedExamEventSessionExamineesDocument, options);
      }
export function useSearchTimeExtendedExamEventSessionExamineesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTimeExtendedExamEventSessionExamineesQuery, SearchTimeExtendedExamEventSessionExamineesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTimeExtendedExamEventSessionExamineesQuery, SearchTimeExtendedExamEventSessionExamineesQueryVariables>(SearchTimeExtendedExamEventSessionExamineesDocument, options);
        }
export function useSearchTimeExtendedExamEventSessionExamineesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTimeExtendedExamEventSessionExamineesQuery, SearchTimeExtendedExamEventSessionExamineesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTimeExtendedExamEventSessionExamineesQuery, SearchTimeExtendedExamEventSessionExamineesQueryVariables>(SearchTimeExtendedExamEventSessionExamineesDocument, options);
        }
export type SearchTimeExtendedExamEventSessionExamineesQueryHookResult = ReturnType<typeof useSearchTimeExtendedExamEventSessionExamineesQuery>;
export type SearchTimeExtendedExamEventSessionExamineesLazyQueryHookResult = ReturnType<typeof useSearchTimeExtendedExamEventSessionExamineesLazyQuery>;
export type SearchTimeExtendedExamEventSessionExamineesSuspenseQueryHookResult = ReturnType<typeof useSearchTimeExtendedExamEventSessionExamineesSuspenseQuery>;
export type SearchTimeExtendedExamEventSessionExamineesQueryResult = Apollo.QueryResult<SearchTimeExtendedExamEventSessionExamineesQuery, SearchTimeExtendedExamEventSessionExamineesQueryVariables>;
export const GetUploadSignedUrlForImportExamineesAnswersDocument = gql`
    query getUploadSignedUrlForImportExamineesAnswers($getUploadSignedUrlForImportExamineesAnswersInput: GetUploadSignedUrlForImportExamineesAnswersInput!) {
  ecGetUploadSignedUrlForImportExamineesAnswers(
    getUploadSignedUrlForImportExamineesAnswersInput: $getUploadSignedUrlForImportExamineesAnswersInput
  ) {
    signedUrl
    storageObject {
      fileName
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlForImportExamineesAnswersQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlForImportExamineesAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlForImportExamineesAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlForImportExamineesAnswersQuery({
 *   variables: {
 *      getUploadSignedUrlForImportExamineesAnswersInput: // value for 'getUploadSignedUrlForImportExamineesAnswersInput'
 *   },
 * });
 */
export function useGetUploadSignedUrlForImportExamineesAnswersQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlForImportExamineesAnswersQuery, GetUploadSignedUrlForImportExamineesAnswersQueryVariables> & ({ variables: GetUploadSignedUrlForImportExamineesAnswersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlForImportExamineesAnswersQuery, GetUploadSignedUrlForImportExamineesAnswersQueryVariables>(GetUploadSignedUrlForImportExamineesAnswersDocument, options);
      }
export function useGetUploadSignedUrlForImportExamineesAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlForImportExamineesAnswersQuery, GetUploadSignedUrlForImportExamineesAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlForImportExamineesAnswersQuery, GetUploadSignedUrlForImportExamineesAnswersQueryVariables>(GetUploadSignedUrlForImportExamineesAnswersDocument, options);
        }
export function useGetUploadSignedUrlForImportExamineesAnswersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForImportExamineesAnswersQuery, GetUploadSignedUrlForImportExamineesAnswersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlForImportExamineesAnswersQuery, GetUploadSignedUrlForImportExamineesAnswersQueryVariables>(GetUploadSignedUrlForImportExamineesAnswersDocument, options);
        }
export type GetUploadSignedUrlForImportExamineesAnswersQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForImportExamineesAnswersQuery>;
export type GetUploadSignedUrlForImportExamineesAnswersLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForImportExamineesAnswersLazyQuery>;
export type GetUploadSignedUrlForImportExamineesAnswersSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForImportExamineesAnswersSuspenseQuery>;
export type GetUploadSignedUrlForImportExamineesAnswersQueryResult = Apollo.QueryResult<GetUploadSignedUrlForImportExamineesAnswersQuery, GetUploadSignedUrlForImportExamineesAnswersQueryVariables>;
export const ImportExamineesAnswersSpreadSheetDocument = gql`
    mutation importExamineesAnswersSpreadSheet($importExamineesAnswersSpreadSheetInput: ImportExamineesAnswersSpreadSheetInput!) {
  ecImportExamineesAnswersSpreadSheet(
    importExamineesAnswersSpreadSheetInput: $importExamineesAnswersSpreadSheetInput
  ) {
    status
    data {
      examGradingStatus
    }
  }
}
    `;
export type ImportExamineesAnswersSpreadSheetMutationFn = Apollo.MutationFunction<ImportExamineesAnswersSpreadSheetMutation, ImportExamineesAnswersSpreadSheetMutationVariables>;

/**
 * __useImportExamineesAnswersSpreadSheetMutation__
 *
 * To run a mutation, you first call `useImportExamineesAnswersSpreadSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportExamineesAnswersSpreadSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importExamineesAnswersSpreadSheetMutation, { data, loading, error }] = useImportExamineesAnswersSpreadSheetMutation({
 *   variables: {
 *      importExamineesAnswersSpreadSheetInput: // value for 'importExamineesAnswersSpreadSheetInput'
 *   },
 * });
 */
export function useImportExamineesAnswersSpreadSheetMutation(baseOptions?: Apollo.MutationHookOptions<ImportExamineesAnswersSpreadSheetMutation, ImportExamineesAnswersSpreadSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportExamineesAnswersSpreadSheetMutation, ImportExamineesAnswersSpreadSheetMutationVariables>(ImportExamineesAnswersSpreadSheetDocument, options);
      }
export type ImportExamineesAnswersSpreadSheetMutationHookResult = ReturnType<typeof useImportExamineesAnswersSpreadSheetMutation>;
export type ImportExamineesAnswersSpreadSheetMutationResult = Apollo.MutationResult<ImportExamineesAnswersSpreadSheetMutation>;
export type ImportExamineesAnswersSpreadSheetMutationOptions = Apollo.BaseMutationOptions<ImportExamineesAnswersSpreadSheetMutation, ImportExamineesAnswersSpreadSheetMutationVariables>;
export const SearchExamEventExamineesDocument = gql`
    query searchExamEventExaminees($searchExamEventExaminees: SearchExamEventExamineesInput!) {
  ecSearchExamEventExaminees(searchExamEventExaminees: $searchExamEventExaminees) {
    examEventExaminees {
      ...Examinee
      registrationStatus
      examEventSessionExaminees {
        examStartedAt
      }
    }
    total
  }
}
    ${ExamineeFragmentDoc}`;

/**
 * __useSearchExamEventExamineesQuery__
 *
 * To run a query within a React component, call `useSearchExamEventExamineesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamEventExamineesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamEventExamineesQuery({
 *   variables: {
 *      searchExamEventExaminees: // value for 'searchExamEventExaminees'
 *   },
 * });
 */
export function useSearchExamEventExamineesQuery(baseOptions: Apollo.QueryHookOptions<SearchExamEventExamineesQuery, SearchExamEventExamineesQueryVariables> & ({ variables: SearchExamEventExamineesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamEventExamineesQuery, SearchExamEventExamineesQueryVariables>(SearchExamEventExamineesDocument, options);
      }
export function useSearchExamEventExamineesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamEventExamineesQuery, SearchExamEventExamineesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamEventExamineesQuery, SearchExamEventExamineesQueryVariables>(SearchExamEventExamineesDocument, options);
        }
export function useSearchExamEventExamineesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamEventExamineesQuery, SearchExamEventExamineesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamEventExamineesQuery, SearchExamEventExamineesQueryVariables>(SearchExamEventExamineesDocument, options);
        }
export type SearchExamEventExamineesQueryHookResult = ReturnType<typeof useSearchExamEventExamineesQuery>;
export type SearchExamEventExamineesLazyQueryHookResult = ReturnType<typeof useSearchExamEventExamineesLazyQuery>;
export type SearchExamEventExamineesSuspenseQueryHookResult = ReturnType<typeof useSearchExamEventExamineesSuspenseQuery>;
export type SearchExamEventExamineesQueryResult = Apollo.QueryResult<SearchExamEventExamineesQuery, SearchExamEventExamineesQueryVariables>;
export const SearchExamEventExamineesWithCertificateStatusAndResultDocument = gql`
    query searchExamEventExamineesWithCertificateStatusAndResult($searchExamEventExaminees: SearchExamEventExamineesInput!) {
  ecSearchExamEventExaminees(searchExamEventExaminees: $searchExamEventExaminees) {
    examEventExaminees {
      ...ExamineeWithCertificateStatusAndExamResult
    }
    total
  }
}
    ${ExamineeWithCertificateStatusAndExamResultFragmentDoc}`;

/**
 * __useSearchExamEventExamineesWithCertificateStatusAndResultQuery__
 *
 * To run a query within a React component, call `useSearchExamEventExamineesWithCertificateStatusAndResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamEventExamineesWithCertificateStatusAndResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamEventExamineesWithCertificateStatusAndResultQuery({
 *   variables: {
 *      searchExamEventExaminees: // value for 'searchExamEventExaminees'
 *   },
 * });
 */
export function useSearchExamEventExamineesWithCertificateStatusAndResultQuery(baseOptions: Apollo.QueryHookOptions<SearchExamEventExamineesWithCertificateStatusAndResultQuery, SearchExamEventExamineesWithCertificateStatusAndResultQueryVariables> & ({ variables: SearchExamEventExamineesWithCertificateStatusAndResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamEventExamineesWithCertificateStatusAndResultQuery, SearchExamEventExamineesWithCertificateStatusAndResultQueryVariables>(SearchExamEventExamineesWithCertificateStatusAndResultDocument, options);
      }
export function useSearchExamEventExamineesWithCertificateStatusAndResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamEventExamineesWithCertificateStatusAndResultQuery, SearchExamEventExamineesWithCertificateStatusAndResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamEventExamineesWithCertificateStatusAndResultQuery, SearchExamEventExamineesWithCertificateStatusAndResultQueryVariables>(SearchExamEventExamineesWithCertificateStatusAndResultDocument, options);
        }
export function useSearchExamEventExamineesWithCertificateStatusAndResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamEventExamineesWithCertificateStatusAndResultQuery, SearchExamEventExamineesWithCertificateStatusAndResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamEventExamineesWithCertificateStatusAndResultQuery, SearchExamEventExamineesWithCertificateStatusAndResultQueryVariables>(SearchExamEventExamineesWithCertificateStatusAndResultDocument, options);
        }
export type SearchExamEventExamineesWithCertificateStatusAndResultQueryHookResult = ReturnType<typeof useSearchExamEventExamineesWithCertificateStatusAndResultQuery>;
export type SearchExamEventExamineesWithCertificateStatusAndResultLazyQueryHookResult = ReturnType<typeof useSearchExamEventExamineesWithCertificateStatusAndResultLazyQuery>;
export type SearchExamEventExamineesWithCertificateStatusAndResultSuspenseQueryHookResult = ReturnType<typeof useSearchExamEventExamineesWithCertificateStatusAndResultSuspenseQuery>;
export type SearchExamEventExamineesWithCertificateStatusAndResultQueryResult = Apollo.QueryResult<SearchExamEventExamineesWithCertificateStatusAndResultQuery, SearchExamEventExamineesWithCertificateStatusAndResultQueryVariables>;
export const GetExamineeSpreadsheetUploadSignedUrlDocument = gql`
    query getExamineeSpreadsheetUploadSignedUrl($input: GetUploadSignedUrlForImportExamineesInput!) {
  ecGetUploadSignedUrlForImportExaminees(
    getUploadSignedUrlForImportExamineesInput: $input
  ) {
    signedUrl
    storageObject {
      fileName
    }
  }
}
    `;

/**
 * __useGetExamineeSpreadsheetUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetExamineeSpreadsheetUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamineeSpreadsheetUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamineeSpreadsheetUploadSignedUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetExamineeSpreadsheetUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetExamineeSpreadsheetUploadSignedUrlQuery, GetExamineeSpreadsheetUploadSignedUrlQueryVariables> & ({ variables: GetExamineeSpreadsheetUploadSignedUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamineeSpreadsheetUploadSignedUrlQuery, GetExamineeSpreadsheetUploadSignedUrlQueryVariables>(GetExamineeSpreadsheetUploadSignedUrlDocument, options);
      }
export function useGetExamineeSpreadsheetUploadSignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamineeSpreadsheetUploadSignedUrlQuery, GetExamineeSpreadsheetUploadSignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamineeSpreadsheetUploadSignedUrlQuery, GetExamineeSpreadsheetUploadSignedUrlQueryVariables>(GetExamineeSpreadsheetUploadSignedUrlDocument, options);
        }
export function useGetExamineeSpreadsheetUploadSignedUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamineeSpreadsheetUploadSignedUrlQuery, GetExamineeSpreadsheetUploadSignedUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamineeSpreadsheetUploadSignedUrlQuery, GetExamineeSpreadsheetUploadSignedUrlQueryVariables>(GetExamineeSpreadsheetUploadSignedUrlDocument, options);
        }
export type GetExamineeSpreadsheetUploadSignedUrlQueryHookResult = ReturnType<typeof useGetExamineeSpreadsheetUploadSignedUrlQuery>;
export type GetExamineeSpreadsheetUploadSignedUrlLazyQueryHookResult = ReturnType<typeof useGetExamineeSpreadsheetUploadSignedUrlLazyQuery>;
export type GetExamineeSpreadsheetUploadSignedUrlSuspenseQueryHookResult = ReturnType<typeof useGetExamineeSpreadsheetUploadSignedUrlSuspenseQuery>;
export type GetExamineeSpreadsheetUploadSignedUrlQueryResult = Apollo.QueryResult<GetExamineeSpreadsheetUploadSignedUrlQuery, GetExamineeSpreadsheetUploadSignedUrlQueryVariables>;
export const ImportExamineesSpreadsheetDocument = gql`
    mutation importExamineesSpreadsheet($input: ImportExamineesSpreadsheetInput!) {
  ecImportExamineesSpreadsheet(importExamineesSpreadsheetInput: $input) {
    success
    fileName
  }
}
    `;
export type ImportExamineesSpreadsheetMutationFn = Apollo.MutationFunction<ImportExamineesSpreadsheetMutation, ImportExamineesSpreadsheetMutationVariables>;

/**
 * __useImportExamineesSpreadsheetMutation__
 *
 * To run a mutation, you first call `useImportExamineesSpreadsheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportExamineesSpreadsheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importExamineesSpreadsheetMutation, { data, loading, error }] = useImportExamineesSpreadsheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportExamineesSpreadsheetMutation(baseOptions?: Apollo.MutationHookOptions<ImportExamineesSpreadsheetMutation, ImportExamineesSpreadsheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportExamineesSpreadsheetMutation, ImportExamineesSpreadsheetMutationVariables>(ImportExamineesSpreadsheetDocument, options);
      }
export type ImportExamineesSpreadsheetMutationHookResult = ReturnType<typeof useImportExamineesSpreadsheetMutation>;
export type ImportExamineesSpreadsheetMutationResult = Apollo.MutationResult<ImportExamineesSpreadsheetMutation>;
export type ImportExamineesSpreadsheetMutationOptions = Apollo.BaseMutationOptions<ImportExamineesSpreadsheetMutation, ImportExamineesSpreadsheetMutationVariables>;
export const GetEKycInfoByExamineeIdAndExamEventIdDocument = gql`
    query getEKycInfoByExamineeIdAndExamEventId($getEKycInfoByExamineeIdAndExamEventIdInput: GetEKycInfoByExamineeIdAndExamEventIdInput!) {
  ecGetEKycInfoByExamineeIdAndExamEventId(
    getEKycInfoByExamineeIdAndExamEventIdInput: $getEKycInfoByExamineeIdAndExamEventIdInput
  ) {
    eKycInfo {
      status
      documents {
        type
        storageObject {
          type
          key
          bucket
        }
      }
      reasons {
        id
        isPassed
      }
      comment
      email
      title
      firstname
      middleName
      lastname
      titleEng
      firstnameEng
      lastnameEng
      idType
      idNumber
      idCode
      dateOfBirth
      issuedDate
      expiryDate
      address
      faceMatchSimilarity
      frontCardVerified
      backCardVerified
      cardVerified
      faceMatched
      id
      userId
      createdAt
      updatedAt
      verificationCheckList {
        photoClarity
        photoIdentityMatch
        idPhotoClarity
      }
    }
  }
}
    `;

/**
 * __useGetEKycInfoByExamineeIdAndExamEventIdQuery__
 *
 * To run a query within a React component, call `useGetEKycInfoByExamineeIdAndExamEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEKycInfoByExamineeIdAndExamEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEKycInfoByExamineeIdAndExamEventIdQuery({
 *   variables: {
 *      getEKycInfoByExamineeIdAndExamEventIdInput: // value for 'getEKycInfoByExamineeIdAndExamEventIdInput'
 *   },
 * });
 */
export function useGetEKycInfoByExamineeIdAndExamEventIdQuery(baseOptions: Apollo.QueryHookOptions<GetEKycInfoByExamineeIdAndExamEventIdQuery, GetEKycInfoByExamineeIdAndExamEventIdQueryVariables> & ({ variables: GetEKycInfoByExamineeIdAndExamEventIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEKycInfoByExamineeIdAndExamEventIdQuery, GetEKycInfoByExamineeIdAndExamEventIdQueryVariables>(GetEKycInfoByExamineeIdAndExamEventIdDocument, options);
      }
export function useGetEKycInfoByExamineeIdAndExamEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEKycInfoByExamineeIdAndExamEventIdQuery, GetEKycInfoByExamineeIdAndExamEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEKycInfoByExamineeIdAndExamEventIdQuery, GetEKycInfoByExamineeIdAndExamEventIdQueryVariables>(GetEKycInfoByExamineeIdAndExamEventIdDocument, options);
        }
export function useGetEKycInfoByExamineeIdAndExamEventIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEKycInfoByExamineeIdAndExamEventIdQuery, GetEKycInfoByExamineeIdAndExamEventIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEKycInfoByExamineeIdAndExamEventIdQuery, GetEKycInfoByExamineeIdAndExamEventIdQueryVariables>(GetEKycInfoByExamineeIdAndExamEventIdDocument, options);
        }
export type GetEKycInfoByExamineeIdAndExamEventIdQueryHookResult = ReturnType<typeof useGetEKycInfoByExamineeIdAndExamEventIdQuery>;
export type GetEKycInfoByExamineeIdAndExamEventIdLazyQueryHookResult = ReturnType<typeof useGetEKycInfoByExamineeIdAndExamEventIdLazyQuery>;
export type GetEKycInfoByExamineeIdAndExamEventIdSuspenseQueryHookResult = ReturnType<typeof useGetEKycInfoByExamineeIdAndExamEventIdSuspenseQuery>;
export type GetEKycInfoByExamineeIdAndExamEventIdQueryResult = Apollo.QueryResult<GetEKycInfoByExamineeIdAndExamEventIdQuery, GetEKycInfoByExamineeIdAndExamEventIdQueryVariables>;
export const EcUpdateEKycStatusDocument = gql`
    mutation EcUpdateEKycStatus($updateEKycStatusInput: UpdateEKycStatusInput!) {
  ecUpdateEKycStatus(updateEKycStatusInput: $updateEKycStatusInput) {
    eKycInfo {
      status
    }
  }
}
    `;
export type EcUpdateEKycStatusMutationFn = Apollo.MutationFunction<EcUpdateEKycStatusMutation, EcUpdateEKycStatusMutationVariables>;

/**
 * __useEcUpdateEKycStatusMutation__
 *
 * To run a mutation, you first call `useEcUpdateEKycStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcUpdateEKycStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecUpdateEKycStatusMutation, { data, loading, error }] = useEcUpdateEKycStatusMutation({
 *   variables: {
 *      updateEKycStatusInput: // value for 'updateEKycStatusInput'
 *   },
 * });
 */
export function useEcUpdateEKycStatusMutation(baseOptions?: Apollo.MutationHookOptions<EcUpdateEKycStatusMutation, EcUpdateEKycStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcUpdateEKycStatusMutation, EcUpdateEKycStatusMutationVariables>(EcUpdateEKycStatusDocument, options);
      }
export type EcUpdateEKycStatusMutationHookResult = ReturnType<typeof useEcUpdateEKycStatusMutation>;
export type EcUpdateEKycStatusMutationResult = Apollo.MutationResult<EcUpdateEKycStatusMutation>;
export type EcUpdateEKycStatusMutationOptions = Apollo.BaseMutationOptions<EcUpdateEKycStatusMutation, EcUpdateEKycStatusMutationVariables>;
export const EcGetEKycDocumentDownloadSignedUrlDocument = gql`
    query EcGetEKycDocumentDownloadSignedUrl($getEKycDocumentDownloadSignedUrlInput: GetEKycDocumentDownloadSignedUrlInput!) {
  ecGetEKycDocumentDownloadSignedUrl(
    getEKycDocumentDownloadSignedUrlInput: $getEKycDocumentDownloadSignedUrlInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useEcGetEKycDocumentDownloadSignedUrlQuery__
 *
 * To run a query within a React component, call `useEcGetEKycDocumentDownloadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useEcGetEKycDocumentDownloadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEcGetEKycDocumentDownloadSignedUrlQuery({
 *   variables: {
 *      getEKycDocumentDownloadSignedUrlInput: // value for 'getEKycDocumentDownloadSignedUrlInput'
 *   },
 * });
 */
export function useEcGetEKycDocumentDownloadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<EcGetEKycDocumentDownloadSignedUrlQuery, EcGetEKycDocumentDownloadSignedUrlQueryVariables> & ({ variables: EcGetEKycDocumentDownloadSignedUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EcGetEKycDocumentDownloadSignedUrlQuery, EcGetEKycDocumentDownloadSignedUrlQueryVariables>(EcGetEKycDocumentDownloadSignedUrlDocument, options);
      }
export function useEcGetEKycDocumentDownloadSignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EcGetEKycDocumentDownloadSignedUrlQuery, EcGetEKycDocumentDownloadSignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EcGetEKycDocumentDownloadSignedUrlQuery, EcGetEKycDocumentDownloadSignedUrlQueryVariables>(EcGetEKycDocumentDownloadSignedUrlDocument, options);
        }
export function useEcGetEKycDocumentDownloadSignedUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EcGetEKycDocumentDownloadSignedUrlQuery, EcGetEKycDocumentDownloadSignedUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EcGetEKycDocumentDownloadSignedUrlQuery, EcGetEKycDocumentDownloadSignedUrlQueryVariables>(EcGetEKycDocumentDownloadSignedUrlDocument, options);
        }
export type EcGetEKycDocumentDownloadSignedUrlQueryHookResult = ReturnType<typeof useEcGetEKycDocumentDownloadSignedUrlQuery>;
export type EcGetEKycDocumentDownloadSignedUrlLazyQueryHookResult = ReturnType<typeof useEcGetEKycDocumentDownloadSignedUrlLazyQuery>;
export type EcGetEKycDocumentDownloadSignedUrlSuspenseQueryHookResult = ReturnType<typeof useEcGetEKycDocumentDownloadSignedUrlSuspenseQuery>;
export type EcGetEKycDocumentDownloadSignedUrlQueryResult = Apollo.QueryResult<EcGetEKycDocumentDownloadSignedUrlQuery, EcGetEKycDocumentDownloadSignedUrlQueryVariables>;
export const SearchExamineeStatusesInExamEventDocument = gql`
    query searchExamineeStatusesInExamEvent($searchExamineeStatusesInExamEvent: SearchExamineeStatusesInExamEventInput!) {
  ecSearchExamineeStatusesInExamEvent(
    searchExamineeStatusesInExamEvent: $searchExamineeStatusesInExamEvent
  ) {
    total
    examEventExaminees {
      id
      userId
      email
      isExamReady
      seatNumber
      sentToSETPortalAt
      status
      remark
      cancelationReason
      registrationStatus
      registrationType
      certificateStatus
      examinee {
        id
        title
        firstName
        middleName
        lastName
        idNumber
        eKycStatus
      }
      examEventExamineeResult {
        id
        result
      }
      examCourse {
        id
        code
      }
      registrationStatus
      examEventSessionExaminees {
        examStartedAt
      }
    }
  }
}
    `;

/**
 * __useSearchExamineeStatusesInExamEventQuery__
 *
 * To run a query within a React component, call `useSearchExamineeStatusesInExamEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamineeStatusesInExamEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamineeStatusesInExamEventQuery({
 *   variables: {
 *      searchExamineeStatusesInExamEvent: // value for 'searchExamineeStatusesInExamEvent'
 *   },
 * });
 */
export function useSearchExamineeStatusesInExamEventQuery(baseOptions: Apollo.QueryHookOptions<SearchExamineeStatusesInExamEventQuery, SearchExamineeStatusesInExamEventQueryVariables> & ({ variables: SearchExamineeStatusesInExamEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamineeStatusesInExamEventQuery, SearchExamineeStatusesInExamEventQueryVariables>(SearchExamineeStatusesInExamEventDocument, options);
      }
export function useSearchExamineeStatusesInExamEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamineeStatusesInExamEventQuery, SearchExamineeStatusesInExamEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamineeStatusesInExamEventQuery, SearchExamineeStatusesInExamEventQueryVariables>(SearchExamineeStatusesInExamEventDocument, options);
        }
export function useSearchExamineeStatusesInExamEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamineeStatusesInExamEventQuery, SearchExamineeStatusesInExamEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamineeStatusesInExamEventQuery, SearchExamineeStatusesInExamEventQueryVariables>(SearchExamineeStatusesInExamEventDocument, options);
        }
export type SearchExamineeStatusesInExamEventQueryHookResult = ReturnType<typeof useSearchExamineeStatusesInExamEventQuery>;
export type SearchExamineeStatusesInExamEventLazyQueryHookResult = ReturnType<typeof useSearchExamineeStatusesInExamEventLazyQuery>;
export type SearchExamineeStatusesInExamEventSuspenseQueryHookResult = ReturnType<typeof useSearchExamineeStatusesInExamEventSuspenseQuery>;
export type SearchExamineeStatusesInExamEventQueryResult = Apollo.QueryResult<SearchExamineeStatusesInExamEventQuery, SearchExamineeStatusesInExamEventQueryVariables>;
export const SearchExamineeEKycStatusesInExamEventDocument = gql`
    query searchExamineeEKycStatusesInExamEvent($searchExamineeEKycStatusesInExamEvent: SearchExamineeEKycStatusesInExamEventInput!) {
  ecSearchExamineeEKycStatusesInExamEvent(
    searchExamineeEKycStatusesInExamEvent: $searchExamineeEKycStatusesInExamEvent
  ) {
    total
    examineeEKycStatuses {
      sourceEKycStatus
      examEventExaminee {
        id
        email
        examinee {
          id
          title
          firstName
          middleName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useSearchExamineeEKycStatusesInExamEventQuery__
 *
 * To run a query within a React component, call `useSearchExamineeEKycStatusesInExamEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamineeEKycStatusesInExamEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamineeEKycStatusesInExamEventQuery({
 *   variables: {
 *      searchExamineeEKycStatusesInExamEvent: // value for 'searchExamineeEKycStatusesInExamEvent'
 *   },
 * });
 */
export function useSearchExamineeEKycStatusesInExamEventQuery(baseOptions: Apollo.QueryHookOptions<SearchExamineeEKycStatusesInExamEventQuery, SearchExamineeEKycStatusesInExamEventQueryVariables> & ({ variables: SearchExamineeEKycStatusesInExamEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamineeEKycStatusesInExamEventQuery, SearchExamineeEKycStatusesInExamEventQueryVariables>(SearchExamineeEKycStatusesInExamEventDocument, options);
      }
export function useSearchExamineeEKycStatusesInExamEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamineeEKycStatusesInExamEventQuery, SearchExamineeEKycStatusesInExamEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamineeEKycStatusesInExamEventQuery, SearchExamineeEKycStatusesInExamEventQueryVariables>(SearchExamineeEKycStatusesInExamEventDocument, options);
        }
export function useSearchExamineeEKycStatusesInExamEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamineeEKycStatusesInExamEventQuery, SearchExamineeEKycStatusesInExamEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamineeEKycStatusesInExamEventQuery, SearchExamineeEKycStatusesInExamEventQueryVariables>(SearchExamineeEKycStatusesInExamEventDocument, options);
        }
export type SearchExamineeEKycStatusesInExamEventQueryHookResult = ReturnType<typeof useSearchExamineeEKycStatusesInExamEventQuery>;
export type SearchExamineeEKycStatusesInExamEventLazyQueryHookResult = ReturnType<typeof useSearchExamineeEKycStatusesInExamEventLazyQuery>;
export type SearchExamineeEKycStatusesInExamEventSuspenseQueryHookResult = ReturnType<typeof useSearchExamineeEKycStatusesInExamEventSuspenseQuery>;
export type SearchExamineeEKycStatusesInExamEventQueryResult = Apollo.QueryResult<SearchExamineeEKycStatusesInExamEventQuery, SearchExamineeEKycStatusesInExamEventQueryVariables>;
export const SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeDocument = gql`
    query searchExamineeStatusesInExamEventWithDataLoaderSessionExaminee($searchExamineeStatusesInExamEvent: SearchExamineeStatusesInExamEventInput!, $examEventSessionId: String) {
  ecSearchExamineeStatusesInExamEvent(
    searchExamineeStatusesInExamEvent: $searchExamineeStatusesInExamEvent
  ) {
    total
    examEventExaminees {
      id
      userId
      email
      isExamReady
      seatNumber
      sentToSETPortalAt
      status
      remark
      cancelationReason
      registrationStatus
      registrationType
      certificateStatus
      examinee {
        id
        title
        firstName
        middleName
        lastName
        idNumber
        eKycStatus
      }
      examEventExamineeResult {
        id
        result
      }
      examEventSessionExaminee(examEventSessionId: $examEventSessionId) {
        id
        loginStatus
        examStatus
        examSubmitStatus
        questionnaireStatus
      }
      examEventSessionExaminees {
        examStartedAt
      }
      examCourse {
        id
        code
      }
    }
  }
}
    `;

/**
 * __useSearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery__
 *
 * To run a query within a React component, call `useSearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery({
 *   variables: {
 *      searchExamineeStatusesInExamEvent: // value for 'searchExamineeStatusesInExamEvent'
 *      examEventSessionId: // value for 'examEventSessionId'
 *   },
 * });
 */
export function useSearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery(baseOptions: Apollo.QueryHookOptions<SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery, SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQueryVariables> & ({ variables: SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery, SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQueryVariables>(SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeDocument, options);
      }
export function useSearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery, SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery, SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQueryVariables>(SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeDocument, options);
        }
export function useSearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery, SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery, SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQueryVariables>(SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeDocument, options);
        }
export type SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQueryHookResult = ReturnType<typeof useSearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery>;
export type SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeLazyQueryHookResult = ReturnType<typeof useSearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeLazyQuery>;
export type SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeSuspenseQueryHookResult = ReturnType<typeof useSearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeSuspenseQuery>;
export type SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQueryResult = Apollo.QueryResult<SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQuery, SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeQueryVariables>;
export const RegisterExamineeWithAlternativeDocumentDocument = gql`
    mutation registerExamineeWithAlternativeDocument($registerExamineeWithAlternativeDocumentInput: RegisterExamineeWithAlternativeDocumentInput!) {
  ecRegisterExamineeWithAlternativeDocument(
    registerExamineeWithAlternativeDocumentInput: $registerExamineeWithAlternativeDocumentInput
  ) {
    message
  }
}
    `;
export type RegisterExamineeWithAlternativeDocumentMutationFn = Apollo.MutationFunction<RegisterExamineeWithAlternativeDocumentMutation, RegisterExamineeWithAlternativeDocumentMutationVariables>;

/**
 * __useRegisterExamineeWithAlternativeDocumentMutation__
 *
 * To run a mutation, you first call `useRegisterExamineeWithAlternativeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterExamineeWithAlternativeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerExamineeWithAlternativeDocumentMutation, { data, loading, error }] = useRegisterExamineeWithAlternativeDocumentMutation({
 *   variables: {
 *      registerExamineeWithAlternativeDocumentInput: // value for 'registerExamineeWithAlternativeDocumentInput'
 *   },
 * });
 */
export function useRegisterExamineeWithAlternativeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RegisterExamineeWithAlternativeDocumentMutation, RegisterExamineeWithAlternativeDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterExamineeWithAlternativeDocumentMutation, RegisterExamineeWithAlternativeDocumentMutationVariables>(RegisterExamineeWithAlternativeDocumentDocument, options);
      }
export type RegisterExamineeWithAlternativeDocumentMutationHookResult = ReturnType<typeof useRegisterExamineeWithAlternativeDocumentMutation>;
export type RegisterExamineeWithAlternativeDocumentMutationResult = Apollo.MutationResult<RegisterExamineeWithAlternativeDocumentMutation>;
export type RegisterExamineeWithAlternativeDocumentMutationOptions = Apollo.BaseMutationOptions<RegisterExamineeWithAlternativeDocumentMutation, RegisterExamineeWithAlternativeDocumentMutationVariables>;
export const RegisterForeignerExamineeWithAlternativeDocumentDocument = gql`
    mutation registerForeignerExamineeWithAlternativeDocument($registerForeignerExamineeWithAlternativeDocumentInput: RegisterForeignerExamineeWithAlternativeDocumentInput!) {
  ecRegisterForeignerExamineeWithAlternativeDocument(
    registerForeignerExamineeWithAlternativeDocumentInput: $registerForeignerExamineeWithAlternativeDocumentInput
  ) {
    message
  }
}
    `;
export type RegisterForeignerExamineeWithAlternativeDocumentMutationFn = Apollo.MutationFunction<RegisterForeignerExamineeWithAlternativeDocumentMutation, RegisterForeignerExamineeWithAlternativeDocumentMutationVariables>;

/**
 * __useRegisterForeignerExamineeWithAlternativeDocumentMutation__
 *
 * To run a mutation, you first call `useRegisterForeignerExamineeWithAlternativeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterForeignerExamineeWithAlternativeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerForeignerExamineeWithAlternativeDocumentMutation, { data, loading, error }] = useRegisterForeignerExamineeWithAlternativeDocumentMutation({
 *   variables: {
 *      registerForeignerExamineeWithAlternativeDocumentInput: // value for 'registerForeignerExamineeWithAlternativeDocumentInput'
 *   },
 * });
 */
export function useRegisterForeignerExamineeWithAlternativeDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RegisterForeignerExamineeWithAlternativeDocumentMutation, RegisterForeignerExamineeWithAlternativeDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterForeignerExamineeWithAlternativeDocumentMutation, RegisterForeignerExamineeWithAlternativeDocumentMutationVariables>(RegisterForeignerExamineeWithAlternativeDocumentDocument, options);
      }
export type RegisterForeignerExamineeWithAlternativeDocumentMutationHookResult = ReturnType<typeof useRegisterForeignerExamineeWithAlternativeDocumentMutation>;
export type RegisterForeignerExamineeWithAlternativeDocumentMutationResult = Apollo.MutationResult<RegisterForeignerExamineeWithAlternativeDocumentMutation>;
export type RegisterForeignerExamineeWithAlternativeDocumentMutationOptions = Apollo.BaseMutationOptions<RegisterForeignerExamineeWithAlternativeDocumentMutation, RegisterForeignerExamineeWithAlternativeDocumentMutationVariables>;
export const GetUploadSignedUrlForAlternativeRegistrationDocument = gql`
    query getUploadSignedUrlForAlternativeRegistration($getUploadSignedUrlForAlternativeRegistrationInput: GetUploadSignedUrlForAlternativeRegistrationInput!) {
  ecGetUploadSignedUrlForAlternativeRegistration(
    getUploadSignedUrlForAlternativeRegistrationInput: $getUploadSignedUrlForAlternativeRegistrationInput
  ) {
    signedUrl
    storageObject {
      fileName
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlForAlternativeRegistrationQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlForAlternativeRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlForAlternativeRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlForAlternativeRegistrationQuery({
 *   variables: {
 *      getUploadSignedUrlForAlternativeRegistrationInput: // value for 'getUploadSignedUrlForAlternativeRegistrationInput'
 *   },
 * });
 */
export function useGetUploadSignedUrlForAlternativeRegistrationQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlForAlternativeRegistrationQuery, GetUploadSignedUrlForAlternativeRegistrationQueryVariables> & ({ variables: GetUploadSignedUrlForAlternativeRegistrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlForAlternativeRegistrationQuery, GetUploadSignedUrlForAlternativeRegistrationQueryVariables>(GetUploadSignedUrlForAlternativeRegistrationDocument, options);
      }
export function useGetUploadSignedUrlForAlternativeRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlForAlternativeRegistrationQuery, GetUploadSignedUrlForAlternativeRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlForAlternativeRegistrationQuery, GetUploadSignedUrlForAlternativeRegistrationQueryVariables>(GetUploadSignedUrlForAlternativeRegistrationDocument, options);
        }
export function useGetUploadSignedUrlForAlternativeRegistrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlForAlternativeRegistrationQuery, GetUploadSignedUrlForAlternativeRegistrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlForAlternativeRegistrationQuery, GetUploadSignedUrlForAlternativeRegistrationQueryVariables>(GetUploadSignedUrlForAlternativeRegistrationDocument, options);
        }
export type GetUploadSignedUrlForAlternativeRegistrationQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForAlternativeRegistrationQuery>;
export type GetUploadSignedUrlForAlternativeRegistrationLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForAlternativeRegistrationLazyQuery>;
export type GetUploadSignedUrlForAlternativeRegistrationSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlForAlternativeRegistrationSuspenseQuery>;
export type GetUploadSignedUrlForAlternativeRegistrationQueryResult = Apollo.QueryResult<GetUploadSignedUrlForAlternativeRegistrationQuery, GetUploadSignedUrlForAlternativeRegistrationQueryVariables>;
export const GetExamEventExamineeByIdDocument = gql`
    query getExamEventExamineeById($getExamEventExamineeByIdInput: GetExamEventExamineeByIdInput!) {
  ecGetExamEventExamineeById(
    getExamEventExamineeByIdInput: $getExamEventExamineeByIdInput
  ) {
    examEventExaminee {
      id
      seatNumber
      email
      registrationStatus
      registrationType
      registeredAt
      registeredBy
      registrationDoc {
        type
        fileName
      }
      reason
      examinee {
        id
        title
        firstName
        middleName
        lastName
        idType
        idNumber
        eKycStatus
        eKycExpiredAt
        dateOfBirth
        countryCode
      }
    }
  }
}
    `;

/**
 * __useGetExamEventExamineeByIdQuery__
 *
 * To run a query within a React component, call `useGetExamEventExamineeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamEventExamineeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamEventExamineeByIdQuery({
 *   variables: {
 *      getExamEventExamineeByIdInput: // value for 'getExamEventExamineeByIdInput'
 *   },
 * });
 */
export function useGetExamEventExamineeByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamEventExamineeByIdQuery, GetExamEventExamineeByIdQueryVariables> & ({ variables: GetExamEventExamineeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamEventExamineeByIdQuery, GetExamEventExamineeByIdQueryVariables>(GetExamEventExamineeByIdDocument, options);
      }
export function useGetExamEventExamineeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamEventExamineeByIdQuery, GetExamEventExamineeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamEventExamineeByIdQuery, GetExamEventExamineeByIdQueryVariables>(GetExamEventExamineeByIdDocument, options);
        }
export function useGetExamEventExamineeByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamEventExamineeByIdQuery, GetExamEventExamineeByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamEventExamineeByIdQuery, GetExamEventExamineeByIdQueryVariables>(GetExamEventExamineeByIdDocument, options);
        }
export type GetExamEventExamineeByIdQueryHookResult = ReturnType<typeof useGetExamEventExamineeByIdQuery>;
export type GetExamEventExamineeByIdLazyQueryHookResult = ReturnType<typeof useGetExamEventExamineeByIdLazyQuery>;
export type GetExamEventExamineeByIdSuspenseQueryHookResult = ReturnType<typeof useGetExamEventExamineeByIdSuspenseQuery>;
export type GetExamEventExamineeByIdQueryResult = Apollo.QueryResult<GetExamEventExamineeByIdQuery, GetExamEventExamineeByIdQueryVariables>;
export const SyncExamEventExamineeWithWrDocument = gql`
    mutation syncExamEventExamineeWithWr($syncExamEventExamineeWithWrInput: syncExamEventExamineeWithWrInput!) {
  ecSyncExamEventExamineeWithWr(
    syncExamEventExamineeWithWrInput: $syncExamEventExamineeWithWrInput
  ) {
    success
    summary {
      validExamineeCount
      canceledExamineeCount
    }
    errors {
      id
      firstName
      middleName
      lastName
      idNumber
      idType
      code
      property
    }
  }
}
    `;
export type SyncExamEventExamineeWithWrMutationFn = Apollo.MutationFunction<SyncExamEventExamineeWithWrMutation, SyncExamEventExamineeWithWrMutationVariables>;

/**
 * __useSyncExamEventExamineeWithWrMutation__
 *
 * To run a mutation, you first call `useSyncExamEventExamineeWithWrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncExamEventExamineeWithWrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncExamEventExamineeWithWrMutation, { data, loading, error }] = useSyncExamEventExamineeWithWrMutation({
 *   variables: {
 *      syncExamEventExamineeWithWrInput: // value for 'syncExamEventExamineeWithWrInput'
 *   },
 * });
 */
export function useSyncExamEventExamineeWithWrMutation(baseOptions?: Apollo.MutationHookOptions<SyncExamEventExamineeWithWrMutation, SyncExamEventExamineeWithWrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncExamEventExamineeWithWrMutation, SyncExamEventExamineeWithWrMutationVariables>(SyncExamEventExamineeWithWrDocument, options);
      }
export type SyncExamEventExamineeWithWrMutationHookResult = ReturnType<typeof useSyncExamEventExamineeWithWrMutation>;
export type SyncExamEventExamineeWithWrMutationResult = Apollo.MutationResult<SyncExamEventExamineeWithWrMutation>;
export type SyncExamEventExamineeWithWrMutationOptions = Apollo.BaseMutationOptions<SyncExamEventExamineeWithWrMutation, SyncExamEventExamineeWithWrMutationVariables>;
export const ResendEKycRequestEmailDocument = gql`
    mutation resendEKycRequestEmail($resendEKycRequestEmailInput: ResendEKycRequestEmailInput!) {
  ecResendEKycRequestEmail(
    resendEKycRequestEmailInput: $resendEKycRequestEmailInput
  ) {
    message
    status
  }
}
    `;
export type ResendEKycRequestEmailMutationFn = Apollo.MutationFunction<ResendEKycRequestEmailMutation, ResendEKycRequestEmailMutationVariables>;

/**
 * __useResendEKycRequestEmailMutation__
 *
 * To run a mutation, you first call `useResendEKycRequestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEKycRequestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEKycRequestEmailMutation, { data, loading, error }] = useResendEKycRequestEmailMutation({
 *   variables: {
 *      resendEKycRequestEmailInput: // value for 'resendEKycRequestEmailInput'
 *   },
 * });
 */
export function useResendEKycRequestEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendEKycRequestEmailMutation, ResendEKycRequestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEKycRequestEmailMutation, ResendEKycRequestEmailMutationVariables>(ResendEKycRequestEmailDocument, options);
      }
export type ResendEKycRequestEmailMutationHookResult = ReturnType<typeof useResendEKycRequestEmailMutation>;
export type ResendEKycRequestEmailMutationResult = Apollo.MutationResult<ResendEKycRequestEmailMutation>;
export type ResendEKycRequestEmailMutationOptions = Apollo.BaseMutationOptions<ResendEKycRequestEmailMutation, ResendEKycRequestEmailMutationVariables>;
export const ResendCertificateEmailDocument = gql`
    mutation resendCertificateEmail($resendCertificateEmailInput: ResendCertificateEmailInput!) {
  ecResendCertificateEmail(
    resendCertificateEmailInput: $resendCertificateEmailInput
  ) {
    message
    status
  }
}
    `;
export type ResendCertificateEmailMutationFn = Apollo.MutationFunction<ResendCertificateEmailMutation, ResendCertificateEmailMutationVariables>;

/**
 * __useResendCertificateEmailMutation__
 *
 * To run a mutation, you first call `useResendCertificateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendCertificateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendCertificateEmailMutation, { data, loading, error }] = useResendCertificateEmailMutation({
 *   variables: {
 *      resendCertificateEmailInput: // value for 'resendCertificateEmailInput'
 *   },
 * });
 */
export function useResendCertificateEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendCertificateEmailMutation, ResendCertificateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendCertificateEmailMutation, ResendCertificateEmailMutationVariables>(ResendCertificateEmailDocument, options);
      }
export type ResendCertificateEmailMutationHookResult = ReturnType<typeof useResendCertificateEmailMutation>;
export type ResendCertificateEmailMutationResult = Apollo.MutationResult<ResendCertificateEmailMutation>;
export type ResendCertificateEmailMutationOptions = Apollo.BaseMutationOptions<ResendCertificateEmailMutation, ResendCertificateEmailMutationVariables>;
export const GetExamEventExamineeCountSummaryDocument = gql`
    query getExamEventExamineeCountSummary($getExamEventExamineeCountSummaryInput: GetExamEventExamineeCountSummaryInput!) {
  ecGetExamEventExamineeCountSummary(
    getExamEventExamineeCountSummaryInput: $getExamEventExamineeCountSummaryInput
  ) {
    total
    prepareForExam
    registered
    inProgress
    canceled
    processing
    pendingResults
    completed
    absent
    eKyc
  }
}
    `;

/**
 * __useGetExamEventExamineeCountSummaryQuery__
 *
 * To run a query within a React component, call `useGetExamEventExamineeCountSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamEventExamineeCountSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamEventExamineeCountSummaryQuery({
 *   variables: {
 *      getExamEventExamineeCountSummaryInput: // value for 'getExamEventExamineeCountSummaryInput'
 *   },
 * });
 */
export function useGetExamEventExamineeCountSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetExamEventExamineeCountSummaryQuery, GetExamEventExamineeCountSummaryQueryVariables> & ({ variables: GetExamEventExamineeCountSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamEventExamineeCountSummaryQuery, GetExamEventExamineeCountSummaryQueryVariables>(GetExamEventExamineeCountSummaryDocument, options);
      }
export function useGetExamEventExamineeCountSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamEventExamineeCountSummaryQuery, GetExamEventExamineeCountSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamEventExamineeCountSummaryQuery, GetExamEventExamineeCountSummaryQueryVariables>(GetExamEventExamineeCountSummaryDocument, options);
        }
export function useGetExamEventExamineeCountSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamEventExamineeCountSummaryQuery, GetExamEventExamineeCountSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamEventExamineeCountSummaryQuery, GetExamEventExamineeCountSummaryQueryVariables>(GetExamEventExamineeCountSummaryDocument, options);
        }
export type GetExamEventExamineeCountSummaryQueryHookResult = ReturnType<typeof useGetExamEventExamineeCountSummaryQuery>;
export type GetExamEventExamineeCountSummaryLazyQueryHookResult = ReturnType<typeof useGetExamEventExamineeCountSummaryLazyQuery>;
export type GetExamEventExamineeCountSummarySuspenseQueryHookResult = ReturnType<typeof useGetExamEventExamineeCountSummarySuspenseQuery>;
export type GetExamEventExamineeCountSummaryQueryResult = Apollo.QueryResult<GetExamEventExamineeCountSummaryQuery, GetExamEventExamineeCountSummaryQueryVariables>;
export const GetExamEventExamineeCountSummaryForProctoringDocument = gql`
    query getExamEventExamineeCountSummaryForProctoring($getExamEventExamineeCountSummaryForProctoringInput: GetExamEventExamineeCountSummaryForProctoringInput!) {
  ecGetExamEventExamineeCountSummaryForProctoring(
    getExamEventExamineeCountSummaryForProctoringInput: $getExamEventExamineeCountSummaryForProctoringInput
  ) {
    total
    eKyc
    canceled
    absent
    passed
    failed
    registrationStatusRegistered
  }
}
    `;

/**
 * __useGetExamEventExamineeCountSummaryForProctoringQuery__
 *
 * To run a query within a React component, call `useGetExamEventExamineeCountSummaryForProctoringQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamEventExamineeCountSummaryForProctoringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamEventExamineeCountSummaryForProctoringQuery({
 *   variables: {
 *      getExamEventExamineeCountSummaryForProctoringInput: // value for 'getExamEventExamineeCountSummaryForProctoringInput'
 *   },
 * });
 */
export function useGetExamEventExamineeCountSummaryForProctoringQuery(baseOptions: Apollo.QueryHookOptions<GetExamEventExamineeCountSummaryForProctoringQuery, GetExamEventExamineeCountSummaryForProctoringQueryVariables> & ({ variables: GetExamEventExamineeCountSummaryForProctoringQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamEventExamineeCountSummaryForProctoringQuery, GetExamEventExamineeCountSummaryForProctoringQueryVariables>(GetExamEventExamineeCountSummaryForProctoringDocument, options);
      }
export function useGetExamEventExamineeCountSummaryForProctoringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamEventExamineeCountSummaryForProctoringQuery, GetExamEventExamineeCountSummaryForProctoringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamEventExamineeCountSummaryForProctoringQuery, GetExamEventExamineeCountSummaryForProctoringQueryVariables>(GetExamEventExamineeCountSummaryForProctoringDocument, options);
        }
export function useGetExamEventExamineeCountSummaryForProctoringSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamEventExamineeCountSummaryForProctoringQuery, GetExamEventExamineeCountSummaryForProctoringQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamEventExamineeCountSummaryForProctoringQuery, GetExamEventExamineeCountSummaryForProctoringQueryVariables>(GetExamEventExamineeCountSummaryForProctoringDocument, options);
        }
export type GetExamEventExamineeCountSummaryForProctoringQueryHookResult = ReturnType<typeof useGetExamEventExamineeCountSummaryForProctoringQuery>;
export type GetExamEventExamineeCountSummaryForProctoringLazyQueryHookResult = ReturnType<typeof useGetExamEventExamineeCountSummaryForProctoringLazyQuery>;
export type GetExamEventExamineeCountSummaryForProctoringSuspenseQueryHookResult = ReturnType<typeof useGetExamEventExamineeCountSummaryForProctoringSuspenseQuery>;
export type GetExamEventExamineeCountSummaryForProctoringQueryResult = Apollo.QueryResult<GetExamEventExamineeCountSummaryForProctoringQuery, GetExamEventExamineeCountSummaryForProctoringQueryVariables>;
export const GetExamEventExamineeScoreReportsDocument = gql`
    query getExamEventExamineeScoreReports($getExamEventExamineeScoreReportsInput: GetExamEventExamineeScoreReportsInput!) {
  ecGetExamEventExamineeScoreReports(
    getExamEventExamineeScoreReportsInput: $getExamEventExamineeScoreReportsInput
  ) {
    examEventExamineeScoreReports {
      title
      firstName
      middleName
      lastName
      idNumber
      totalScore
      seatNumber
      status
      registrationStatus
      resultByTags {
        refId
        tagId
        tagName
        category
        score
      }
      result
    }
  }
}
    `;

/**
 * __useGetExamEventExamineeScoreReportsQuery__
 *
 * To run a query within a React component, call `useGetExamEventExamineeScoreReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamEventExamineeScoreReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamEventExamineeScoreReportsQuery({
 *   variables: {
 *      getExamEventExamineeScoreReportsInput: // value for 'getExamEventExamineeScoreReportsInput'
 *   },
 * });
 */
export function useGetExamEventExamineeScoreReportsQuery(baseOptions: Apollo.QueryHookOptions<GetExamEventExamineeScoreReportsQuery, GetExamEventExamineeScoreReportsQueryVariables> & ({ variables: GetExamEventExamineeScoreReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamEventExamineeScoreReportsQuery, GetExamEventExamineeScoreReportsQueryVariables>(GetExamEventExamineeScoreReportsDocument, options);
      }
export function useGetExamEventExamineeScoreReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamEventExamineeScoreReportsQuery, GetExamEventExamineeScoreReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamEventExamineeScoreReportsQuery, GetExamEventExamineeScoreReportsQueryVariables>(GetExamEventExamineeScoreReportsDocument, options);
        }
export function useGetExamEventExamineeScoreReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamEventExamineeScoreReportsQuery, GetExamEventExamineeScoreReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamEventExamineeScoreReportsQuery, GetExamEventExamineeScoreReportsQueryVariables>(GetExamEventExamineeScoreReportsDocument, options);
        }
export type GetExamEventExamineeScoreReportsQueryHookResult = ReturnType<typeof useGetExamEventExamineeScoreReportsQuery>;
export type GetExamEventExamineeScoreReportsLazyQueryHookResult = ReturnType<typeof useGetExamEventExamineeScoreReportsLazyQuery>;
export type GetExamEventExamineeScoreReportsSuspenseQueryHookResult = ReturnType<typeof useGetExamEventExamineeScoreReportsSuspenseQuery>;
export type GetExamEventExamineeScoreReportsQueryResult = Apollo.QueryResult<GetExamEventExamineeScoreReportsQuery, GetExamEventExamineeScoreReportsQueryVariables>;
export const GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdDocument = gql`
    query getQConfigStructuresReorderedByExamEventIdAndExamCourseId($input: GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdInput!) {
  ecGetQConfigStructuresReorderedByExamEventIdAndExamCourseId(input: $input) {
    qConfigStructures {
      qConfigStructure {
        id
        name
        type
        totalQuestions
        score
        order
        parentId
      }
      calculatedOrder
    }
  }
}
    `;

/**
 * __useGetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery__
 *
 * To run a query within a React component, call `useGetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery(baseOptions: Apollo.QueryHookOptions<GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery, GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQueryVariables> & ({ variables: GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery, GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQueryVariables>(GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdDocument, options);
      }
export function useGetQConfigStructuresReorderedByExamEventIdAndExamCourseIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery, GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery, GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQueryVariables>(GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdDocument, options);
        }
export function useGetQConfigStructuresReorderedByExamEventIdAndExamCourseIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery, GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery, GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQueryVariables>(GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdDocument, options);
        }
export type GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQueryHookResult = ReturnType<typeof useGetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery>;
export type GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdLazyQueryHookResult = ReturnType<typeof useGetQConfigStructuresReorderedByExamEventIdAndExamCourseIdLazyQuery>;
export type GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdSuspenseQueryHookResult = ReturnType<typeof useGetQConfigStructuresReorderedByExamEventIdAndExamCourseIdSuspenseQuery>;
export type GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQueryResult = Apollo.QueryResult<GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQuery, GetQConfigStructuresReorderedByExamEventIdAndExamCourseIdQueryVariables>;
export const ExportExamEventExamineeScoreReportsDocument = gql`
    query exportExamEventExamineeScoreReports($exportExamEventExamineeScoreReportsInput: ExportExamEventExamineeScoreReportsInput!) {
  ecExportExamEventExamineeScoreReports(
    exportExamEventExamineeScoreReportsInput: $exportExamEventExamineeScoreReportsInput
  ) {
    status
  }
}
    `;

/**
 * __useExportExamEventExamineeScoreReportsQuery__
 *
 * To run a query within a React component, call `useExportExamEventExamineeScoreReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportExamEventExamineeScoreReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportExamEventExamineeScoreReportsQuery({
 *   variables: {
 *      exportExamEventExamineeScoreReportsInput: // value for 'exportExamEventExamineeScoreReportsInput'
 *   },
 * });
 */
export function useExportExamEventExamineeScoreReportsQuery(baseOptions: Apollo.QueryHookOptions<ExportExamEventExamineeScoreReportsQuery, ExportExamEventExamineeScoreReportsQueryVariables> & ({ variables: ExportExamEventExamineeScoreReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportExamEventExamineeScoreReportsQuery, ExportExamEventExamineeScoreReportsQueryVariables>(ExportExamEventExamineeScoreReportsDocument, options);
      }
export function useExportExamEventExamineeScoreReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportExamEventExamineeScoreReportsQuery, ExportExamEventExamineeScoreReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportExamEventExamineeScoreReportsQuery, ExportExamEventExamineeScoreReportsQueryVariables>(ExportExamEventExamineeScoreReportsDocument, options);
        }
export function useExportExamEventExamineeScoreReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportExamEventExamineeScoreReportsQuery, ExportExamEventExamineeScoreReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportExamEventExamineeScoreReportsQuery, ExportExamEventExamineeScoreReportsQueryVariables>(ExportExamEventExamineeScoreReportsDocument, options);
        }
export type ExportExamEventExamineeScoreReportsQueryHookResult = ReturnType<typeof useExportExamEventExamineeScoreReportsQuery>;
export type ExportExamEventExamineeScoreReportsLazyQueryHookResult = ReturnType<typeof useExportExamEventExamineeScoreReportsLazyQuery>;
export type ExportExamEventExamineeScoreReportsSuspenseQueryHookResult = ReturnType<typeof useExportExamEventExamineeScoreReportsSuspenseQuery>;
export type ExportExamEventExamineeScoreReportsQueryResult = Apollo.QueryResult<ExportExamEventExamineeScoreReportsQuery, ExportExamEventExamineeScoreReportsQueryVariables>;
export const CancelExamEventExamineeDocument = gql`
    mutation cancelExamEventExaminee($cancelExamEventExamineeInput: CancelExamEventExamineeInput!) {
  ecCancelExamEventExaminee(
    cancelExamEventExamineeInput: $cancelExamEventExamineeInput
  ) {
    examEventExaminee {
      id
      status
      remark
      cancelationReason
    }
  }
}
    `;
export type CancelExamEventExamineeMutationFn = Apollo.MutationFunction<CancelExamEventExamineeMutation, CancelExamEventExamineeMutationVariables>;

/**
 * __useCancelExamEventExamineeMutation__
 *
 * To run a mutation, you first call `useCancelExamEventExamineeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelExamEventExamineeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelExamEventExamineeMutation, { data, loading, error }] = useCancelExamEventExamineeMutation({
 *   variables: {
 *      cancelExamEventExamineeInput: // value for 'cancelExamEventExamineeInput'
 *   },
 * });
 */
export function useCancelExamEventExamineeMutation(baseOptions?: Apollo.MutationHookOptions<CancelExamEventExamineeMutation, CancelExamEventExamineeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelExamEventExamineeMutation, CancelExamEventExamineeMutationVariables>(CancelExamEventExamineeDocument, options);
      }
export type CancelExamEventExamineeMutationHookResult = ReturnType<typeof useCancelExamEventExamineeMutation>;
export type CancelExamEventExamineeMutationResult = Apollo.MutationResult<CancelExamEventExamineeMutation>;
export type CancelExamEventExamineeMutationOptions = Apollo.BaseMutationOptions<CancelExamEventExamineeMutation, CancelExamEventExamineeMutationVariables>;
export const ReinstateExamEventExamineeDocument = gql`
    mutation reinstateExamEventExaminee($reinstateExamEventExamineeInput: ReinstateExamEventExamineeInput!) {
  ecReinstateExamEventExaminee(
    reinstateExamEventExamineeInput: $reinstateExamEventExamineeInput
  ) {
    examEventExaminee {
      id
      status
      remark
      cancelationReason
    }
  }
}
    `;
export type ReinstateExamEventExamineeMutationFn = Apollo.MutationFunction<ReinstateExamEventExamineeMutation, ReinstateExamEventExamineeMutationVariables>;

/**
 * __useReinstateExamEventExamineeMutation__
 *
 * To run a mutation, you first call `useReinstateExamEventExamineeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReinstateExamEventExamineeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reinstateExamEventExamineeMutation, { data, loading, error }] = useReinstateExamEventExamineeMutation({
 *   variables: {
 *      reinstateExamEventExamineeInput: // value for 'reinstateExamEventExamineeInput'
 *   },
 * });
 */
export function useReinstateExamEventExamineeMutation(baseOptions?: Apollo.MutationHookOptions<ReinstateExamEventExamineeMutation, ReinstateExamEventExamineeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReinstateExamEventExamineeMutation, ReinstateExamEventExamineeMutationVariables>(ReinstateExamEventExamineeDocument, options);
      }
export type ReinstateExamEventExamineeMutationHookResult = ReturnType<typeof useReinstateExamEventExamineeMutation>;
export type ReinstateExamEventExamineeMutationResult = Apollo.MutationResult<ReinstateExamEventExamineeMutation>;
export type ReinstateExamEventExamineeMutationOptions = Apollo.BaseMutationOptions<ReinstateExamEventExamineeMutation, ReinstateExamEventExamineeMutationVariables>;
export const SearchExamCenterInReviewProctorRequestsDocument = gql`
    query searchExamCenterInReviewProctorRequests($searchExamCenterProctorRequestsInput: SearchExamCenterProctorRequestsInput!) {
  ecSearchExamCenterProctorRequests(
    searchExamCenterProctorRequestsInput: $searchExamCenterProctorRequestsInput
  ) {
    examCenterProctorRequests {
      id
      type
      firstNameTh
      titleTh
      middleNameTh
      lastNameTh
      step
      refCode
      requestedAt
    }
    total
  }
}
    `;

/**
 * __useSearchExamCenterInReviewProctorRequestsQuery__
 *
 * To run a query within a React component, call `useSearchExamCenterInReviewProctorRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamCenterInReviewProctorRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamCenterInReviewProctorRequestsQuery({
 *   variables: {
 *      searchExamCenterProctorRequestsInput: // value for 'searchExamCenterProctorRequestsInput'
 *   },
 * });
 */
export function useSearchExamCenterInReviewProctorRequestsQuery(baseOptions: Apollo.QueryHookOptions<SearchExamCenterInReviewProctorRequestsQuery, SearchExamCenterInReviewProctorRequestsQueryVariables> & ({ variables: SearchExamCenterInReviewProctorRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamCenterInReviewProctorRequestsQuery, SearchExamCenterInReviewProctorRequestsQueryVariables>(SearchExamCenterInReviewProctorRequestsDocument, options);
      }
export function useSearchExamCenterInReviewProctorRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamCenterInReviewProctorRequestsQuery, SearchExamCenterInReviewProctorRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamCenterInReviewProctorRequestsQuery, SearchExamCenterInReviewProctorRequestsQueryVariables>(SearchExamCenterInReviewProctorRequestsDocument, options);
        }
export function useSearchExamCenterInReviewProctorRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCenterInReviewProctorRequestsQuery, SearchExamCenterInReviewProctorRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamCenterInReviewProctorRequestsQuery, SearchExamCenterInReviewProctorRequestsQueryVariables>(SearchExamCenterInReviewProctorRequestsDocument, options);
        }
export type SearchExamCenterInReviewProctorRequestsQueryHookResult = ReturnType<typeof useSearchExamCenterInReviewProctorRequestsQuery>;
export type SearchExamCenterInReviewProctorRequestsLazyQueryHookResult = ReturnType<typeof useSearchExamCenterInReviewProctorRequestsLazyQuery>;
export type SearchExamCenterInReviewProctorRequestsSuspenseQueryHookResult = ReturnType<typeof useSearchExamCenterInReviewProctorRequestsSuspenseQuery>;
export type SearchExamCenterInReviewProctorRequestsQueryResult = Apollo.QueryResult<SearchExamCenterInReviewProctorRequestsQuery, SearchExamCenterInReviewProctorRequestsQueryVariables>;
export const SearchExamCenterRejectedProctorRequestsDocument = gql`
    query searchExamCenterRejectedProctorRequests($searchExamCenterProctorRequestsInput: SearchExamCenterProctorRequestsInput!) {
  ecSearchExamCenterProctorRequests(
    searchExamCenterProctorRequestsInput: $searchExamCenterProctorRequestsInput
  ) {
    examCenterProctorRequests {
      id
      type
      firstNameTh
      titleTh
      middleNameTh
      lastNameTh
      step
      refCode
      verdicts {
        submittedAt
      }
    }
    total
  }
}
    `;

/**
 * __useSearchExamCenterRejectedProctorRequestsQuery__
 *
 * To run a query within a React component, call `useSearchExamCenterRejectedProctorRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamCenterRejectedProctorRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamCenterRejectedProctorRequestsQuery({
 *   variables: {
 *      searchExamCenterProctorRequestsInput: // value for 'searchExamCenterProctorRequestsInput'
 *   },
 * });
 */
export function useSearchExamCenterRejectedProctorRequestsQuery(baseOptions: Apollo.QueryHookOptions<SearchExamCenterRejectedProctorRequestsQuery, SearchExamCenterRejectedProctorRequestsQueryVariables> & ({ variables: SearchExamCenterRejectedProctorRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamCenterRejectedProctorRequestsQuery, SearchExamCenterRejectedProctorRequestsQueryVariables>(SearchExamCenterRejectedProctorRequestsDocument, options);
      }
export function useSearchExamCenterRejectedProctorRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamCenterRejectedProctorRequestsQuery, SearchExamCenterRejectedProctorRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamCenterRejectedProctorRequestsQuery, SearchExamCenterRejectedProctorRequestsQueryVariables>(SearchExamCenterRejectedProctorRequestsDocument, options);
        }
export function useSearchExamCenterRejectedProctorRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCenterRejectedProctorRequestsQuery, SearchExamCenterRejectedProctorRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamCenterRejectedProctorRequestsQuery, SearchExamCenterRejectedProctorRequestsQueryVariables>(SearchExamCenterRejectedProctorRequestsDocument, options);
        }
export type SearchExamCenterRejectedProctorRequestsQueryHookResult = ReturnType<typeof useSearchExamCenterRejectedProctorRequestsQuery>;
export type SearchExamCenterRejectedProctorRequestsLazyQueryHookResult = ReturnType<typeof useSearchExamCenterRejectedProctorRequestsLazyQuery>;
export type SearchExamCenterRejectedProctorRequestsSuspenseQueryHookResult = ReturnType<typeof useSearchExamCenterRejectedProctorRequestsSuspenseQuery>;
export type SearchExamCenterRejectedProctorRequestsQueryResult = Apollo.QueryResult<SearchExamCenterRejectedProctorRequestsQuery, SearchExamCenterRejectedProctorRequestsQueryVariables>;
export const SearchExamCenterDraftProctorRequestsDocument = gql`
    query searchExamCenterDraftProctorRequests($searchExamCenterProctorRequestsInput: SearchExamCenterProctorRequestsInput!) {
  ecSearchExamCenterProctorRequests(
    searchExamCenterProctorRequestsInput: $searchExamCenterProctorRequestsInput
  ) {
    examCenterProctorRequests {
      id
      type
      firstNameTh
      titleTh
      middleNameTh
      lastNameTh
      step
      refCode
      editedAt
      editedUser {
        lastname
        firstname
      }
    }
    total
  }
}
    `;

/**
 * __useSearchExamCenterDraftProctorRequestsQuery__
 *
 * To run a query within a React component, call `useSearchExamCenterDraftProctorRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamCenterDraftProctorRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamCenterDraftProctorRequestsQuery({
 *   variables: {
 *      searchExamCenterProctorRequestsInput: // value for 'searchExamCenterProctorRequestsInput'
 *   },
 * });
 */
export function useSearchExamCenterDraftProctorRequestsQuery(baseOptions: Apollo.QueryHookOptions<SearchExamCenterDraftProctorRequestsQuery, SearchExamCenterDraftProctorRequestsQueryVariables> & ({ variables: SearchExamCenterDraftProctorRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamCenterDraftProctorRequestsQuery, SearchExamCenterDraftProctorRequestsQueryVariables>(SearchExamCenterDraftProctorRequestsDocument, options);
      }
export function useSearchExamCenterDraftProctorRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamCenterDraftProctorRequestsQuery, SearchExamCenterDraftProctorRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamCenterDraftProctorRequestsQuery, SearchExamCenterDraftProctorRequestsQueryVariables>(SearchExamCenterDraftProctorRequestsDocument, options);
        }
export function useSearchExamCenterDraftProctorRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCenterDraftProctorRequestsQuery, SearchExamCenterDraftProctorRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamCenterDraftProctorRequestsQuery, SearchExamCenterDraftProctorRequestsQueryVariables>(SearchExamCenterDraftProctorRequestsDocument, options);
        }
export type SearchExamCenterDraftProctorRequestsQueryHookResult = ReturnType<typeof useSearchExamCenterDraftProctorRequestsQuery>;
export type SearchExamCenterDraftProctorRequestsLazyQueryHookResult = ReturnType<typeof useSearchExamCenterDraftProctorRequestsLazyQuery>;
export type SearchExamCenterDraftProctorRequestsSuspenseQueryHookResult = ReturnType<typeof useSearchExamCenterDraftProctorRequestsSuspenseQuery>;
export type SearchExamCenterDraftProctorRequestsQueryResult = Apollo.QueryResult<SearchExamCenterDraftProctorRequestsQuery, SearchExamCenterDraftProctorRequestsQueryVariables>;
export const CreateExamCenterProctorRequestDocument = gql`
    mutation createExamCenterProctorRequest($createExamCenterProctorRequestInput: CreateExamCenterProctorRequestInput!) {
  ecCreateExamCenterProctorRequest(
    createExamCenterProctorRequestInput: $createExamCenterProctorRequestInput
  ) {
    examCenterProctorRequest {
      id
    }
  }
}
    `;
export type CreateExamCenterProctorRequestMutationFn = Apollo.MutationFunction<CreateExamCenterProctorRequestMutation, CreateExamCenterProctorRequestMutationVariables>;

/**
 * __useCreateExamCenterProctorRequestMutation__
 *
 * To run a mutation, you first call `useCreateExamCenterProctorRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExamCenterProctorRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExamCenterProctorRequestMutation, { data, loading, error }] = useCreateExamCenterProctorRequestMutation({
 *   variables: {
 *      createExamCenterProctorRequestInput: // value for 'createExamCenterProctorRequestInput'
 *   },
 * });
 */
export function useCreateExamCenterProctorRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateExamCenterProctorRequestMutation, CreateExamCenterProctorRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExamCenterProctorRequestMutation, CreateExamCenterProctorRequestMutationVariables>(CreateExamCenterProctorRequestDocument, options);
      }
export type CreateExamCenterProctorRequestMutationHookResult = ReturnType<typeof useCreateExamCenterProctorRequestMutation>;
export type CreateExamCenterProctorRequestMutationResult = Apollo.MutationResult<CreateExamCenterProctorRequestMutation>;
export type CreateExamCenterProctorRequestMutationOptions = Apollo.BaseMutationOptions<CreateExamCenterProctorRequestMutation, CreateExamCenterProctorRequestMutationVariables>;
export const SubmitExamCenterProctorRequestForReviewDocument = gql`
    mutation submitExamCenterProctorRequestForReview($submitExamCenterProctorRequestInput: SubmitExamCenterProctorRequestInput!) {
  ecSubmitExamCenterProctorRequest(
    submitExamCenterProctorRequestInput: $submitExamCenterProctorRequestInput
  ) {
    examCenterProctorRequest {
      id
    }
  }
}
    `;
export type SubmitExamCenterProctorRequestForReviewMutationFn = Apollo.MutationFunction<SubmitExamCenterProctorRequestForReviewMutation, SubmitExamCenterProctorRequestForReviewMutationVariables>;

/**
 * __useSubmitExamCenterProctorRequestForReviewMutation__
 *
 * To run a mutation, you first call `useSubmitExamCenterProctorRequestForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitExamCenterProctorRequestForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitExamCenterProctorRequestForReviewMutation, { data, loading, error }] = useSubmitExamCenterProctorRequestForReviewMutation({
 *   variables: {
 *      submitExamCenterProctorRequestInput: // value for 'submitExamCenterProctorRequestInput'
 *   },
 * });
 */
export function useSubmitExamCenterProctorRequestForReviewMutation(baseOptions?: Apollo.MutationHookOptions<SubmitExamCenterProctorRequestForReviewMutation, SubmitExamCenterProctorRequestForReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitExamCenterProctorRequestForReviewMutation, SubmitExamCenterProctorRequestForReviewMutationVariables>(SubmitExamCenterProctorRequestForReviewDocument, options);
      }
export type SubmitExamCenterProctorRequestForReviewMutationHookResult = ReturnType<typeof useSubmitExamCenterProctorRequestForReviewMutation>;
export type SubmitExamCenterProctorRequestForReviewMutationResult = Apollo.MutationResult<SubmitExamCenterProctorRequestForReviewMutation>;
export type SubmitExamCenterProctorRequestForReviewMutationOptions = Apollo.BaseMutationOptions<SubmitExamCenterProctorRequestForReviewMutation, SubmitExamCenterProctorRequestForReviewMutationVariables>;
export const GetUploadSignedUrlsForExamCenterProctorRequestDocument = gql`
    query getUploadSignedUrlsForExamCenterProctorRequest($getUploadSignedUrlsForExamCenterProctorRequestInput: GetUploadSignedUrlsForExamCenterProctorRequestInputType!) {
  ecGetUploadSignedUrlsForExamCenterProctorRequest(
    getUploadSignedUrlsForExamCenterProctorRequestInput: $getUploadSignedUrlsForExamCenterProctorRequestInput
  ) {
    signedUrls {
      url
      contentType
      storageObject {
        fileName
      }
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlsForExamCenterProctorRequestQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlsForExamCenterProctorRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlsForExamCenterProctorRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlsForExamCenterProctorRequestQuery({
 *   variables: {
 *      getUploadSignedUrlsForExamCenterProctorRequestInput: // value for 'getUploadSignedUrlsForExamCenterProctorRequestInput'
 *   },
 * });
 */
export function useGetUploadSignedUrlsForExamCenterProctorRequestQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlsForExamCenterProctorRequestQuery, GetUploadSignedUrlsForExamCenterProctorRequestQueryVariables> & ({ variables: GetUploadSignedUrlsForExamCenterProctorRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlsForExamCenterProctorRequestQuery, GetUploadSignedUrlsForExamCenterProctorRequestQueryVariables>(GetUploadSignedUrlsForExamCenterProctorRequestDocument, options);
      }
export function useGetUploadSignedUrlsForExamCenterProctorRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlsForExamCenterProctorRequestQuery, GetUploadSignedUrlsForExamCenterProctorRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlsForExamCenterProctorRequestQuery, GetUploadSignedUrlsForExamCenterProctorRequestQueryVariables>(GetUploadSignedUrlsForExamCenterProctorRequestDocument, options);
        }
export function useGetUploadSignedUrlsForExamCenterProctorRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlsForExamCenterProctorRequestQuery, GetUploadSignedUrlsForExamCenterProctorRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlsForExamCenterProctorRequestQuery, GetUploadSignedUrlsForExamCenterProctorRequestQueryVariables>(GetUploadSignedUrlsForExamCenterProctorRequestDocument, options);
        }
export type GetUploadSignedUrlsForExamCenterProctorRequestQueryHookResult = ReturnType<typeof useGetUploadSignedUrlsForExamCenterProctorRequestQuery>;
export type GetUploadSignedUrlsForExamCenterProctorRequestLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlsForExamCenterProctorRequestLazyQuery>;
export type GetUploadSignedUrlsForExamCenterProctorRequestSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlsForExamCenterProctorRequestSuspenseQuery>;
export type GetUploadSignedUrlsForExamCenterProctorRequestQueryResult = Apollo.QueryResult<GetUploadSignedUrlsForExamCenterProctorRequestQuery, GetUploadSignedUrlsForExamCenterProctorRequestQueryVariables>;
export const DeleteExamCenterDraftProctorRequestDocument = gql`
    mutation deleteExamCenterDraftProctorRequest($deleteExamCenterProctorRequestByIdInput: DeleteExamCenterProctorRequestByIdInput!) {
  ecDeleteExamCenterProctorRequestById(
    deleteExamCenterProctorRequestByIdInput: $deleteExamCenterProctorRequestByIdInput
  ) {
    status
    message
    data
  }
}
    `;
export type DeleteExamCenterDraftProctorRequestMutationFn = Apollo.MutationFunction<DeleteExamCenterDraftProctorRequestMutation, DeleteExamCenterDraftProctorRequestMutationVariables>;

/**
 * __useDeleteExamCenterDraftProctorRequestMutation__
 *
 * To run a mutation, you first call `useDeleteExamCenterDraftProctorRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExamCenterDraftProctorRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExamCenterDraftProctorRequestMutation, { data, loading, error }] = useDeleteExamCenterDraftProctorRequestMutation({
 *   variables: {
 *      deleteExamCenterProctorRequestByIdInput: // value for 'deleteExamCenterProctorRequestByIdInput'
 *   },
 * });
 */
export function useDeleteExamCenterDraftProctorRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExamCenterDraftProctorRequestMutation, DeleteExamCenterDraftProctorRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExamCenterDraftProctorRequestMutation, DeleteExamCenterDraftProctorRequestMutationVariables>(DeleteExamCenterDraftProctorRequestDocument, options);
      }
export type DeleteExamCenterDraftProctorRequestMutationHookResult = ReturnType<typeof useDeleteExamCenterDraftProctorRequestMutation>;
export type DeleteExamCenterDraftProctorRequestMutationResult = Apollo.MutationResult<DeleteExamCenterDraftProctorRequestMutation>;
export type DeleteExamCenterDraftProctorRequestMutationOptions = Apollo.BaseMutationOptions<DeleteExamCenterDraftProctorRequestMutation, DeleteExamCenterDraftProctorRequestMutationVariables>;
export const GetExamCenterProctorRequestVerdictsByIdDocument = gql`
    query getExamCenterProctorRequestVerdictsById($getExamCenterProctorRequestByIdInput: GetExamCenterProctorRequestByIdInputType!) {
  ecGetExamCenterProctorRequestById(
    getExamCenterProctorRequestByIdInput: $getExamCenterProctorRequestByIdInput
  ) {
    examCenterProctorRequest {
      verdicts {
        id
        step
        verdict
        comment
        submittedAt
        requestedAt
      }
    }
  }
}
    `;

/**
 * __useGetExamCenterProctorRequestVerdictsByIdQuery__
 *
 * To run a query within a React component, call `useGetExamCenterProctorRequestVerdictsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCenterProctorRequestVerdictsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCenterProctorRequestVerdictsByIdQuery({
 *   variables: {
 *      getExamCenterProctorRequestByIdInput: // value for 'getExamCenterProctorRequestByIdInput'
 *   },
 * });
 */
export function useGetExamCenterProctorRequestVerdictsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamCenterProctorRequestVerdictsByIdQuery, GetExamCenterProctorRequestVerdictsByIdQueryVariables> & ({ variables: GetExamCenterProctorRequestVerdictsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCenterProctorRequestVerdictsByIdQuery, GetExamCenterProctorRequestVerdictsByIdQueryVariables>(GetExamCenterProctorRequestVerdictsByIdDocument, options);
      }
export function useGetExamCenterProctorRequestVerdictsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCenterProctorRequestVerdictsByIdQuery, GetExamCenterProctorRequestVerdictsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCenterProctorRequestVerdictsByIdQuery, GetExamCenterProctorRequestVerdictsByIdQueryVariables>(GetExamCenterProctorRequestVerdictsByIdDocument, options);
        }
export function useGetExamCenterProctorRequestVerdictsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCenterProctorRequestVerdictsByIdQuery, GetExamCenterProctorRequestVerdictsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCenterProctorRequestVerdictsByIdQuery, GetExamCenterProctorRequestVerdictsByIdQueryVariables>(GetExamCenterProctorRequestVerdictsByIdDocument, options);
        }
export type GetExamCenterProctorRequestVerdictsByIdQueryHookResult = ReturnType<typeof useGetExamCenterProctorRequestVerdictsByIdQuery>;
export type GetExamCenterProctorRequestVerdictsByIdLazyQueryHookResult = ReturnType<typeof useGetExamCenterProctorRequestVerdictsByIdLazyQuery>;
export type GetExamCenterProctorRequestVerdictsByIdSuspenseQueryHookResult = ReturnType<typeof useGetExamCenterProctorRequestVerdictsByIdSuspenseQuery>;
export type GetExamCenterProctorRequestVerdictsByIdQueryResult = Apollo.QueryResult<GetExamCenterProctorRequestVerdictsByIdQuery, GetExamCenterProctorRequestVerdictsByIdQueryVariables>;
export const SaveExamCenterProctorRequestAsRejectedDocument = gql`
    mutation saveExamCenterProctorRequestAsRejected($saveExamCenterProctorRequestAsRejectedInput: SaveExamCenterProctorRequestAsRejectedInput!) {
  ecSaveExamCenterProctorRequestAsRejected(
    saveExamCenterProctorRequestAsRejectedInput: $saveExamCenterProctorRequestAsRejectedInput
  ) {
    examCenterProctorRequest {
      id
    }
  }
}
    `;
export type SaveExamCenterProctorRequestAsRejectedMutationFn = Apollo.MutationFunction<SaveExamCenterProctorRequestAsRejectedMutation, SaveExamCenterProctorRequestAsRejectedMutationVariables>;

/**
 * __useSaveExamCenterProctorRequestAsRejectedMutation__
 *
 * To run a mutation, you first call `useSaveExamCenterProctorRequestAsRejectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveExamCenterProctorRequestAsRejectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveExamCenterProctorRequestAsRejectedMutation, { data, loading, error }] = useSaveExamCenterProctorRequestAsRejectedMutation({
 *   variables: {
 *      saveExamCenterProctorRequestAsRejectedInput: // value for 'saveExamCenterProctorRequestAsRejectedInput'
 *   },
 * });
 */
export function useSaveExamCenterProctorRequestAsRejectedMutation(baseOptions?: Apollo.MutationHookOptions<SaveExamCenterProctorRequestAsRejectedMutation, SaveExamCenterProctorRequestAsRejectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveExamCenterProctorRequestAsRejectedMutation, SaveExamCenterProctorRequestAsRejectedMutationVariables>(SaveExamCenterProctorRequestAsRejectedDocument, options);
      }
export type SaveExamCenterProctorRequestAsRejectedMutationHookResult = ReturnType<typeof useSaveExamCenterProctorRequestAsRejectedMutation>;
export type SaveExamCenterProctorRequestAsRejectedMutationResult = Apollo.MutationResult<SaveExamCenterProctorRequestAsRejectedMutation>;
export type SaveExamCenterProctorRequestAsRejectedMutationOptions = Apollo.BaseMutationOptions<SaveExamCenterProctorRequestAsRejectedMutation, SaveExamCenterProctorRequestAsRejectedMutationVariables>;
export const CreateExamCenterProctorDocument = gql`
    mutation createExamCenterProctor($createExamCenterProctorInput: CreateExamCenterProctorInput!) {
  ecCreateExamCenterProctor(
    CreateExamCenterProctorInput: $createExamCenterProctorInput
  ) {
    examCenterProctor {
      id
    }
  }
}
    `;
export type CreateExamCenterProctorMutationFn = Apollo.MutationFunction<CreateExamCenterProctorMutation, CreateExamCenterProctorMutationVariables>;

/**
 * __useCreateExamCenterProctorMutation__
 *
 * To run a mutation, you first call `useCreateExamCenterProctorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExamCenterProctorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExamCenterProctorMutation, { data, loading, error }] = useCreateExamCenterProctorMutation({
 *   variables: {
 *      createExamCenterProctorInput: // value for 'createExamCenterProctorInput'
 *   },
 * });
 */
export function useCreateExamCenterProctorMutation(baseOptions?: Apollo.MutationHookOptions<CreateExamCenterProctorMutation, CreateExamCenterProctorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExamCenterProctorMutation, CreateExamCenterProctorMutationVariables>(CreateExamCenterProctorDocument, options);
      }
export type CreateExamCenterProctorMutationHookResult = ReturnType<typeof useCreateExamCenterProctorMutation>;
export type CreateExamCenterProctorMutationResult = Apollo.MutationResult<CreateExamCenterProctorMutation>;
export type CreateExamCenterProctorMutationOptions = Apollo.BaseMutationOptions<CreateExamCenterProctorMutation, CreateExamCenterProctorMutationVariables>;
export const SearchExamCenterProctorsDocument = gql`
    query searchExamCenterProctors($searchExamCenterProctorsInput: SearchExamCenterProctorsInput!) {
  ecSearchExamCenterProctors(
    SearchExamCenterProctorsInput: $searchExamCenterProctorsInput
  ) {
    examCenterProctors {
      ...ExamCenterProctor
    }
    total
  }
}
    ${ExamCenterProctorFragmentDoc}`;

/**
 * __useSearchExamCenterProctorsQuery__
 *
 * To run a query within a React component, call `useSearchExamCenterProctorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamCenterProctorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamCenterProctorsQuery({
 *   variables: {
 *      searchExamCenterProctorsInput: // value for 'searchExamCenterProctorsInput'
 *   },
 * });
 */
export function useSearchExamCenterProctorsQuery(baseOptions: Apollo.QueryHookOptions<SearchExamCenterProctorsQuery, SearchExamCenterProctorsQueryVariables> & ({ variables: SearchExamCenterProctorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamCenterProctorsQuery, SearchExamCenterProctorsQueryVariables>(SearchExamCenterProctorsDocument, options);
      }
export function useSearchExamCenterProctorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamCenterProctorsQuery, SearchExamCenterProctorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamCenterProctorsQuery, SearchExamCenterProctorsQueryVariables>(SearchExamCenterProctorsDocument, options);
        }
export function useSearchExamCenterProctorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamCenterProctorsQuery, SearchExamCenterProctorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamCenterProctorsQuery, SearchExamCenterProctorsQueryVariables>(SearchExamCenterProctorsDocument, options);
        }
export type SearchExamCenterProctorsQueryHookResult = ReturnType<typeof useSearchExamCenterProctorsQuery>;
export type SearchExamCenterProctorsLazyQueryHookResult = ReturnType<typeof useSearchExamCenterProctorsLazyQuery>;
export type SearchExamCenterProctorsSuspenseQueryHookResult = ReturnType<typeof useSearchExamCenterProctorsSuspenseQuery>;
export type SearchExamCenterProctorsQueryResult = Apollo.QueryResult<SearchExamCenterProctorsQuery, SearchExamCenterProctorsQueryVariables>;
export const GetExamCenterProctorByIdDocument = gql`
    query getExamCenterProctorById($getExamCenterProctorByIdInput: GetExamCenterProctorByIdInput!) {
  ecGetExamCenterProctorById(
    GetExamCenterProctorByIdInput: $getExamCenterProctorByIdInput
  ) {
    examCenterProctor {
      ...ExamCenterProctor
    }
  }
}
    ${ExamCenterProctorFragmentDoc}`;

/**
 * __useGetExamCenterProctorByIdQuery__
 *
 * To run a query within a React component, call `useGetExamCenterProctorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCenterProctorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCenterProctorByIdQuery({
 *   variables: {
 *      getExamCenterProctorByIdInput: // value for 'getExamCenterProctorByIdInput'
 *   },
 * });
 */
export function useGetExamCenterProctorByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamCenterProctorByIdQuery, GetExamCenterProctorByIdQueryVariables> & ({ variables: GetExamCenterProctorByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCenterProctorByIdQuery, GetExamCenterProctorByIdQueryVariables>(GetExamCenterProctorByIdDocument, options);
      }
export function useGetExamCenterProctorByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCenterProctorByIdQuery, GetExamCenterProctorByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCenterProctorByIdQuery, GetExamCenterProctorByIdQueryVariables>(GetExamCenterProctorByIdDocument, options);
        }
export function useGetExamCenterProctorByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCenterProctorByIdQuery, GetExamCenterProctorByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCenterProctorByIdQuery, GetExamCenterProctorByIdQueryVariables>(GetExamCenterProctorByIdDocument, options);
        }
export type GetExamCenterProctorByIdQueryHookResult = ReturnType<typeof useGetExamCenterProctorByIdQuery>;
export type GetExamCenterProctorByIdLazyQueryHookResult = ReturnType<typeof useGetExamCenterProctorByIdLazyQuery>;
export type GetExamCenterProctorByIdSuspenseQueryHookResult = ReturnType<typeof useGetExamCenterProctorByIdSuspenseQuery>;
export type GetExamCenterProctorByIdQueryResult = Apollo.QueryResult<GetExamCenterProctorByIdQuery, GetExamCenterProctorByIdQueryVariables>;
export const AdminSearchExamCenterProctorsDocument = gql`
    query adminSearchExamCenterProctors($searchExamCenterProctorsInput: SearchExamCenterProctorsInput!) {
  ecAdminSearchExamCenterProctors(
    SearchExamCenterProctorsInput: $searchExamCenterProctorsInput
  ) {
    examCenterProctors {
      ...ExamCenterProctor
    }
    total
  }
}
    ${ExamCenterProctorFragmentDoc}`;

/**
 * __useAdminSearchExamCenterProctorsQuery__
 *
 * To run a query within a React component, call `useAdminSearchExamCenterProctorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSearchExamCenterProctorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSearchExamCenterProctorsQuery({
 *   variables: {
 *      searchExamCenterProctorsInput: // value for 'searchExamCenterProctorsInput'
 *   },
 * });
 */
export function useAdminSearchExamCenterProctorsQuery(baseOptions: Apollo.QueryHookOptions<AdminSearchExamCenterProctorsQuery, AdminSearchExamCenterProctorsQueryVariables> & ({ variables: AdminSearchExamCenterProctorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSearchExamCenterProctorsQuery, AdminSearchExamCenterProctorsQueryVariables>(AdminSearchExamCenterProctorsDocument, options);
      }
export function useAdminSearchExamCenterProctorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSearchExamCenterProctorsQuery, AdminSearchExamCenterProctorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSearchExamCenterProctorsQuery, AdminSearchExamCenterProctorsQueryVariables>(AdminSearchExamCenterProctorsDocument, options);
        }
export function useAdminSearchExamCenterProctorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminSearchExamCenterProctorsQuery, AdminSearchExamCenterProctorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSearchExamCenterProctorsQuery, AdminSearchExamCenterProctorsQueryVariables>(AdminSearchExamCenterProctorsDocument, options);
        }
export type AdminSearchExamCenterProctorsQueryHookResult = ReturnType<typeof useAdminSearchExamCenterProctorsQuery>;
export type AdminSearchExamCenterProctorsLazyQueryHookResult = ReturnType<typeof useAdminSearchExamCenterProctorsLazyQuery>;
export type AdminSearchExamCenterProctorsSuspenseQueryHookResult = ReturnType<typeof useAdminSearchExamCenterProctorsSuspenseQuery>;
export type AdminSearchExamCenterProctorsQueryResult = Apollo.QueryResult<AdminSearchExamCenterProctorsQuery, AdminSearchExamCenterProctorsQueryVariables>;
export const AdminGetExamCenterProctorByIdDocument = gql`
    query adminGetExamCenterProctorById($getExamCenterProctorByIdInput: GetExamCenterProctorByIdInput!) {
  ecAdminGetExamCenterProctorById(
    GetExamCenterProctorByIdInput: $getExamCenterProctorByIdInput
  ) {
    examCenterProctor {
      ...ExamCenterProctor
    }
  }
}
    ${ExamCenterProctorFragmentDoc}`;

/**
 * __useAdminGetExamCenterProctorByIdQuery__
 *
 * To run a query within a React component, call `useAdminGetExamCenterProctorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetExamCenterProctorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetExamCenterProctorByIdQuery({
 *   variables: {
 *      getExamCenterProctorByIdInput: // value for 'getExamCenterProctorByIdInput'
 *   },
 * });
 */
export function useAdminGetExamCenterProctorByIdQuery(baseOptions: Apollo.QueryHookOptions<AdminGetExamCenterProctorByIdQuery, AdminGetExamCenterProctorByIdQueryVariables> & ({ variables: AdminGetExamCenterProctorByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetExamCenterProctorByIdQuery, AdminGetExamCenterProctorByIdQueryVariables>(AdminGetExamCenterProctorByIdDocument, options);
      }
export function useAdminGetExamCenterProctorByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetExamCenterProctorByIdQuery, AdminGetExamCenterProctorByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetExamCenterProctorByIdQuery, AdminGetExamCenterProctorByIdQueryVariables>(AdminGetExamCenterProctorByIdDocument, options);
        }
export function useAdminGetExamCenterProctorByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetExamCenterProctorByIdQuery, AdminGetExamCenterProctorByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetExamCenterProctorByIdQuery, AdminGetExamCenterProctorByIdQueryVariables>(AdminGetExamCenterProctorByIdDocument, options);
        }
export type AdminGetExamCenterProctorByIdQueryHookResult = ReturnType<typeof useAdminGetExamCenterProctorByIdQuery>;
export type AdminGetExamCenterProctorByIdLazyQueryHookResult = ReturnType<typeof useAdminGetExamCenterProctorByIdLazyQuery>;
export type AdminGetExamCenterProctorByIdSuspenseQueryHookResult = ReturnType<typeof useAdminGetExamCenterProctorByIdSuspenseQuery>;
export type AdminGetExamCenterProctorByIdQueryResult = Apollo.QueryResult<AdminGetExamCenterProctorByIdQuery, AdminGetExamCenterProctorByIdQueryVariables>;
export const GetDownloadSignedUrlsForExamCenterProctorDocument = gql`
    query getDownloadSignedUrlsForExamCenterProctor($getDownloadSignedUrlsForExamCenterProctorInput: GetDownloadSignedUrlsForExamCenterProctorInput!) {
  ecGetDownloadSignedUrlsForExamCenterProctor(
    GetDownloadSignedUrlsForExamCenterProctorInput: $getDownloadSignedUrlsForExamCenterProctorInput
  ) {
    signedUrls
  }
}
    `;

/**
 * __useGetDownloadSignedUrlsForExamCenterProctorQuery__
 *
 * To run a query within a React component, call `useGetDownloadSignedUrlsForExamCenterProctorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadSignedUrlsForExamCenterProctorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadSignedUrlsForExamCenterProctorQuery({
 *   variables: {
 *      getDownloadSignedUrlsForExamCenterProctorInput: // value for 'getDownloadSignedUrlsForExamCenterProctorInput'
 *   },
 * });
 */
export function useGetDownloadSignedUrlsForExamCenterProctorQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadSignedUrlsForExamCenterProctorQuery, GetDownloadSignedUrlsForExamCenterProctorQueryVariables> & ({ variables: GetDownloadSignedUrlsForExamCenterProctorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadSignedUrlsForExamCenterProctorQuery, GetDownloadSignedUrlsForExamCenterProctorQueryVariables>(GetDownloadSignedUrlsForExamCenterProctorDocument, options);
      }
export function useGetDownloadSignedUrlsForExamCenterProctorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadSignedUrlsForExamCenterProctorQuery, GetDownloadSignedUrlsForExamCenterProctorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadSignedUrlsForExamCenterProctorQuery, GetDownloadSignedUrlsForExamCenterProctorQueryVariables>(GetDownloadSignedUrlsForExamCenterProctorDocument, options);
        }
export function useGetDownloadSignedUrlsForExamCenterProctorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDownloadSignedUrlsForExamCenterProctorQuery, GetDownloadSignedUrlsForExamCenterProctorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDownloadSignedUrlsForExamCenterProctorQuery, GetDownloadSignedUrlsForExamCenterProctorQueryVariables>(GetDownloadSignedUrlsForExamCenterProctorDocument, options);
        }
export type GetDownloadSignedUrlsForExamCenterProctorQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlsForExamCenterProctorQuery>;
export type GetDownloadSignedUrlsForExamCenterProctorLazyQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlsForExamCenterProctorLazyQuery>;
export type GetDownloadSignedUrlsForExamCenterProctorSuspenseQueryHookResult = ReturnType<typeof useGetDownloadSignedUrlsForExamCenterProctorSuspenseQuery>;
export type GetDownloadSignedUrlsForExamCenterProctorQueryResult = Apollo.QueryResult<GetDownloadSignedUrlsForExamCenterProctorQuery, GetDownloadSignedUrlsForExamCenterProctorQueryVariables>;
export const UpdateExamCenterProctorFromExamCenterManagerDocument = gql`
    mutation updateExamCenterProctorFromExamCenterManager($input: UpdateExamCenterProctorFromExamCenterManagerInput!) {
  ecUpdateExamCenterProctorFromExamCenterManager(
    UpdateExamCenterProctorFromExamCenterManagerInput: $input
  ) {
    examCenterProctor {
      ...ExamCenterProctor
    }
  }
}
    ${ExamCenterProctorFragmentDoc}`;
export type UpdateExamCenterProctorFromExamCenterManagerMutationFn = Apollo.MutationFunction<UpdateExamCenterProctorFromExamCenterManagerMutation, UpdateExamCenterProctorFromExamCenterManagerMutationVariables>;

/**
 * __useUpdateExamCenterProctorFromExamCenterManagerMutation__
 *
 * To run a mutation, you first call `useUpdateExamCenterProctorFromExamCenterManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamCenterProctorFromExamCenterManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamCenterProctorFromExamCenterManagerMutation, { data, loading, error }] = useUpdateExamCenterProctorFromExamCenterManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExamCenterProctorFromExamCenterManagerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExamCenterProctorFromExamCenterManagerMutation, UpdateExamCenterProctorFromExamCenterManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExamCenterProctorFromExamCenterManagerMutation, UpdateExamCenterProctorFromExamCenterManagerMutationVariables>(UpdateExamCenterProctorFromExamCenterManagerDocument, options);
      }
export type UpdateExamCenterProctorFromExamCenterManagerMutationHookResult = ReturnType<typeof useUpdateExamCenterProctorFromExamCenterManagerMutation>;
export type UpdateExamCenterProctorFromExamCenterManagerMutationResult = Apollo.MutationResult<UpdateExamCenterProctorFromExamCenterManagerMutation>;
export type UpdateExamCenterProctorFromExamCenterManagerMutationOptions = Apollo.BaseMutationOptions<UpdateExamCenterProctorFromExamCenterManagerMutation, UpdateExamCenterProctorFromExamCenterManagerMutationVariables>;
export const UpdateExamCenterProctorFromProctorAdminDocument = gql`
    mutation updateExamCenterProctorFromProctorAdmin($updateExamCenterProctorFromProctorAdminInput: UpdateExamCenterProctorFromProctorAdminInput!) {
  ecUpdateExamCenterProctorFromProctorAdmin(
    UpdateExamCenterProctorFromProctorAdminInput: $updateExamCenterProctorFromProctorAdminInput
  ) {
    examCenterProctor {
      ...ExamCenterProctor
    }
  }
}
    ${ExamCenterProctorFragmentDoc}`;
export type UpdateExamCenterProctorFromProctorAdminMutationFn = Apollo.MutationFunction<UpdateExamCenterProctorFromProctorAdminMutation, UpdateExamCenterProctorFromProctorAdminMutationVariables>;

/**
 * __useUpdateExamCenterProctorFromProctorAdminMutation__
 *
 * To run a mutation, you first call `useUpdateExamCenterProctorFromProctorAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExamCenterProctorFromProctorAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExamCenterProctorFromProctorAdminMutation, { data, loading, error }] = useUpdateExamCenterProctorFromProctorAdminMutation({
 *   variables: {
 *      updateExamCenterProctorFromProctorAdminInput: // value for 'updateExamCenterProctorFromProctorAdminInput'
 *   },
 * });
 */
export function useUpdateExamCenterProctorFromProctorAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExamCenterProctorFromProctorAdminMutation, UpdateExamCenterProctorFromProctorAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExamCenterProctorFromProctorAdminMutation, UpdateExamCenterProctorFromProctorAdminMutationVariables>(UpdateExamCenterProctorFromProctorAdminDocument, options);
      }
export type UpdateExamCenterProctorFromProctorAdminMutationHookResult = ReturnType<typeof useUpdateExamCenterProctorFromProctorAdminMutation>;
export type UpdateExamCenterProctorFromProctorAdminMutationResult = Apollo.MutationResult<UpdateExamCenterProctorFromProctorAdminMutation>;
export type UpdateExamCenterProctorFromProctorAdminMutationOptions = Apollo.BaseMutationOptions<UpdateExamCenterProctorFromProctorAdminMutation, UpdateExamCenterProctorFromProctorAdminMutationVariables>;
export const GetUploadSignedUrlsForExamCenterProctorDocument = gql`
    query getUploadSignedUrlsForExamCenterProctor($getUploadSignedUrlsForExamCenterProctorInput: GetUploadSignedUrlsForExamCenterProctorInputType!) {
  ecGetUploadSignedUrlsForExamCenterProctor(
    getUploadSignedUrlsForExamCenterProctorInput: $getUploadSignedUrlsForExamCenterProctorInput
  ) {
    signedUrls {
      url
      storageObject {
        provider
        bucket
        key
        fileName
      }
      contentType
    }
  }
}
    `;

/**
 * __useGetUploadSignedUrlsForExamCenterProctorQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlsForExamCenterProctorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlsForExamCenterProctorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlsForExamCenterProctorQuery({
 *   variables: {
 *      getUploadSignedUrlsForExamCenterProctorInput: // value for 'getUploadSignedUrlsForExamCenterProctorInput'
 *   },
 * });
 */
export function useGetUploadSignedUrlsForExamCenterProctorQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlsForExamCenterProctorQuery, GetUploadSignedUrlsForExamCenterProctorQueryVariables> & ({ variables: GetUploadSignedUrlsForExamCenterProctorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlsForExamCenterProctorQuery, GetUploadSignedUrlsForExamCenterProctorQueryVariables>(GetUploadSignedUrlsForExamCenterProctorDocument, options);
      }
export function useGetUploadSignedUrlsForExamCenterProctorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlsForExamCenterProctorQuery, GetUploadSignedUrlsForExamCenterProctorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlsForExamCenterProctorQuery, GetUploadSignedUrlsForExamCenterProctorQueryVariables>(GetUploadSignedUrlsForExamCenterProctorDocument, options);
        }
export function useGetUploadSignedUrlsForExamCenterProctorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlsForExamCenterProctorQuery, GetUploadSignedUrlsForExamCenterProctorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlsForExamCenterProctorQuery, GetUploadSignedUrlsForExamCenterProctorQueryVariables>(GetUploadSignedUrlsForExamCenterProctorDocument, options);
        }
export type GetUploadSignedUrlsForExamCenterProctorQueryHookResult = ReturnType<typeof useGetUploadSignedUrlsForExamCenterProctorQuery>;
export type GetUploadSignedUrlsForExamCenterProctorLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlsForExamCenterProctorLazyQuery>;
export type GetUploadSignedUrlsForExamCenterProctorSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlsForExamCenterProctorSuspenseQuery>;
export type GetUploadSignedUrlsForExamCenterProctorQueryResult = Apollo.QueryResult<GetUploadSignedUrlsForExamCenterProctorQuery, GetUploadSignedUrlsForExamCenterProctorQueryVariables>;
export const CountActiveExamCenterProctorsByTypeDocument = gql`
    query countActiveExamCenterProctorsByType($countActiveExamCenterProctorsByTypeInput: CountActiveExamCenterProctorsByTypeInput!) {
  ecCountActiveExamCenterProctorsByType(
    CountActiveExamCenterProctorsByTypeInput: $countActiveExamCenterProctorsByTypeInput
  ) {
    proctorsCountByType
  }
}
    `;

/**
 * __useCountActiveExamCenterProctorsByTypeQuery__
 *
 * To run a query within a React component, call `useCountActiveExamCenterProctorsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountActiveExamCenterProctorsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountActiveExamCenterProctorsByTypeQuery({
 *   variables: {
 *      countActiveExamCenterProctorsByTypeInput: // value for 'countActiveExamCenterProctorsByTypeInput'
 *   },
 * });
 */
export function useCountActiveExamCenterProctorsByTypeQuery(baseOptions: Apollo.QueryHookOptions<CountActiveExamCenterProctorsByTypeQuery, CountActiveExamCenterProctorsByTypeQueryVariables> & ({ variables: CountActiveExamCenterProctorsByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountActiveExamCenterProctorsByTypeQuery, CountActiveExamCenterProctorsByTypeQueryVariables>(CountActiveExamCenterProctorsByTypeDocument, options);
      }
export function useCountActiveExamCenterProctorsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountActiveExamCenterProctorsByTypeQuery, CountActiveExamCenterProctorsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountActiveExamCenterProctorsByTypeQuery, CountActiveExamCenterProctorsByTypeQueryVariables>(CountActiveExamCenterProctorsByTypeDocument, options);
        }
export function useCountActiveExamCenterProctorsByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountActiveExamCenterProctorsByTypeQuery, CountActiveExamCenterProctorsByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountActiveExamCenterProctorsByTypeQuery, CountActiveExamCenterProctorsByTypeQueryVariables>(CountActiveExamCenterProctorsByTypeDocument, options);
        }
export type CountActiveExamCenterProctorsByTypeQueryHookResult = ReturnType<typeof useCountActiveExamCenterProctorsByTypeQuery>;
export type CountActiveExamCenterProctorsByTypeLazyQueryHookResult = ReturnType<typeof useCountActiveExamCenterProctorsByTypeLazyQuery>;
export type CountActiveExamCenterProctorsByTypeSuspenseQueryHookResult = ReturnType<typeof useCountActiveExamCenterProctorsByTypeSuspenseQuery>;
export type CountActiveExamCenterProctorsByTypeQueryResult = Apollo.QueryResult<CountActiveExamCenterProctorsByTypeQuery, CountActiveExamCenterProctorsByTypeQueryVariables>;
export const SearchProctorAuditLogDocument = gql`
    query SearchProctorAuditLog($searchProctorAuditLogInput: SearchProctorAuditLogInput!) {
  ecSearchProctorAuditLog(SearchProctorAuditLogInput: $searchProctorAuditLogInput) {
    total
    proctorAuditLogs {
      id
      action
      fullName
      detail
      actionTime
    }
  }
}
    `;

/**
 * __useSearchProctorAuditLogQuery__
 *
 * To run a query within a React component, call `useSearchProctorAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProctorAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProctorAuditLogQuery({
 *   variables: {
 *      searchProctorAuditLogInput: // value for 'searchProctorAuditLogInput'
 *   },
 * });
 */
export function useSearchProctorAuditLogQuery(baseOptions: Apollo.QueryHookOptions<SearchProctorAuditLogQuery, SearchProctorAuditLogQueryVariables> & ({ variables: SearchProctorAuditLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchProctorAuditLogQuery, SearchProctorAuditLogQueryVariables>(SearchProctorAuditLogDocument, options);
      }
export function useSearchProctorAuditLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchProctorAuditLogQuery, SearchProctorAuditLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchProctorAuditLogQuery, SearchProctorAuditLogQueryVariables>(SearchProctorAuditLogDocument, options);
        }
export function useSearchProctorAuditLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchProctorAuditLogQuery, SearchProctorAuditLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchProctorAuditLogQuery, SearchProctorAuditLogQueryVariables>(SearchProctorAuditLogDocument, options);
        }
export type SearchProctorAuditLogQueryHookResult = ReturnType<typeof useSearchProctorAuditLogQuery>;
export type SearchProctorAuditLogLazyQueryHookResult = ReturnType<typeof useSearchProctorAuditLogLazyQuery>;
export type SearchProctorAuditLogSuspenseQueryHookResult = ReturnType<typeof useSearchProctorAuditLogSuspenseQuery>;
export type SearchProctorAuditLogQueryResult = Apollo.QueryResult<SearchProctorAuditLogQuery, SearchProctorAuditLogQueryVariables>;
export const ExportQuestionnairesDocument = gql`
    query exportQuestionnaires($exportQuestionnairesInput: ExportQuestionnairesInput!) {
  ecExportQuestionnaires(ExportQuestionnairesInput: $exportQuestionnairesInput) {
    status
  }
}
    `;

/**
 * __useExportQuestionnairesQuery__
 *
 * To run a query within a React component, call `useExportQuestionnairesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportQuestionnairesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportQuestionnairesQuery({
 *   variables: {
 *      exportQuestionnairesInput: // value for 'exportQuestionnairesInput'
 *   },
 * });
 */
export function useExportQuestionnairesQuery(baseOptions: Apollo.QueryHookOptions<ExportQuestionnairesQuery, ExportQuestionnairesQueryVariables> & ({ variables: ExportQuestionnairesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportQuestionnairesQuery, ExportQuestionnairesQueryVariables>(ExportQuestionnairesDocument, options);
      }
export function useExportQuestionnairesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportQuestionnairesQuery, ExportQuestionnairesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportQuestionnairesQuery, ExportQuestionnairesQueryVariables>(ExportQuestionnairesDocument, options);
        }
export function useExportQuestionnairesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportQuestionnairesQuery, ExportQuestionnairesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportQuestionnairesQuery, ExportQuestionnairesQueryVariables>(ExportQuestionnairesDocument, options);
        }
export type ExportQuestionnairesQueryHookResult = ReturnType<typeof useExportQuestionnairesQuery>;
export type ExportQuestionnairesLazyQueryHookResult = ReturnType<typeof useExportQuestionnairesLazyQuery>;
export type ExportQuestionnairesSuspenseQueryHookResult = ReturnType<typeof useExportQuestionnairesSuspenseQuery>;
export type ExportQuestionnairesQueryResult = Apollo.QueryResult<ExportQuestionnairesQuery, ExportQuestionnairesQueryVariables>;
export const CountExamEventsWithQuestionnairesDocument = gql`
    query countExamEventsWithQuestionnaires($countExamEventsWithQuestionnairesInput: CountExamEventsWithQuestionnairesInput!) {
  ecCountExamEventsWithQuestionnaires(
    CountExamEventsWithQuestionnairesInput: $countExamEventsWithQuestionnairesInput
  ) {
    total
  }
}
    `;

/**
 * __useCountExamEventsWithQuestionnairesQuery__
 *
 * To run a query within a React component, call `useCountExamEventsWithQuestionnairesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountExamEventsWithQuestionnairesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountExamEventsWithQuestionnairesQuery({
 *   variables: {
 *      countExamEventsWithQuestionnairesInput: // value for 'countExamEventsWithQuestionnairesInput'
 *   },
 * });
 */
export function useCountExamEventsWithQuestionnairesQuery(baseOptions: Apollo.QueryHookOptions<CountExamEventsWithQuestionnairesQuery, CountExamEventsWithQuestionnairesQueryVariables> & ({ variables: CountExamEventsWithQuestionnairesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountExamEventsWithQuestionnairesQuery, CountExamEventsWithQuestionnairesQueryVariables>(CountExamEventsWithQuestionnairesDocument, options);
      }
export function useCountExamEventsWithQuestionnairesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountExamEventsWithQuestionnairesQuery, CountExamEventsWithQuestionnairesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountExamEventsWithQuestionnairesQuery, CountExamEventsWithQuestionnairesQueryVariables>(CountExamEventsWithQuestionnairesDocument, options);
        }
export function useCountExamEventsWithQuestionnairesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountExamEventsWithQuestionnairesQuery, CountExamEventsWithQuestionnairesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountExamEventsWithQuestionnairesQuery, CountExamEventsWithQuestionnairesQueryVariables>(CountExamEventsWithQuestionnairesDocument, options);
        }
export type CountExamEventsWithQuestionnairesQueryHookResult = ReturnType<typeof useCountExamEventsWithQuestionnairesQuery>;
export type CountExamEventsWithQuestionnairesLazyQueryHookResult = ReturnType<typeof useCountExamEventsWithQuestionnairesLazyQuery>;
export type CountExamEventsWithQuestionnairesSuspenseQueryHookResult = ReturnType<typeof useCountExamEventsWithQuestionnairesSuspenseQuery>;
export type CountExamEventsWithQuestionnairesQueryResult = Apollo.QueryResult<CountExamEventsWithQuestionnairesQuery, CountExamEventsWithQuestionnairesQueryVariables>;
export const GetServerTimeDocument = gql`
    query getServerTime {
  ecGetServerTime {
    currentTime
  }
}
    `;

/**
 * __useGetServerTimeQuery__
 *
 * To run a query within a React component, call `useGetServerTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServerTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServerTimeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServerTimeQuery(baseOptions?: Apollo.QueryHookOptions<GetServerTimeQuery, GetServerTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServerTimeQuery, GetServerTimeQueryVariables>(GetServerTimeDocument, options);
      }
export function useGetServerTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServerTimeQuery, GetServerTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServerTimeQuery, GetServerTimeQueryVariables>(GetServerTimeDocument, options);
        }
export function useGetServerTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServerTimeQuery, GetServerTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServerTimeQuery, GetServerTimeQueryVariables>(GetServerTimeDocument, options);
        }
export type GetServerTimeQueryHookResult = ReturnType<typeof useGetServerTimeQuery>;
export type GetServerTimeLazyQueryHookResult = ReturnType<typeof useGetServerTimeLazyQuery>;
export type GetServerTimeSuspenseQueryHookResult = ReturnType<typeof useGetServerTimeSuspenseQuery>;
export type GetServerTimeQueryResult = Apollo.QueryResult<GetServerTimeQuery, GetServerTimeQueryVariables>;
export const SearchSetPortalExamResultFilesDocument = gql`
    query searchSETPortalExamResultFiles($searchSetPortalExamResultFilesInput: SearchSETPortalExamResultFilesInput!) {
  ecSearchSETPortalExamResultFiles(
    SearchSETPortalExamResultFilesInput: $searchSetPortalExamResultFilesInput
  ) {
    setPortalExamResultFiles {
      id
      fileName
      fileSize
      createdAt
    }
    total
  }
}
    `;

/**
 * __useSearchSetPortalExamResultFilesQuery__
 *
 * To run a query within a React component, call `useSearchSetPortalExamResultFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSetPortalExamResultFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSetPortalExamResultFilesQuery({
 *   variables: {
 *      searchSetPortalExamResultFilesInput: // value for 'searchSetPortalExamResultFilesInput'
 *   },
 * });
 */
export function useSearchSetPortalExamResultFilesQuery(baseOptions: Apollo.QueryHookOptions<SearchSetPortalExamResultFilesQuery, SearchSetPortalExamResultFilesQueryVariables> & ({ variables: SearchSetPortalExamResultFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSetPortalExamResultFilesQuery, SearchSetPortalExamResultFilesQueryVariables>(SearchSetPortalExamResultFilesDocument, options);
      }
export function useSearchSetPortalExamResultFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSetPortalExamResultFilesQuery, SearchSetPortalExamResultFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSetPortalExamResultFilesQuery, SearchSetPortalExamResultFilesQueryVariables>(SearchSetPortalExamResultFilesDocument, options);
        }
export function useSearchSetPortalExamResultFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSetPortalExamResultFilesQuery, SearchSetPortalExamResultFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSetPortalExamResultFilesQuery, SearchSetPortalExamResultFilesQueryVariables>(SearchSetPortalExamResultFilesDocument, options);
        }
export type SearchSetPortalExamResultFilesQueryHookResult = ReturnType<typeof useSearchSetPortalExamResultFilesQuery>;
export type SearchSetPortalExamResultFilesLazyQueryHookResult = ReturnType<typeof useSearchSetPortalExamResultFilesLazyQuery>;
export type SearchSetPortalExamResultFilesSuspenseQueryHookResult = ReturnType<typeof useSearchSetPortalExamResultFilesSuspenseQuery>;
export type SearchSetPortalExamResultFilesQueryResult = Apollo.QueryResult<SearchSetPortalExamResultFilesQuery, SearchSetPortalExamResultFilesQueryVariables>;
export const DownloadSetPortalExamResultFileDocument = gql`
    query downloadSETPortalExamResultFile($downloadSetPortalExamResultFileInput: DownloadSETPortalExamResultFileInput!) {
  ecDownloadSETPortalExamResultFile(
    DownloadSETPortalExamResultFileInput: $downloadSetPortalExamResultFileInput
  ) {
    downloadUrl
  }
}
    `;

/**
 * __useDownloadSetPortalExamResultFileQuery__
 *
 * To run a query within a React component, call `useDownloadSetPortalExamResultFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadSetPortalExamResultFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadSetPortalExamResultFileQuery({
 *   variables: {
 *      downloadSetPortalExamResultFileInput: // value for 'downloadSetPortalExamResultFileInput'
 *   },
 * });
 */
export function useDownloadSetPortalExamResultFileQuery(baseOptions: Apollo.QueryHookOptions<DownloadSetPortalExamResultFileQuery, DownloadSetPortalExamResultFileQueryVariables> & ({ variables: DownloadSetPortalExamResultFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadSetPortalExamResultFileQuery, DownloadSetPortalExamResultFileQueryVariables>(DownloadSetPortalExamResultFileDocument, options);
      }
export function useDownloadSetPortalExamResultFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadSetPortalExamResultFileQuery, DownloadSetPortalExamResultFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadSetPortalExamResultFileQuery, DownloadSetPortalExamResultFileQueryVariables>(DownloadSetPortalExamResultFileDocument, options);
        }
export function useDownloadSetPortalExamResultFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadSetPortalExamResultFileQuery, DownloadSetPortalExamResultFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadSetPortalExamResultFileQuery, DownloadSetPortalExamResultFileQueryVariables>(DownloadSetPortalExamResultFileDocument, options);
        }
export type DownloadSetPortalExamResultFileQueryHookResult = ReturnType<typeof useDownloadSetPortalExamResultFileQuery>;
export type DownloadSetPortalExamResultFileLazyQueryHookResult = ReturnType<typeof useDownloadSetPortalExamResultFileLazyQuery>;
export type DownloadSetPortalExamResultFileSuspenseQueryHookResult = ReturnType<typeof useDownloadSetPortalExamResultFileSuspenseQuery>;
export type DownloadSetPortalExamResultFileQueryResult = Apollo.QueryResult<DownloadSetPortalExamResultFileQuery, DownloadSetPortalExamResultFileQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    